import { PHIValue } from './lib/phi-value';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** Month and year scalar type */
  MonthAndYear: string;
  /** Protected Health Information (PHI) boolean scalar type */
  PHIBoolean: PHIValue<boolean>;
  /** Protected Health Information (PHI) number scalar type */
  PHINumber: PHIValue<number>;
  /** Protected Health Information (PHI) string scalar type */
  PHIString: PHIValue<string>;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: File | Blob;
  Void: any;
};


export type ActiveUsersInsightMetric = {
  __typename?: 'ActiveUsersInsightMetric';
  id: Scalars['ID'];
  activeUserCount: Scalars['Int'];
};

export type AdminBulkCompleteManualCampaignOfferInputItem = {
  organizationId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
  userExternalEmployeeId?: Maybe<Scalars['String']>;
  userWorkEmail?: Maybe<Scalars['String']>;
  userPersonalEmail?: Maybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  numCompleted: Scalars['Int'];
};

export type AdminBulkCompleteManualCampaignOffersResponse = {
  __typename?: 'AdminBulkCompleteManualCampaignOffersResponse';
  numCompleted: Scalars['Int'];
  errors: Array<Scalars['String']>;
};

export type AdminBulkCreateOrUpdateRewardOfferInputItem = {
  organizationId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
  userExternalEmployeeId?: Maybe<Scalars['String']>;
  userWorkEmail?: Maybe<Scalars['String']>;
  userPersonalEmail?: Maybe<Scalars['String']>;
  externalOfferId: Scalars['String'];
  /**
   * Must be either "yes" or "no".
   *
   * If "yes", the offer will be revoked and the card will no longer be visible to the user.
   */
  revoked?: Maybe<Scalars['String']>;
  /**
   * Available options:
   * - `discrete_progress`
   * - `one_time`
   * - `unlimited`
   */
  structureType: Scalars['String'];
  /**
   * If `structureType` is `discrete_progress`, this must be
   * a comma-delimited list of numbers to award at each step
   */
  structureDiscreteProgressSteps?: Maybe<Scalars['String']>;
  /** If `structureType` is `one_time`, this is required */
  structureOneTimePointValue?: Maybe<Scalars['Int']>;
  /** If `structureType` is `unlimited`, this is required */
  structureUnlimitedPointValue?: Maybe<Scalars['Int']>;
  /** Number of times the offer should be marked as completed. */
  numCompleted?: Maybe<Scalars['Int']>;
  cardTitle: Scalars['String'];
  cardPointsTextOverride?: Maybe<Scalars['String']>;
  cardGraphicKey: RewardOfferCardGraphicKey;
  cardButtonLabel: Scalars['String'];
  /**
   * Available options:
   * - `modal`
   */
  actionType: Scalars['String'];
  /** If action type is 'modal', this is required */
  actionModalContentsHtml?: Maybe<Scalars['String']>;
  /**
   * Rank is used to sort the offers in the UI, and extract ranked communication
   * categories when sending out emails, so we can display most important/relevant
   * reward offer cards first.
   */
  rank?: Maybe<Scalars['Int']>;
  communicationCategory?: Maybe<Scalars['String']>;
};

export type AdminBulkCreateOrUpdateRewardOffersResponse = {
  __typename?: 'AdminBulkCreateOrUpdateRewardOffersResponse';
  numGranted: Scalars['Int'];
  numRevoked: Scalars['Int'];
  numCompleted: Scalars['Int'];
  numCardConfigUpdated: Scalars['Int'];
  numActionUpdated: Scalars['Int'];
  errors: Array<Scalars['String']>;
};

export type AdminBulkCreateOrUpdateVideoOfferInputItem = {
  organizationId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
  userExternalEmployeeId?: Maybe<Scalars['String']>;
  userWorkEmail?: Maybe<Scalars['String']>;
  userPersonalEmail?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  videoId: Scalars['ID'];
  /**
   * Must be either "yes" or "no".
   *
   * If "yes", the video offer will be deleted, and they can no longer earn points for watching.
   */
  deleted?: Maybe<Scalars['String']>;
  pointValue: Scalars['Int'];
};

export type AdminBulkCreateOrUpdateVideoOffersResponse = {
  __typename?: 'AdminBulkCreateOrUpdateVideoOffersResponse';
  numCreated: Scalars['Int'];
  numDeleted: Scalars['Int'];
  errors: Array<Scalars['String']>;
};

export type AdminBulkCreateRewardsUserError = {
  __typename?: 'AdminBulkCreateRewardsUserError';
  index: Scalars['Int'];
  error: Scalars['String'];
};

export type AdminBulkCreateRewardsUserPayload = {
  externalEmployeeId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  personalEmail?: Maybe<Scalars['String']>;
  personalPhoneNumber?: Maybe<Scalars['String']>;
  workEmail?: Maybe<Scalars['String']>;
  workPhoneNumber?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['String']>;
};

export type AdminBulkCreateRewardsUserResponse = {
  __typename?: 'AdminBulkCreateRewardsUserResponse';
  results: Array<AdminBulkCreateRewardsUserResult>;
  numCreated: Scalars['Int'];
};

export type AdminBulkCreateRewardsUserResult = AdminBulkCreateRewardsUserError | AdminBulkCreateRewardsUserSuccess;

export type AdminBulkCreateRewardsUserSuccess = {
  __typename?: 'AdminBulkCreateRewardsUserSuccess';
  index: Scalars['Int'];
  userId: Scalars['String'];
};

export type AdminBulkUpdateRewardsUserError = {
  __typename?: 'AdminBulkUpdateRewardsUserError';
  error: Scalars['String'];
  index: Scalars['Int'];
};

export type AdminBulkUpdateRewardsUserPayload = {
  /** Must be provided if `externalEmployeeId` is not */
  userId?: Maybe<Scalars['ID']>;
  /** Must be provided if `userId` is not */
  externalEmployeeId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  personalEmail?: Maybe<Scalars['String']>;
  personalPhoneNumber?: Maybe<Scalars['String']>;
  workEmail?: Maybe<Scalars['String']>;
  workPhoneNumber?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type AdminBulkUpdateRewardsUserResponse = {
  __typename?: 'AdminBulkUpdateRewardsUserResponse';
  results: Array<AdminBulkUpdateRewardsUserError>;
  numUpdated: Scalars['Int'];
};

export type AdminGetRewardOfferStatsNumUsersByOfferCount = {
  __typename?: 'AdminGetRewardOfferStatsNumUsersByOfferCount';
  numNonRevokedOffers: Scalars['Int'];
  numUsers: Scalars['Int'];
};

export type AdminGetRewardOfferStatsResponse = {
  __typename?: 'AdminGetRewardOfferStatsResponse';
  numUsersByOfferCount: Array<AdminGetRewardOfferStatsNumUsersByOfferCount>;
};

export type AdminGoal = {
  __typename?: 'AdminGoal';
  id: Scalars['ID'];
  type: AdminGoalType;
  status: AdminGoalStatus;
  rewards: AdminGoalRewards;
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
  tracker: AdminGoalTracker;
  goalDetails?: Maybe<AdminGoalDetails>;
};

/** Configuration for a single branch in branch-specific admin goals */
export type AdminGoalBranchConfig = {
  __typename?: 'AdminGoalBranchConfig';
  branchId: Scalars['ID'];
  admins: Array<RewardsAdminUser>;
  rewards: AdminGoalRewards;
  target: AdminGoalTarget;
};

/**
 * Admin goal configuration that supports both organization-wide and branch-specific modes.
 * Use orgWideConfig when configMode is ORG_WIDE, and branchConfigs when configMode is BRANCH_SPECIFIC.
 */
export type AdminGoalConfig = {
  __typename?: 'AdminGoalConfig';
  id: Scalars['ID'];
  /** @deprecated Use orgWideConfig.admins or branchConfigs[].admins instead */
  admins: Array<RewardsAdminUser>;
  goalType: AdminGoalType;
  /** @deprecated Use orgWideConfig.rewards or branchConfigs[].rewards instead */
  rewards: AdminGoalRewards;
  /** @deprecated Use orgWideConfig.target or branchConfigs[].target instead */
  target: AdminGoalTarget;
  /** Date-only string in the format 'YYYY-MM-DD' */
  startDate: Scalars['String'];
  /** Date-only string in the format 'YYYY-MM-DD' */
  endDate: Scalars['String'];
  enabled: Scalars['Boolean'];
  launched: Scalars['Boolean'];
  recurring: Scalars['Boolean'];
  /** @deprecated Use orgWideConfig.admins or recurringBranchConfigs[].admins instead */
  recurringAdmins?: Maybe<Array<RewardsAdminUser>>;
  /** @deprecated Use orgWideConfig.rewards or recurringBranchConfigs[].rewards instead */
  recurringRewards?: Maybe<AdminGoalRewards>;
  /** @deprecated Use orgWideConfig.target or recurringBranchConfigs[].target instead */
  recurringTarget?: Maybe<AdminGoalTarget>;
  /** The configuration mode (ORG_WIDE or BRANCH_SPECIFIC) */
  configMode: AdminGoalConfigMode;
  /**
   * Organization-wide configuration. Required and only available when configMode is ORG_WIDE.
   * Contains admins, rewards, and target shared across the organization.
   * Must be null for BRANCH_SPECIFIC mode.
   */
  orgWideConfig?: Maybe<AdminGoalOrgWideConfig>;
  /**
   * Branch-specific configurations. Required and only available when configMode is BRANCH_SPECIFIC.
   * Contains branch-specific admins, rewards, and targets.
   * Must be null for ORG_WIDE mode.
   */
  branchConfigs?: Maybe<Array<AdminGoalBranchConfig>>;
  /**
   * Organization-wide configuration for recurring goals. Available when configMode is ORG_WIDE and recurring is true.
   * Contains admins, rewards, and target shared across the organization for recurring goals.
   * Must be null for BRANCH_SPECIFIC mode.
   */
  recurringOrgWideConfig?: Maybe<AdminGoalOrgWideConfig>;
  /**
   * Branch-specific configurations for recurring goals. Available when configMode is BRANCH_SPECIFIC and recurring is true.
   * Contains branch-specific admins, rewards, and targets for recurring goals.
   * Must be null for ORG_WIDE mode.
   */
  recurringBranchConfigs?: Maybe<Array<AdminGoalBranchConfig>>;
};

export enum AdminGoalConfigMode {
  /** Organization-wide configuration where all admins share the same target and rewards */
  OrgWide = 'ORG_WIDE',
  /** Branch-specific configuration where each branch has its own admins, targets, and rewards */
  BranchSpecific = 'BRANCH_SPECIFIC'
}

export type AdminGoalDetails = TimeToFirstShiftAdminGoalDetails;

/** Configuration for organization-wide admin goals */
export type AdminGoalOrgWideConfig = {
  __typename?: 'AdminGoalOrgWideConfig';
  admins: Array<RewardsAdminUser>;
  rewards: AdminGoalRewards;
  target: AdminGoalTarget;
};

export type AdminGoalRewards = AdminGoalRewardsGiftCard | AdminGoalRewardsPayroll | AdminGoalRewardsNoReward;

export type AdminGoalRewardsGiftCard = {
  __typename?: 'AdminGoalRewardsGiftCard';
  dollarValue: Scalars['Int'];
};

export type AdminGoalRewardsInput = {
  type: AdminGoalRewardsType;
  /**
   * The dollar value of the reward if the type is ORGANIZATION_DEFAULT.
   * The reward will be given in the organization's selected redemption method
   * (ie. gift card or payroll).
   */
  dollarValue?: Maybe<Scalars['Int']>;
  /** The dollar value of the reward if the type is GIFT_CARD. */
  giftCardDollarValue?: Maybe<Scalars['Int']>;
};

export type AdminGoalRewardsNoReward = {
  __typename?: 'AdminGoalRewardsNoReward';
  /** This will always be `true`. */
  rewardsExcluded: Scalars['Boolean'];
};

export type AdminGoalRewardsPayroll = {
  __typename?: 'AdminGoalRewardsPayroll';
  dollarValue: Scalars['Int'];
};

export enum AdminGoalRewardsType {
  OrganizationDefault = 'ORGANIZATION_DEFAULT',
  GiftCard = 'GIFT_CARD',
  NoReward = 'NO_REWARD'
}

export enum AdminGoalStatus {
  Available = 'AVAILABLE',
  Achieved = 'ACHIEVED',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED',
  WaitingForLateArrivingData = 'WAITING_FOR_LATE_ARRIVING_DATA'
}

export type AdminGoalTarget = AdminGoalTargetPercentage | AdminGoalTargetTimeToFirstShift;

export type AdminGoalTargetInput = {
  type: AdminGoalTargetType;
  /** Required if the target type is PERCENTAGE. */
  percentageValue?: Maybe<Scalars['Int']>;
  /** Required if the target type is TIME_TO_FIRST_SHIFT. */
  timeToFirstShiftValue?: Maybe<AdminGoalTargetTimeToFirstShiftInput>;
};

export type AdminGoalTargetPercentage = {
  __typename?: 'AdminGoalTargetPercentage';
  percentage: Scalars['Int'];
};

export type AdminGoalTargetTimeToFirstShift = {
  __typename?: 'AdminGoalTargetTimeToFirstShift';
  averageDaysToFirstShift: Scalars['Int'];
  newHiresScheduledPercentage: Scalars['Int'];
};

export type AdminGoalTargetTimeToFirstShiftInput = {
  averageDaysToFirstShift: Scalars['Int'];
  newHiresScheduledPercentage: Scalars['Int'];
};

export enum AdminGoalTargetType {
  Percentage = 'PERCENTAGE',
  TimeToFirstShift = 'TIME_TO_FIRST_SHIFT'
}

export type AdminGoalTracker = BudgetUtilizationAdminGoalTracker | LoginAdminGoalTracker | TimeToFirstShiftAdminGoalTracker;

export enum AdminGoalType {
  BudgetUtilization = 'BUDGET_UTILIZATION',
  LoginAfterLaunch = 'LOGIN_AFTER_LAUNCH',
  TimeToFirstShift = 'TIME_TO_FIRST_SHIFT'
}

/**
 * Input for updating an admin goal configuration, supporting both org-wide and branch-specific modes.
 * The fields to use depend on the configuration mode of the goal being updated.
 */
export type AdminGoalUpdateInput = {
  /** Organization-wide admin IDs. Used only for ORG_WIDE configuration mode. */
  adminIds?: Maybe<Array<Scalars['ID']>>;
  /** Organization-wide rewards. Used only for ORG_WIDE configuration mode. */
  rewards?: Maybe<AdminGoalRewardsInput>;
  /** Organization-wide target. Used only for ORG_WIDE configuration mode. */
  target?: Maybe<AdminGoalTargetInput>;
  /**
   * Branch-specific configurations. Used only for BRANCH_SPECIFIC configuration mode.
   * Each branch config includes the branch ID, admin IDs, rewards, and target for that branch.
   */
  branchConfigs?: Maybe<Array<OrganizationAdminGoalBranchConfigUpdateInput>>;
};

/** Specifies which parts of the goal config to update */
export enum AdminGoalUpdateTarget {
  Current = 'CURRENT',
  Recurring = 'RECURRING'
}

export type AdminListRewardOffersResponse = {
  __typename?: 'AdminListRewardOffersResponse';
  total: Scalars['Int'];
  items: Array<RewardVideoOffer>;
};

export type AdminListRewardsOrganizationsResponse = {
  __typename?: 'AdminListRewardsOrganizationsResponse';
  items: Array<RewardsOrganization>;
};

export type AdminShiftRewardBudgetPeriodSummary = BaseBudgetPeriodSummary & {
  __typename?: 'AdminShiftRewardBudgetPeriodSummary';
  currentPeriodStart?: Maybe<Scalars['String']>;
  currentPeriodEnd?: Maybe<Scalars['String']>;
  postedBalance: Scalars['Int'];
  balanceIncludingPending: Scalars['Int'];
  amountPending: Scalars['Int'];
  balanceUpperLimit?: Maybe<Scalars['Int']>;
  unitType: BudgetUnitType;
  /** The shift posting visit IDs that are already included in the budget. */
  shiftPostingVisitIdsIncludedInBudget: Array<Scalars['ID']>;
};

export type AdminlistRewardOffersResponse = {
  __typename?: 'AdminlistRewardOffersResponse';
  total: Scalars['Int'];
  items: Array<RewardOffer>;
};

export type AdminsUsingRecognitionInsightMetric = {
  __typename?: 'AdminsUsingRecognitionInsightMetric';
  id: Scalars['ID'];
  adminsUsingRecognitionCount: Scalars['Int'];
};

export type AlayaCareCaribouUserSync = {
  __typename?: 'AlayaCareCaribouUserSync';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  filters: AlayaCareCaribouUserSyncFilters;
};

export type AlayaCareCaribouUserSyncFilterOption = {
  __typename?: 'AlayaCareCaribouUserSyncFilterOption';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AlayaCareCaribouUserSyncFilters = {
  __typename?: 'AlayaCareCaribouUserSyncFilters';
  departments: Array<AlayaCareCaribouUserSyncFilterOption>;
  branches: Array<AlayaCareCaribouUserSyncFilterOption>;
  groups: Array<AlayaCareCaribouUserSyncFilterOption>;
  roles: Array<AlayaCareCaribouUserSyncFilterOption>;
  jobTitles: Array<Maybe<Scalars['String']>>;
  emailDomains: Array<Maybe<Scalars['String']>>;
};

export type AlayaCareIntegration = {
  __typename?: 'AlayaCareIntegration';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  userAutoSyncs: Array<AlayaCareCaribouUserSync>;
};

export type AnniversaryGoalDetails = {
  __typename?: 'AnniversaryGoalDetails';
  minimumHoursPastYear?: Maybe<Scalars['Int']>;
};

export type AnniversaryGoalDistributionConfig = {
  __typename?: 'AnniversaryGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  anniversaryRewardModeOverride?: Maybe<AnniversaryRewardMode>;
  anniversaryFlatRewardOverride?: Maybe<GoalConfigRewardOverride>;
  anniversaryTieredRewards?: Maybe<Array<AnniversaryTieredReward>>;
  anniversaryMessage: Scalars['String'];
  minimumHoursPastYear?: Maybe<Scalars['Int']>;
};

export type AnniversaryGoalDistributionConfigAdminInput = {
  anniversaryRewardModeOverride?: Maybe<AnniversaryRewardMode>;
  anniversaryFlatRewardOverride?: Maybe<GoalRewardsInput>;
  anniversaryTieredRewards?: Maybe<Array<AnniversaryTieredRewardInput>>;
  anniversaryMessage: Scalars['String'];
  minimumHoursPastYear?: Maybe<Scalars['Int']>;
};

export type AnniversaryGoalTracker = {
  __typename?: 'AnniversaryGoalTracker';
  id: Scalars['ID'];
  anniversaryReached: Scalars['Boolean'];
  anniversaryMessage: Scalars['String'];
  yearOfService: Scalars['Int'];
};

export enum AnniversaryRewardMode {
  Flat = 'FLAT',
  Tiered = 'TIERED'
}

export type AnniversaryTieredReward = {
  __typename?: 'AnniversaryTieredReward';
  yearOfService: Scalars['Int'];
  reward: GoalConfigRewardOverride;
};

export type AnniversaryTieredRewardInput = {
  yearOfService: Scalars['Int'];
  reward: GoalRewardsInput;
};

export enum AppName {
  Caribou = 'CARIBOU',
  CaribouPro = 'CARIBOU_PRO'
}

export type ApplicantsInsightMetric = {
  __typename?: 'ApplicantsInsightMetric';
  id: Scalars['ID'];
  applicantCount: Scalars['Int'];
};

export type ApplicationSubmission = {
  __typename?: 'ApplicationSubmission';
  id: Scalars['ID'];
  submittedAt: Scalars['Timestamp'];
  jobPosting: JobPosting;
  referredByUser: RewardsUser;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  residingCity?: Maybe<Scalars['String']>;
  hasDriversLicenseAndAccessToCar?: Maybe<JobApplicationDriversLicenseAnswer>;
  yearsOfExperience?: Maybe<JobApplicationYearsOfExperienceAnswer>;
  yesNoAnswers?: Maybe<Array<ApplicationSubmissionYesNoAnswer>>;
};

export type ApplicationSubmissionYesNoAnswer = {
  __typename?: 'ApplicationSubmissionYesNoAnswer';
  fieldId: Scalars['String'];
  question: Scalars['String'];
  answer: JobPostingYesNoFieldAnswer;
};

export type ApploiIntegration = {
  __typename?: 'ApploiIntegration';
  id: Scalars['ID'];
  externalId: Scalars['String'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type AssignCaregiverToShiftPostingVisitsError = {
  __typename?: 'AssignCaregiverToShiftPostingVisitsError';
  shiftPostingVisitId: Scalars['ID'];
  errorCode: AssignCaregiverToShiftPostingVisitsErrorCode;
  /**
   * Present when errorCode is CAREGIVER_SCHEDULED_FOR_INACTIVE_STATUS and the
   * inactive date was parsed from the scheduling system (ISO date YYYY-MM-DD).
   */
  scheduledInactiveDate?: Maybe<Scalars['Date']>;
};

export enum AssignCaregiverToShiftPostingVisitsErrorCode {
  VisitAlreadyAssigned = 'VISIT_ALREADY_ASSIGNED',
  VisitDeleted = 'VISIT_DELETED',
  CaregiverConflict = 'CAREGIVER_CONFLICT',
  CaregiverDeclinedByPatient = 'CAREGIVER_DECLINED_BY_PATIENT',
  MissingServiceCode = 'MISSING_SERVICE_CODE',
  CaregiverAbsence = 'CAREGIVER_ABSENCE',
  CaregiverNotAuthorizedForVisit = 'CAREGIVER_NOT_AUTHORIZED_FOR_VISIT',
  CaregiverNotCompliant = 'CAREGIVER_NOT_COMPLIANT',
  CaregiverRestrictedForSelectedContract = 'CAREGIVER_RESTRICTED_FOR_SELECTED_CONTRACT',
  CaregiverOvertime = 'CAREGIVER_OVERTIME',
  MissingPayCode = 'MISSING_PAY_CODE',
  CaregiverDoesNotMatchPatientOffice = 'CAREGIVER_DOES_NOT_MATCH_PATIENT_OFFICE',
  CaregiverScheduledForInactiveStatus = 'CAREGIVER_SCHEDULED_FOR_INACTIVE_STATUS',
  CaregiverInServiceClassOverlap = 'CAREGIVER_IN_SERVICE_CLASS_OVERLAP',
  UnknownError = 'UNKNOWN_ERROR'
}

export type AssignCaregiverToShiftPostingVisitsResponse = {
  __typename?: 'AssignCaregiverToShiftPostingVisitsResponse';
  /** The updated shift posting after assigning the visits. */
  phiShiftPosting: PhiShiftPosting;
  /** This will be `true` if any or all of the visits were unable to be assigned. */
  someVisitsFailedToAssign: Scalars['Boolean'];
  errors: Array<AssignCaregiverToShiftPostingVisitsError>;
};

export type AutomatedDrawConfig = {
  __typename?: 'AutomatedDrawConfig';
  enabled: Scalars['Boolean'];
  prizeStructure?: Maybe<BaseDrawPrizeStructure>;
  announcementVideoId?: Maybe<Scalars['ID']>;
  announcementVideo?: Maybe<RewardVideo>;
  cadence?: Maybe<AutomatedDrawConfigCadence>;
};

export type AutomatedDrawConfigCadence = {
  __typename?: 'AutomatedDrawConfigCadence';
  frequency: AutomatedDrawConfigCadenceFrequency;
  startDayOfWeek?: Maybe<AutomatedDrawConfigCadenceStartDayOfWeek>;
};

export enum AutomatedDrawConfigCadenceFrequency {
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY'
}

export type AutomatedDrawConfigCadenceInput = {
  frequency: AutomatedDrawConfigCadenceFrequency;
  /**
   * If the frequency is `WEEKLY`, this is required and is the day of the week
   * that the draws will start on.
   */
  startDayOfWeek?: Maybe<AutomatedDrawConfigCadenceStartDayOfWeek>;
};

export enum AutomatedDrawConfigCadenceStartDayOfWeek {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY'
}

export type AutomatedDrawConfigInput = {
  enabled: Scalars['Boolean'];
  prizeStructure?: Maybe<Array<DrawPrizeStructureInput>>;
  announcementVideoId?: Maybe<Scalars['ID']>;
  cadence: AutomatedDrawConfigCadenceInput;
};

/** Deprecated - use RecognitionPoints instead */
export type AwardedBonusPoints = {
  __typename?: 'AwardedBonusPoints';
  id: Scalars['ID'];
  rewardsStructureId: Scalars['ID'];
  sentToRewardsUser: RewardsUser;
  /** @deprecated Field no longer supported */
  sentByAdminUser?: Maybe<RewardsAdminUser>;
  pointsAwarded: Scalars['Int'];
  from?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  defaultMessage?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Timestamp']>;
  status: BonusPointsStatus;
  category?: Maybe<RewardsBonusPointCategory>;
  mustBeClaimed: Scalars['Boolean'];
  claimedAt?: Maybe<Scalars['Timestamp']>;
  reminders: Array<BonusPointsReminder>;
  scheduledToSendOn?: Maybe<Scalars['Date']>;
};

export type AwardedDrawTicketTransaction = {
  __typename?: 'AwardedDrawTicketTransaction';
  id: Scalars['ID'];
  awardedAt: Scalars['Timestamp'];
  numTickets: Scalars['Int'];
  metadata: TransactionMetadata;
};

export type BaseBudgetPeriodSummary = {
  /** Null if there is no replenishment period on the budget. */
  currentPeriodStart?: Maybe<Scalars['String']>;
  /** Null if there is no replenishment period on the budget. */
  currentPeriodEnd?: Maybe<Scalars['String']>;
  /**
   * This is the committed balance of the budget, which excludes any pending debits that have not yet been confirmed.
   *
   * It is virtualized because it includes the replenishment amount even if a replenishment has not yet occurred.
   * This is safe to use because we lazily replenish the budget when we perform actions on a budget.
   */
  postedBalance: Scalars['Int'];
  /**
   * This is the balance of the budget including any pending debits that have not yet been confirmed.
   *
   * It is virtualized because it includes the replenishment amount even if a replenishment has not yet occurred.
   * This is safe to use because we lazily replenish the budget when we perform actions on a budget.
   */
  balanceIncludingPending: Scalars['Int'];
  /** This is the amount of pending debits that have not yet been confirmed. */
  amountPending: Scalars['Int'];
  /**
   * This is the upper limit of the balance of the budget.
   *
   * Usually the balance the budget was last replenished up to, or the initial budget amount.
   */
  balanceUpperLimit?: Maybe<Scalars['Int']>;
  /** Balance amount units for the budget. */
  unitType: BudgetUnitType;
};

export type BaseCaregiverImpactMonthDistinctionSlideContent = {
  impactLevel: CaregiverImpactMonthSlideImpactLevel;
};

export type BaseDraw = {
  id: Scalars['ID'];
  prizeStructure: BaseDrawPrizeStructure;
  scheduledStartDate: Scalars['Timestamp'];
  scheduledEndDate: Scalars['Timestamp'];
  /**
   * For rewards users to query the number of tickets
   * they have in the draw.
   */
  myNumTicketsInDraw: Scalars['Int'];
};

export type BaseDrawPrize = {
  id: Scalars['ID'];
  numWinners?: Maybe<Scalars['Int']>;
};

export type BaseDrawPrizeStructure = {
  id: Scalars['ID'];
  totalPrizePointValue: Scalars['Int'];
  numWinners: Scalars['Int'];
};

export type BillableHoursEvaluationPeriod = {
  __typename?: 'BillableHoursEvaluationPeriod';
  lookbackWeeks: Scalars['Int'];
};

export type BillableHoursEvaluationPeriodInput = {
  lookbackWeeks: Scalars['Int'];
};

export type BillableHoursGoalDistributionConfig = {
  __typename?: 'BillableHoursGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  requireEVVComplianceOverride: Scalars['Boolean'];
  evaluationPeriodOverride?: Maybe<BillableHoursEvaluationPeriod>;
  targetHourSegmentsOverride?: Maybe<Array<BillableHoursTargetSegment>>;
  eligibleBranchIds?: Maybe<Array<Scalars['ID']>>;
  eligibleTagIds?: Maybe<Array<Scalars['ID']>>;
};

export type BillableHoursGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  requireEVVComplianceOverride: Scalars['Boolean'];
  evaluationPeriodOverride: BillableHoursEvaluationPeriodInput;
  targetHourSegmentsOverride: Array<BillableHoursTargetSegmentInput>;
  /**
   * Optional list of branch IDs. If provided, only users assigned to these branches will be eligible for billable hours goals.
   * If both eligibleBranchIds and eligibleTagIds are provided, users must match BOTH conditions to be eligible.
   */
  eligibleBranchIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * Optional list of tag IDs. If provided, only users with at least one of these tags will be eligible for billable hours goals.
   * If both eligibleBranchIds and eligibleTagIds are provided, users must match BOTH conditions to be eligible.
   */
  eligibleTagIds?: Maybe<Array<Scalars['ID']>>;
};

export type BillableHoursGoalTracker = {
  __typename?: 'BillableHoursGoalTracker';
  id: Scalars['ID'];
  targetBillableHours: Scalars['Int'];
  trackedBillableHours: Scalars['Int'];
  requiresEVVCompliance: Scalars['Boolean'];
  availability?: Maybe<Scalars['String']>;
  trackedVisits: Array<BillableHoursGoalTrackerVisitDetail>;
};

export type BillableHoursGoalTrackerVisitDetail = {
  __typename?: 'BillableHoursGoalTrackerVisitDetail';
  id: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
};

export type BillableHoursTargetSegment = {
  __typename?: 'BillableHoursTargetSegment';
  maxAverageHours: Scalars['Int'];
  goalHours: Scalars['Int'];
  reward: GoalConfigRewardOverride;
};

export type BillableHoursTargetSegmentInput = {
  maxAverageHours: Scalars['Int'];
  goalHours: Scalars['Int'];
  reward: GoalRewardsInput;
};

export type BirthdayGoalDistributionConfig = {
  __typename?: 'BirthdayGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  birthdayRewardOverride?: Maybe<GoalConfigRewardOverride>;
  birthdayMessage: Scalars['String'];
};

export type BirthdayGoalDistributionConfigAdminInput = {
  birthdayRewardOverride?: Maybe<GoalRewardsInput>;
  birthdayMessage: Scalars['String'];
};

export type BirthdayGoalTracker = {
  __typename?: 'BirthdayGoalTracker';
  id: Scalars['ID'];
  birthdayReached: Scalars['Boolean'];
  birthdayMessage: Scalars['String'];
};

export enum BirthdaySocialPostCopyVariant {
  OneBirthday = 'ONE_BIRTHDAY',
  OneBirthdayCheers = 'ONE_BIRTHDAY_CHEERS',
  MultipleBirthdaysShoutout = 'MULTIPLE_BIRTHDAYS_SHOUTOUT',
  MultipleBirthdaysCelebrating = 'MULTIPLE_BIRTHDAYS_CELEBRATING',
  MultipleBirthdaysAmazing = 'MULTIPLE_BIRTHDAYS_AMAZING'
}

export type BirthdaySocialPostDetails = {
  __typename?: 'BirthdaySocialPostDetails';
  id: Scalars['ID'];
  dateOnly: Scalars['Date'];
  copyVariant: BirthdaySocialPostCopyVariant;
  imageVariant: BirthdaySocialPostImageVariant;
};

export enum BirthdaySocialPostImageVariant {
  Balloons = 'BALLOONS',
  CakeLarge = 'CAKE_LARGE',
  CakeSmall = 'CAKE_SMALL',
  Gifts = 'GIFTS'
}

export type BonusPointsReminder = {
  __typename?: 'BonusPointsReminder';
  id: Scalars['ID'];
  sentAt: Scalars['Timestamp'];
};

export enum BonusPointsStatus {
  Scheduled = 'SCHEDULED',
  Cancelled = 'CANCELLED',
  Sent = 'SENT'
}

export enum BroadcastChannel {
  Sms = 'SMS'
}

export enum BroadcastSentByType {
  System = 'SYSTEM',
  Admin = 'ADMIN',
  Superuser = 'SUPERUSER'
}

export enum BudgetUnitType {
  Tickets = 'TICKETS',
  Points = 'POINTS'
}

export type BudgetUsageInsightMetric = {
  __typename?: 'BudgetUsageInsightMetric';
  id: Scalars['ID'];
  pointsSentByAdminsWithBudgets: Scalars['Int'];
  adminBudgetTotal: Scalars['Int'];
};

export type BudgetUtilizationAdminGoalTracker = {
  __typename?: 'BudgetUtilizationAdminGoalTracker';
  id: Scalars['ID'];
  targetPercentage: Scalars['Int'];
  /**
   * The admin's total budget during the goal period.
   * This may be null if the admin has not been assigned a budget, or
   * if the goal progress has not yet been updated.
   */
  totalPointsBudget?: Maybe<Scalars['Int']>;
  /**
   * The total points the admin has sent during the goal period.
   * This may be greater than the `totalPointsBudget` for admins who have
   * permission to exceed their budget.
   * This may be null if the goal progress has not yet been updated.
   */
  totalPointsSent?: Maybe<Scalars['Int']>;
  progressUpdatedAt?: Maybe<Scalars['Timestamp']>;
};

export type BulkAcknowledgeMyRewardOfferCompletionsData = {
  offerId: Scalars['ID'];
  completionIds: Array<Scalars['ID']>;
};

export type BulkGenerateRedemptionExportInput = {
  organizationId: Scalars['ID'];
  redemptionIds: Array<Scalars['ID']>;
};

export type BulkGenerateRedemptionExportResult = {
  __typename?: 'BulkGenerateRedemptionExportResult';
  items: Array<BulkGenerateRedemptionExportResultItem>;
};

export type BulkGenerateRedemptionExportResultItem = {
  __typename?: 'BulkGenerateRedemptionExportResultItem';
  organizationId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  status: RedemptionExportStatus;
  error?: Maybe<Scalars['String']>;
};

export type BulkImportError = {
  __typename?: 'BulkImportError';
  index: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
};

export enum BulkImportStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Processed = 'PROCESSED',
  ProcessingFailed = 'PROCESSING_FAILED'
}

export type BulkImportStatusResponse = {
  __typename?: 'BulkImportStatusResponse';
  id: Scalars['ID'];
  status: BulkImportStatus;
  durationMs?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<BulkImportError>>;
  results: Scalars['JSON'];
  uploadedAt: Scalars['String'];
  processingStartedAt?: Maybe<Scalars['String']>;
  processingCompletedAt?: Maybe<Scalars['String']>;
};

export enum BulkImportType {
  CreateOrUpdateRewardOffers = 'CREATE_OR_UPDATE_REWARD_OFFERS',
  CreatePowerHoursOffers = 'CREATE_POWER_HOURS_OFFERS',
  CreateOrUpdateEmployees = 'CREATE_OR_UPDATE_EMPLOYEES',
  CreateAdmins = 'CREATE_ADMINS',
  BulkCreateOrUpdateAdmins = 'BULK_CREATE_OR_UPDATE_ADMINS',
  CompleteManualCampaignOffers = 'COMPLETE_MANUAL_CAMPAIGN_OFFERS',
  SendRecognitionPoints = 'SEND_RECOGNITION_POINTS',
  ScheduleRecognitionPoints = 'SCHEDULE_RECOGNITION_POINTS',
  SetHoursForPowerHoursOffer = 'SET_HOURS_FOR_POWER_HOURS_OFFER',
  SetHoursForPowerHoursCampaigns = 'SET_HOURS_FOR_POWER_HOURS_CAMPAIGNS',
  UpdateUserAssignedSmsFromNumber = 'UPDATE_USER_ASSIGNED_SMS_FROM_NUMBER',
  UpdateSurveyOfferExternalIds = 'UPDATE_SURVEY_OFFER_EXTERNAL_IDS',
  AddOrRemoveUsersToSegment = 'ADD_OR_REMOVE_USERS_TO_SEGMENT',
  UpdateAdminAutomatedRecognitionBudgetsConfig = 'UPDATE_ADMIN_AUTOMATED_RECOGNITION_BUDGETS_CONFIG',
  SetManualManagerRecognitionBudgets = 'SET_MANUAL_MANAGER_RECOGNITION_BUDGETS',
  UpdateEvvCompletionRateCampaignsState = 'UPDATE_EVV_COMPLETION_RATE_CAMPAIGNS_STATE',
  UpdateExternalEmployeeIds = 'UPDATE_EXTERNAL_EMPLOYEE_IDS',
  DeductAllRewardsUserPoints = 'DEDUCT_ALL_REWARDS_USER_POINTS',
  CreateOrUpdateVisits = 'CREATE_OR_UPDATE_VISITS',
  BulkRedeemPoints = 'BULK_REDEEM_POINTS'
}

export type BulkRecognitionUpload = {
  __typename?: 'BulkRecognitionUpload';
  id: Scalars['ID'];
};

export type BulkRecognitionUploadPreviewTotals = {
  recognitions: Scalars['Int'];
  points?: Maybe<Scalars['Int']>;
  tickets?: Maybe<Scalars['Int']>;
};

export type BulkRewardsUserUpload = {
  __typename?: 'BulkRewardsUserUpload';
  id: Scalars['ID'];
};

export type CaMailingAddress = {
  __typename?: 'CAMailingAddress';
  countryCode: MailingAddressCountryCode;
  provinceCode: CaProvinceCode;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  postalCode: Scalars['String'];
};

export enum CaProvinceCode {
  Ab = 'AB',
  Bc = 'BC',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Nt = 'NT',
  Ns = 'NS',
  Nu = 'NU',
  On = 'ON',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK',
  Yt = 'YT'
}

export type Candidate = {
  __typename?: 'Candidate';
  id: Scalars['ID'];
  organization: RewardsOrganization;
  archived: Scalars['Boolean'];
  archivedAt?: Maybe<Scalars['Timestamp']>;
  archiveReason?: Maybe<CandidateArchiveReason>;
  completed: Scalars['Boolean'];
  /** @deprecated to support hours based milestone use `completedStepsV2` instead */
  completedSteps: Array<RecordedCandidateStep>;
  completedStepsV2: Array<RecordedCandidateStepV2>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  jobsAppliedTo: Array<JobPosting>;
  appliedOnDates: Array<Scalars['Date']>;
  referredByUser: RewardsUser;
  pointsEarnedByReferredByUser: Scalars['Int'];
  /**
   * Notes that an admin can write to provide context for a candidate.
   * (e.g. why the candidate didn't pass their interview, or why they were archived)
   */
  adminNotes?: Maybe<Scalars['String']>;
  hasUploadedResume: Scalars['Boolean'];
  temporaryResumeDownloadLink?: Maybe<Scalars['String']>;
  /** @deprecated Use jobsAppliedTo instead */
  jobAppliedTo: JobPosting;
  /** @deprecated Use appliedOnDates instead */
  appliedOnDate: Scalars['Date'];
  applicationSubmissions: Array<ApplicationSubmission>;
  resumeReminders: Array<CandidateResumeReminder>;
  assignedToAdmin?: Maybe<RewardsAdminUser>;
  assignedToJobPosting?: Maybe<JobPosting>;
  linkedEmployee?: Maybe<RewardsUser>;
  /** The ATS sync status for this candidate. */
  atsSyncStatus?: Maybe<CandidateAtsSyncStatus>;
  /**
   * If present, represents the next step that the candidate is able to complete.
   * Is not present if the candidate has completed all steps, or is archived.
   */
  nextStepToComplete?: Maybe<CandidateStepV2>;
  /**
   * All possible next steps for the candidate, based on their job posting's referral structure,
   * in the correct sequence.
   */
  nextSteps: Array<CandidateStepV2>;
  /** Represents the last step activity _or_ archived date (if archived) of the candidate. */
  lastStepOrArchivedDate: Scalars['Timestamp'];
};

export enum CandidateArchiveReason {
  Unknown = 'UNKNOWN',
  Completed = 'COMPLETED',
  JobClosed = 'JOB_CLOSED',
  AutoReject = 'AUTO_REJECT',
  Fraudulent = 'FRAUDULENT'
}

export enum CandidateAtsSyncStatus {
  ManualSync = 'MANUAL_SYNC',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Duplicated = 'DUPLICATED'
}

export type CandidateHourlyRetentionStep = {
  __typename?: 'CandidateHourlyRetentionStep';
  durationHours: Scalars['Int'];
};

export type CandidateHourlyRetentionStepFilterOption = {
  __typename?: 'CandidateHourlyRetentionStepFilterOption';
  durationHours: Scalars['Int'];
};

export type CandidateMonthlyRetentionStep = {
  __typename?: 'CandidateMonthlyRetentionStep';
  durationMonths: Scalars['Int'];
};

export type CandidateMonthlyRetentionStepFilterOption = {
  __typename?: 'CandidateMonthlyRetentionStepFilterOption';
  durationMonths: Scalars['Int'];
};

export type CandidateNextStepFilterOption = CandidateRecruitmentStepFilterOption | CandidateMonthlyRetentionStepFilterOption | CandidateHourlyRetentionStepFilterOption;

export type CandidateRecruitmentStep = {
  __typename?: 'CandidateRecruitmentStep';
  stepName: CandidateRecruitmentStepName;
};

export type CandidateRecruitmentStepFilterOption = {
  __typename?: 'CandidateRecruitmentStepFilterOption';
  stepName: CandidateRecruitmentStepName;
};

export enum CandidateRecruitmentStepName {
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  Contacted = 'CONTACTED',
  InterviewScheduled = 'INTERVIEW_SCHEDULED',
  InterviewSuccessful = 'INTERVIEW_SUCCESSFUL',
  Hired = 'HIRED',
  StartedWork = 'STARTED_WORK',
  StartedOrientation = 'STARTED_ORIENTATION',
  CompletedOrientation = 'COMPLETED_ORIENTATION',
  CompletedFirstShift = 'COMPLETED_FIRST_SHIFT'
}

export type CandidateResumeReminder = {
  __typename?: 'CandidateResumeReminder';
  id: Scalars['ID'];
  sentAt: Scalars['Timestamp'];
};

export type CandidateRetentionStep = {
  __typename?: 'CandidateRetentionStep';
  durationMonths: Scalars['Int'];
};

/** Deprecated: Use `CandidateStepV2` instead */
export type CandidateStep = CandidateRecruitmentStep | CandidateRetentionStep;

export type CandidateStepV2 = CandidateRecruitmentStep | CandidateMonthlyRetentionStep | CandidateHourlyRetentionStep;

export type CaregiverImpactLifesaverDistinctionSlide = BaseCaregiverImpactMonthDistinctionSlideContent & {
  __typename?: 'CaregiverImpactLifesaverDistinctionSlide';
  impactLevel: CaregiverImpactMonthSlideImpactLevel;
  impactCopyVariant?: Maybe<CaregiverImpactLifesaverSlideImpactCopyVariant>;
  numVisitHoursWorked: Scalars['Int'];
};

export enum CaregiverImpactLifesaverSlideImpactCopyVariant {
  TrustAndSecurity = 'TRUST_AND_SECURITY',
  ConsistentComplexCare = 'CONSISTENT_COMPLEX_CARE',
  ImprovedPatientOutcomes = 'IMPROVED_PATIENT_OUTCOMES'
}

export type CaregiverImpactMonth = {
  __typename?: 'CaregiverImpactMonth';
  id: Scalars['ID'];
  month: Scalars['MonthAndYear'];
  result: CaregiverImpactMonthResult;
  publishedAt: Scalars['Timestamp'];
  firstOpenedAt?: Maybe<Scalars['Timestamp']>;
  firstFinishedAt?: Maybe<Scalars['Timestamp']>;
  acknowledgedAnnouncementModal: Scalars['Boolean'];
  slides: Array<CaregiverImpactMonthSlide>;
};

export enum CaregiverImpactMonthResult {
  Published = 'PUBLISHED',
  NoActivity = 'NO_ACTIVITY',
  UserDeactivated = 'USER_DEACTIVATED'
}

export type CaregiverImpactMonthSlide = {
  __typename?: 'CaregiverImpactMonthSlide';
  id: Scalars['ID'];
  sequenceWithinImpactMonth: Scalars['Int'];
  firstOpenedAt?: Maybe<Scalars['Timestamp']>;
  content: CaregiverImpactMonthSlideContent;
};

export type CaregiverImpactMonthSlideContent = CaregiverImpactLifesaverDistinctionSlide | CaregiverImpactWeekendShiftWarriorDistinctionSlide | CaregiverImpactReliableHeroDistinctionSlide;

export enum CaregiverImpactMonthSlideImpactLevel {
  High = 'HIGH',
  Low = 'LOW'
}

export type CaregiverImpactReliableHeroDistinctionSlide = BaseCaregiverImpactMonthDistinctionSlideContent & {
  __typename?: 'CaregiverImpactReliableHeroDistinctionSlide';
  impactLevel: CaregiverImpactMonthSlideImpactLevel;
  impactCopyVariant?: Maybe<CaregiverImpactReliableHeroSlideImpactCopyVariant>;
  evvCompliancePercentage: Scalars['Int'];
};

export enum CaregiverImpactReliableHeroSlideImpactCopyVariant {
  ProperCareTiming = 'PROPER_CARE_TIMING',
  ContinuityOfCare = 'CONTINUITY_OF_CARE',
  AgencyEfficiency = 'AGENCY_EFFICIENCY'
}

export type CaregiverImpactWeekendShiftWarriorDistinctionSlide = BaseCaregiverImpactMonthDistinctionSlideContent & {
  __typename?: 'CaregiverImpactWeekendShiftWarriorDistinctionSlide';
  impactLevel: CaregiverImpactMonthSlideImpactLevel;
  impactCopyVariant?: Maybe<CaregiverImpactWeekendWarriorSlideImpactCopyVariant>;
  numWeekendShiftsWorked: Scalars['Int'];
};

export enum CaregiverImpactWeekendWarriorSlideImpactCopyVariant {
  ConsistentCare = 'CONSISTENT_CARE',
  ComfortAndCompanionship = 'COMFORT_AND_COMPANIONSHIP',
  FamilyReassurance = 'FAMILY_REASSURANCE'
}

export enum CaregiverMatchesFilterDateRange {
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
  ThisWeek = 'THIS_WEEK',
  NextWeek = 'NEXT_WEEK',
  Weekends = 'WEEKENDS'
}

export enum CaregiverMatchesFilterTimeOfDay {
  Morning = 'MORNING',
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Overnight = 'OVERNIGHT'
}

export type CaregiverPayCodeInfo = {
  __typename?: 'CaregiverPayCodeInfo';
  payCodeId: Scalars['Int'];
  payCodeName: Scalars['String'];
  discipline: Scalars['String'];
};

export type CaregiverProfile = {
  __typename?: 'CaregiverProfile';
  id: Scalars['ID'];
  gender?: Maybe<CaregiverProfileGender>;
  workingLanguages?: Maybe<Array<CaregiverProfileWorkingLanguage>>;
  desiredHoursPerWeek?: Maybe<Scalars['Int']>;
  availability?: Maybe<Array<CaregiverProfileDayOfWeekAvailability>>;
  comfortableWithPets?: Maybe<Scalars['Boolean']>;
  comfortableWithSmokers?: Maybe<Scalars['Boolean']>;
  comfortableWithHeavyPatients?: Maybe<Scalars['Boolean']>;
  openToShortShifts?: Maybe<Scalars['Boolean']>;
  hoyerLiftExperience?: Maybe<Scalars['Boolean']>;
  primaryMethodOfTransportation?: Maybe<CaregiverProfilePrimaryMethodOfTransportation>;
  maximumTravelDistance?: Maybe<CaregiverProfileTravelDistance>;
  preferredPatientGender?: Maybe<CaregiverProfilePreferredPatientGender>;
  smsNotificationPreferences?: Maybe<CaregiverProfileSmsNotificationPreferences>;
  lookingForShiftsInNext2Weeks?: Maybe<Scalars['Boolean']>;
  wantsPermanentOrTemporaryShifts?: Maybe<Array<CaregiverProfileShiftTypePreference>>;
  openShiftOnboardingLastCompletedAt?: Maybe<Scalars['Timestamp']>;
  completed: Scalars['Boolean'];
  dismissed: Scalars['Boolean'];
  profileLastUpdatedAt?: Maybe<Scalars['Timestamp']>;
};

export enum CaregiverProfileAvailabilityTimeBlock {
  Morning = 'MORNING',
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Overnight = 'OVERNIGHT'
}

export type CaregiverProfileDayOfWeekAvailability = {
  __typename?: 'CaregiverProfileDayOfWeekAvailability';
  dayOfWeek: DayOfWeek;
  availability: Array<CaregiverProfileAvailabilityTimeBlock>;
};

export type CaregiverProfileDayOfWeekAvailabilityInput = {
  dayOfWeek: DayOfWeek;
  availability: Array<CaregiverProfileAvailabilityTimeBlock>;
};

export enum CaregiverProfileGender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type CaregiverProfileInput = {
  gender?: Maybe<CaregiverProfileGender>;
  workingLanguages?: Maybe<Array<CaregiverProfileWorkingLanguageInput>>;
  desiredHoursPerWeek?: Maybe<Scalars['Int']>;
  availability?: Maybe<Array<CaregiverProfileDayOfWeekAvailabilityInput>>;
  comfortableWithPets?: Maybe<Scalars['Boolean']>;
  comfortableWithSmokers?: Maybe<Scalars['Boolean']>;
  comfortableWithHeavyPatients?: Maybe<Scalars['Boolean']>;
  openToShortShifts?: Maybe<Scalars['Boolean']>;
  hoyerLiftExperience?: Maybe<Scalars['Boolean']>;
  primaryMethodOfTransportation?: Maybe<CaregiverProfilePrimaryMethodOfTransportation>;
  maximumTravelDistance?: Maybe<CaregiverProfileTravelDistanceInput>;
  preferredPatientGender?: Maybe<CaregiverProfilePreferredPatientGender>;
  smsNotificationPreferences?: Maybe<CaregiverProfileSmsNotificationPreferencesInput>;
  lookingForShiftsInNext2Weeks?: Maybe<Scalars['Boolean']>;
  wantsPermanentOrTemporaryShifts?: Maybe<Array<CaregiverProfileShiftTypePreference>>;
  /**
   * Should be set to `true` when all available fields have been completed.
   * This will indicate that we can reward the caregiver for completing their profile (if applicable).
   *
   * If already completed, and `false` is passed in, no change will be made (profile will not revert back to 'incomplete').
   */
  completed: Scalars['Boolean'];
  /**
   * Should be set to `true` to mark that the caregiver has completed the open shift onboarding.
   *
   * If `false`, nothing will be done.
   */
  markOpenShiftOnboardingCompleted?: Maybe<Scalars['Boolean']>;
};

export enum CaregiverProfileNotificationPreference {
  Yes = 'YES',
  No = 'NO'
}

export enum CaregiverProfilePreferredPatientGender {
  Male = 'MALE',
  Female = 'FEMALE',
  NoPreference = 'NO_PREFERENCE'
}

export enum CaregiverProfilePrimaryMethodOfTransportation {
  Car = 'CAR',
  Transit = 'TRANSIT',
  Walking = 'WALKING'
}

export enum CaregiverProfileShiftTypePreference {
  Permanent = 'PERMANENT',
  Temporary = 'TEMPORARY'
}

export type CaregiverProfileSmsNotificationPreferences = {
  __typename?: 'CaregiverProfileSmsNotificationPreferences';
  shiftBroadcasts: CaregiverProfileNotificationPreference;
};

export type CaregiverProfileSmsNotificationPreferencesInput = {
  shiftBroadcasts: CaregiverProfileNotificationPreference;
};

export type CaregiverProfileTravelDistance = CaregiverProfileTravelDistanceMinutes;

export type CaregiverProfileTravelDistanceInput = {
  minutes: Scalars['Int'];
};

export type CaregiverProfileTravelDistanceMinutes = {
  __typename?: 'CaregiverProfileTravelDistanceMinutes';
  value: Scalars['Int'];
};

export type CaregiverProfileWorkingLanguage = CaregiverProfileWorkingLanguagePredefined | CaregiverProfileWorkingLanguageCustom;

export type CaregiverProfileWorkingLanguageCustom = {
  __typename?: 'CaregiverProfileWorkingLanguageCustom';
  customLanguage: Scalars['String'];
};

export type CaregiverProfileWorkingLanguageInput = {
  /** To be provided if the language is one of our predefined options */
  locale?: Maybe<CaregiverProfileWorkingLanguageOption>;
  /** To be provided if the language is a custom input. */
  customLanguage?: Maybe<Scalars['String']>;
};

export enum CaregiverProfileWorkingLanguageOption {
  En = 'en',
  Es = 'es',
  It = 'it',
  Ru = 'ru',
  ZhCn = 'zhCN',
  ZhHk = 'zhHK'
}

export type CaregiverProfileWorkingLanguagePredefined = {
  __typename?: 'CaregiverProfileWorkingLanguagePredefined';
  locale: CaregiverProfileWorkingLanguageOption;
};

export enum CaregiverShiftConflictStatus {
  Yes = 'YES',
  No = 'NO',
  UnknownTooFarInAdvance = 'UNKNOWN_TOO_FAR_IN_ADVANCE'
}

export type CaregiverShiftInterest = {
  __typename?: 'CaregiverShiftInterest';
  id: Scalars['ID'];
  visitId: Scalars['ID'];
  caregiverUserId: Scalars['ID'];
};

export enum CaregiverShiftPostingInterestSubmittedBy {
  Web = 'WEB',
  VoiceAgent = 'VOICE_AGENT'
}

export enum CaregiverShiftPostingMatchShiftAvailability {
  MostlyAvailable = 'MOSTLY_AVAILABLE',
  FullyAvailable = 'FULLY_AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE',
  UnknownNoAvailability = 'UNKNOWN_NO_AVAILABILITY'
}

/**
 * Non-PHI unmatch reasons that are safe to share with caregivers.
 *
 * These are a carefully curated subset of predefined unmatch reasons that:
 * - Do NOT contain PHI (Protected Health Information)
 * - Are generic and do not reveal specific patient details, medical conditions, or sensitive health information
 * - Have been approved for caregiver visibility after PHI review
 *
 * This enum represents the only unmatch reasons that coordinators can choose to share
 * with caregivers when unmatching them from shift postings.
 */
export enum CaregiverShiftPostingUnmatchReasonAllowedNonPhiReason {
  ShiftAssignedToSomeoneElse = 'SHIFT_ASSIGNED_TO_SOMEONE_ELSE',
  CaregiverDoesNotWantShift = 'CAREGIVER_DOES_NOT_WANT_SHIFT',
  CaregiverNotAvailable = 'CAREGIVER_NOT_AVAILABLE',
  CaregiverExpressedInterestByMistake = 'CAREGIVER_EXPRESSED_INTEREST_BY_MISTAKE',
  Other = 'OTHER'
}

/**
 * Note: if neither `predefinedReason` nor `customReason` are provided, the default
 * reason will be "OTHER".
 */
export type CaregiverShiftPostingUnmatchReasonInput = {
  /** To be provided if the reason is selected from the predefined list. */
  predefinedReason?: Maybe<CaregiverShiftPostingUnmatchReasonPredefinedReason>;
  /** To be provided if the reason is a custom input. */
  customReason?: Maybe<Scalars['String']>;
};

export enum CaregiverShiftPostingUnmatchReasonPredefinedReason {
  CaregiverDoesNotWantShift = 'CAREGIVER_DOES_NOT_WANT_SHIFT',
  CaregiverDoesNotSpeakLanguage = 'CAREGIVER_DOES_NOT_SPEAK_LANGUAGE',
  CaregiverLacksRequiredExperience = 'CAREGIVER_LACKS_REQUIRED_EXPERIENCE',
  CaregiverNotAvailable = 'CAREGIVER_NOT_AVAILABLE',
  CaregiverExpressedInterestByMistake = 'CAREGIVER_EXPRESSED_INTEREST_BY_MISTAKE',
  CaregiverTravelDistanceTooFar = 'CAREGIVER_TRAVEL_DISTANCE_TOO_FAR',
  ShiftAssignedToSomeoneElse = 'SHIFT_ASSIGNED_TO_SOMEONE_ELSE',
  Other = 'OTHER'
}

export type CaregiverTravelDistance = {
  __typename?: 'CaregiverTravelDistance';
  /**
   * The travel distance by transit.
   *
   * This is an estimated distance using the haversine formula.
   */
  phiEstimatedTravelDistanceInMinutesByTransit: Scalars['PHINumber'];
  /**
   * The travel distance by car.
   *
   * This is an estimated distance using the haversine formula.
   */
  phiEstimatedTravelDistanceInMinutesByCar: Scalars['PHINumber'];
  /**
   * The travel method assumed for the travel distance.
   *
   * We can use this to determine which travel distance to display as the point of reference,
   * although we can still display both distances if more detail is desired.
   */
  assumedTravelMethod: CaregiverTravelMethod;
  /**
   * Whether the assumed travel method is based on the caregiver's profile.
   *
   * If it's not, then it's assumed based on their location (ZIP). For e.g.
   * NY Metro Area is assumed to be transit, while outskirts are assumed to be car.
   */
  assumedTravelMethodIsBasedOnCaregiverProfile: Scalars['Boolean'];
};

export enum CaregiverTravelMethod {
  Car = 'CAR',
  Transit = 'TRANSIT',
  Walking = 'WALKING'
}

export enum CaribouRewardsPrototypeRecruitmentStep {
  JobPostingShared = 'JOB_POSTING_SHARED',
  JobApplicationSubmitted = 'JOB_APPLICATION_SUBMITTED'
}

/**
 * Represents a draw that is sponsored-by and operated by Caribou,
 * and functions cross-org.
 */
export type CaribouSponsoredDraw = BaseDraw & {
  __typename?: 'CaribouSponsoredDraw';
  id: Scalars['ID'];
  prizeStructure: BaseDrawPrizeStructure;
  scheduledStartDate: Scalars['Timestamp'];
  scheduledEndDate: Scalars['Timestamp'];
  /**
   * For rewards users to query the number of tickets
   * they have in the draw.
   */
  myNumTicketsInDraw: Scalars['Int'];
  linkToExternalMarketingPage: Scalars['String'];
};

export type CategorizedTransactionMetadata = {
  /** Represents the category of the transaction. */
  category: TransactionMetadataCategory;
};

export type CognitoMutationResponse = {
  __typename?: 'CognitoMutationResponse';
  success: Scalars['Boolean'];
};

export type CompleteCaregiverProfileGoalTracker = {
  __typename?: 'CompleteCaregiverProfileGoalTracker';
  id: Scalars['ID'];
};

export type CompleteTrainingGoalDetails = {
  __typename?: 'CompleteTrainingGoalDetails';
  /**
   * The ID of the training program that should be completed to achieve this goal.
   * This will always be present on available training goals.
   */
  trainingProgramId: Scalars['ID'];
  trainingProgramName: Scalars['String'];
  trainingProgramDurationSeconds: Scalars['Int'];
};

export type CompleteTrainingGoalDistributionConfig = {
  __typename?: 'CompleteTrainingGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
};

export type CompleteTrainingGoalTracker = {
  __typename?: 'CompleteTrainingGoalTracker';
  id: Scalars['ID'];
  programDurationCompletedSeconds: Scalars['Int'];
  progressUpdatedAt: Scalars['Timestamp'];
};

export type ConnectJobPostingToAtsResult = {
  __typename?: 'ConnectJobPostingToATSResult';
  success: Scalars['Boolean'];
  /**
   * Team ID from the ATS integration. Only applicable for Apploi integrations.
   * Will be null for Paradox and other ATS integrations that don't use team IDs.
   */
  teamId?: Maybe<Scalars['String']>;
};

export type CoordinatorAdminConnectionInput = {
  externalCoordinatorId: Scalars['String'];
  rewardsAdminIds: Array<Scalars['ID']>;
};

export type CostOfReferralsInsightMetric = {
  __typename?: 'CostOfReferralsInsightMetric';
  id: Scalars['ID'];
  pointsForReferrals: Scalars['Int'];
};

export type CountMyJobSharesForRange = {
  __typename?: 'CountMyJobSharesForRange';
  numShares: Scalars['Int'];
};

export type CountMyTicketsInDrawResponse = {
  __typename?: 'CountMyTicketsInDrawResponse';
  numTickets: Scalars['Int'];
};

export type CreateJobShareResponse = {
  __typename?: 'CreateJobShareResponse';
  jobShareId: Scalars['ID'];
  jobShareUrl: Scalars['String'];
};

export type CreatePresignedVideoUploadUrlResponse = {
  __typename?: 'CreatePresignedVideoUploadUrlResponse';
  /** Presigned video upload URL for the newly created video */
  presignedVideoUploadUrl: Scalars['String'];
  video: RewardVideo;
};

export type CreateRewardsGroupInput = {
  name: Scalars['String'];
  tagsConfigV1: RewardsGroupTagsConfigSchemaV1Input;
};

export type CreateRewardsUserSmsLoginChallengeResponse = {
  __typename?: 'CreateRewardsUserSMSLoginChallengeResponse';
  challengeId: Scalars['String'];
};

export type CustomSocialPostDetails = {
  __typename?: 'CustomSocialPostDetails';
  id: Scalars['ID'];
  messageText: Scalars['String'];
};

export type CustomerIoEmailFailureMetric = {
  __typename?: 'CustomerIOEmailFailureMetric';
  metric: Scalars['String'];
  numEmails: Scalars['Int'];
};

export type CustomerIoGenerateRewardsUserLoginLinkResponse = {
  __typename?: 'CustomerIOGenerateRewardsUserLoginLinkResponse';
  loginLink: Scalars['String'];
};

export type CustomerIoListNewUsersToScheduleResponse = {
  __typename?: 'CustomerIOListNewUsersToScheduleResponse';
  items: Array<RewardsUser>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type CustomerIoListUsersInterestedInMoreBillableHoursResponse = {
  __typename?: 'CustomerIOListUsersInterestedInMoreBillableHoursResponse';
  items: Array<CustomerIoListUsersInterestedInShiftItem>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type CustomerIoListUsersInterestedInShiftItem = {
  __typename?: 'CustomerIOListUsersInterestedInShiftItem';
  user: RewardsUser;
  availability?: Maybe<Scalars['String']>;
};

export type CustomerIoListUsersInterestedLastMinuteShiftsResponse = {
  __typename?: 'CustomerIOListUsersInterestedLastMinuteShiftsResponse';
  items: Array<CustomerIoListUsersInterestedInShiftItem>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type CustomerIoListUsersInterestedWeekendShiftsResponse = {
  __typename?: 'CustomerIOListUsersInterestedWeekendShiftsResponse';
  items: Array<CustomerIoListUsersInterestedInShiftItem>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type DailyReward = {
  __typename?: 'DailyReward';
  id: Scalars['ID'];
  type: DailyRewardType;
  status: DailyRewardStatus;
  tracker: DailyRewardTracker;
  rewards: DailyRewardRewards;
  streak: DailyRewardStreak;
  /**
   * Will be `true` if the user has previously achieved a daily reward before
   * this one was given.
   * If this is `false` but status is "ACHIEVED" that means this was the first
   * daily reward achieved by the user.
   */
  hasPreviouslyAchievedDailyReward: Scalars['Boolean'];
};

export type DailyRewardRewardMultiplier = {
  __typename?: 'DailyRewardRewardMultiplier';
  factor: Scalars['Int'];
  baseNumPoints?: Maybe<Scalars['Int']>;
  baseNumOrganizationDrawTickets?: Maybe<Scalars['Int']>;
};

export type DailyRewardRewards = {
  __typename?: 'DailyRewardRewards';
  numPoints?: Maybe<Scalars['Int']>;
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
  multiplier?: Maybe<DailyRewardRewardMultiplier>;
};

export enum DailyRewardStatus {
  Available = 'AVAILABLE',
  Achieved = 'ACHIEVED',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED'
}

export type DailyRewardStreak = {
  __typename?: 'DailyRewardStreak';
  currentStreak: Scalars['Int'];
  targetStreak: Scalars['Int'];
};

export type DailyRewardTracker = DailyRewardTrackerSocialPost;

export type DailyRewardTrackerSocialPost = {
  __typename?: 'DailyRewardTrackerSocialPost';
  socialPostId: Scalars['ID'];
};

export enum DailyRewardType {
  ViewSocialPost = 'VIEW_SOCIAL_POST'
}


export enum DayOfWeek {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY'
}

export type DeductPointsInput = {
  /** The ID of the user whose points are being deducted. */
  userId: Scalars['ID'];
  /** The number of points to deduct. */
  amount: Scalars['Int'];
  /** The reason for deducting points. */
  reason: Scalars['String'];
};

export type DefaultPayCodeConfigurationItem = {
  __typename?: 'DefaultPayCodeConfigurationItem';
  discipline: Scalars['String'];
  hhaxPayCodeId: Scalars['Int'];
  hhaxPayCodeName: Scalars['String'];
  hhaxPayCodeOfficeNames: Scalars['String'];
};

export type DeleteRecognitionCategoryResponse = {
  __typename?: 'DeleteRecognitionCategoryResponse';
  deleted: Scalars['Boolean'];
};

export type DependingGoalUnlockCriteria = {
  __typename?: 'DependingGoalUnlockCriteria';
  dependingGoalId: Scalars['ID'];
  /**
   * Loads the goal that must be achieved before this goal
   * is unlocked.
   */
  dependingGoal: Goal;
};

/** Represents a `Draw` that is organization-run. */
export type Draw = BaseDraw & {
  __typename?: 'Draw';
  id: Scalars['ID'];
  /** Represents the draw's status on the schedule */
  scheduleStatus: DrawStatusOnSchedule;
  name?: Maybe<Scalars['String']>;
  prizeStructure: BaseDrawPrizeStructure;
  scheduledStartDate: Scalars['Timestamp'];
  scheduledEndDate: Scalars['Timestamp'];
  announcementVideo?: Maybe<RewardVideo>;
  status: DrawStatus;
  pendingWinnerApproval: Scalars['Boolean'];
  winnersAnnounced: Scalars['Boolean'];
  /**
   * For admins to view the winners, before approving them.
   * If `null`, there are no winners to approve.
   */
  winnersToApprove?: Maybe<Array<DrawWinnerToApprove>>;
  /** @deprecated Use `scheduledStartDate` */
  scheduledOpenDate: Scalars['Timestamp'];
  /** @deprecated Use `scheduledEndDate` */
  scheduledCloseDate: Scalars['Timestamp'];
  myRewardsUserHasTicketsInDraw: Scalars['Boolean'];
  myRewardsUserViewedWinners: Scalars['Boolean'];
  /**
   * The "approved" winners. These are the winners
   * which should be visible in the rewards app,
   * and who can claim their prize.
   */
  winners?: Maybe<Array<DrawWinner>>;
  /**
   * For rewards users to query the number of tickets
   * they have in the draw.
   */
  myNumTicketsInDraw: Scalars['Int'];
};

export type DrawPrize = DrawPrizePoints | DrawTieredPrizePoints;

export type DrawPrizePoints = BaseDrawPrize & {
  __typename?: 'DrawPrizePoints';
  id: Scalars['ID'];
  pointValue: Scalars['Int'];
  numWinners?: Maybe<Scalars['Int']>;
};

export type DrawPrizeStructureInput = {
  numWinners: Scalars['Int'];
  pointValue: Scalars['Int'];
};

export type DrawPrizeStructureSinglePrizeMultipleWinners = BaseDrawPrizeStructure & {
  __typename?: 'DrawPrizeStructureSinglePrizeMultipleWinners';
  id: Scalars['ID'];
  totalPrizePointValue: Scalars['Int'];
  prize: DrawPrize;
  numWinners: Scalars['Int'];
};

export type DrawPrizeStructureTieredPrizesMultipleWinners = BaseDrawPrizeStructure & {
  __typename?: 'DrawPrizeStructureTieredPrizesMultipleWinners';
  id: Scalars['ID'];
  totalPrizePointValue: Scalars['Int'];
  prizes: Array<DrawPrize>;
  numWinners: Scalars['Int'];
};

export enum DrawStatus {
  Scheduled = 'SCHEDULED',
  Open = 'OPEN',
  Closed = 'CLOSED'
}

export enum DrawStatusOnSchedule {
  Scheduled = 'SCHEDULED',
  Live = 'LIVE',
  Completed = 'COMPLETED'
}

export type DrawTieredPrizePoints = BaseDrawPrize & {
  __typename?: 'DrawTieredPrizePoints';
  id: Scalars['ID'];
  pointValue: Scalars['Int'];
  numWinners: Scalars['Int'];
};

export type DrawWayToEarn = {
  id: Scalars['ID'];
  title: Scalars['String'];
  numTickets: Scalars['Int'];
};

export type DrawWayToEarnRewardOffer = DrawWayToEarn & {
  __typename?: 'DrawWayToEarnRewardOffer';
  id: Scalars['ID'];
  title: Scalars['String'];
  numTickets: Scalars['Int'];
  rewardOffer: RewardOffer;
};

export type DrawWayToEarnShareJobs = DrawWayToEarn & {
  __typename?: 'DrawWayToEarnShareJobs';
  id: Scalars['ID'];
  title: Scalars['String'];
  numTickets: Scalars['Int'];
};

export type DrawWinner = {
  __typename?: 'DrawWinner';
  id: Scalars['ID'];
  userDisplayName: Scalars['String'];
  isMe: Scalars['Boolean'];
  prizeTierIndex?: Maybe<Scalars['Int']>;
  claimedPrize: DrawWinnerClaimedPrize;
  user: RewardsUser;
  wonAt?: Maybe<Scalars['Timestamp']>;
};

export enum DrawWinnerClaimedPrize {
  Unknown = 'UNKNOWN',
  Yes = 'YES',
  No = 'NO'
}

export type DrawWinnerToApprove = {
  __typename?: 'DrawWinnerToApprove';
  id: Scalars['ID'];
  user: RewardsUser;
  prizeTierIndex?: Maybe<Scalars['Int']>;
  prizeTierUpdated?: Maybe<Scalars['Boolean']>;
};

export type EvvCompletionRateLevel = {
  __typename?: 'EVVCompletionRateLevel';
  id: Scalars['ID'];
  /**
   * The index of this level within the offer.
   *
   * It is a 1-based index (the first level is `1`).
   */
  levelNumber: Scalars['Int'];
  /** The total number of evv completion percentage required to finish this level. */
  evvCompletionPercentage: Scalars['Int'];
  /**
   * The total number of draw tickets that the user will earn if this is the level
   * that they end on.
   */
  numDrawTickets: Scalars['Int'];
  /** If `true`, the user has finished this level. */
  finished: Scalars['Boolean'];
};

export type EvvCompletionRateOffer = {
  __typename?: 'EVVCompletionRateOffer';
  id: Scalars['ID'];
  /** All levels for this offer. */
  levels: Array<EvvCompletionRateLevel>;
  /**
   * The "targetLevel" level is the initially configured target.
   * This won't change over the lifetime of the offer.
   */
  targetLevel: EvvCompletionRateLevel;
  /**
   * The "adjustedTargetLevel" level tries to determine a target level to display to the user
   * so that they still have an achievable goal.
   */
  adjustedTargetLevel: EvvCompletionRateLevel;
  /** The start of the range in which visits completed with evv count towards this offer. */
  rangeStart: Scalars['Timestamp'];
  /**
   * The end of the range in which visits completed with evv count towards this offer.
   *
   * This is also the timestamp at which the offer ends.
   */
  rangeEnd: Scalars['Timestamp'];
  /** The total number of scheduled visits the user has during this offer. */
  numCountedVisits: Scalars['Int'];
  /** The total number of completed visits with EVV the user has during this offer. */
  numCountedVisitsWithCompletedEVV: Scalars['Int'];
  /**
   * The number of evv completion rate the user has completed towards this offer.
   * This will be `null` if `numCountedVisits === 0` (there are no counted visits for this offer yet).
   */
  trackedEVVCompletionPercentage?: Maybe<Scalars['Int']>;
  /** The time when user's data has been updated for this offer. */
  lastUpdatedAsOf?: Maybe<Scalars['Timestamp']>;
  /** If `true`, the offer has ended (likely because the `rangeEnd` has elapsed). */
  ended: Scalars['Boolean'];
};

export type EvvGoalDistributionConfig = {
  __typename?: 'EVVGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  rewardConfigByStreak?: Maybe<Array<EvvRewardConfigByStreak>>;
  mobileLoginGoalEnabled: Scalars['Boolean'];
  mobileLoginRewardOverride?: Maybe<GoalConfigRewardOverride>;
};

export type EvvGoalDistributionConfigAdminInput = {
  rewardConfigByStreak?: Maybe<Array<EvvRewardConfigByStreakInput>>;
};

export type EvvGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  rewardConfigByStreak?: Maybe<Array<EvvRewardConfigByStreakInput>>;
  mobileLoginGoalEnabled: Scalars['Boolean'];
  mobileLoginRewardOverride?: Maybe<GoalRewardsInput>;
};

export type EvvRewardConfigByStreak = {
  __typename?: 'EVVRewardConfigByStreak';
  /** Supported values are 1, 3, 10 */
  targetStreak: Scalars['Int'];
  reward: GoalConfigRewardOverride;
};

export type EvvRewardConfigByStreakInput = {
  targetStreak: Scalars['Int'];
  reward: GoalRewardsInput;
};

export type EvvRules = {
  __typename?: 'EVVRules';
  minutesLessThanScheduledStart?: Maybe<Scalars['Int']>;
  minutesGreaterThanScheduledStart?: Maybe<Scalars['Int']>;
  minutesLessThanScheduledEnd?: Maybe<Scalars['Int']>;
  minutesGreaterThanScheduledEnd?: Maybe<Scalars['Int']>;
  minutesLessThanScheduledDuration?: Maybe<Scalars['Int']>;
  minutesGreaterThanScheduledDuration?: Maybe<Scalars['Int']>;
  validClockMethods?: Maybe<Array<EvvRulesClockMethod>>;
};

export enum EvvRulesClockMethod {
  MobileApp = 'MOBILE_APP',
  Ivr = 'IVR',
  SystemAutoClock = 'SYSTEM_AUTO_CLOCK',
  Fob = 'FOB',
  Unknown = 'UNKNOWN'
}

export type EvvRulesInput = {
  minutesLessThanScheduledStart?: Maybe<Scalars['Int']>;
  minutesGreaterThanScheduledStart?: Maybe<Scalars['Int']>;
  minutesLessThanScheduledEnd?: Maybe<Scalars['Int']>;
  minutesGreaterThanScheduledEnd?: Maybe<Scalars['Int']>;
  minutesLessThanScheduledDuration?: Maybe<Scalars['Int']>;
  minutesGreaterThanScheduledDuration?: Maybe<Scalars['Int']>;
  validClockMethods?: Maybe<Array<EvvRulesClockMethod>>;
};

export enum EvvStreakGoalTrackedEvvStatus {
  EvvCompliant = 'evv_compliant',
  NotEvvCompliant = 'not_evv_compliant',
  MissedByCaregiver = 'missed_by_caregiver',
  Pending = 'pending'
}

export type EvvStreakGoalTracker = {
  __typename?: 'EVVStreakGoalTracker';
  id: Scalars['ID'];
  targetStreak: Scalars['Int'];
  currentStreak: Scalars['Int'];
  trackedVisits: Array<EvvStreakGoalTrackerVisitDetail>;
};

export type EvvStreakGoalTrackerVisitDetail = {
  __typename?: 'EVVStreakGoalTrackerVisitDetail';
  id: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
  status: EvvStreakGoalTrackedEvvStatus;
};

export type EligibleFirstShiftSurveyAverageInsightMetric = {
  __typename?: 'EligibleFirstShiftSurveyAverageInsightMetric';
  id: Scalars['ID'];
  averageScore: Scalars['Float'];
};

export type EligibleFirstShiftSurveyResponseRateInsightMetric = {
  __typename?: 'EligibleFirstShiftSurveyResponseRateInsightMetric';
  id: Scalars['ID'];
  firstShiftSurveyCreatedCount: Scalars['Int'];
  firstShiftSurveySubmittedCount: Scalars['Int'];
};

export type EligibleReferralHoursWorkedInsightMetric = {
  __typename?: 'EligibleReferralHoursWorkedInsightMetric';
  id: Scalars['ID'];
  numHoursWorked: Scalars['Float'];
};

export type EligibleTimeToFirstShiftInsightMetric = {
  __typename?: 'EligibleTimeToFirstShiftInsightMetric';
  id: Scalars['ID'];
  startedWorkingCount: Scalars['Int'];
  averageDaysToFirstShift?: Maybe<Scalars['Float']>;
};

export type EmployeeSummary = {
  __typename?: 'EmployeeSummary';
  id: Scalars['ID'];
  rewardsUser: RewardsUser;
};

export enum ErrorCode {
  InvalidArguments = 'INVALID_ARGUMENTS',
  CandidateLinkedToEmployee = 'CANDIDATE_LINKED_TO_EMPLOYEE',
  GiftCardEmailInBlockList = 'GIFT_CARD_EMAIL_IN_BLOCK_LIST',
  GiftCardOrderNotFound = 'GIFT_CARD_ORDER_NOT_FOUND',
  InvalidFileType = 'INVALID_FILE_TYPE',
  RequestedRedemptionPointsBelowOrganizationThreshold = 'REQUESTED_REDEMPTION_POINTS_BELOW_ORGANIZATION_THRESHOLD',
  ReferralStructureNameAlreadyExists = 'REFERRAL_STRUCTURE_NAME_ALREADY_EXISTS',
  NotEnoughPointsToRedeemProvidedAmount = 'NOT_ENOUGH_POINTS_TO_REDEEM_PROVIDED_AMOUNT',
  AdminDoesNotExist = 'ADMIN_DOES_NOT_EXIST',
  UserDoesNotExist = 'USER_DOES_NOT_EXIST',
  UnknownFileType = 'UNKNOWN_FILE_TYPE',
  InvalidRedemptionMethod = 'INVALID_REDEMPTION_METHOD',
  RedemptionNotFound = 'REDEMPTION_NOT_FOUND',
  ResendGiftCardLinkRateLimitExceeded = 'RESEND_GIFT_CARD_LINK_RATE_LIMIT_EXCEEDED',
  OrganizationDoesNotExist = 'ORGANIZATION_DOES_NOT_EXIST',
  OrganizationNotLaunched = 'ORGANIZATION_NOT_LAUNCHED',
  CandidateHasRecordedRecruitmentStepsOrMilestones = 'CANDIDATE_HAS_RECORDED_RECRUITMENT_STEPS_OR_MILESTONES',
  GoalConfigRewardTicketWithoutDraws = 'GOAL_CONFIG_REWARD_TICKET_WITHOUT_DRAWS',
  GoalConfigUpdateConcurrency = 'GOAL_CONFIG_UPDATE_CONCURRENCY',
  PulseSurveyConfigOverlappingPeriods = 'PULSE_SURVEY_CONFIG_OVERLAPPING_PERIODS',
  MilestoneSettingsNotInitialized = 'MILESTONE_SETTINGS_NOT_INITIALIZED',
  VisitDoesNotMatchCaregiverIntegration = 'VISIT_DOES_NOT_MATCH_CAREGIVER_INTEGRATION',
  OpenShiftNotAvailable = 'OPEN_SHIFT_NOT_AVAILABLE',
  ShiftNotEligibleForInterest = 'SHIFT_NOT_ELIGIBLE_FOR_INTEREST',
  AdminDoesNotBelongToOrganization = 'ADMIN_DOES_NOT_BELONG_TO_ORGANIZATION',
  NoCaregiverUserIdsProvided = 'NO_CAREGIVER_USER_IDS_PROVIDED',
  SomeCaregiverUsersDoNotExist = 'SOME_CAREGIVER_USERS_DO_NOT_EXIST',
  InactiveCaregiverUsers = 'INACTIVE_CAREGIVER_USERS',
  NoAdminIdsToAlertProvided = 'NO_ADMIN_IDS_TO_ALERT_PROVIDED',
  InactiveAdmins = 'INACTIVE_ADMINS',
  GoalNotInEvaluatableStatus = 'GOAL_NOT_IN_EVALUATABLE_STATUS',
  GoalNotInActivatableStatus = 'GOAL_NOT_IN_ACTIVATABLE_STATUS',
  CandidateDoesNotExist = 'CANDIDATE_DOES_NOT_EXIST',
  CannotAddHourlyMilestoneToMonthsBasedRetentionMilestones = 'CANNOT_ADD_HOURLY_MILESTONE_TO_MONTHS_BASED_RETENTION_MILESTONES',
  ShiftPostingHasNoOpenShifts = 'SHIFT_POSTING_HAS_NO_OPEN_SHIFTS',
  ShiftPostingIsNotUrgent = 'SHIFT_POSTING_IS_NOT_URGENT',
  NoCaregiversToNotify = 'NO_CAREGIVERS_TO_NOTIFY',
  CaregiverNotEligibleToUnmatch = 'CAREGIVER_NOT_ELIGIBLE_TO_UNMATCH',
  JobPostingExternalIdAlreadyExists = 'JOB_POSTING_EXTERNAL_ID_ALREADY_EXISTS',
  InsufficientRecognitionBudget = 'INSUFFICIENT_RECOGNITION_BUDGET',
  InvalidLanguageCode = 'INVALID_LANGUAGE_CODE',
  ShiftNotOpen = 'SHIFT_NOT_OPEN',
  BudgetNotFound = 'BUDGET_NOT_FOUND',
  BudgetInsufficientBalance = 'BUDGET_INSUFFICIENT_BALANCE',
  BudgetBalanceOverflow = 'BUDGET_BALANCE_OVERFLOW',
  ApploiJobNotFound = 'APPLOI_JOB_NOT_FOUND',
  ApploiJobDraft = 'APPLOI_JOB_DRAFT',
  ApploiJobArchived = 'APPLOI_JOB_ARCHIVED',
  ParadoxJobNotFound = 'PARADOX_JOB_NOT_FOUND',
  ExternalAtsFieldsMustBeUpdatedTogether = 'EXTERNAL_ATS_FIELDS_MUST_BE_UPDATED_TOGETHER',
  SelectedShiftUnavailable = 'SELECTED_SHIFT_UNAVAILABLE',
  SelectedShiftMismatch = 'SELECTED_SHIFT_MISMATCH'
}

export type ExternalIntegration = {
  __typename?: 'ExternalIntegration';
  id: Scalars['ID'];
  externalIdPrefix: Scalars['String'];
};

export enum FilterableTransactionMetadataCategory {
  Redemption = 'REDEMPTION'
}

export type FirstShiftSurveyAverageInsightMetric = EligibleFirstShiftSurveyAverageInsightMetric | IneligibleFirstShiftSurveyAverageInsightMetric;

export type FirstShiftSurveyResponseRateInsightMetric = EligibleFirstShiftSurveyResponseRateInsightMetric | IneligibleFirstShiftSurveyResponseRateInsightMetric;

export type ForceDeductAllPointsInput = {
  /**
   * The ID of the user whose points are being force deducted.
   * The user must be deactivated.
   */
  userId: Scalars['ID'];
  /** The reason for deducting all points. */
  reason: Scalars['String'];
};

export type ForceRedemptionInput = {
  /** The ID of the user whose points are being force redeemed. */
  userId: Scalars['ID'];
  /**
   * The redemption method to use. Only CATALOG or PAYROLL are supported.
   * If CATALOG is selected, Amazon gift card will be automatically selected.
   */
  redemptionMethod: ForceRedemptionMethod;
};

/**
 * Allowed redemption methods for force redemption.
 * Only CATALOG (gift cards) and PAYROLL are supported.
 */
export enum ForceRedemptionMethod {
  Catalog = 'CATALOG',
  Payroll = 'PAYROLL'
}

export type GenerateExternalApiCredentialsResponse = {
  __typename?: 'GenerateExternalApiCredentialsResponse';
  bearerToken: Scalars['String'];
};

export type GenerateExternalSqsCredentialsResponse = {
  __typename?: 'GenerateExternalSqsCredentialsResponse';
  queueUrl: Scalars['String'];
  accessKeyId: Scalars['String'];
  secretAccessKey: Scalars['String'];
  awsRegion: Scalars['String'];
};

export type GenerateMyNevvonLoginLinkResponse = {
  __typename?: 'GenerateMyNevvonLoginLinkResponse';
  loginLink?: Maybe<Scalars['String']>;
};

export type GenerateMyRewardsUserLoginLinkResponse = {
  __typename?: 'GenerateMyRewardsUserLoginLinkResponse';
  loginLink: Scalars['String'];
};

export type GenerateRedemptionExportResult = {
  __typename?: 'GenerateRedemptionExportResult';
  /** Redemption export id */
  id: Scalars['ID'];
  downloadLink: Scalars['String'];
};

export type GenerateRewardsUserExportResponse = {
  __typename?: 'GenerateRewardsUserExportResponse';
  downloadLink: Scalars['String'];
};

export type GetAllDrawsByScheduleStatusResponse = {
  __typename?: 'GetAllDrawsByScheduleStatusResponse';
  /** The organization ID */
  id: Scalars['ID'];
  scheduled: Array<Draw>;
  live?: Maybe<Draw>;
  completed: Array<Draw>;
};

export type GetHhaxCaregiversToSyncResponse = {
  __typename?: 'GetHHAXCaregiversToSyncResponse';
  items: Array<HhaxCaregiverToSync>;
  total: Scalars['Int'];
};

export type GetJobShareLinkDisabledForUserResponse = {
  __typename?: 'GetJobShareLinkDisabledForUserResponse';
  disabled: Scalars['Boolean'];
};

export type GetMyAdminShiftRewardBudgetPeriodSummaryResponse = {
  __typename?: 'GetMyAdminShiftRewardBudgetPeriodSummaryResponse';
  budgetPeriodSummary?: Maybe<AdminShiftRewardBudgetPeriodSummary>;
};

export type GetMyDrawWaysToEarnResponse = {
  __typename?: 'GetMyDrawWaysToEarnResponse';
  items: Array<DrawWayToEarn>;
};

export type GetMyManagedEmployeesRecognitionPointsReceivedSummary = {
  __typename?: 'GetMyManagedEmployeesRecognitionPointsReceivedSummary';
  /** null if authenticated manager has no managed employees */
  pointsReceivedTotal?: Maybe<Scalars['Int']>;
  /** null if authenticated manager has no managed employees */
  pointsReceivedFromManager?: Maybe<Scalars['Int']>;
  /** null if authenticated manager has no managed employees */
  pointsReceivedFromOthers?: Maybe<Scalars['Int']>;
  /** null if authenticated manager has no managed employees */
  percentageOfTeamEarnedPoints?: Maybe<Scalars['Int']>;
};

export type GetMyManagedEmployeesRecognitionPointsReceivedSummaryV2Response = {
  __typename?: 'GetMyManagedEmployeesRecognitionPointsReceivedSummaryV2Response';
  /** null if authenticated manager has no managed employees */
  pointsReceivedTotal?: Maybe<Scalars['Int']>;
  /** null if authenticated manager has no managed employees */
  pointsReceivedFromManager?: Maybe<Scalars['Int']>;
  /** null if authenticated manager has no managed employees */
  pointsReceivedFromOthers?: Maybe<Scalars['Int']>;
  /** null if authenticated manager has no managed employees */
  percentageOfTeamEarnedPoints?: Maybe<Scalars['Int']>;
};

export type GetMyRecognitionPointsSentSummaryResponse = {
  __typename?: 'GetMyRecognitionPointsSentSummaryResponse';
  daysLeftToAward?: Maybe<Scalars['Int']>;
  pointsSentTotal: Scalars['Int'];
  pointsSentToManagedEmployees: Scalars['Int'];
  pointsSentToOtherEmployees: Scalars['Int'];
  /** null if no budget */
  pointsAvailableInBudget?: Maybe<Scalars['Int']>;
  /** null if no budget */
  pointsBudget?: Maybe<Scalars['Int']>;
};

export type GetMyRecognitionPointsSentSummaryV2Response = {
  __typename?: 'GetMyRecognitionPointsSentSummaryV2Response';
  daysLeftToAward?: Maybe<Scalars['Int']>;
  pointsSentTotal: Scalars['Int'];
  pointsSentToManagedEmployees: Scalars['Int'];
  pointsSentToOtherEmployees: Scalars['Int'];
  /** null if no budget */
  pointsAvailableInBudget?: Maybe<Scalars['Int']>;
  /** null if no budget */
  pointsBudget?: Maybe<Scalars['Int']>;
};

export type GetMyRewardsAdminMfaStatusResponse = {
  __typename?: 'GetMyRewardsAdminMfaStatusResponse';
  /** The admin's ID, or Rewards Superuser ID. */
  id: Scalars['ID'];
  /** True if the user must enable MFA. */
  smsMFARequired: Scalars['Boolean'];
  /** True if the user has set a verified phone number to use for SMS MFA. */
  smsNumberVerified: Scalars['Boolean'];
};

export type GetMyRewardsOrganizationRecognitionCategoriesFilter = {
  disableSendFromManagers?: Maybe<Scalars['Boolean']>;
  hasDefaultAmount?: Maybe<Scalars['Boolean']>;
};

export type GetMyRewardsUserGoalTrackResponse = {
  __typename?: 'GetMyRewardsUserGoalTrackResponse';
  availableGoals: Array<Goal>;
  lockedGoals: Array<Goal>;
  achievedGoals: Array<Goal>;
  trackProgress: TrackProgress;
};

export type GetMyRewardsUserRedemptionsResponse = {
  __typename?: 'GetMyRewardsUserRedemptionsResponse';
  items: Array<RewardsUserRedemption>;
};

export type GetMyTotalUnclaimedDrawsResponse = {
  __typename?: 'GetMyTotalUnclaimedDrawsResponse';
  totalUnclaimedDraws: Scalars['Int'];
};

export type GetRewardsAdminAuthStatusResponse = {
  __typename?: 'GetRewardsAdminAuthStatusResponse';
  /** The admin's ID, or Rewards Superuser ID. */
  id: Scalars['ID'];
  status: RewardsAdminAuthStatus;
};

export type GetRewardsUserExistsForIdAndOrganizationResponse = {
  __typename?: 'GetRewardsUserExistsForIdAndOrganizationResponse';
  exists: Scalars['Boolean'];
};

export type GetRewardsUserLoginTokenDetailsResponse = {
  __typename?: 'GetRewardsUserLoginTokenDetailsResponse';
  obscuredPhoneNumber: Scalars['String'];
  whiteLabelConfig?: Maybe<RewardsOrganizationWhiteLabelConfig>;
};

export type GetSharableJobPostingFilterCombination = {
  __typename?: 'GetSharableJobPostingFilterCombination';
  id: Scalars['ID'];
  title: Scalars['String'];
  geography: Scalars['String'];
  numJobs: Scalars['Int'];
};

export type GetSharableJobPostingFilterOptions = {
  __typename?: 'GetSharableJobPostingFilterOptions';
  combinations: Array<GetSharableJobPostingFilterCombination>;
};

export type GetUserEligibilitySummaryResponse = {
  __typename?: 'GetUserEligibilitySummaryResponse';
  countActiveIneligibleUsers: Scalars['Int'];
  countInactiveEligibleUsers: Scalars['Int'];
};

export type Goal = {
  __typename?: 'Goal';
  id: Scalars['ID'];
  type: GoalType;
  /** Contains information about how this goal can be unlocked. */
  unlockCriteria?: Maybe<GoalUnlockCriteria>;
  /**
   * Contains details about tracking the goal's progress, which is specific to this goal's `type`:
   * - Criteria for how to complete the goal
   * - State for the goal (such as progress)
   */
  goalTracker: GoalTracker;
  /** The current `status` of the goal (e.g. `locked`, `active`, etc) */
  status: GoalStatus;
  /**
   * If a Goal may have an associated `track`, it means that this goal is associated with
   * a greater "sequence" of goals.
   *
   * A "track" may have a sub-page in the app.
   */
  trackName?: Maybe<GoalTrackName>;
  /**
   * The current progress of a goal, as a value out of 100.
   * Some goal types may not have a progress, this includes (at the time of writing): job shares and surveys.
   */
  progress?: Maybe<Scalars['Int']>;
  /** Populated if points are awarded for achieving this goal. */
  numPoints?: Maybe<Scalars['Int']>;
  /**
   * Populated if tickets for the Caribou-sponsored draw are
   * awarded for achieving this goal.
   */
  numCaribouSponsoredDrawTickets?: Maybe<Scalars['Int']>;
  /**
   * Populated if tickets for the Organization's draw are
   * awarded for achieving this goal.
   */
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
  /** If defined. indicates the date/time that this goal was avaialble */
  availableAt?: Maybe<Scalars['Timestamp']>;
  /** If defined, indicates the date/time that this goal will expire. */
  expiresAt?: Maybe<Scalars['Timestamp']>;
  /** If defined. indicates the date/time that this goal was achieved */
  achievedAt?: Maybe<Scalars['Timestamp']>;
  /** If defined. indicates the date/time that this goal was activated */
  activatedAt?: Maybe<Scalars['Timestamp']>;
  /** Other details about the goal, specific to the goal's `type`. */
  goalDetails?: Maybe<GoalDetails>;
};

export type GoalConfigRewardOverride = {
  __typename?: 'GoalConfigRewardOverride';
  /** Points awarded for achieving this goal */
  numPoints?: Maybe<Scalars['Int']>;
  /** Number of Caribou-sponsored draw tickets awarded for achieving this goal */
  numCaribouSponsoredDrawTickets?: Maybe<Scalars['Int']>;
  /** Number of Organization draw tickets awarded for achieving this goal */
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
};

export type GoalDetails = SurveyGoalDetails | WatchVideoGoalDetails | CompleteTrainingGoalDetails | ShiftRewardGoalDetails | AnniversaryGoalDetails;

export enum GoalDistributionType {
  /** System automatically determines the goals and rewards for users */
  Auto = 'AUTO',
  /** Only specific goals are distributed to users */
  Custom = 'CUSTOM'
}

export enum GoalDistributionUpdatePolicy {
  /**
   * Do not cancel locked or available goals that have been distributed already.
   * No future goals will be distributed.
   */
  NoCancel = 'NO_CANCEL',
  /**
   * Cancel existing goals, but keep available goals that have been distributed already.
   * No future goals will be distributed.
   */
  CancelLockedGoals = 'CANCEL_LOCKED_GOALS',
  /**
   * Cancel existing and available goals.
   * No future goals will be distributed.
   */
  CancelLockedAndAvailableGoals = 'CANCEL_LOCKED_AND_AVAILABLE_GOALS'
}

export enum GoalRewardUpdatePolicy {
  /**
   * Do not update locked or available goals that have been disitributed already.
   * Applies goals that will be distributed in the future.
   */
  NoUpdate = 'NO_UPDATE',
  /**
   * Update locked goals, but do not update available goals that have been distributed already.
   * Also, applies to goals that will be distributed in the future.
   */
  UpdateLockedGoals = 'UPDATE_LOCKED_GOALS',
  /**
   * Update locked and available goals.
   * Also, applies to goals that will be distributed in the future.
   */
  UpdateLockedAndAvailableGoals = 'UPDATE_LOCKED_AND_AVAILABLE_GOALS'
}

export type GoalRewardsInput = {
  numPoints?: Maybe<Scalars['Int']>;
  numCaribouSponsoredDrawTickets?: Maybe<Scalars['Int']>;
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
};

export enum GoalStatus {
  Locked = 'LOCKED',
  Available = 'AVAILABLE',
  Achieved = 'ACHIEVED',
  ExpiredWaitingForLateArrivingData = 'EXPIRED_WAITING_FOR_LATE_ARRIVING_DATA',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED'
}

export enum GoalTrackName {
  ShareJobTrack = 'SHARE_JOB_TRACK',
  SurveyTrack = 'SURVEY_TRACK',
  EvvTrack = 'EVV_TRACK',
  LastMinuteShiftTrack = 'LAST_MINUTE_SHIFT_TRACK',
  WeekendShiftTrack = 'WEEKEND_SHIFT_TRACK',
  BillableHoursTrack = 'BILLABLE_HOURS_TRACK'
}

export type GoalTracker = JobShareGoalTracker | SurveyGoalTracker | EvvStreakGoalTracker | WatchVideoGoalTracker | HhaxLoginGoalTracker | LastMinuteShiftGoalTracker | CompleteTrainingGoalTracker | WeekendShiftGoalTracker | BillableHoursGoalTracker | CompleteCaregiverProfileGoalTracker | WelcomeGoalTracker | ShiftRewardGoalTracker | BirthdayGoalTracker | AnniversaryGoalTracker;

export enum GoalType {
  ShareJob = 'SHARE_JOB',
  Survey = 'SURVEY',
  EvvStreak = 'EVV_STREAK',
  WatchVideo = 'WATCH_VIDEO',
  HhaxLogin = 'HHAX_LOGIN',
  LastMinuteShift = 'LAST_MINUTE_SHIFT',
  CompleteTraining = 'COMPLETE_TRAINING',
  WeekendShift = 'WEEKEND_SHIFT',
  BillableHours = 'BILLABLE_HOURS',
  CompleteCaregiverProfile = 'COMPLETE_CAREGIVER_PROFILE',
  Welcome = 'WELCOME',
  ShiftReward = 'SHIFT_REWARD',
  Birthday = 'BIRTHDAY',
  Anniversary = 'ANNIVERSARY'
}

export type GoalUnlockCriteria = DependingGoalUnlockCriteria | TimeBasedlUnlockCriteria;

export enum GoalUpdateStatus {
  /** Goals are currently being updated, updates to goals coinfig is restricted. */
  Updating = 'UPDATING',
  /** Goals are not currently being updated, updates to goals config are allowed. */
  NotUpdating = 'NOT_UPDATING'
}

export type GoalsAchievedInsightMetric = {
  __typename?: 'GoalsAchievedInsightMetric';
  id: Scalars['ID'];
  goalsAchievedCount: Scalars['Int'];
};

/**
 * Strictly for QA usage, this allows creating a RewardsHHAXCaregiver for a given user.
 * Designed to be used with the `retoolCreateQARewardsUser` mutation and user params from it.
 */
export type HhaxCaregiverInput = {
  caregiverMobileId?: Maybe<Scalars['Int']>;
};

export type HhaxCaregiverToSync = {
  __typename?: 'HHAXCaregiverToSync';
  id: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  personalEmail?: Maybe<Scalars['String']>;
  personalPhone?: Maybe<Scalars['String']>;
  disciplines?: Maybe<Array<Maybe<Scalars['String']>>>;
  branchId?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  firstWorkedDate?: Maybe<Scalars['String']>;
};

export type HhaxCaribouUserSync = {
  __typename?: 'HHAXCaribouUserSync';
  id: Scalars['ID'];
  hhaxIntegrationId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  filters?: Maybe<HhaxCaribouUserSyncFilters>;
};

export type HhaxCaribouUserSyncBranchFilterOption = {
  __typename?: 'HHAXCaribouUserSyncBranchFilterOption';
  branchId?: Maybe<Scalars['String']>;
};

export type HhaxCaribouUserSyncFilters = {
  __typename?: 'HHAXCaribouUserSyncFilters';
  disciplines: Array<Maybe<Scalars['String']>>;
  branches: Array<HhaxCaribouUserSyncBranchFilterOption>;
  offices: Array<HhaxCaribouUserSyncOfficeFilterOption>;
  teams: Array<HhaxCaribouUserSyncTeamFilterOption>;
  hasCompletedFirstShift: Array<HasCompletedFirstShiftFilterOptions>;
};

export type HhaxCaribouUserSyncFiltersInput = {
  disciplines?: Maybe<Array<Maybe<Scalars['String']>>>;
  branchIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  officeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  teamIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasCompletedFirstShift?: Maybe<Array<HasCompletedFirstShiftFilterOptions>>;
};

export type HhaxCaribouUserSyncOfficeFilterOption = {
  __typename?: 'HHAXCaribouUserSyncOfficeFilterOption';
  officeId?: Maybe<Scalars['String']>;
};

export type HhaxCaribouUserSyncTeamFilterOption = {
  __typename?: 'HHAXCaribouUserSyncTeamFilterOption';
  teamId?: Maybe<Scalars['String']>;
};

export type HhaxCoordinator = {
  __typename?: 'HHAXCoordinator';
  /** Same as the externalId */
  id: Scalars['String'];
  externalId: Scalars['String'];
  name: Scalars['String'];
  active: Scalars['Boolean'];
  /** Count of open shift postings (active and future) for patients assigned to this coordinator */
  numOpenShiftPostings: Scalars['Int'];
  /** Whether this coordinator has been connected to at least one Rewards Admin. */
  connectedToRewardsAdmin: Scalars['Boolean'];
  /** The Rewards Admins that this coordinator is connected to. */
  connectedRewardsAdmins: Array<RewardsAdminUser>;
  /** The email address of the coordinator, if available. */
  email?: Maybe<Scalars['String']>;
};

export type HhaxDisciplineCompatibility = {
  __typename?: 'HHAXDisciplineCompatibility';
  discipline: Scalars['String'];
  compatibleDisciplines: Array<Scalars['String']>;
};

export type HhaxIntegration = {
  __typename?: 'HHAXIntegration';
  id: Scalars['ID'];
  status: HhaxIntegrationStatus;
  userAutoSyncs: Array<Maybe<HhaxCaribouUserSync>>;
  /** @deprecated Replaced by `userAutoSyncs` array with `enabled` field */
  autoSyncEnabled: Scalars['Boolean'];
};

export enum HhaxIntegrationStatus {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED'
}

export type HhaxLoginGoalTracker = {
  __typename?: 'HHAXLoginGoalTracker';
  id: Scalars['ID'];
  loginCompletionData?: Maybe<HhaxLoginGoalTrackerLoginCompletionData>;
};

export type HhaxLoginGoalTrackerLoginCompletionData = HhaxLoginGoalTrackerLoginCompletionDataV1;

export type HhaxLoginGoalTrackerLoginCompletionDataV1 = {
  __typename?: 'HHAXLoginGoalTrackerLoginCompletionDataV1';
  type: Scalars['String'];
  mobileId: Scalars['String'];
};

export type HhaxOrganizationShiftPostingCountWithNoAssignedCoordinator = {
  __typename?: 'HHAXOrganizationShiftPostingCountWithNoAssignedCoordinator';
  /** Count of open shift postings (active and future) for patients with no coordinators assigned */
  numOpenShiftPostingsWithNoAssignedCoordinator: Scalars['Int'];
};

export type HasAvailableGoalsFilter = {
  surveyType?: Maybe<SurveyType>;
};

export type HasAvailableGoalsResponse = {
  __typename?: 'HasAvailableGoalsResponse';
  hasAvailableGoals: Scalars['Boolean'];
};

export enum HasCompletedFirstShiftFilterOptions {
  CompletedFirstShift = 'COMPLETED_FIRST_SHIFT',
  HasntCompletedFirstShift = 'HASNT_COMPLETED_FIRST_SHIFT'
}

export type HoursMilestoneGoal = {
  __typename?: 'HoursMilestoneGoal';
  type: Scalars['String'];
  numHours: Scalars['Int'];
};

export type Identity = {
  __typename?: 'Identity';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  roles: Array<IdentityRole>;
};

export type IdentityAssumedRole = {
  __typename?: 'IdentityAssumedRole';
  id: Scalars['ID'];
  roleName: Role;
};

export type IdentityRole = {
  __typename?: 'IdentityRole';
  id: Scalars['ID'];
  roleName: Role;
  email?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  tenantId?: Maybe<Scalars['ID']>;
};

export type IneligibleFirstShiftSurveyAverageInsightMetric = {
  __typename?: 'IneligibleFirstShiftSurveyAverageInsightMetric';
  id: Scalars['ID'];
};

export type IneligibleFirstShiftSurveyResponseRateInsightMetric = {
  __typename?: 'IneligibleFirstShiftSurveyResponseRateInsightMetric';
  id: Scalars['ID'];
};

export type IneligibleReferralHoursWorkedInsightMetric = {
  __typename?: 'IneligibleReferralHoursWorkedInsightMetric';
  id: Scalars['ID'];
};

export type IneligibleTimeToFirstShiftInsightMetric = {
  __typename?: 'IneligibleTimeToFirstShiftInsightMetric';
  id: Scalars['ID'];
};

export type InsightDateRanges = LaunchedInsightDateRanges | NotLaunchedInsightDateRanges;

export type InsightsMonthlyDateRange = {
  __typename?: 'InsightsMonthlyDateRange';
  id: Scalars['ID'];
  year: Scalars['Int'];
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};

export type InsightsQuarterlyDateRange = {
  __typename?: 'InsightsQuarterlyDateRange';
  id: Scalars['ID'];
  label: InsightsQuarterlyDateRangeLabel;
  year: Scalars['Int'];
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};

export enum InsightsQuarterlyDateRangeLabel {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4'
}

export type InterviewBookingLink = {
  url: Scalars['String'];
  mustUploadResumeBeforeBookingInterview?: Maybe<Scalars['Boolean']>;
};



export enum JobApplicationDriversLicenseAnswer {
  Yes = 'YES',
  No = 'NO',
  Unsure = 'UNSURE'
}

export enum JobApplicationFieldName {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  PreferredName = 'PREFERRED_NAME',
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER',
  ResidingCity = 'RESIDING_CITY',
  PostalCode = 'POSTAL_CODE',
  HasDriversLicenseAndAccessToCar = 'HAS_DRIVERS_LICENSE_AND_ACCESS_TO_CAR',
  YearsOfExperienceWithRole = 'YEARS_OF_EXPERIENCE_WITH_ROLE'
}

export enum JobApplicationYearsOfExperienceAnswer {
  LessThanAYear = 'LESS_THAN_A_YEAR',
  OneToThreeYears = 'ONE_TO_THREE_YEARS',
  GreaterThanThreeYears = 'GREATER_THAN_THREE_YEARS'
}

export type JobPosting = {
  __typename?: 'JobPosting';
  id: Scalars['ID'];
  externalId?: Maybe<Scalars['String']>;
  importedFromIntegration: Scalars['Boolean'];
  organizationId: Scalars['ID'];
  branch?: Maybe<RewardsOrganizationBranch>;
  referralStructure: ReferralStructure;
  title: Scalars['String'];
  ratesOfPay?: Maybe<Scalars['String']>;
  geography: Scalars['String'];
  hoursRequired: Scalars['String'];
  descriptionHTML: Scalars['String'];
  publishedAt: Scalars['Timestamp'];
  closedForSubmission: Scalars['Boolean'];
  /**
   * All of the application fields that should be displayed to
   * applicants. This includes fields like "FIRST_NAME", etc,
   * in addition to screener questions.
   *
   * Use `screenerQuestions` instead for managing the screener questions (e.g. for Rewards Admins)
   */
  applicationFields: Array<JobPostingApplicationField>;
  /**
   * The screener questions for the job postings.
   *
   * Use `applicationFields` instead for viewing all of the fields that the
   * applicant must fill out (which includes the screener questions)
   */
  screenerQuestions: Array<JobPostingScreenerQuestion>;
  /** The emails which receive candidate alerts. */
  candidateAlertEmails: Array<Scalars['String']>;
  /**
   * The email which receives candidate alerts.
   *
   * This will be either the organization-wide email for candidate alerts,
   * or an override that is specific for this job posting.
   * @deprecated Use candidateAlertEmails instead
   */
  candidateAlertEmail?: Maybe<Scalars['String']>;
  /** @deprecated Use applicationFields instead */
  applicationFieldConfiguration: Array<JobPostingFieldConfiguration>;
  /** @deprecated Use the 'job share' endpoints instead */
  url: Scalars['String'];
  /** @deprecated Use 'hoursRequired' instead */
  hoursRequiredPerWeek: Scalars['String'];
  /** @deprecated Use 'descriptionHTML' instead */
  descriptionText: Scalars['String'];
  /** The rewards organization associated with this job posting. */
  organization: RewardsOrganization;
  activePromotion?: Maybe<JobPostingPromotion>;
  /** For Rewards Admins only. */
  stats: JobPostingStats;
  customizedApplicantSMSMessage?: Maybe<Scalars['String']>;
  customizedApplicantEmailMessage?: Maybe<Scalars['String']>;
  interviewBookingLink?: Maybe<Scalars['String']>;
  mustUploadResumeBeforeBookingInterview?: Maybe<Scalars['Boolean']>;
  externalAtsTeamId?: Maybe<Scalars['String']>;
  externalAtsIntegrationId?: Maybe<Scalars['String']>;
  externalAtsJobPostingId?: Maybe<Scalars['String']>;
  /** Display-only job ID extracted from externalAtsJobPostingId (e.g. for Paradox/Apploi). */
  externalAtsJobId?: Maybe<Scalars['String']>;
};

export type JobPostingApplicationField = JobPostingSystemRequiredField | JobPostingSystemMaybeOptionalField | JobPostingYesNoField;

export enum JobPostingAutoRejectResponse {
  Yes = 'YES',
  No = 'NO'
}

export type JobPostingFieldConfiguration = {
  __typename?: 'JobPostingFieldConfiguration';
  /** @deprecated Use type instead */
  field: JobApplicationFieldName;
  optional?: Maybe<Scalars['Boolean']>;
};

export type JobPostingFieldConfigurationInput = {
  type: JobPostingFieldType;
  /** Required if the field type is YES_OR_NO */
  question?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
};

export type JobPostingFieldInterface = {
  id: Scalars['String'];
  type: JobPostingFieldType;
};

export enum JobPostingFieldType {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER',
  PreferredName = 'PREFERRED_NAME',
  ResidingCity = 'RESIDING_CITY',
  PostalCode = 'POSTAL_CODE',
  ZipCode = 'ZIP_CODE',
  HasDriversLicenseAndAccessToCar = 'HAS_DRIVERS_LICENSE_AND_ACCESS_TO_CAR',
  YearsOfExperienceWithRole = 'YEARS_OF_EXPERIENCE_WITH_ROLE',
  YesOrNo = 'YES_OR_NO'
}

export type JobPostingFilterInput = {
  /**
   * Allows filtering by organization branch ID.
   * If provided, will only show results from given branch(es)
   * If not provided, will show results from all branches
   * If [null] is provided, will show results that have no branch assigned
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  closed?: Maybe<Scalars['Boolean']>;
  statusIn?: Maybe<Array<JobPostingStatusFilter>>;
  searchQuery?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<JobPostingFilterInputSort>>;
};

export type JobPostingFilterInputSort = {
  property: JobPostingFilterInputSortProperty;
  direction: Sort;
};

export enum JobPostingFilterInputSortProperty {
  Title = 'TITLE',
  CreatedAt = 'CREATED_AT',
  ClosedForSubmission = 'CLOSED_FOR_SUBMISSION',
  Promoted = 'PROMOTED',
  Featured = 'FEATURED'
}

export type JobPostingListResponse = {
  __typename?: 'JobPostingListResponse';
  total: Scalars['Int'];
  items: Array<JobPosting>;
};

export enum JobPostingLocationField {
  PostalCode = 'POSTAL_CODE',
  ZipCode = 'ZIP_CODE',
  ResidingCity = 'RESIDING_CITY'
}

export type JobPostingPromotion = {
  __typename?: 'JobPostingPromotion';
  id: Scalars['ID'];
  bannerMessage?: Maybe<Scalars['String']>;
};

export type JobPostingScreenerQuestion = {
  __typename?: 'JobPostingScreenerQuestion';
  id: Scalars['ID'];
  type: JobPostingScreenerQuestionType;
  /** Only defined if `type` is YES_OR_NO */
  question?: Maybe<Scalars['String']>;
  autoRejectResponses?: Maybe<Array<JobPostingAutoRejectResponse>>;
};

export type JobPostingScreenerQuestionInput = {
  type: JobPostingScreenerQuestionType;
  /** This is required if `type` is `YES_OR_NO` */
  question?: Maybe<Scalars['String']>;
  autoRejectResponses?: Maybe<Array<JobPostingAutoRejectResponse>>;
};

export enum JobPostingScreenerQuestionType {
  HasDriversLicenseAndAccessToCar = 'HAS_DRIVERS_LICENSE_AND_ACCESS_TO_CAR',
  YesOrNo = 'YES_OR_NO'
}

export type JobPostingStats = {
  __typename?: 'JobPostingStats';
  id: Scalars['ID'];
  numShares: Scalars['Int'];
  numCandidates: Scalars['Int'];
  numInterviewsScheduled: Scalars['Int'];
  numHires: Scalars['Int'];
};

export enum JobPostingStatusFilter {
  Open = 'OPEN',
  Closed = 'CLOSED',
  OpenPromoted = 'OPEN_PROMOTED'
}

export type JobPostingSystemMaybeOptionalField = JobPostingFieldInterface & {
  __typename?: 'JobPostingSystemMaybeOptionalField';
  id: Scalars['String'];
  type: JobPostingFieldType;
  optional?: Maybe<Scalars['Boolean']>;
};

export type JobPostingSystemRequiredField = JobPostingFieldInterface & {
  __typename?: 'JobPostingSystemRequiredField';
  id: Scalars['String'];
  type: JobPostingFieldType;
};

export type JobPostingYesNoField = JobPostingFieldInterface & {
  __typename?: 'JobPostingYesNoField';
  id: Scalars['String'];
  type: JobPostingFieldType;
  optional?: Maybe<Scalars['Boolean']>;
  question: Scalars['String'];
};

export enum JobPostingYesNoFieldAnswer {
  Yes = 'YES',
  No = 'NO'
}

export type JobShareGoalDistributionConfig = {
  __typename?: 'JobShareGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  jobShareRewardOverride?: Maybe<GoalConfigRewardOverride>;
};

export type JobShareGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  jobShareRewardOverride?: Maybe<GoalRewardsInput>;
};

export type JobShareGoalTracker = {
  __typename?: 'JobShareGoalTracker';
  id: Scalars['ID'];
};

export type JobShareStructureRewardInput = {
  type: JobShareStructureRewardType;
  pointValue?: Maybe<Scalars['Int']>;
  numTickets?: Maybe<Scalars['Int']>;
};

export enum JobShareStructureRewardType {
  Points = 'POINTS',
  DrawTickets = 'DRAW_TICKETS'
}

export type JobSharesInsightMetric = {
  __typename?: 'JobSharesInsightMetric';
  id: Scalars['ID'];
  jobShareCount: Scalars['Int'];
};

export type LastMinuteShiftGoalDistributionConfig = {
  __typename?: 'LastMinuteShiftGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  lastMinuteShiftRewardOverride?: Maybe<GoalConfigRewardOverride>;
};

export type LastMinuteShiftGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  lastMinuteShiftRewardOverride?: Maybe<GoalRewardsInput>;
};

export type LastMinuteShiftGoalTracker = {
  __typename?: 'LastMinuteShiftGoalTracker';
  id: Scalars['ID'];
  trackedVisit?: Maybe<LastMinuteShiftGoalTrackerVisitDetail>;
  availability?: Maybe<Scalars['String']>;
};

export type LastMinuteShiftGoalTrackerVisitDetail = {
  __typename?: 'LastMinuteShiftGoalTrackerVisitDetail';
  id: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
};

export type LaunchedInsightDateRanges = {
  __typename?: 'LaunchedInsightDateRanges';
  id: Scalars['ID'];
  quarterly: Array<InsightsQuarterlyDateRange>;
  monthly: Array<InsightsMonthlyDateRange>;
};

export type ListArchivedAssignedShiftPostingsForCoordinatorsResponse = {
  __typename?: 'ListArchivedAssignedShiftPostingsForCoordinatorsResponse';
  items: Array<PhiShiftPosting>;
  total: Scalars['Int'];
};

export type ListAssignedShiftPostingsForCoordinatorResponse = {
  __typename?: 'ListAssignedShiftPostingsForCoordinatorResponse';
  items: Array<PhiShiftPosting>;
  total: Scalars['Int'];
};

export type ListAwardedBonusPointsFilter = {
  /**
   * If provided, filters the results to only return
   * bonus points sent to the provided user id.
   */
  sentToUserId?: Maybe<Scalars['ID']>;
  /**
   * Allows filtering by organization branch ID.
   * If provided, will only show results for users from given branch(es)
   * If not provided, will show results for users from all branches
   * If [null] is provided, will show results for users that have no branch assigned
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ListAwardedBonusPointsResponse = {
  __typename?: 'ListAwardedBonusPointsResponse';
  total: Scalars['Int'];
  items: Array<AwardedBonusPoints>;
};

export type ListAwardedDrawTicketTransactionsForUserResponse = {
  __typename?: 'ListAwardedDrawTicketTransactionsForUserResponse';
  total: Scalars['Int'];
  items: Array<AwardedDrawTicketTransaction>;
};

export type ListBroadcastsForShiftPostingResponse = {
  __typename?: 'ListBroadcastsForShiftPostingResponse';
  items: Array<ShiftPostingBroadcastHistoryItem>;
  total: Scalars['Int'];
};

export type ListCandidateV2FilterStatusInput = {
  recruitmentStep?: Maybe<CandidateRecruitmentStepName>;
  retentionDurationMonths?: Maybe<Scalars['Int']>;
};

export type ListCandidateV2NextStepInInput = {
  recruitmentStep?: Maybe<CandidateRecruitmentStepName>;
  retentionDurationMonths?: Maybe<Scalars['Int']>;
  retentionDurationHours?: Maybe<Scalars['Int']>;
};

export type ListCandidatesFilterInput = {
  /** Search query for name or job title */
  searchQuery?: Maybe<Scalars['String']>;
  /**
   * If true, includes archived results.
   *
   * If not provided, defaults to `false`.
   */
  includeArchived?: Maybe<Scalars['Boolean']>;
  /**
   * For each recruitment step provided, candidates who have
   * reached that step of the recruitment process will be returned.
   *
   * If not provided, defaults to each recruitment status.
   */
  includeRecruitmentStatuses?: Maybe<Array<CandidateRecruitmentStepName>>;
  /**
   * For each number of months provided (e.g. [3, 6]), candidates
   * who have been retained for those lengths of time will be returned.
   *
   * If not provided, defaults to each retention month status.
   */
  includedRetentionMonthStatuses?: Maybe<Array<Scalars['Int']>>;
};

export type ListCandidatesResponse = {
  __typename?: 'ListCandidatesResponse';
  total: Scalars['Int'];
  items: Array<Candidate>;
};

export type ListCandidatesV2FilterInput = {
  /** Search query for name or job title */
  searchQuery?: Maybe<Scalars['String']>;
  /**
   * If true, shows only archived candidates.
   * If false, shows only open candidates.
   */
  archived?: Maybe<Scalars['Boolean']>;
  /**
   * If true, shows only candidates who have uploaded a resume.
   * If false, shows only candidates who haven't uploaded a resume.
   */
  hasUploadedResume?: Maybe<Scalars['Boolean']>;
  /** If provided, only matches candidates who have the given next step. */
  nextStepIn?: Maybe<Array<ListCandidateV2NextStepInInput>>;
  /** Deprecated: Use `nextStepIn` instead */
  statuses?: Maybe<Array<ListCandidateV2FilterStatusInput>>;
  /**
   * If provided, only matches candidates who have applied to at
   * least one of the provided job posting ids.
   */
  assignedToJobPostingIds?: Maybe<Array<Scalars['ID']>>;
  /** @deprecated use `assignedToJobPostingIds` instead */
  appliedToJobPostingIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * If provided, only matches candidates who were referred by the
   * employee with the given ID.
   */
  referredByUserId?: Maybe<Scalars['ID']>;
};

export enum ListCandidatesV2OrderField {
  MostRecentApplicationDate = 'MOST_RECENT_APPLICATION_DATE',
  LastUpdateDate = 'LAST_UPDATE_DATE',
  LastStepOrArchivedDate = 'LAST_STEP_OR_ARCHIVED_DATE',
  FirstNameLastName = 'FIRST_NAME_LAST_NAME'
}

export type ListCandidatesV2OrderInput = {
  field: ListCandidatesV2OrderField;
  direction: Sort;
};

export type ListEmployeeSummariesByCursorFilterInput = {
  /**
   * Allows filtering by organization branch ID.
   * If provided:
   * - any branch ID specified will be included
   * - if null is provided, results without a branch will be included
   * If not provided, will show results from all branches
   */
  branchIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  isActive?: Maybe<Scalars['Boolean']>;
  nameOrEmailSearch?: Maybe<Scalars['String']>;
  nameSearch?: Maybe<Scalars['String']>;
};

export type ListEmployeeSummariesByCursorResponse = {
  __typename?: 'ListEmployeeSummariesByCursorResponse';
  items: Array<EmployeeSummary>;
  cursor?: Maybe<Scalars['String']>;
};

export type ListEmployeeSummariesByCursorSortInput = {
  key: ListEmployeeSummariesByCursorSortKey;
  direction: Sort;
};

export enum ListEmployeeSummariesByCursorSortKey {
  Name = 'NAME',
  EmploymentStartDate = 'EMPLOYMENT_START_DATE',
  PointsBalance = 'POINTS_BALANCE',
  LatestPointsEarned = 'LATEST_POINTS_EARNED',
  LastestLogin = 'LASTEST_LOGIN',
  LatestNps = 'LATEST_NPS'
}

export type ListGiftCardOptionsResponse = {
  __typename?: 'ListGiftCardOptionsResponse';
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  minPointsAllowed: Scalars['Int'];
  maxPointsAllowed: Scalars['Int'];
  brandName: Scalars['String'];
};

export type ListGiftCardOptionsResponseResponse = {
  __typename?: 'ListGiftCardOptionsResponseResponse';
  items: Array<ListGiftCardOptionsResponse>;
};

export type ListInterestedCaregiversForShiftPostingResponseV2 = {
  __typename?: 'ListInterestedCaregiversForShiftPostingResponseV2';
  items: Array<RewardsUser>;
  total: Scalars['Int'];
};

export type ListMyCaregiverImpactMonthsByCursorResponse = {
  __typename?: 'ListMyCaregiverImpactMonthsByCursorResponse';
  items: Array<CaregiverImpactMonth>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListMyEvvCompletionRateOffersFilter = {
  /** This determines if the offer has ended */
  ended?: Maybe<Scalars['Boolean']>;
  /**
   * This determines if a rewards user has acknowledged an offer as "ended"
   * And, it is referred to ensure they do not receive the congratulations
   * modal a second time (when querying via `listMyEVVCompletionRateOffers`)
   */
  acknowledgedOfferEnded?: Maybe<Scalars['Boolean']>;
};

export type ListMyManagedEmployeesRecognitionSummaryFilterInput = {
  month: Scalars['MonthAndYear'];
};

export type ListMyManagedEmployeesRecognitionSummaryPageInput = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};

export type ListMyManagedEmployeesRecognitionSummaryResponse = {
  __typename?: 'ListMyManagedEmployeesRecognitionSummaryResponse';
  total: Scalars['Int'];
  items: Array<ListMyManagedEmployeesRecognitionSummaryResponseItem>;
};

export type ListMyManagedEmployeesRecognitionSummaryResponseItem = {
  __typename?: 'ListMyManagedEmployeesRecognitionSummaryResponseItem';
  /** The rewards user id */
  id: Scalars['ID'];
  employee: RewardsUser;
  pointsReceivedInMonth: Scalars['Int'];
  pointsReceivedYTD: Scalars['Int'];
};

export type ListMyManagedEmployeesRecognitionSummaryV2FilterInput = {
  range?: Maybe<ListMyManagedEmployeesRecognitionSummaryV2FilterRangeInput>;
};

export type ListMyManagedEmployeesRecognitionSummaryV2FilterRangeInput = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};

export type ListMyManagedEmployeesRecognitionSummaryV2PageInput = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};

export type ListMyManagedEmployeesRecognitionSummaryV2Response = {
  __typename?: 'ListMyManagedEmployeesRecognitionSummaryV2Response';
  total: Scalars['Int'];
  items: Array<ListMyManagedEmployeesRecognitionSummaryV2ResponseItem>;
};

export type ListMyManagedEmployeesRecognitionSummaryV2ResponseItem = {
  __typename?: 'ListMyManagedEmployeesRecognitionSummaryV2ResponseItem';
  /** The rewards user id */
  id: Scalars['ID'];
  employee: RewardsUser;
  /** Null if no range is provided to the query. */
  pointsReceivedInRange?: Maybe<Scalars['Int']>;
  pointsReceivedYTD: Scalars['Int'];
};

export type ListMyManagerScheduledRecognitionPointsFilter = {
  hasMessage?: Maybe<Scalars['Boolean']>;
};

export type ListMyManagerScheduledRecognitionPointsResponse = {
  __typename?: 'ListMyManagerScheduledRecognitionPointsResponse';
  total: Scalars['Int'];
  items: Array<RecognitionPoints>;
};

/**
 * Filter input for the V2 card matches query (listMyNonPHIShiftPostingCardMatches).
 *
 * Includes all fields from ListMyNonPHIShiftPostingMatchesFilterInput plus
 * caregiverShiftTypePreferences, which is only supported by the V2 query.
 */
export type ListMyNonPhiShiftPostingCardMatchesFilterInput = {
  dateRanges?: Maybe<Array<CaregiverMatchesFilterDateRange>>;
  timesOfDay?: Maybe<Array<CaregiverMatchesFilterTimeOfDay>>;
  /**
   * The IANA timezone to use when filtering shift postings by date/time (ex: `America/New_York`).
   * If not provided, the organization's timezone will be used.
   */
  timezone?: Maybe<Scalars['String']>;
  /**
   * Filter shift postings by caregiver shift type preference (temporary or permanent).
   * If provided, only shift postings matching the specified types will be returned.
   */
  caregiverShiftTypePreferences?: Maybe<Array<CaregiverProfileShiftTypePreference>>;
};

/**
 * Response for listing shift posting card matches for the current user.
 *
 * This is the V2 version that returns NonPHIShiftPostingCard union types instead
 * of NonPHIShiftPosting. Cards group permanent/recurring shifts by
 * day-of-week and time pattern, providing a cleaner representation for the frontend.
 *
 * Use this query when you need to display shift postings in a format that
 * distinguishes between temporary (one-time) and permanent (recurring) shifts.
 *
 * Unlike ListMyNonPHIShiftPostingMatchesResponse which returns individual visits
 * for all shift postings, this response type returns cards that:
 * - Show individual visits for temporary shift postings (NonPHIShiftPostingCardTemporary)
 * - Group recurring shifts by pattern for permanent shift postings (NonPHIShiftPostingCardPermanent)
 *
 * This allows the frontend to render different UI components based on whether a
 * shift posting is temporary or permanent, optimizing the display of recurring shifts.
 *
 * Note: For permanent shift postings that have urgent shifts, both card types will
 * be returned:
 * - A permanent card (NonPHIShiftPostingCardPermanent) showing the recurring patterns
 * - A separate temporary card (NonPHIShiftPostingCardTemporary) containing only the
 *   urgent shifts, surfaced separately to increase caregiver engagement with time-sensitive shifts
 */
export type ListMyNonPhiShiftPostingCardMatchesResponse = {
  __typename?: 'ListMyNonPHIShiftPostingCardMatchesResponse';
  items: Array<NonPhiShiftPostingCard>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListMyNonPhiShiftPostingMatchesFilterInput = {
  dateRanges?: Maybe<Array<CaregiverMatchesFilterDateRange>>;
  timesOfDay?: Maybe<Array<CaregiverMatchesFilterTimeOfDay>>;
  /**
   * The IANA timezone to use when filtering shift postings by date/time (ex: `America/New_York`).
   * If not provided, the organization's timezone will be used.
   */
  timezone?: Maybe<Scalars['String']>;
};

export type ListMyNonPhiShiftPostingMatchesResponse = {
  __typename?: 'ListMyNonPHIShiftPostingMatchesResponse';
  items: Array<NonPhiShiftPosting>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListMyPowerHoursFilter = {
  ended?: Maybe<Scalars['Boolean']>;
  acknowledgedOfferEnded?: Maybe<Scalars['Boolean']>;
  finishedSomeLevels?: Maybe<Scalars['Boolean']>;
  acknowledgedLatestFinishedLevel?: Maybe<Scalars['Boolean']>;
};

export type ListMyRecognitionBudgetPeriodsResponse = {
  __typename?: 'ListMyRecognitionBudgetPeriodsResponse';
  items: Array<RecognitionBudgetPeriod>;
};

export type ListMyRewardOffersFilter = {
  structureType?: Maybe<RewardOfferStructureType>;
  acknowledgedMostRecentlyAwardedCompletion?: Maybe<Scalars['Boolean']>;
};

export type ListMyRewardsUserPointTransactionsByCursorResponse = {
  __typename?: 'ListMyRewardsUserPointTransactionsByCursorResponse';
  items: Array<RewardsAccountTransaction>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListMySocialFeedPostsByCursorResponse = {
  __typename?: 'ListMySocialFeedPostsByCursorResponse';
  items: Array<SocialPost>;
  nextCursor?: Maybe<Scalars['String']>;
};

/** Input type for pagination when listing visits for a caregiver. */
export type ListMyVisitsAsOfStartDatePageInput = {
  /** Filters the visits where the start date is greater than or equal to this value. */
  startDateGte: Scalars['Timestamp'];
  /** The maximum number of items to return. Default limit is 50. */
  limit?: Maybe<Scalars['Int']>;
};

export type ListMyVisitsAsOfStartDateResponse = {
  __typename?: 'ListMyVisitsAsOfStartDateResponse';
  /** The list of caregiver visits. */
  items: Array<Visit>;
};

export type ListNotifiedCaregiversForShiftPostingResponseV2 = {
  __typename?: 'ListNotifiedCaregiversForShiftPostingResponseV2';
  items: Array<RewardsUser>;
  total: Scalars['Int'];
};

export type ListOpenShiftPostingsForCoordinatorsResponse = {
  __typename?: 'ListOpenShiftPostingsForCoordinatorsResponse';
  items: Array<PhiShiftPosting>;
  total: Scalars['Int'];
};

export type ListOpenShiftPostingsResponse = {
  __typename?: 'ListOpenShiftPostingsResponse';
  items: Array<PhiShiftPosting>;
  total: Scalars['Int'];
};

export type ListPhiCaregiverMatchesForShiftPostingResponse = {
  __typename?: 'ListPHICaregiverMatchesForShiftPostingResponse';
  items: Array<PhiCaregiverShiftPostingMatch>;
};

export type ListPhiInterestedCaregiversForShiftPostingResponse = {
  __typename?: 'ListPHIInterestedCaregiversForShiftPostingResponse';
  items: Array<PhiCaregiverShiftPostingMatch>;
  total: Scalars['Int'];
};

export type ListPhiNotifiedCaregiversForShiftPostingResponse = {
  __typename?: 'ListPHINotifiedCaregiversForShiftPostingResponse';
  items: Array<PhiCaregiverShiftPostingMatch>;
  total: Scalars['Int'];
};

export type ListPhiShiftCaregiverSummariesResponse = {
  __typename?: 'ListPHIShiftCaregiverSummariesResponse';
  items: Array<PhiShiftCaregiverSummary>;
  total: Scalars['Int'];
};

export type ListPhiTopRecommendedCaregiversToReachOutToForShiftPostingResponse = {
  __typename?: 'ListPHITopRecommendedCaregiversToReachOutToForShiftPostingResponse';
  items: Array<PhiCaregiverShiftPostingMatch>;
};

export type ListRecognitionCategoriesResponse = {
  __typename?: 'ListRecognitionCategoriesResponse';
  total: Scalars['Int'];
  items: Array<RecognitionCategory>;
};

export type ListRedemptionsByCursorFilterInput = {
  status?: Maybe<RedemptionStatus>;
  redemptionMethods?: Maybe<Array<RedemptionMethod>>;
  redemptionItemStatus?: Maybe<RedemptionItemStatus>;
  catalogItemCategory?: Maybe<RedemptionCatalogItemCategory>;
  organizationIds?: Maybe<Array<Scalars['Int']>>;
};

export type ListRedemptionsByCursorResponse = {
  __typename?: 'ListRedemptionsByCursorResponse';
  total: Scalars['Int'];
  items?: Maybe<Array<Maybe<Redemption>>>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListRewardsAdminsResponse = {
  __typename?: 'ListRewardsAdminsResponse';
  total: Scalars['Int'];
  items: Array<RewardsAdminUser>;
};

export type ListRewardsGroupsResponse = {
  __typename?: 'ListRewardsGroupsResponse';
  total: Scalars['Int'];
  items: Array<RewardsGroup>;
};

export type ListRewardsTagsResponse = {
  __typename?: 'ListRewardsTagsResponse';
  total: Scalars['Int'];
  items: Array<RewardsTag>;
};

export type ListRewardsUserGroupResponse = {
  __typename?: 'ListRewardsUserGroupResponse';
  items: Array<RewardsUserGroup>;
};

export type ListRewardsUsersFilterInput = {
  active?: Maybe<Scalars['Boolean']>;
  /**
   * Allows filtering by organization branch ID.
   * If provided, will only show results from given branch(es)
   * If not provided, will show results from all branches
   * If [null] is provided, will show results that have no branch assigned
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  providedPersonalInfo?: Maybe<Scalars['Boolean']>;
};

export type ListRewardsUsersResponse = {
  __typename?: 'ListRewardsUsersResponse';
  total: Scalars['Int'];
  items: Array<RewardsUser>;
};

export type ListSchoolsEmployerSurveysResponse = {
  __typename?: 'ListSchoolsEmployerSurveysResponse';
  items: Array<SchoolsEmployerSurvey>;
};

export type ListSentRecognitionFilter = {
  /**
   * If provided, filters the results to only return
   * recognition sent to the provided employee id.
   */
  employeeId?: Maybe<Scalars['ID']>;
  /**
   * Allows filtering by organization branch ID.
   * If provided, will only show results for employees from given branch(es)
   * If not provided, will show results for employees from all branches
   * If [null] is provided, will show results for employees that have no branch assigned
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  recognitionCategoryIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  froms?: Maybe<Array<Scalars['String']>>;
  claimed?: Maybe<Scalars['Boolean']>;
  /**
   * If provided, filters results to only recognition with the given reward type.
   * points: recognition that awards bonus points (reward.numPoints is set)
   * draw_tickets: recognition that awards draw tickets (reward.numOrganizationDrawTickets is set)
   */
  rewardType?: Maybe<RecognitionRewardType>;
};

/** Deprecated - use ListSentRecognitionFilter instead */
export type ListSentRecognitionPointsFilter = {
  /**
   * If provided, filters the results to only return
   * recognition points sent to the provided employee id.
   */
  employeeId?: Maybe<Scalars['ID']>;
  /**
   * Allows filtering by organization branch ID.
   * If provided, will only show results for employees from given branch(es)
   * If not provided, will show results for employees from all branches
   * If [null] is provided, will show results for employees that have no branch assigned
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  recognitionCategoryIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  froms?: Maybe<Array<Scalars['String']>>;
  claimed?: Maybe<Scalars['Boolean']>;
};

export type ListSentRecognitionPointsResponse = {
  __typename?: 'ListSentRecognitionPointsResponse';
  total: Scalars['Int'];
  items: Array<RecognitionPoints>;
};

export type ListSentRecognitionResponse = {
  __typename?: 'ListSentRecognitionResponse';
  total: Scalars['Int'];
  items: Array<Recognition>;
};

export type ListShareableJobPostingsFilters = {
  /** Filters for jobs that match at least one of the provided title values */
  titleIn?: Maybe<Array<Scalars['String']>>;
  /** Filters for jobs that match at least one of the provided geography values */
  geographyIn?: Maybe<Array<Scalars['String']>>;
};

export type ListSurveyCommentsResponse = {
  __typename?: 'ListSurveyCommentsResponse';
  total: Scalars['Int'];
  items: Array<SurveyQuestionResponse>;
};

export type ListTopRecommendedCaregiversToReachOutToForShiftPostingResponseV2 = {
  __typename?: 'ListTopRecommendedCaregiversToReachOutToForShiftPostingResponseV2';
  items: Array<RewardsUser>;
};

export type ListTopRecommendedCaregiversToReachOutToForShiftPostingResponseV3 = {
  __typename?: 'ListTopRecommendedCaregiversToReachOutToForShiftPostingResponseV3';
  items: Array<RewardsUser>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListTransactionsForRewardsAccountResponse = {
  __typename?: 'ListTransactionsForRewardsAccountResponse';
  items: Array<RewardsAccountTransaction>;
  total: Scalars['Int'];
};

export type ListUniqueCandidateAlertEmailsResponse = {
  __typename?: 'ListUniqueCandidateAlertEmailsResponse';
  emails: Array<Scalars['String']>;
};

export enum Locale {
  En = 'en',
  Fr = 'fr',
  Ht = 'ht',
  ZhCn = 'zhCN',
  Ru = 'ru',
  Es = 'es',
  KmKh = 'kmKH',
  Uk = 'uk',
  Vi = 'vi'
}

export type LoggedInUsersInsightMetric = {
  __typename?: 'LoggedInUsersInsightMetric';
  id: Scalars['ID'];
  usersWhoLoggedInCount: Scalars['Int'];
  activeUserCount: Scalars['Int'];
};

export type LoginAdminGoalTracker = {
  __typename?: 'LoginAdminGoalTracker';
  id: Scalars['ID'];
  targetPercentage: Scalars['Int'];
  /**
   * The total number of active users who have checked in during the goal period.
   * This may be null if the goal progress has not yet been updated.
   */
  totalUsersWhoCheckedIn?: Maybe<Scalars['Int']>;
  /**
   * The total number of active users during the goal period.
   * This may be null if the goal progress has not yet been updated.
   */
  totalActiveUsers?: Maybe<Scalars['Int']>;
  progressUpdatedAt?: Maybe<Scalars['Timestamp']>;
};

export type MailingAddress = CaMailingAddress | UsMailingAddress;

export enum MailingAddressCountryCode {
  Ca = 'CA',
  Us = 'US'
}

export type MailingAddressInput = {
  countryCode: MailingAddressCountryCode;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  /** Required for CA addresses */
  caPostalCode?: Maybe<Scalars['String']>;
  /** Required for CA address */
  caProvinceCode?: Maybe<CaProvinceCode>;
  /** Required for US addresses */
  usZipCode?: Maybe<Scalars['String']>;
  /** Required for US addresses */
  usStateAbbreviation?: Maybe<UsStateAbbreviation>;
};

export type MilestoneGoal = VisitMilestoneGoal | HoursMilestoneGoal;

export type MilestoneRewardsBackfillConfig = MilestoneRewardsDisableBackfillConfig | MilestoneRewardsEnableBackfillConfig;

export type MilestoneRewardsBackfillRewardsPreviewResult = {
  __typename?: 'MilestoneRewardsBackfillRewardsPreviewResult';
  status: MilestoneRewardsBackfillRewardsPreviewResultStatus;
  result?: Maybe<Scalars['Int']>;
};

export enum MilestoneRewardsBackfillRewardsPreviewResultStatus {
  Pending = 'PENDING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED'
}

export type MilestoneRewardsDisableBackfillConfig = {
  __typename?: 'MilestoneRewardsDisableBackfillConfig';
  shouldBackfill: Scalars['Boolean'];
};

export type MilestoneRewardsEnableBackfillConfig = {
  __typename?: 'MilestoneRewardsEnableBackfillConfig';
  shouldBackfill: Scalars['Boolean'];
  backfillAsOfDays: Scalars['Int'];
};


export type Mutation = {
  __typename?: 'Mutation';
  uploadBulkImport: UploadBulkImportResponse;
  /** Allows an admin to generate their own rewards user's login link */
  generateMyRewardsUserLoginLink: GenerateMyRewardsUserLoginLinkResponse;
  /** Allows superadmin to generate a login link for any user */
  generateEmployeeImpersonationLoginLink: GenerateMyRewardsUserLoginLinkResponse;
  /** Allows superadmin to generate External GQL API Credentials for an agency */
  retoolGenerateExternalApiCredentials: GenerateExternalApiCredentialsResponse;
  /** Allows superadmin to generate External SQS Credentials for an agency */
  retoolGenerateExternalSqsCredentials: GenerateExternalSqsCredentialsResponse;
  trackCaribouRewardsPrototypeAction: Scalars['String'];
  createRewardsAdmin: RewardsAdminUser;
  updateRewardsAdmin: RewardsAdminUser;
  /**
   * Allows a rewards admin or rewards superuser to enable MFA by providing
   * a phone number that was verified with Cognito.
   */
  enableSmsMfaForMyRewardsAdmin: GetMyRewardsAdminMfaStatusResponse;
  sendLoginLinkToEmployee?: Maybe<Scalars['Void']>;
  sendInvitationLinkToEmployee?: Maybe<Scalars['Void']>;
  sendOpenShiftsPageLinkToEmployee?: Maybe<Scalars['Void']>;
  /**
   * Allows a rewards admin or rewards superuser to set an autogenerated password for users
   * that have not yet set their password.
   */
  generateAndSendRewardsAdminTemporaryPassword?: Maybe<Scalars['Void']>;
  /**
   * (Deprecated)
   * Creates a new admin goal config and marks it as launched,
   * which in turn gives the goal to all selected admins.
   * @deprecated Use upcoming mutation `enableNewOrganizationAdminGoalConfig` instead
   */
  launchNewAdminGoalConfig: Scalars['ID'];
  /**
   * Enables a new admin goal config that gets launched immediately or when the
   * start date arrives, which in turn gives the goal to all selected admins.
   * Supports both organization-wide and branch-specific configurations.
   */
  enableNewOrganizationAdminGoalConfig: Scalars['ID'];
  /**
   * Updates an existing admin goal configuration. Can update both current and recurring settings.
   * For organization-wide configurations, use adminIds, rewards, and target fields.
   * For branch-specific configurations, use the branchConfigs field.
   */
  partialUpdateOrganizationAdminGoalConfig: AdminGoalConfig;
  /**
   * Disables an existing admin goal configuration.
   * This will prevent any new goals from being created and cancel any recurring goals.
   */
  disableOrganizationAdminGoalConfig: AdminGoalConfig;
  /**
   * Allows a rewards admin to update the message
   * of scheduled recognition points.
   * @deprecated Scheduled recognition is deprecated
   */
  updateScheduledRecognitionPointsMessage: RecognitionPoints;
  /** Allows an admin to award bonus points to a rewards user. */
  awardRecognition?: Maybe<Recognition>;
  /**
   * Allows an admin to award bonus points to a rewards user.
   * @deprecated Use `awardRecognition` instead
   */
  awardUserBonusPoints?: Maybe<AwardedBonusPoints>;
  /** @deprecated Use `awardUserBonusPoints` instead */
  awardBonusPoints?: Maybe<Scalars['Void']>;
  /**
   * Allows a rewards user to claim their bonus points
   * @deprecated Use `bulkClaimRecognitionPoints` instead
   */
  bulkClaimBonusPoints: Array<AwardedBonusPoints>;
  /**
   * Allows a rewards user to claim their recognition points
   * @deprecated Use `bulkClaimRecognitionPoints` instead
   */
  bulkClaimRecognitionPoints: Array<RecognitionPoints>;
  createRecognitionCategory: RecognitionCategory;
  partialUpdateRecognitionCategory: RecognitionCategory;
  /**
   * Deletes a recognition category.
   *
   * If it's already deleted, returns `deleted: false`.
   * Throws an error if the recognition category never existed.
   */
  deleteRecognitionCategory: DeleteRecognitionCategoryResponse;
  /**
   * Allows an admin to upload a bulk recognition file for async processing.
   *
   * This does not send out recognition points directly - it only saves the file
   * and triggers a notification to internal Caribou employees.
   * This is idempotent based on the given requestId.
   */
  uploadBulkRecognitionFile: BulkRecognitionUpload;
  /**
   * Allows a RewardsUser to like their recognition.
   *
   * Note: exactly one of recognitionId or recognitionPointsId must be provided.
   */
  recordRecognitionLike: Recognition;
  /**
   * Allows a RewardsUser to like their recognition points.
   * @deprecated Use `recordRecognitionLike` instead
   */
  recordRecognitionPointsLike: RecognitionPoints;
  /**
   * Marks Recognition as viewed by the RewardsUser.
   *
   * Note: exactly one of recognitionId or recognitionPointsId must be provided.
   */
  recordRecognitionFirstView: Recognition;
  /**
   * Marks RecognitionPoints as viewed by the RewardsUser.
   * @deprecated Use `recordRecognitionFirstView` instead
   */
  recordRecognitionPointsFirstView: RecognitionPoints;
  /** Allows a rewards admin to add a candidate manually. */
  addCandidate: Candidate;
  recordCandidateRecruitmentStep: Candidate;
  recordCandidateRetentionStep: Candidate;
  recordCandidateHourlyRetentionStep: Candidate;
  undoCandidateRecruitmentStep: Candidate;
  /**
   * Archives a candidate.
   * The admin can optionally update the admin notes for the candidate.
   * This will override any existing notes for the candidate.
   */
  archiveCandidate: Candidate;
  /** Bulk-archives multiple candidates. */
  bulkArchiveCandidates: Array<Candidate>;
  /** A.K.A "un-archive" candidate */
  reopenCandidate: Candidate;
  /** Updates a candidate's admin notes */
  updateCandidateAdminNotes: Candidate;
  /** Assigns the candidate to a different job posting */
  assignCandidateToJobPosting: Candidate;
  /**
   * Merges multiple "from" candidates into a given "to" candidate
   * and resolves the merged candidate.
   */
  mergeCandidates: Candidate;
  /**
   * Sends a reminder to a candidate to upload their resume.
   * Fails if the candidate has already uploaded their resume.
   * Fails if the candidate does not have an email.
   */
  sendCandidateResumeReminder: Candidate;
  /** Sets the "referred by user" of a candidate */
  correctCandidateReferredByUser: Candidate;
  /** Allows a rewards admin to link a hired candidate to an employee. */
  linkCandidateToEmployee: Candidate;
  /**
   * Allows a rewards admin or rewards superuser to upload a resume.
   * Either `applicationSubmissionId` or `candidateId` must be provided
   */
  uploadCandidateResume: UploadCandidateResumeResponse;
  markCaregiverImpactSlideAsOpened: CaregiverImpactMonth;
  markCaregiverImpactMonthAsFinished: CaregiverImpactMonth;
  markCaregiverImpactMonthAnnouncementModalAsAcknowledged: CaregiverImpactMonth;
  cognitoSendTemporaryPasswordEmail: CognitoMutationResponse;
  cognitoSendPasswordResetCodeEmail: CognitoMutationResponse;
  cognitoSendRewardsAdminSmsVerificationCode: CognitoMutationResponse;
  cognitoTrackLogin: CognitoMutationResponse;
  customerIOGenerateRewardsUserLoginLink: CustomerIoGenerateRewardsUserLoginLinkResponse;
  scheduleDraw: Draw;
  scheduleDrawV2: Draw;
  updateDraw: Draw;
  updateDrawV2: Draw;
  deleteDraw?: Maybe<Scalars['Void']>;
  /**
   * Approves draw winners.
   *
   * If draw winners were already approved, this functions as a no-op.
   */
  approveDrawWinners: Draw;
  /**
   * Marks draw winners as viewed by the user.
   *
   * If draw winners were already viewed, this functions as a no-op.
   */
  markDrawWinnersAsViewed: Draw;
  /**
   * Allows a rewards user to claim their draw prize, if they are a winner.
   *
   * If the user has already claimed their prize, this functions as a no-op.
   */
  claimDrawPrize: Draw;
  /**
   * Allows admins to reject a winner before approving all the winners
   *
   * Then automatically bump everyone in the list and redraw for the empty spots
   */
  redrawWinner?: Maybe<Draw>;
  /** Allows admins to update the organization draw settings. */
  updateOrganizationDrawSettings: OrganizationDrawSettings;
  /**
   * Allows a rewards user to acknowledge an offer as "ended",
   * which will ensure they do not receive the congratulations
   * modal a second time (when querying via `listMyEVVCompletionRateOffers`)
   */
  acknowledgeEVVCompletionRateOfferEnded: EvvCompletionRateOffer;
  /** Marks a goal as achievement acknowledged. */
  acknowledgeGoalAchievement?: Maybe<Goal>;
  /**
   * Given a `goalId` and `videoWatchId`, attempts to
   * evaluate/achieve the goal, and returns the goal.
   */
  evaluateGoal: Goal;
  /** Given a `goalId`, attempts to activate the goal, and returns the goal. */
  activateGoal: Goal;
  /** Updates the user's availability for a specific goal and returns the updated goal. */
  updateGoalAvailability: Goal;
  /**
   * Generates an authenticated SSO login link to Nevvon for the current user,
   * if they can be mapped to a Nevvon-integrated user account.
   *
   * To be used for Complete Training goals where the training program is in Nevvon.
   * In the case when this link is missing there should be an error
   * raised on the front-end.
   */
  generateMyNevvonLoginLink?: Maybe<GenerateMyNevvonLoginLinkResponse>;
  /** Initialize CUSTOM goals config for an organization, as a superuser/retool user. */
  retoolInitializeGoalsConfigForOrganization: OrganizationGoalConfig;
  /** Update goals config for an organization, as a superuser/retool user. */
  retoolUpdateGoalsConfigForOrganization: OrganizationGoalConfig;
  /**
   * Allows admins to create or update their organization's pulse check survey goals config.
   * If pulse check surveys are disabled, re-enables them.
   */
  partialUpdateMyOrganizationPulseCheckSurveyGoalsConfig: PulseCheckSurveyGoalDistributionConfig;
  /**
   * Allows admins to create or update their organization's quick check survey goals config.
   * If quick check surveys are disabled, re-enables them.
   */
  partialUpdateMyOrganizationQuickCheckSurveyGoalsConfig: QuickCheckSurveyGoalDistributionConfig;
  /** Allows admins to create or update their organization's birthday goal config. */
  partialUpdateMyOrganizationBirthdayGoalConfig: BirthdayGoalDistributionConfig;
  /** Allows admins to create or update their organization's anniversary goal config. */
  partialUpdateMyOrganizationAnniversaryGoalConfig: AnniversaryGoalDistributionConfig;
  /** Allows admins to create or update their organization's EVV goal config. */
  partialUpdateMyOrganizationEVVGoalConfig: EvvGoalDistributionConfig;
  /** Allows admins to disable organization's EVV goal config. */
  disableMyOrganizationEVVGoalConfig: EvvGoalDistributionConfig;
  /** Allows admins to disable organization's birthday goal config. */
  disableMyOrganizationBirthdayGoalConfig: BirthdayGoalDistributionConfig;
  /** Allows admins to disable organization's anniversary goal config. */
  disableMyOrganizationAnniversaryGoalConfig: AnniversaryGoalDistributionConfig;
  /** Allows admins to disable organization's pulse check survey goals config. */
  disableMyOrganizationPulseCheckSurveyGoalsConfig: PulseCheckSurveyGoalDistributionConfig;
  /** Allows admins to disable organization's quick check survey goals config. */
  disableMyOrganizationQuickCheckSurveyGoalsConfig: QuickCheckSurveyGoalDistributionConfig;
  /** Allows admins to create or update their organization's welcome goal config. */
  partialUpdateMyOrganizationWelcomeGoalConfig: WelcomeGoalDistributionConfig;
  /** Allows admins to disable organization's welcome goal config. */
  disableMyOrganizationWelcomeGoalConfig: WelcomeGoalDistributionConfig;
  /** Allows admins to create or update their organization's welcome video goal config. */
  partialUpdateMyOrganizationWelcomeVideoGoalConfig: WelcomeVideoGoalDistributionConfig;
  /** Allows admins to disable organization's welcome video goal config. */
  disableMyOrganizationWelcomeVideoGoalConfig: WelcomeVideoGoalDistributionConfig;
  /** Create a group of tags, with given config */
  createRewardsGroup: Scalars['ID'];
  enableCaribouUserSyncForHHAXIntegration?: Maybe<HhaxIntegration>;
  updateHHAXCaribouUserSyncFilters: HhaxCaribouUserSync;
  /** Strictly for QA purposes, supports updating mobileId only */
  retoolUpdateQAHHAXCaregiver?: Maybe<Scalars['Void']>;
  /** Public mutation which allows someone to submit a job application */
  submitJobApplication: SubmitJobApplicationResponse;
  /**
   * Public mutation which allows someone to upload a resume.
   * Either `applicationSubmissionId` or `candidateId` must be provided
   */
  uploadJobApplicationResume: UploadJobApplicationResumeResponse;
  /** Allows a rewards admin to create and publish a job posting. */
  createJobPosting: JobPosting;
  /** Allows a rewards admin to edit a job posting. */
  updateJobPosting: JobPosting;
  /** Allows a rewards admin to close a job posting. */
  closeJobPosting: JobPosting;
  /**
   * Allows a rewards admin to reopen a closed job posting.
   * Only super admins or admins with full access can reopen a job posting.
   */
  reopenJobPosting: JobPosting;
  /**
   * Allows a rewards admin to start a job posting promotion.
   * If there is currently an active promotion for the job,
   * it will stop that promotion before starting this one.
   */
  startJobPostingPromotion: JobPosting;
  /** Allows a rewards admin to stop a job posting promotion. */
  stopJobPostingPromotion: JobPosting;
  /**
   * Connects a job posting to an external ATS job.
   * The appropriate ATS integration is determined by the externalAtsIntegrationId.
   */
  connectJobPostingToATSJob: ConnectJobPostingToAtsResult;
  /** Creates a job share link. */
  createJobShareLink?: Maybe<CreateJobShareResponse>;
  markJobShared?: Maybe<Scalars['Void']>;
  initializeOrganizationMilestoneRewardSettings: OrganizationMilestoneRewardSettings;
  updateOrganizationMilestoneRewardSettings: OrganizationMilestoneRewardSettings;
  enableOrganizationMilestoneRewardSettings: OrganizationMilestoneRewardSettings;
  /**
   * Kicks off a one-off background backfill rewards calculation (preview)
   * @returns {String} The workflowId of the backfill rewards calculation
   */
  triggerBackfillRewardsPreviewCalculation: Scalars['String'];
  /**
   * Allows an authenticated Rewards User to bulk acknowledge
   * reward offer completions.
   */
  bulkAcknowledgeMyRewardOfferCompletions: Array<RewardOffer>;
  adminBulkCreateOrUpdateRewardOffers?: Maybe<AdminBulkCreateOrUpdateRewardOffersResponse>;
  adminBulkCompleteManualCampaignOffers?: Maybe<AdminBulkCompleteManualCampaignOffersResponse>;
  enableUserEligibilitySettings: UserEligibilitySettings;
  updateUserEligibilitySettings: UserEligibilitySettings;
  disableUserEligibilitySettings: UserEligibilitySettings;
  partialUpdateMyRewardsOrganization: RewardsOrganization;
  /** Mutation to update the EVV rules for the organization */
  updateOrganizationEVVRules: RewardsOrganization;
  /** @deprecated Use referral structure APIs instead */
  updateMyRewardsOrganizationReferralStructureRewardValues: RewardsOrganization;
  partialUpdateMyRewardsOrganizationRedemptionSettings: RewardsOrganization;
  submitBulkRewardsUserUploadFile: BulkRewardsUserUpload;
  /** Manually records an organization onboarding step as completed. */
  markRewardsOrganizationOnboardingStepCompleted: RewardsOrganization;
  /** Create a rewards organization as a superuser */
  retoolCreateRewardsOrganization: RewardsOrganization;
  /**
   * (Deprecated)
   * Launches the rewards organization.
   * @deprecated This is no longer supported; the 'onboarding' flow replaces the launch flow
   */
  launchRewardsOrganization: RewardsOrganization;
  /** Launches organization from Retool. */
  retoolLaunchOrganization: RewardsOrganization;
  /**
   * (Deprecated)
   * Manually records an organization launch step as completed.
   *
   * Note that `JOB_POSTINGS_ADDED` and `REWARDS_USERS_ADDED` cannot be marked as completed.
   * Those steps will be automatically marked as complete when jobs & employees are created.
   * @deprecated This is no longer supported; the 'onboarding' flow replaces the launch flow
   */
  recordCompletedRewardsOrganizationLaunchStep: RewardsOrganization;
  /**
   * Allows an admin to creates a branch for an organization.
   *
   * Depending on the branch's auto membership criteria,
   * users may be automatically assigned to this branch.
   */
  createOrganizationBranch: RewardsOrganizationBranch;
  /**
   * Allows an admin to update a branch for an organization.
   *
   * Depending on the branch's auto membership criteria,
   * users may be automatically assigned to this branch.
   */
  partialUpdateOrganizationBranch: RewardsOrganizationBranch;
  /**
   * Allows a rewards user to acknowledge an offer as "ended",
   * which will ensure they do not receive the congratulations
   * modal a second time (when querying via `listMyPowerHoursOffers`)
   */
  acknowledgePowerHoursOfferEnded: PowerHoursOffer;
  /**
   * Allows a rewards user to acknowledge a level as "finished",
   * which will ensure they do not receive the congratulations
   * modal a second time (when querying via `listMyPowerHoursOffers`)
   */
  acknowledgePowerHoursLevelFinished: PowerHoursOffer;
  /** Attempts to achieve the specified daily reward for the authenticated rewards user. */
  achieveDailyReward?: Maybe<Scalars['Void']>;
  /**
   * Returns the authenticated rewards user's current daily reward.
   * If no reward exists yet for the current day, one is distributed first.
   * If daily rewards are not enabled for the organization, this returns null.
   */
  getOrDistributeMyDailyReward?: Maybe<DailyReward>;
  /**
   * Marks each redemption ID as sent to payroll. If one of them fails,
   * the returned `Redemption` for that index will be `null`,
   * and response errors will be populated.
   */
  bulkMarkRedemptionsAsSentToPayroll?: Maybe<Scalars['Void']>;
  /**
   * Marks each redemption ID as fulfilled. If one of them fails,
   * the returned `Redemption` for that index will be `null`,
   * and response errors will be populated.
   */
  bulkMarkRedemptionsAsFulfilled?: Maybe<Scalars['Void']>;
  /**
   * Marks each redemption ID as paid. If one of them fails,
   * the returned `Redemption` for that index will be `null`,
   * and response errors will be populated.
   */
  bulkMarkRedemptionsAsPaid?: Maybe<Scalars['Void']>;
  /**
   * Marks each redemption as approved. If one of them fails,
   * the returned `Redemption` for that index will be `null`,
   * and response errors will be populated.
   */
  bulkMarkRedemptionsAsApproved?: Maybe<Scalars['Void']>;
  /** Generates a redemption export and a link that can be used to download it */
  generateRewardsRedemptionExport: GenerateRedemptionExportResult;
  /**
   * Marks each redemption ID as generic gift card sent. If one of them fails,
   * the returned `Redemption` for that index will be `null`,
   * and response errors will be populated.
   */
  bulkMarkRedemptionsAsGenericGiftCardSent?: Maybe<Scalars['Void']>;
  /** Queues RedemptionExports for generation, and returns the ID of the exports */
  retoolBulkGenerateRedemptionExport: BulkGenerateRedemptionExportResult;
  rejectRedemptionAndDeductPoint?: Maybe<Scalars['Void']>;
  /**
   * Allows a user to request a point redemption for one or many catalog items.
   *
   * This is only supported if the organization has `CATALOG` as a redemption method.
   *
   * The user must provide an array of catalog item IDs and point amounts for each item.
   */
  requestCatalogRedemption: RewardsUserRedemption;
  /**
   * Allows a full access admin to force a point redemption for a user.
   *
   * This bypasses the minimum redemption threshold.
   * The user must be active (not deactivated) and have points available.
   * All available points for the user will be redeemed.
   *
   * Only CATALOG (gift cards) or PAYROLL redemption methods are supported.
   * If CATALOG is selected, Amazon gift card will be automatically selected from available catalog items.
   */
  forceRedemption: Redemption;
  /** Allows a rewards admin to create a new referral structure. */
  createReferralStructure: ReferralStructure;
  /** Allows a rewards admin to update a referral structure. */
  partialUpdateReferralStructure: ReferralStructure;
  /**
   * Allows Rewards Admins and Superusers to submit a request
   * to generate a report.
   *
   * Currently, only CSVs are supported. Each requested dataset
   * will be generated into its own CSV file.
   */
  submitReportRequest: RewardReport;
  /**
   * Force deducts all available points for a deactivated user.
   *
   * Only admins with full access can trigger this mutation.
   * The user must be deactivated - this mutation will fail if the user is active.
   */
  forceDeductAllPoints?: Maybe<Scalars['Void']>;
  /** Deducts a specific number of points from a user's rewards account. */
  deductPoints?: Maybe<Scalars['Void']>;
  /**
   * Allows a REWARDS_USER to submit an interest in an open shift.
   * @deprecated Use `submitInterestInShiftPosting` instead.
   */
  submitInterestInOpenShift: CaregiverShiftInterest;
  /**
   * Allows a REWARDS_USER to submit interest in specific visits for a shift posting.
   *
   * If they have previously submitted interest in the shift posting, this will
   * replace their previous interest with the newly provided list of visit IDs.
   *
   * If they have previously removed their interest from the shift posting, this
   * will re-instate their interest.
   */
  submitInterestInShiftPosting: NonPhiShiftPosting;
  /**
   * Allows a REWARDS_USER to submit interest in recurring shift patterns for a permanent shift posting.
   *
   * Caregivers select recurring shift patterns (day-of-week + time ranges) rather than specific visit IDs.
   * The backend converts these patterns to the actual visit IDs and submits interest.
   *
   * If they have previously submitted interest in the shift posting, this will
   * replace their previous interest with the newly provided list of recurring shift IDs.
   *
   * If they have previously removed their interest from the shift posting, this
   * will re-instate their interest.
   */
  submitInterestInPermanentShiftPosting: NonPhiShiftPostingCard;
  /**
   * Allows a REWARDS_USER to remove their interest from a shift posting.
   * @deprecated Use removeInterestFromShiftPostingCard instead.
   */
  removeInterestFromShiftPosting: NonPhiShiftPosting;
  /** Allows a REWARDS_USER to remove their interest from a shift posting card. */
  removeInterestFromShiftPostingCard: NonPhiShiftPostingCard;
  /** Allows a REWARDS_USER to submit their caregiver profile, with any subset of the fields. */
  submitMyCaregiverProfile: CaregiverProfile;
  /** Allows a REWARDS_USER to dismiss their caregiver profile before completing it. */
  dismissMyCaregiverProfile: CaregiverProfile;
  /**
   * Allows a REWARDS_USER to dismiss a top shift posting pick (i.e. "Not for me").
   * Returns the updated list of top shift postings.
   */
  dismissMyTopShiftPostingPick: Array<NonPhiShiftPostingCard>;
  /** @deprecated No longer supported (is a NO-OP) */
  regenerateMyShiftPostingMatches?: Maybe<Scalars['Void']>;
  /** Allows a REWARDS_ADMIN to notify caregivers about a shift posting. */
  notifyCaregiversAboutShiftPosting?: Maybe<Scalars['Void']>;
  /** Allows a REWARDS_ADMIN to broadcast a shift posting to caregivers using the new broadcast model. */
  broadcastShiftPostingToCaregivers?: Maybe<Scalars['Void']>;
  /** Allows RETOOL to broadcast an open shift SMS to caregivers. */
  retoolBroadcastOpenShiftToCaregivers?: Maybe<Scalars['Void']>;
  /** For Retool use only. Marks shift booking as launched to coordinators for an organization. */
  retoolLaunchShiftBookingToCoordinators?: Maybe<RetoolShiftBookingSetting>;
  /** For Retool use only. Marks shift booking as launched to caregivers for an organization. */
  retoolLaunchShiftBookingToCaregivers?: Maybe<RetoolShiftBookingSetting>;
  /** Allows a REWARDS_ADMIN to toggle the `doNotAutomaticallyStaff` flag for a patient. */
  toggleDoNotAutomaticallyStaffPHIPatient: PhiPatient;
  /** Allows a REWARDS_ADMIN to manually unmatch a caregiver from a shift posting. */
  unmatchCaregiverFromShiftPosting: PhiCaregiverShiftPostingMatch;
  /** Allows a REWARDS_ADMIN to assign visits to a caregiver in the external scheduling software. */
  assignCaregiverToShiftPostingVisits: AssignCaregiverToShiftPostingVisitsResponse;
  /** Allows a REWARDS_ADMIN to confirm any assigned visits that are pending confirmation. */
  confirmPHIShiftPostingVisits: PhiShiftPosting;
  /** Allows a REWARDS_USER to confirm any of their assigned visits that are pending confirmation. */
  confirmMyAssignedShiftPostingVisits?: Maybe<Scalars['Void']>;
  /**
   * Allows a REWARDS_USER to record a view on multiple shift posting cards.
   * Will update the `lastViewedCardAt` field for the given shift posting cards, in case the view is recorded multiple times.
   */
  recordCaregiverShiftPostingCardView?: Maybe<Scalars['Void']>;
  /**
   * Allows a REWARDS_USER to record a view on shift posting details.
   * Will update the `lastViewedDetails` field for the given shift posting details, in case the view is recorded multiple times.
   */
  recordCaregiverShiftPostingDetailsView?: Maybe<Scalars['Void']>;
  /**
   * Allows a REWARDS_ADMIN to add, update, or remove the rewards for a shift posting visit.
   * These rewards would be earned by the caregiver who works the shift.
   *
   * If `shiftRewardPoints` is `null`, the rewards will be removed from the visit.
   */
  updateShiftRewardForShiftPostingVisit: PhiShiftPosting;
  /**
   * Allows a REWARDS_ADMIN to update the preferred languages for a patient.
   *
   * If the patient has preferred languages set, this will replace the existing
   * preferred languages with the new list.
   *
   * This will override any future language updates being synced from the
   * external scheduling software.
   */
  updatePHIPatientPreferredLanguages: PhiPatient;
  /**
   * Given an array of patient IDs, will re-sync their shifts from the external scheduling software
   * (e.g. HHAeXchange).
   *
   * Returns a list of results by patient, indicating whether the re-sync was successful.
   *
   * As a convenience, also returns the current unarchived shift posting for the patient, if any.
   */
  syncShiftsForPHIPatients: Array<ResyncShiftsForPhiPatientsResult>;
  /**
   * Allows a REWARDS_ADMIN to connect their account to multiple coordinators.
   * This will replace their existing coordinator connections with the provided list.
   */
  connectMyRewardsAdminToCoordinators: RewardsAdminUser;
  /**
   * Allows a REWARDS_ADMIN to manage connections between coordinators and rewards admins.
   * For each coordinator, this will replace their existing admin connections with the provided list.
   */
  connectCoordinatorsToRewardsAdmins?: Maybe<Scalars['Void']>;
  /** Allows a REWARDS_ADMIN to dismiss a caregiver voice callback request. */
  dismissCaregiverVoiceCallback: PhiCaregiverVoiceCallback;
  /**
   * Allows a rewards user to sync and view their latest shift milestone details.
   * If null is returned, shift milestones are disabled for the user.
   */
  resyncMyShiftMilestones?: Maybe<RewardsUserShiftMilestoneDetails>;
  publishCustomSocialPost: SocialPost;
  recordReaction: SocialPost;
  removeReaction: SocialPost;
  /**
   * Records post view of a user, for multiple posts.
   * Intended to be used for batching, but we're only supporting one post view per user in MVP.
   */
  recordViews: Array<SocialPost>;
  /** Updates the social feed settings for an organization. */
  updateOrganizationSocialFeedSettings: OrganizationSocialFeedSettings;
  /**
   * Allows admins to create or update their organization's first shift survey settings.
   * If settings don't exist, they will be created (enabled by default).
   * If settings exist and are disabled, this mutation will re-enable them.
   *
   * Email addresses to receive notifications when negative survey responses occur.
   * At least one email must be provided when creating settings for the first time.
   *
   * negativeAnswerScoreThresholdInclusive sets the survey answer score threshold for triggering an email to Admins.
   * If at least one survey answer score is less than or equal to this value, an email will be sent. Defaults to 2.
   * Answer scores range from 1 (strongly disagree) to 5 (strongly agree).
   *
   * segmentByBranch determines whether to segment negative response emails by the RewardsUser's branch.
   * If true:
   * - Email addresses not associated with an Admin will receive the email regardless of the RewardsUser's branch.
   * - Admins who are assigned to all branches will receive the email regardless of the RewardsUser's branch.
   * - Admins who are assigned to the same branch as the RewardsUser will receive the email.
   * - Admins who are not assigned to the RewardsUser's branch will not receive the email.
   * If false (default):
   * - The email will be sent to all email addresses present in the sendToEmails list.
   */
  updateMyOrganizationFirstShiftSurveySettings: OrganizationFirstShiftSurveySettings;
  /**
   * Allows admins to disable their organization's first shift survey.
   * The settings are preserved but the feature is turned off.
   */
  disableMyOrganizationFirstShiftSurveySettings: OrganizationFirstShiftSurveySettings;
  authenticateRewardsUserLoginToken: RewardsUserLoginResponse;
  /**
   * Creates a login challenge for the given login token ID (when re-authing)
   * an SMS with the challenge verification code.
   *
   * A `loginTokenId` or `userId` can be provided in order to
   * identify the user to be logged in.
   */
  createRewardsUserTokenReauthChallenge: CreateRewardsUserSmsLoginChallengeResponse;
  /**
   * Creates a login challenge for the given phone number and sends
   * an SMS with the challenge verification code.
   */
  createRewardsUserSMSLoginChallenge: CreateRewardsUserSmsLoginChallengeResponse;
  /**
   * Completes a login challenge for the given challenge id
   * and attempted verification code
   */
  completeRewardsUserSMSLoginChallenge: RewardsUserLoginResponse;
  /**
   * Redeems points for a rewards user.
   *
   * Note - this is only supported for non-CATALOG redemptions.
   * Use `requestCatalogRedemption` to redeem for catalog items.
   */
  redeemPoints: RewardsUser;
  /**
   * Resends a generic gift card link to a rewards user.
   *
   * Note - this is only supported for legacy generic gift card redemptions.
   * Use `resendCatalogGiftCardOrder` to resend a link for a catalog gift card.
   */
  resendGenericGiftCardLink?: Maybe<Scalars['Void']>;
  /**
   * Resends a catalog gift card to a rewards user.
   *
   * Note - this is only supported for catalog gift card redemptions.
   */
  resendCatalogGiftCardOrder?: Maybe<Scalars['Void']>;
  setMyRewardsUserLocale: RewardsUser;
  /**
   * Allows a user to "opt in" to Caribou Rewards by providing their personal information.
   * If this succeeds, the user will receive a login link to their personal email and phone number.
   *
   * This is a public query (doesn't require authentication).
   */
  optInWithPersonalInformation?: Maybe<Scalars['Void']>;
  /**
   * Allows a rewards admin to create a rewards user's account.
   *
   * If personal information is provided, both email and phone number are required.
   * If no personal information is provided, only work email is required.
   *
   * If a personal information is provided, the user will be sent an activation email & SMS.
   * If no personal information is provided, the user will be sent an invitation to opt-in (to their work email and phone).
   *
   * Various errors may be thrown, such as if an email or phone number belongs to
   * another user's account.
   */
  createRewardsUser: RewardsUser;
  /**
   * Creates a daily check-in for the authenticated rewards user.
   * This mutation is scoped to the currently authenticated user and does not allow creating check-ins for other users.
   *
   * Returns:
   * - `true` if the check-in was successfully recorded.
   * - `false` if a check-in already exists for the specified date.
   */
  createMyRewardsUserAppDailyCheckIn: Scalars['Boolean'];
  /** Allows a rewards admin to update a rewards user's contact information */
  updateRewardsUserInformation: RewardsUser;
  adminBulkCreateRewardsUsers?: Maybe<AdminBulkCreateRewardsUserResponse>;
  adminBulkUpdateRewardsUsers?: Maybe<AdminBulkUpdateRewardsUserResponse>;
  /** Generates a rewards users export CSV and returns the download link for it */
  generateRewardsUserExport?: Maybe<GenerateRewardsUserExportResponse>;
  /** Awards points to rewards user for completing a welcome offer */
  completeWelcomeOffer: RewardsUser;
  /** Enables creating a new RewardsUser with previously used email/phone on QA or Demo orgs. */
  retoolCreateQARewardsUser: RewardsUser;
  /** Allows a rewards user to update their personal email address */
  updateMyRewardsUserEmail: RewardsUser;
  markRewardVideoUploaded: RewardVideo;
  markRewardVideoDeleted: RewardVideo;
  /** @deprecated Use 'createPresignedVideoUploadUrlV2' instead */
  createPresignedVideoUploadUrl: CreatePresignedVideoUploadUrlResponse;
  /** Creates a presigned video upload URL for a video aggregate. */
  createPresignedVideoUploadUrlV2: CreatePresignedVideoUploadUrlResponse;
  recordVideoWatchByMe: RecordVideoWatchByMeResponse;
  markRewardVideoOfferWatched: RewardVideoOffer;
  adminBulkCreateOrUpdateVideoOffers?: Maybe<AdminBulkCreateOrUpdateVideoOffersResponse>;
  /** Creates a fake visit for a RewardsUser identified by email in a QA/Demo Organization. Useful for testing visit-based features. */
  retoolCreateQAVisit: RetoolCreateQaVisitResult;
  retoolSignalVisitLoadComplete: RetoolSignalVisitLoadCompleteResponse;
  /**
   * Fetches the authenticated user's visits in the requested date range,
   * resyncing them from the external scheduling system if applicable.
   */
  resyncMyVisitsInRange: Array<Visit>;
  /**
   * Fetches the authenticated user's visits associated with a specific patient in the requested
   * date range, resyncing them from the external scheduling system if applicable.
   *
   * The patient is identified as the patient associated to the provided visit ID.
   */
  resyncMyVisitsForPHIPatientFromVisitId: ResyncMyVisitsForPhiPatientResult;
  applyToSchoolsEmployer?: Maybe<Scalars['Void']>;
  signUpAsSchoolsStudent: SchoolsStudentLoginResponse;
  authenticateSchoolsStudentLoginToken: SchoolsStudentLoginResponse;
  createSchoolsStudentApplication: SchoolsJobApplication;
};


export type MutationUploadBulkImportArgs = {
  type: BulkImportType;
  items: Array<Scalars['JSONObject']>;
};


export type MutationGenerateEmployeeImpersonationLoginLinkArgs = {
  employeeId: Scalars['ID'];
};


export type MutationRetoolGenerateExternalApiCredentialsArgs = {
  organizationId: Scalars['ID'];
};


export type MutationRetoolGenerateExternalSqsCredentialsArgs = {
  organizationId: Scalars['ID'];
};


export type MutationTrackCaribouRewardsPrototypeActionArgs = {
  accessCode: Scalars['String'];
  recruitmentStep: CaribouRewardsPrototypeRecruitmentStep;
};


export type MutationCreateRewardsAdminArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  permissions: RewardsAdminPermissionsInput;
  branchIds?: Maybe<Array<Scalars['ID']>>;
  role?: Maybe<RewardsAdminRoleType>;
  automaticRecognitionBudgetConfig?: Maybe<RewardsAdminAutomaticRecognitionBudgetConfigInput>;
  shiftRewardBudgetConfig?: Maybe<RewardsAdminShiftRewardBudgetConfigInput>;
};


export type MutationUpdateRewardsAdminArgs = {
  userId: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<RewardsAdminPermissionsInput>;
  branchIds?: Maybe<Array<Scalars['ID']>>;
  role?: Maybe<RewardsAdminRoleType>;
  automaticRecognitionBudgetConfig?: Maybe<RewardsAdminAutomaticRecognitionBudgetConfigInput>;
  shiftRewardBudgetConfig?: Maybe<RewardsAdminShiftRewardBudgetConfigInput>;
};


export type MutationSendLoginLinkToEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type MutationSendInvitationLinkToEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type MutationSendOpenShiftsPageLinkToEmployeeArgs = {
  employeeId: Scalars['ID'];
};


export type MutationGenerateAndSendRewardsAdminTemporaryPasswordArgs = {
  adminId: Scalars['ID'];
};


export type MutationLaunchNewAdminGoalConfigArgs = {
  adminIds: Array<Scalars['ID']>;
  goalType: AdminGoalType;
  rewards: AdminGoalRewardsInput;
  target: AdminGoalTargetInput;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type MutationEnableNewOrganizationAdminGoalConfigArgs = {
  adminIds?: Maybe<Array<Scalars['ID']>>;
  goalType: AdminGoalType;
  rewards?: Maybe<AdminGoalRewardsInput>;
  target?: Maybe<AdminGoalTargetInput>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  recurring: Scalars['Boolean'];
  configMode?: Maybe<AdminGoalConfigMode>;
  branchConfigs?: Maybe<Array<OrganizationAdminGoalBranchConfigInput>>;
};


export type MutationPartialUpdateOrganizationAdminGoalConfigArgs = {
  configId: Scalars['ID'];
  recurring?: Maybe<Scalars['Boolean']>;
  updateTargets: Array<AdminGoalUpdateTarget>;
  props: AdminGoalUpdateInput;
};


export type MutationDisableOrganizationAdminGoalConfigArgs = {
  configId: Scalars['ID'];
};


export type MutationUpdateScheduledRecognitionPointsMessageArgs = {
  recognitionPointsId: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationAwardRecognitionArgs = {
  reward: RecognitionRewardInput;
  userId: Scalars['ID'];
  messageToUser: Scalars['String'];
  from: Scalars['String'];
  mustBeClaimed?: Maybe<Scalars['Boolean']>;
  categoryId?: Maybe<Scalars['ID']>;
};


export type MutationAwardUserBonusPointsArgs = {
  amount: Scalars['Int'];
  userId: Scalars['ID'];
  messageToUser: Scalars['String'];
  from: Scalars['String'];
  mustBeClaimed?: Maybe<Scalars['Boolean']>;
  categoryId?: Maybe<Scalars['ID']>;
};


export type MutationAwardBonusPointsArgs = {
  amount: Scalars['Int'];
  userId: Scalars['ID'];
  messageToUser: Scalars['String'];
  from: Scalars['String'];
};


export type MutationBulkClaimBonusPointsArgs = {
  bonusPointsIds: Array<Scalars['ID']>;
};


export type MutationBulkClaimRecognitionPointsArgs = {
  recognitionPointsIds: Array<Scalars['ID']>;
};


export type MutationCreateRecognitionCategoryArgs = {
  name: Scalars['String'];
  defaultPointAmount?: Maybe<Scalars['Int']>;
  disableSendFromManagers?: Maybe<Scalars['Boolean']>;
};


export type MutationPartialUpdateRecognitionCategoryArgs = {
  recognitionCategoryId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  defaultPointAmount?: Maybe<Scalars['Int']>;
  disableSendFromManagers?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteRecognitionCategoryArgs = {
  recognitionCategoryId: Scalars['ID'];
};


export type MutationUploadBulkRecognitionFileArgs = {
  bulkRecognitionFile: Scalars['Upload'];
  requestId: Scalars['String'];
  from: Scalars['String'];
  categoryId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  previewTotals: BulkRecognitionUploadPreviewTotals;
};


export type MutationRecordRecognitionLikeArgs = {
  recognitionId?: Maybe<Scalars['ID']>;
  recognitionPointsId?: Maybe<Scalars['ID']>;
};


export type MutationRecordRecognitionPointsLikeArgs = {
  recognitionPointsId: Scalars['ID'];
};


export type MutationRecordRecognitionFirstViewArgs = {
  recognitionId?: Maybe<Scalars['ID']>;
  recognitionPointsId?: Maybe<Scalars['ID']>;
};


export type MutationRecordRecognitionPointsFirstViewArgs = {
  recognitionPointsId: Scalars['ID'];
};


export type MutationAddCandidateArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  referredByUserId: Scalars['ID'];
  appledToJobPostingId: Scalars['ID'];
  appliedOnDate: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};


export type MutationRecordCandidateRecruitmentStepArgs = {
  candidateId: Scalars['ID'];
  step: CandidateRecruitmentStepName;
};


export type MutationRecordCandidateRetentionStepArgs = {
  candidateId: Scalars['ID'];
  durationMonths: Scalars['Int'];
};


export type MutationRecordCandidateHourlyRetentionStepArgs = {
  candidateId: Scalars['ID'];
  durationHours: Scalars['Int'];
};


export type MutationUndoCandidateRecruitmentStepArgs = {
  candidateId: Scalars['ID'];
  step: CandidateRecruitmentStepName;
};


export type MutationArchiveCandidateArgs = {
  candidateId: Scalars['ID'];
  updatedAdminNotes?: Maybe<Scalars['String']>;
  reason?: Maybe<CandidateArchiveReason>;
};


export type MutationBulkArchiveCandidatesArgs = {
  candidateIds: Array<Scalars['ID']>;
  reason?: Maybe<CandidateArchiveReason>;
};


export type MutationReopenCandidateArgs = {
  candidateId: Scalars['ID'];
};


export type MutationUpdateCandidateAdminNotesArgs = {
  candidateId: Scalars['ID'];
  adminNotes: Scalars['String'];
};


export type MutationAssignCandidateToJobPostingArgs = {
  candidateId: Scalars['ID'];
  jobPostingId: Scalars['ID'];
};


export type MutationMergeCandidatesArgs = {
  fromCandidateIds: Array<Scalars['ID']>;
  toCandidateId: Scalars['ID'];
};


export type MutationSendCandidateResumeReminderArgs = {
  candidateId: Scalars['ID'];
};


export type MutationCorrectCandidateReferredByUserArgs = {
  candidateId: Scalars['ID'];
  referredByUserId: Scalars['ID'];
};


export type MutationLinkCandidateToEmployeeArgs = {
  candidateId: Scalars['ID'];
  employeeId: Scalars['ID'];
};


export type MutationUploadCandidateResumeArgs = {
  candidateId: Scalars['ID'];
  resume: Scalars['Upload'];
};


export type MutationMarkCaregiverImpactSlideAsOpenedArgs = {
  caregiverImpactMonthId: Scalars['ID'];
  slideId: Scalars['ID'];
};


export type MutationMarkCaregiverImpactMonthAsFinishedArgs = {
  caregiverImpactMonthId: Scalars['ID'];
};


export type MutationMarkCaregiverImpactMonthAnnouncementModalAsAcknowledgedArgs = {
  caregiverImpactMonthId: Scalars['ID'];
};


export type MutationCognitoSendTemporaryPasswordEmailArgs = {
  userId: Scalars['ID'];
  encryptedTemporaryPasswordCode: Scalars['String'];
};


export type MutationCognitoSendPasswordResetCodeEmailArgs = {
  userId: Scalars['ID'];
  encryptedCode: Scalars['String'];
};


export type MutationCognitoSendRewardsAdminSmsVerificationCodeArgs = {
  adminId: Scalars['ID'];
  phoneNumber: Scalars['String'];
  encryptedCode: Scalars['String'];
};


export type MutationCognitoTrackLoginArgs = {
  userId: Scalars['ID'];
};


export type MutationCustomerIoGenerateRewardsUserLoginLinkArgs = {
  userId: Scalars['ID'];
  organizationId?: Maybe<Scalars['Int']>;
  currentLoginLink?: Maybe<Scalars['String']>;
  format: RewardsUserLoginLinkFormat;
  shorten?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
};


export type MutationScheduleDrawArgs = {
  prizeStructure: DrawPrizeStructureInput;
  name: Scalars['String'];
  start: Scalars['Timestamp'];
  end: Scalars['Timestamp'];
  announcementVideoId?: Maybe<Scalars['ID']>;
};


export type MutationScheduleDrawV2Args = {
  prizeStructure: Array<DrawPrizeStructureInput>;
  name: Scalars['String'];
  start: Scalars['Timestamp'];
  end: Scalars['Timestamp'];
  announcementVideoId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateDrawArgs = {
  drawId: Scalars['ID'];
  prizeStructure?: Maybe<DrawPrizeStructureInput>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Timestamp']>;
  end?: Maybe<Scalars['Timestamp']>;
};


export type MutationUpdateDrawV2Args = {
  drawId: Scalars['ID'];
  prizeStructure?: Maybe<Array<DrawPrizeStructureInput>>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Timestamp']>;
  end?: Maybe<Scalars['Timestamp']>;
  announcementVideoId?: Maybe<Scalars['ID']>;
};


export type MutationDeleteDrawArgs = {
  drawId: Scalars['ID'];
};


export type MutationApproveDrawWinnersArgs = {
  drawId: Scalars['ID'];
  winnerIds: Array<Scalars['ID']>;
  prizeTierIndexes?: Maybe<Array<Scalars['Int']>>;
};


export type MutationMarkDrawWinnersAsViewedArgs = {
  drawId: Scalars['ID'];
};


export type MutationClaimDrawPrizeArgs = {
  drawId: Scalars['ID'];
};


export type MutationRedrawWinnerArgs = {
  drawId: Scalars['ID'];
  winnerId: Scalars['ID'];
};


export type MutationUpdateOrganizationDrawSettingsArgs = {
  config: AutomatedDrawConfigInput;
};


export type MutationAcknowledgeEvvCompletionRateOfferEndedArgs = {
  evvCompletionRateOfferId: Scalars['ID'];
};


export type MutationAcknowledgeGoalAchievementArgs = {
  goalId: Scalars['ID'];
};


export type MutationEvaluateGoalArgs = {
  goalId: Scalars['ID'];
};


export type MutationActivateGoalArgs = {
  goalId: Scalars['ID'];
};


export type MutationUpdateGoalAvailabilityArgs = {
  goalId: Scalars['ID'];
  availability: Scalars['String'];
};


export type MutationRetoolInitializeGoalsConfigForOrganizationArgs = {
  organizationId: Scalars['ID'];
  distributionType: GoalDistributionType;
};


export type MutationRetoolUpdateGoalsConfigForOrganizationArgs = {
  organizationId: Scalars['ID'];
  distributionType?: Maybe<GoalDistributionType>;
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
  welcomeVideoGoalDistributionConfig?: Maybe<WelcomeVideoGoalDistributionConfigInput>;
  jobShareGoalDistributionConfig?: Maybe<JobShareGoalDistributionConfigInput>;
  evvGoalDistributionConfig?: Maybe<EvvGoalDistributionConfigInput>;
  pulseCheckSurveyGoalDistributionConfig?: Maybe<PulseCheckSurveyGoalDistributionConfigInput>;
  weekendShiftGoalDistributionConfig?: Maybe<WeekendShiftGoalDistributionConfigInput>;
  lastMinuteShiftGoalDistributionConfig?: Maybe<LastMinuteShiftGoalDistributionConfigInput>;
  billableHoursGoalDistributionConfig?: Maybe<BillableHoursGoalDistributionConfigInput>;
  welcomeGoalDistributionConfig?: Maybe<WelcomeGoalDistributionConfigInput>;
};


export type MutationPartialUpdateMyOrganizationPulseCheckSurveyGoalsConfigArgs = {
  pulseSurveyConfig: PulseCheckSurveyGoalDistributionConfigAdminInput;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
};


export type MutationPartialUpdateMyOrganizationQuickCheckSurveyGoalsConfigArgs = {
  quickCheckSurveyConfig: QuickCheckSurveyGoalDistributionConfigAdminInput;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
};


export type MutationPartialUpdateMyOrganizationBirthdayGoalConfigArgs = {
  birthdayGoalConfig: BirthdayGoalDistributionConfigAdminInput;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
};


export type MutationPartialUpdateMyOrganizationAnniversaryGoalConfigArgs = {
  anniversaryGoalConfig: AnniversaryGoalDistributionConfigAdminInput;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
};


export type MutationPartialUpdateMyOrganizationEvvGoalConfigArgs = {
  evvGoalConfig: EvvGoalDistributionConfigAdminInput;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
};


export type MutationDisableMyOrganizationEvvGoalConfigArgs = {
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
};


export type MutationDisableMyOrganizationBirthdayGoalConfigArgs = {
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
};


export type MutationDisableMyOrganizationAnniversaryGoalConfigArgs = {
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
};


export type MutationDisableMyOrganizationPulseCheckSurveyGoalsConfigArgs = {
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
};


export type MutationDisableMyOrganizationQuickCheckSurveyGoalsConfigArgs = {
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
};


export type MutationPartialUpdateMyOrganizationWelcomeGoalConfigArgs = {
  welcomeGoalConfig: WelcomeGoalDistributionConfigAdminInput;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
};


export type MutationDisableMyOrganizationWelcomeGoalConfigArgs = {
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
};


export type MutationPartialUpdateMyOrganizationWelcomeVideoGoalConfigArgs = {
  welcomeVideoGoalConfig: WelcomeVideoGoalDistributionConfigAdminInput;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
};


export type MutationDisableMyOrganizationWelcomeVideoGoalConfigArgs = {
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
};


export type MutationCreateRewardsGroupArgs = {
  input: CreateRewardsGroupInput;
};


export type MutationEnableCaribouUserSyncForHhaxIntegrationArgs = {
  hhaxIntegrationId: Scalars['ID'];
  filters: HhaxCaribouUserSyncFiltersInput;
};


export type MutationUpdateHhaxCaribouUserSyncFiltersArgs = {
  userSyncId: Scalars['ID'];
  filters: HhaxCaribouUserSyncFiltersInput;
};


export type MutationRetoolUpdateQahhaxCaregiverArgs = {
  organizationId: Scalars['ID'];
  email: Scalars['String'];
  savedFields: HhaxCaregiverInput;
};


export type MutationSubmitJobApplicationArgs = {
  jobPostingId?: Maybe<Scalars['ID']>;
  jobShareId?: Maybe<Scalars['ID']>;
  referringUserId?: Maybe<Scalars['ID']>;
  locale?: Maybe<Locale>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  residingCity?: Maybe<Scalars['String']>;
  hasDriversLicenseAndAccessToCar?: Maybe<JobApplicationDriversLicenseAnswer>;
  yearsOfExperience?: Maybe<JobApplicationYearsOfExperienceAnswer>;
  yesNoAnswers?: Maybe<Array<SubmissionYesNoFieldAnswerInput>>;
};


export type MutationUploadJobApplicationResumeArgs = {
  applicationSubmissionId?: Maybe<Scalars['ID']>;
  candidateId?: Maybe<Scalars['ID']>;
  applicantUploadToken: Scalars['String'];
  resume: Scalars['Upload'];
};


export type MutationCreateJobPostingArgs = {
  branchId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  hoursRequired: Scalars['String'];
  ratesOfPay?: Maybe<Scalars['String']>;
  geography: Scalars['String'];
  descriptionHTML: Scalars['String'];
  screenerQuestions?: Maybe<Array<JobPostingScreenerQuestionInput>>;
  candidateAlertEmails?: Maybe<Array<Scalars['String']>>;
  candidateAlertEmail?: Maybe<Scalars['String']>;
  wasDuplicatedFromJobPostingId?: Maybe<Scalars['ID']>;
  customizedApplicantEmailMessage?: Maybe<Scalars['String']>;
  customizedApplicantSMSMessage?: Maybe<Scalars['String']>;
  interviewBookingLink?: Maybe<InterviewBookingLink>;
  referralStructureId?: Maybe<Scalars['ID']>;
  fieldConfiguration?: Maybe<Array<JobPostingFieldConfigurationInput>>;
  externalId?: Maybe<Scalars['String']>;
  externalAtsIntegrationId?: Maybe<Scalars['String']>;
};


export type MutationUpdateJobPostingArgs = {
  jobPostingId: Scalars['ID'];
  branchId?: Maybe<Scalars['ID']>;
  referralStructureId?: Maybe<Scalars['ID']>;
  hoursRequired: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  ratesOfPay?: Maybe<Scalars['String']>;
  geography: Scalars['String'];
  descriptionHTML: Scalars['String'];
  screenerQuestions?: Maybe<Array<JobPostingScreenerQuestionInput>>;
  candidateAlertEmails?: Maybe<Array<Scalars['String']>>;
  candidateAlertEmail?: Maybe<Scalars['String']>;
  customizedApplicantEmailMessage?: Maybe<Scalars['String']>;
  customizedApplicantSMSMessage?: Maybe<Scalars['String']>;
  interviewBookingLink?: Maybe<InterviewBookingLink>;
  fieldConfiguration?: Maybe<Array<JobPostingFieldConfigurationInput>>;
  externalId?: Maybe<Scalars['String']>;
  externalAtsIntegrationId?: Maybe<Scalars['String']>;
};


export type MutationCloseJobPostingArgs = {
  jobPostingId: Scalars['ID'];
};


export type MutationReopenJobPostingArgs = {
  jobPostingId: Scalars['ID'];
};


export type MutationStartJobPostingPromotionArgs = {
  jobPostingId: Scalars['ID'];
};


export type MutationStopJobPostingPromotionArgs = {
  jobPostingId: Scalars['ID'];
};


export type MutationConnectJobPostingToAtsJobArgs = {
  jobPostingId: Scalars['ID'];
  externalJobId: Scalars['String'];
  externalAtsIntegrationId: Scalars['String'];
};


export type MutationCreateJobShareLinkArgs = {
  jobPostingId: Scalars['ID'];
};


export type MutationMarkJobSharedArgs = {
  jobShareId: Scalars['ID'];
  platform: SharePlatform;
};


export type MutationUpdateOrganizationMilestoneRewardSettingsArgs = {
  milestones?: Maybe<Array<OrganizationMilestoneRewardInput>>;
  evvComplianceEnforced?: Maybe<Scalars['Boolean']>;
  backfillConfig?: Maybe<OrganizationMilestoneRewardBackfillConfigInput>;
};


export type MutationEnableOrganizationMilestoneRewardSettingsArgs = {
  milestones?: Maybe<Array<OrganizationMilestoneRewardInput>>;
  evvComplianceEnforced?: Maybe<Scalars['Boolean']>;
  backfillConfig?: Maybe<OrganizationMilestoneRewardBackfillConfigInput>;
};


export type MutationTriggerBackfillRewardsPreviewCalculationArgs = {
  milestones: Array<OrganizationMilestoneRewardInput>;
};


export type MutationBulkAcknowledgeMyRewardOfferCompletionsArgs = {
  data: Array<BulkAcknowledgeMyRewardOfferCompletionsData>;
};


export type MutationAdminBulkCreateOrUpdateRewardOffersArgs = {
  data: Array<AdminBulkCreateOrUpdateRewardOfferInputItem>;
};


export type MutationAdminBulkCompleteManualCampaignOffersArgs = {
  data: Array<AdminBulkCompleteManualCampaignOfferInputItem>;
};


export type MutationEnableUserEligibilitySettingsArgs = {
  externalIntegrationId: Scalars['String'];
  filters: UserEligibilityFiltersInput;
};


export type MutationUpdateUserEligibilitySettingsArgs = {
  externalIntegrationId: Scalars['String'];
  filters: UserEligibilityFiltersInput;
};


export type MutationDisableUserEligibilitySettingsArgs = {
  externalIntegrationId: Scalars['String'];
};


export type MutationPartialUpdateMyRewardsOrganizationArgs = {
  timezone?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  longName?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<MailingAddressInput>;
  websiteUrl?: Maybe<Scalars['String']>;
  emailBannerLogoImage?: Maybe<Scalars['Upload']>;
  workEmailDomain?: Maybe<Scalars['String']>;
  jobPostingThemeColor?: Maybe<Scalars['String']>;
  jobPostingBannerImage?: Maybe<Scalars['Upload']>;
  jobPostingLogoImage?: Maybe<Scalars['Upload']>;
  jobPostingLocationField?: Maybe<JobPostingLocationField>;
  jobShareStructure?: Maybe<PartialUpdateOrganizationJobShareStructureInput>;
  onboardingBusinessType?: Maybe<RewardsOrganizationOnboardingBusinessType>;
  onboardingBusinessRegistrationNumber?: Maybe<Scalars['String']>;
  onboardingCommitmentToSuccess?: Maybe<RewardsOrganizationOnboardingCommitmentToSuccess>;
  onboardingChampions?: Maybe<Array<RewardsOrganizationOnboardingChampionInput>>;
  onboardingWantsAutomatedBirthdayRecognition?: Maybe<Scalars['Boolean']>;
  onboardingWantsAutomatedAnniversaryRecognition?: Maybe<Scalars['Boolean']>;
  onboardingTargetLaunchDate?: Maybe<Scalars['Date']>;
  payrollFrequency?: Maybe<RewardsOrganizationPayrollFrequency>;
  leaderboardEmailContact?: Maybe<RewardsOrganizationLeaderboardEmailContactInput>;
};


export type MutationUpdateOrganizationEvvRulesArgs = {
  newRules: EvvRulesInput;
};


export type MutationUpdateMyRewardsOrganizationReferralStructureRewardValuesArgs = {
  input: UpdateReferralStructureInput;
};


export type MutationPartialUpdateMyRewardsOrganizationRedemptionSettingsArgs = {
  minimumPointsNeededToRedeem?: Maybe<Scalars['Int']>;
  redemptionSummaryNotificationEmails?: Maybe<Array<Scalars['String']>>;
};


export type MutationSubmitBulkRewardsUserUploadFileArgs = {
  file: Scalars['Upload'];
};


export type MutationMarkRewardsOrganizationOnboardingStepCompletedArgs = {
  step: RewardsOrganizationOnboardingStepName;
};


export type MutationRetoolCreateRewardsOrganizationArgs = {
  shortName: Scalars['String'];
  country: RewardsOrganizationCountry;
  isQA: Scalars['Boolean'];
  isDemo: Scalars['Boolean'];
  redemptionMethods: Array<RedemptionMethod>;
  disabledOnboarding: Scalars['Boolean'];
  socialFeedEnabled?: Maybe<Scalars['Boolean']>;
  caregiverImpactEnabled?: Maybe<Scalars['Boolean']>;
  drawsEnabled: Scalars['Boolean'];
  recognitionBudgetsEnabled: Scalars['Boolean'];
  automaticRecognitionBudgetConfig?: Maybe<RewardsOrganizationAutomaticRecognitionBudgetConfigInput>;
  parentOrganizationId?: Maybe<Scalars['ID']>;
};


export type MutationRetoolLaunchOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type MutationRecordCompletedRewardsOrganizationLaunchStepArgs = {
  step: RewardsOrganizationLaunchStep;
};


export type MutationCreateOrganizationBranchArgs = {
  name: Scalars['String'];
  autoMembershipTagCriteriaV1?: Maybe<RewardsGroupTagsConfigSchemaV1Input>;
  timezone?: Maybe<Scalars['String']>;
};


export type MutationPartialUpdateOrganizationBranchArgs = {
  branchId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  autoMembershipTagCriteriaV1?: Maybe<RewardsGroupTagsConfigSchemaV1Input>;
  timezone?: Maybe<Scalars['String']>;
};


export type MutationAcknowledgePowerHoursOfferEndedArgs = {
  powerHoursOfferId: Scalars['ID'];
};


export type MutationAcknowledgePowerHoursLevelFinishedArgs = {
  powerHoursOfferId: Scalars['ID'];
  levelNumber: Scalars['Int'];
};


export type MutationAchieveDailyRewardArgs = {
  dailyRewardId: Scalars['ID'];
};


export type MutationBulkMarkRedemptionsAsSentToPayrollArgs = {
  redemptionIds: Array<Scalars['ID']>;
};


export type MutationBulkMarkRedemptionsAsFulfilledArgs = {
  redemptionIds: Array<Scalars['ID']>;
};


export type MutationBulkMarkRedemptionsAsPaidArgs = {
  redemptionIds: Array<Scalars['ID']>;
};


export type MutationBulkMarkRedemptionsAsApprovedArgs = {
  redemptionIds: Array<Scalars['ID']>;
};


export type MutationGenerateRewardsRedemptionExportArgs = {
  redemptionIds: Array<Scalars['ID']>;
};


export type MutationBulkMarkRedemptionsAsGenericGiftCardSentArgs = {
  redemptionIds: Array<Scalars['ID']>;
};


export type MutationRetoolBulkGenerateRedemptionExportArgs = {
  input: Array<BulkGenerateRedemptionExportInput>;
};


export type MutationRejectRedemptionAndDeductPointArgs = {
  input: RejectRedemptionAndDeductPointInput;
};


export type MutationRequestCatalogRedemptionArgs = {
  items: Array<RedemptionCatalogItemInput>;
};


export type MutationForceRedemptionArgs = {
  input: ForceRedemptionInput;
};


export type MutationCreateReferralStructureArgs = {
  name: Scalars['String'];
  structure: ReferralStructureInput;
};


export type MutationPartialUpdateReferralStructureArgs = {
  referralStructureId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  structure?: Maybe<ReferralStructureInput>;
};


export type MutationSubmitReportRequestArgs = {
  dataSets: Array<RewardReportDataSetConfigInput>;
};


export type MutationForceDeductAllPointsArgs = {
  input: ForceDeductAllPointsInput;
};


export type MutationDeductPointsArgs = {
  input: DeductPointsInput;
};


export type MutationSubmitInterestInOpenShiftArgs = {
  visitId: Scalars['String'];
};


export type MutationSubmitInterestInShiftPostingArgs = {
  shiftPostingId: Scalars['ID'];
  interestedShiftPostingVisitIds: Array<Scalars['ID']>;
};


export type MutationSubmitInterestInPermanentShiftPostingArgs = {
  shiftPostingId: Scalars['ID'];
  interestedRecurringShiftIds: Array<Scalars['ID']>;
};


export type MutationRemoveInterestFromShiftPostingArgs = {
  shiftPostingId: Scalars['ID'];
};


export type MutationRemoveInterestFromShiftPostingCardArgs = {
  shiftPostingId: Scalars['ID'];
  cardType: CaregiverProfileShiftTypePreference;
};


export type MutationSubmitMyCaregiverProfileArgs = {
  profile: CaregiverProfileInput;
};


export type MutationDismissMyTopShiftPostingPickArgs = {
  shiftPostingId: Scalars['ID'];
};


export type MutationNotifyCaregiversAboutShiftPostingArgs = {
  shiftPostingId: Scalars['ID'];
  caregiverUserIds: Array<Scalars['ID']>;
};


export type MutationBroadcastShiftPostingToCaregiversArgs = {
  organizationId: Scalars['Int'];
  shiftPostingId: Scalars['ID'];
  caregiverUserIds: Array<Scalars['ID']>;
  sentBy: BroadcastSentByType;
  channel: BroadcastChannel;
};


export type MutationRetoolBroadcastOpenShiftToCaregiversArgs = {
  organizationId: Scalars['String'];
  visitExternalId: Scalars['String'];
  caregiverUserIds: Array<Scalars['String']>;
  adminEmailsToAlert: Array<Scalars['String']>;
  broadcastNotes?: Maybe<Scalars['String']>;
};


export type MutationRetoolLaunchShiftBookingToCoordinatorsArgs = {
  organizationId: Scalars['ID'];
};


export type MutationRetoolLaunchShiftBookingToCaregiversArgs = {
  organizationId: Scalars['ID'];
};


export type MutationToggleDoNotAutomaticallyStaffPhiPatientArgs = {
  phiPatientId: Scalars['String'];
  doNotAutomaticallyStaff: Scalars['Boolean'];
  phiAccessReason: Scalars['String'];
};


export type MutationUnmatchCaregiverFromShiftPostingArgs = {
  shiftPostingId: Scalars['ID'];
  caregiverUserId: Scalars['ID'];
  unmatchReason: CaregiverShiftPostingUnmatchReasonInput;
  doShareUnmatchReasonWithCaregiver?: Maybe<Scalars['Boolean']>;
  phiAccessReason: Scalars['String'];
};


export type MutationAssignCaregiverToShiftPostingVisitsArgs = {
  shiftPostingId: Scalars['ID'];
  caregiverUserId: Scalars['ID'];
  shiftPostingVisitIds: Array<Scalars['ID']>;
  caregiverPayCodeId?: Maybe<Scalars['Int']>;
  requiresConfirmation?: Maybe<Scalars['Boolean']>;
  phiAccessReason: Scalars['String'];
};


export type MutationConfirmPhiShiftPostingVisitsArgs = {
  shiftPostingId: Scalars['ID'];
  shiftPostingVisitIds: Array<Scalars['ID']>;
  phiAccessReason: Scalars['String'];
};


export type MutationConfirmMyAssignedShiftPostingVisitsArgs = {
  shiftPostingVisitIds: Array<Scalars['ID']>;
};


export type MutationRecordCaregiverShiftPostingCardViewArgs = {
  shiftPostingIds: Array<Scalars['ID']>;
};


export type MutationRecordCaregiverShiftPostingDetailsViewArgs = {
  shiftPostingId: Scalars['ID'];
  visitIds: Array<Scalars['ID']>;
};


export type MutationUpdateShiftRewardForShiftPostingVisitArgs = {
  shiftPostingId: Scalars['ID'];
  shiftPostingVisitId: Scalars['ID'];
  shiftRewardPoints?: Maybe<Scalars['Int']>;
  phiAccessReason: Scalars['String'];
};


export type MutationUpdatePhiPatientPreferredLanguagesArgs = {
  phiPatientId: Scalars['String'];
  phiLanguageCodes: Array<Scalars['String']>;
  phiAccessReason: Scalars['String'];
};


export type MutationSyncShiftsForPhiPatientsArgs = {
  phiPatientIds: Array<Scalars['String']>;
  phiAccessReason: Scalars['String'];
};


export type MutationConnectMyRewardsAdminToCoordinatorsArgs = {
  externalCoordinatorIds: Array<Scalars['String']>;
};


export type MutationConnectCoordinatorsToRewardsAdminsArgs = {
  connections: Array<CoordinatorAdminConnectionInput>;
};


export type MutationDismissCaregiverVoiceCallbackArgs = {
  caregiverVoiceCallbackId: Scalars['ID'];
  phiAccessReason: Scalars['String'];
};


export type MutationPublishCustomSocialPostArgs = {
  messageText: Scalars['String'];
  branchId?: Maybe<Scalars['ID']>;
  videoId?: Maybe<Scalars['String']>;
};


export type MutationRecordReactionArgs = {
  postId: Scalars['ID'];
  reactionType: ReactionType;
};


export type MutationRemoveReactionArgs = {
  postId: Scalars['ID'];
  reactionType: ReactionType;
};


export type MutationRecordViewsArgs = {
  postIds: Array<Scalars['ID']>;
};


export type MutationUpdateOrganizationSocialFeedSettingsArgs = {
  input: UpdateOrganizationSocialFeedSettingsInput;
};


export type MutationUpdateMyOrganizationFirstShiftSurveySettingsArgs = {
  sendToEmails?: Maybe<Array<Scalars['String']>>;
  negativeAnswerScoreThresholdInclusive?: Maybe<Scalars['Int']>;
  segmentByBranch?: Maybe<Scalars['Boolean']>;
  rewardOverride?: Maybe<RewardOverrideInput>;
};


export type MutationAuthenticateRewardsUserLoginTokenArgs = {
  emailOrPhoneNumber: Scalars['String'];
  loginTokenId?: Maybe<Scalars['String']>;
  loginToken: Scalars['String'];
  clientId: Scalars['String'];
  impersonating?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateRewardsUserTokenReauthChallengeArgs = {
  loginTokenId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};


export type MutationCreateRewardsUserSmsLoginChallengeArgs = {
  phoneNumber: Scalars['String'];
  organizationId?: Maybe<Scalars['ID']>;
};


export type MutationCompleteRewardsUserSmsLoginChallengeArgs = {
  clientId: Scalars['String'];
  challengeId: Scalars['String'];
  verificationCode: Scalars['String'];
};


export type MutationRedeemPointsArgs = {
  amount: Scalars['Int'];
  redemptionMethod?: Maybe<RedemptionMethod>;
};


export type MutationResendGenericGiftCardLinkArgs = {
  redemptionId: Scalars['String'];
};


export type MutationResendCatalogGiftCardOrderArgs = {
  redemptionId: Scalars['ID'];
  redemptionItemId: Scalars['ID'];
};


export type MutationSetMyRewardsUserLocaleArgs = {
  locale: Locale;
};


export type MutationOptInWithPersonalInformationArgs = {
  workEmail: Scalars['String'];
  personalEmail: Scalars['String'];
  personalPhoneNumber: Scalars['String'];
};


export type MutationCreateRewardsUserArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  workEmail?: Maybe<Scalars['String']>;
  workPhoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  externalEmployeeId?: Maybe<Scalars['String']>;
  assignedToUserGroupIds?: Maybe<Array<Scalars['ID']>>;
  branchId?: Maybe<Scalars['ID']>;
  managerId?: Maybe<Scalars['ID']>;
  employmentStartDate?: Maybe<Scalars['Date']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  reassignDeactivatedWorkPhoneNumber?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateRewardsUserInformationArgs = {
  userId: Scalars['ID'];
  workEmail?: Maybe<Scalars['String']>;
  workPhoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  employmentStartDate?: Maybe<Scalars['Date']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  branchId?: Maybe<Scalars['ID']>;
  managerId?: Maybe<Scalars['ID']>;
  active?: Maybe<Scalars['Boolean']>;
  reassignDeactivatedWorkPhoneNumber?: Maybe<Scalars['Boolean']>;
  referralLinkDisabled?: Maybe<Scalars['Boolean']>;
};


export type MutationAdminBulkCreateRewardsUsersArgs = {
  organizationId: Scalars['ID'];
  data: Array<AdminBulkCreateRewardsUserPayload>;
};


export type MutationAdminBulkUpdateRewardsUsersArgs = {
  organizationId: Scalars['ID'];
  data: Array<AdminBulkUpdateRewardsUserPayload>;
};


export type MutationGenerateRewardsUserExportArgs = {
  searchQuery?: Maybe<Scalars['String']>;
  filter?: Maybe<ListRewardsUsersFilterInput>;
};


export type MutationCompleteWelcomeOfferArgs = {
  userId: Scalars['ID'];
};


export type MutationRetoolCreateQaRewardsUserArgs = {
  organizationId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  hhaxCaregiver?: Maybe<HhaxCaregiverInput>;
};


export type MutationUpdateMyRewardsUserEmailArgs = {
  email: Scalars['String'];
};


export type MutationMarkRewardVideoUploadedArgs = {
  videoId: Scalars['ID'];
};


export type MutationMarkRewardVideoDeletedArgs = {
  videoId: Scalars['ID'];
};


export type MutationCreatePresignedVideoUploadUrlArgs = {
  originalFilename: Scalars['String'];
};


export type MutationCreatePresignedVideoUploadUrlV2Args = {
  originalFilename: Scalars['String'];
  type: VideoType;
  title?: Maybe<Scalars['String']>;
};


export type MutationRecordVideoWatchByMeArgs = {
  videoId: Scalars['ID'];
};


export type MutationMarkRewardVideoOfferWatchedArgs = {
  videoOfferId: Scalars['ID'];
};


export type MutationAdminBulkCreateOrUpdateVideoOffersArgs = {
  data: Array<AdminBulkCreateOrUpdateVideoOfferInputItem>;
};


export type MutationRetoolCreateQaVisitArgs = {
  personalEmail?: Maybe<Scalars['String']>;
  externalIntegrationId?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  visit: RetoolQaVisitInput;
};


export type MutationRetoolSignalVisitLoadCompleteArgs = {
  organizationId: Scalars['ID'];
  integrationId: Scalars['ID'];
};


export type MutationResyncMyVisitsInRangeArgs = {
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
};


export type MutationResyncMyVisitsForPhiPatientFromVisitIdArgs = {
  visitId: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
  phiAccessReason: Scalars['String'];
};


export type MutationApplyToSchoolsEmployerArgs = {
  employerId: Scalars['ID'];
};


export type MutationSignUpAsSchoolsStudentArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  graduationDate: Scalars['MonthAndYear'];
};


export type MutationAuthenticateSchoolsStudentLoginTokenArgs = {
  phoneNumber: Scalars['String'];
  loginTokenId: Scalars['String'];
  loginToken: Scalars['String'];
  clientId: Scalars['String'];
};


export type MutationCreateSchoolsStudentApplicationArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  homePostalCode: Scalars['String'];
  travelCapability: SchoolsJobApplicationTravelCapability;
  previousEmployers: Array<Scalars['String']>;
  desiredHours: SchoolsJobApplicationDesiredHours;
  desiredShiftTimesOfDay: Array<SchoolsJobApplicationDesiredShiftTimeOfDay>;
  desiredShiftDaysOfWeek: Array<SchoolsJobApplicationDesiredShiftDaysOfWeek>;
};

export type NonPhiShiftPosting = NonPhiShiftPostingCardBase & {
  __typename?: 'NonPHIShiftPosting';
  id: Scalars['ID'];
  shiftPostingId: Scalars['ID'];
  archived: Scalars['Boolean'];
  /** The location of the posting, if available. */
  location?: Maybe<Scalars['String']>;
  /**
   * The short location of the posting, if available.
   * This will not include the state - just the city.
   */
  locationShort?: Maybe<Scalars['String']>;
  /** The ZIP5 of the posting, if available. */
  zip5?: Maybe<Scalars['String']>;
  /**
   * The distance to the posting from the caregiver's home location, if available.
   * @deprecated Use myRewardsUserDistanceFromHomeInMinutes to be more explicit
   */
  myRewardsUserDistanceInMinutes?: Maybe<Scalars['Int']>;
  /** The distance to the posting from the caregiver's home location, if available. */
  myRewardsUserDistanceFromHomeInMinutes?: Maybe<Scalars['Int']>;
  /**
   * The distance to the posting from the caregiver's closest work location, if available.
   * This will be `null` if the caregiver is within their distance preference from home,
   * or if the caregiver is not scheduled around the open shifts.
   */
  myRewardsUserClosestDistanceFromWorkInMinutes?: Maybe<Scalars['Int']>;
  /** The transportation mode used to calculate the distance, if available. */
  myRewardsUserDistanceAssumedTransportationMode?: Maybe<CaregiverProfilePrimaryMethodOfTransportation>;
  /**
   * Whether the patient is bed-bound, parsed from `phiAlerts`.
   * Only available when population is >= 20,000.
   */
  isBedBound?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the patient requires a hoyer lift, parsed from `phiAlerts`.
   * Only available when population is >= 20,000.
   */
  requiresHoyerLift?: Maybe<Scalars['Boolean']>;
  /**
   * Format: ordered list of 2-character language codes
   * The first element is the primary preferred language, subsequent elements are alternates.
   * Only "en" and "es" are allowed to be shown.
   */
  preferredCaregiverLanguages?: Maybe<Array<Scalars['String']>>;
  /**
   * The gender of the patient, if available. One of "male" or "female".
   * Only available when population is >= 20,000.
   */
  gender?: Maybe<Scalars['String']>;
  /** Whether the patient has pets, if available. */
  hasPets?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has cats, if available. */
  hasCats?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has dogs, if available. */
  hasDogs?: Maybe<Scalars['Boolean']>;
  /** All non-removed visits associated with the shift posting. */
  nonRemovedVisits: Array<NonPhiShiftPostingVisit>;
  /**
   * To be used by caregivers to view only open shifts eligible for submitting interest.
   * Sorted by earliest rangeStart.
   */
  openVisits: Array<NonPhiShiftPostingVisit>;
  /** The total point rewards for open shifts on this shift posting. */
  totalPointRewardsForOpenShifts: Scalars['Int'];
  /** The 6-character active shift key for this posting. Can be used to lookup the shift posting by shift key. */
  activeShiftKey?: Maybe<Scalars['String']>;
  /** Whether the current user is a match for this shift posting. */
  myRewardsUserIsMatch: Scalars['Boolean'];
  /**
   * The unmatch reason that is allowed by coordinator to be shown to the current user.
   * This is a specific list of allowed non PHI reasons that we can display to the caregiver.
   */
  nonPhiAllowedUnmatchReasonToShow?: Maybe<CaregiverShiftPostingUnmatchReasonAllowedNonPhiReason>;
  /** The first name of the coordinator assigned to the client for this shift posting, if known. */
  coordinatorName?: Maybe<Scalars['String']>;
};

/**
 * Union type representing a shift posting.
 * Can be either a temporary shift posting (with individual visits) or a permanent
 * shift posting (with recurring shift patterns grouped by day and time).
 */
export type NonPhiShiftPostingCard = NonPhiShiftPostingCardPermanent | NonPhiShiftPostingCardTemporary;

/** Interface containing shared fields for both temporary and permanent shift posting cards. */
export type NonPhiShiftPostingCardBase = {
  id: Scalars['ID'];
  shiftPostingId: Scalars['ID'];
  archived: Scalars['Boolean'];
  /** The location of the posting, if available. */
  location?: Maybe<Scalars['String']>;
  /**
   * The short location of the posting, if available.
   * This will not include the state - just the city.
   */
  locationShort?: Maybe<Scalars['String']>;
  /** The ZIP5 of the posting, if available. */
  zip5?: Maybe<Scalars['String']>;
  /** The distance to the posting from the caregiver's home location, if available. */
  myRewardsUserDistanceFromHomeInMinutes?: Maybe<Scalars['Int']>;
  /**
   * The distance to the posting from the caregiver's closest work location, if available.
   * This will be `null` if the caregiver is within their distance preference from home,
   * or if the caregiver is not scheduled around the open shifts.
   * @deprecated No longer supported - always returns `null`
   */
  myRewardsUserClosestDistanceFromWorkInMinutes?: Maybe<Scalars['Int']>;
  /** The transportation mode used to calculate the distance, if available. */
  myRewardsUserDistanceAssumedTransportationMode?: Maybe<CaregiverProfilePrimaryMethodOfTransportation>;
  /**
   * Whether the patient is bed-bound, parsed from `phiAlerts`.
   * Only available when population is >= 20,000.
   */
  isBedBound?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the patient requires a hoyer lift, parsed from `phiAlerts`.
   * Only available when population is >= 20,000.
   */
  requiresHoyerLift?: Maybe<Scalars['Boolean']>;
  /**
   * Format: ordered list of 2-character language codes
   * The first element is the primary preferred language, subsequent elements are alternates.
   * Only "en" and "es" are allowed to be shown.
   */
  preferredCaregiverLanguages?: Maybe<Array<Scalars['String']>>;
  /**
   * The gender of the patient, if available. One of "male" or "female".
   * Only available when population is >= 20,000.
   */
  gender?: Maybe<Scalars['String']>;
  /** Whether the patient has pets, if available. */
  hasPets?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has cats, if available. */
  hasCats?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has dogs, if available. */
  hasDogs?: Maybe<Scalars['Boolean']>;
  /** The total point rewards for open shifts on this shift posting. */
  totalPointRewardsForOpenShifts: Scalars['Int'];
  /** The 6-character active shift key for this posting. Can be used to lookup the shift posting by shift key. */
  activeShiftKey?: Maybe<Scalars['String']>;
  /** Whether the current user is a match for this shift posting. */
  myRewardsUserIsMatch: Scalars['Boolean'];
  /**
   * The unmatch reason that is allowed by coordinator to be shown to the current user.
   * This is a specific list of allowed non PHI reasons that we can display to the caregiver.
   */
  nonPhiAllowedUnmatchReasonToShow?: Maybe<CaregiverShiftPostingUnmatchReasonAllowedNonPhiReason>;
  /** The first name of the coordinator assigned to the client for this shift posting, if known. */
  coordinatorName?: Maybe<Scalars['String']>;
};

/**
 * Permanent shift posting card - used for shift postings with permanent/recurring shifts.
 * Groups recurring shifts by day-of-week and time pattern instead of showing individual visits.
 */
export type NonPhiShiftPostingCardPermanent = NonPhiShiftPostingCardBase & {
  __typename?: 'NonPHIShiftPostingCardPermanent';
  /**
   * Unique identifier for this card.
   * Format: "shiftPostingId:cardType" (e.g. "12345678:temporary")
   */
  id: Scalars['ID'];
  shiftPostingId: Scalars['ID'];
  archived: Scalars['Boolean'];
  /** The location of the posting, if available. */
  location?: Maybe<Scalars['String']>;
  /**
   * The short location of the posting, if available.
   * This will not include the state - just the city.
   */
  locationShort?: Maybe<Scalars['String']>;
  /** The ZIP5 of the posting, if available. */
  zip5?: Maybe<Scalars['String']>;
  /** The distance to the posting from the caregiver's home location, if available. */
  myRewardsUserDistanceFromHomeInMinutes?: Maybe<Scalars['Int']>;
  /**
   * The distance to the posting from the caregiver's closest work location, if available.
   * This will be `null` if the caregiver is within their distance preference from home,
   * or if the caregiver is not scheduled around the open shifts.
   */
  myRewardsUserClosestDistanceFromWorkInMinutes?: Maybe<Scalars['Int']>;
  /** The transportation mode used to calculate the distance, if available. */
  myRewardsUserDistanceAssumedTransportationMode?: Maybe<CaregiverProfilePrimaryMethodOfTransportation>;
  /**
   * Whether the patient is bed-bound, parsed from `phiAlerts`.
   * Only available when population is > 20,000.
   */
  isBedBound?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the patient requires a hoyer lift, parsed from `phiAlerts`.
   * Only available when population is >= 20,000.
   */
  requiresHoyerLift?: Maybe<Scalars['Boolean']>;
  /**
   * Format: ordered list of 2-character language codes
   * The first element is the primary preferred language, subsequent elements are alternates.
   * Only "en" and "es" are allowed to be shown.
   */
  preferredCaregiverLanguages?: Maybe<Array<Scalars['String']>>;
  /**
   * The gender of the patient, if available. One of "male" or "female".
   * Only available when population is >= 20,000.
   */
  gender?: Maybe<Scalars['String']>;
  /** Whether the patient has pets, if available. */
  hasPets?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has cats, if available. */
  hasCats?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has dogs, if available. */
  hasDogs?: Maybe<Scalars['Boolean']>;
  /** The total point rewards for open shifts on this shift posting. */
  totalPointRewardsForOpenShifts: Scalars['Int'];
  /** The 6-character active shift key for this posting. Can be used to lookup the shift posting by shift key. */
  activeShiftKey?: Maybe<Scalars['String']>;
  /** Whether the current user is a match for this shift posting. */
  myRewardsUserIsMatch: Scalars['Boolean'];
  /**
   * The unmatch reason that is allowed by coordinator to be shown to the current user.
   * This is a specific list of allowed non PHI reasons that we can display to the caregiver.
   */
  nonPhiAllowedUnmatchReasonToShow?: Maybe<CaregiverShiftPostingUnmatchReasonAllowedNonPhiReason>;
  /**
   * Recurring shift options grouped by day-of-week and time pattern.
   * Each option represents a recurring shift pattern (e.g., Monday 3pm-6pm).
   */
  recurringShiftOptions: Array<NonPhiShiftPostingCardPermanentRecurringShift>;
  /** To be used by caregivers to view only open recurring shifts eligible for submitting interest. */
  openRecurringShiftOptions: Array<NonPhiShiftPostingCardPermanentRecurringShift>;
  /** Date-only string in the format 'YYYY-MM-DD' */
  recurringShiftsStartDate?: Maybe<Scalars['String']>;
  /** The first name of the coordinator assigned to the client for this shift posting, if known. */
  coordinatorName?: Maybe<Scalars['String']>;
};

/**
 * Represents a recurring shift pattern for a permanent shift posting.
 * Groups multiple permanent visits that occur on the same day-of-week and time range.
 */
export type NonPhiShiftPostingCardPermanentRecurringShift = {
  __typename?: 'NonPHIShiftPostingCardPermanentRecurringShift';
  /**
   * Unique identifier for this recurring shift pattern.
   * Format: `${shiftPostingId}:permanent-shift:${dayOfWeek}:${startTimeOfDayInMinutes}:${endTimeOfDayInMinutes}`
   */
  id: Scalars['ID'];
  /**
   * The start time of day for this recurring shift, in minutes since midnight.
   * For example, `0` is midnight, `900` is 3pm (15:00), `1080` is 6pm (18:00).
   */
  startTimeOfDayInMinutes: Scalars['Int'];
  /**
   * The end time of day for this recurring shift, in minutes since midnight.
   * For example, `0` is midnight, `900` is 3pm (15:00), `1080` is 6pm (18:00).
   */
  endTimeOfDayInMinutes: Scalars['Int'];
  /** The day of the week this recurring shift occurs on. */
  dayOfWeek: DayOfWeek;
  /**
   * Whether the current user has expressed interest in any visit matching this recurring shift pattern.
   * This checks if the caregiver has interest in any visit that occurs on this day-of-week
   * and time range for this shift posting.
   */
  myRewardsUserIsInterestedInRecurringShift: Scalars['Boolean'];
  /** The HHAX visit ID for one of the recurring visits, if available. */
  hhaxVisitId?: Maybe<Scalars['String']>;
};

/**
 * Temporary shift posting card - similar to NonPHIShiftPosting.
 * Used for shift postings that have temporary (non-recurring) shifts.
 * Shows individual open visits and all non-removed visits associated with the shift posting.
 */
export type NonPhiShiftPostingCardTemporary = NonPhiShiftPostingCardBase & {
  __typename?: 'NonPHIShiftPostingCardTemporary';
  /**
   * Unique identifier for this card.
   * Format: "shiftPostingId:cardType" (e.g. "12345678:temporary")
   */
  id: Scalars['ID'];
  shiftPostingId: Scalars['ID'];
  archived: Scalars['Boolean'];
  /** The location of the posting, if available. */
  location?: Maybe<Scalars['String']>;
  /**
   * The short location of the posting, if available.
   * This will not include the state - just the city.
   */
  locationShort?: Maybe<Scalars['String']>;
  /** The ZIP5 of the posting, if available. */
  zip5?: Maybe<Scalars['String']>;
  /** The distance to the posting from the caregiver's home location, if available. */
  myRewardsUserDistanceFromHomeInMinutes?: Maybe<Scalars['Int']>;
  /**
   * The distance to the posting from the caregiver's closest work location, if available.
   * This will be `null` if the caregiver is within their distance preference from home,
   * or if the caregiver is not scheduled around the open shifts.
   */
  myRewardsUserClosestDistanceFromWorkInMinutes?: Maybe<Scalars['Int']>;
  /** The transportation mode used to calculate the distance, if available. */
  myRewardsUserDistanceAssumedTransportationMode?: Maybe<CaregiverProfilePrimaryMethodOfTransportation>;
  /**
   * Whether the patient is bed-bound, parsed from `phiAlerts`.
   * Only available when population is > 20,000.
   */
  isBedBound?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the patient requires a hoyer lift, parsed from `phiAlerts`.
   * Only available when population is >= 20,000.
   */
  requiresHoyerLift?: Maybe<Scalars['Boolean']>;
  /**
   * Format: ordered list of 2-character language codes
   * The first element is the primary preferred language, subsequent elements are alternates.
   * Only "en" and "es" are allowed to be shown.
   */
  preferredCaregiverLanguages?: Maybe<Array<Scalars['String']>>;
  /**
   * The gender of the patient, if available. One of "male" or "female".
   * Only available when population is >= 20,000.
   */
  gender?: Maybe<Scalars['String']>;
  /** Whether the patient has pets, if available. */
  hasPets?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has cats, if available. */
  hasCats?: Maybe<Scalars['Boolean']>;
  /** Whether the patient has dogs, if available. */
  hasDogs?: Maybe<Scalars['Boolean']>;
  /** The total point rewards for open shifts on this shift posting. */
  totalPointRewardsForOpenShifts: Scalars['Int'];
  /** The 6-character active shift key for this posting. Can be used to lookup the shift posting by shift key. */
  activeShiftKey?: Maybe<Scalars['String']>;
  /** Whether the current user is a match for this shift posting. */
  myRewardsUserIsMatch: Scalars['Boolean'];
  /**
   * The unmatch reason that is allowed by coordinator to be shown to the current user.
   * This is a specific list of allowed non PHI reasons that we can display to the caregiver.
   */
  nonPhiAllowedUnmatchReasonToShow?: Maybe<CaregiverShiftPostingUnmatchReasonAllowedNonPhiReason>;
  /** All non-removed visits associated with the shift posting. */
  nonRemovedVisits: Array<NonPhiShiftPostingVisit>;
  /**
   * To be used by caregivers to view only open shifts eligible for submitting interest.
   * Sorted by earliest rangeStart.
   */
  openVisits: Array<NonPhiShiftPostingVisit>;
  /** The first name of the coordinator assigned to the client for this shift posting, if known. */
  coordinatorName?: Maybe<Scalars['String']>;
};

export type NonPhiShiftPostingVisit = {
  __typename?: 'NonPHIShiftPostingVisit';
  id: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
  shortShift: Scalars['Boolean'];
  assigned: Scalars['Boolean'];
  permanent: Scalars['Boolean'];
  myRewardsUserIsInterested: Scalars['Boolean'];
  /**
   * Whether the current user has a conflict with this visit.
   *
   * A conflict can be either a scheduled visit that overlaps,
   * or a scheduled unavailability on the same day as the visit.
   */
  myRewardsUserHasConflict: Scalars['Boolean'];
  /**
   * Whether the current user is pending confirmation for this visit. This happens
   * when the visit is assigned to the caregiver but requires confirmation.
   */
  myRewardsUserIsPendingConfirmation: Scalars['Boolean'];
  /** The points to be earned by the caregiver who works this shift, if any. */
  shiftRewardPoints?: Maybe<Scalars['Int']>;
  /** The ID of the visit in HHAX, if that is the scheduling system for this visit. */
  hhaxVisitId?: Maybe<Scalars['String']>;
};

export type NotLaunchedInsightDateRanges = {
  __typename?: 'NotLaunchedInsightDateRanges';
  id: Scalars['ID'];
};

export type NotificationDeliveryMetrics = {
  __typename?: 'NotificationDeliveryMetrics';
  numEmails: Scalars['Int'];
  numEmailsPending: Scalars['Int'];
  numEmailsSentToServiceProvider: Scalars['Int'];
  numEmailsSent: Scalars['Int'];
  numEmailsDelivered: Scalars['Int'];
  numEmailsFailed: Scalars['Int'];
  numEmailsFailuresByCustomerIOErrorMetric: Array<CustomerIoEmailFailureMetric>;
  numSms: Scalars['Int'];
  numSmsPending: Scalars['Int'];
  numSmsSentToServiceProvider: Scalars['Int'];
  numSmsSent: Scalars['Int'];
  numSmsDelivered: Scalars['Int'];
  numSmsFailed: Scalars['Int'];
  numSmsFailuresByTwilioErrorCode: Array<TwilioSmsFailureMetric>;
};

export type NumActiveCandidatesByJobPostingAndNextStep = {
  __typename?: 'NumActiveCandidatesByJobPostingAndNextStep';
  items: Array<NumActiveCandidatesByJobPostingAndNextStepItem>;
};

export type NumActiveCandidatesByJobPostingAndNextStepItem = {
  __typename?: 'NumActiveCandidatesByJobPostingAndNextStepItem';
  jobPosting: JobPosting;
  total: Scalars['Int'];
  totalsByNextStep: Array<NumActiveCandidatesByJobPostingAndNextStepItemTotal>;
};

export type NumActiveCandidatesByJobPostingAndNextStepItemTotal = NumActiveCandidatesByJobPostingAndNextStepItemTotalRecruitment | NumActiveCandidatesByJobPostingAndNextStepItemTotalRetention;

export type NumActiveCandidatesByJobPostingAndNextStepItemTotalRecruitment = {
  __typename?: 'NumActiveCandidatesByJobPostingAndNextStepItemTotalRecruitment';
  numActiveCandidates: Scalars['Int'];
  recruitmentStepName: CandidateRecruitmentStepName;
};

export type NumActiveCandidatesByJobPostingAndNextStepItemTotalRetention = {
  __typename?: 'NumActiveCandidatesByJobPostingAndNextStepItemTotalRetention';
  numActiveCandidates: Scalars['Int'];
  retentionDurationMonths?: Maybe<Scalars['Int']>;
  retentionDurationHours?: Maybe<Scalars['Int']>;
};

export type NumActiveCandidatesByJobPostingAndStatus = {
  __typename?: 'NumActiveCandidatesByJobPostingAndStatus';
  items: Array<NumActiveCandidatesByJobPostingAndStatusItem>;
};

export type NumActiveCandidatesByJobPostingAndStatusItem = {
  __typename?: 'NumActiveCandidatesByJobPostingAndStatusItem';
  jobPosting: JobPosting;
  total: Scalars['Int'];
  totalsByStatus: Array<NumActiveCandidatesByJobPostingAndStatusItemTotal>;
};

export type NumActiveCandidatesByJobPostingAndStatusItemTotal = NumActiveCandidatesByJobPostingAndStatusItemTotalRecruitment | NumActiveCandidatesByJobPostingAndStatusItemTotalRetention;

export type NumActiveCandidatesByJobPostingAndStatusItemTotalRecruitment = {
  __typename?: 'NumActiveCandidatesByJobPostingAndStatusItemTotalRecruitment';
  numActiveCandidates: Scalars['Int'];
  recruitmentStepName: CandidateRecruitmentStepName;
};

export type NumActiveCandidatesByJobPostingAndStatusItemTotalRetention = {
  __typename?: 'NumActiveCandidatesByJobPostingAndStatusItemTotalRetention';
  numActiveCandidates: Scalars['Int'];
  retentionDurationMonths: Scalars['Int'];
};

export type OpenJobPostingFilterInput = {
  searchQuery?: Maybe<Scalars['String']>;
};

/** Configuration for a specific branch in branch-specific admin goals */
export type OrganizationAdminGoalBranchConfigInput = {
  branchId: Scalars['ID'];
  adminIds: Array<Scalars['ID']>;
  rewards: AdminGoalRewardsInput;
  target: AdminGoalTargetInput;
};

/** Input for updating a specific branch configuration */
export type OrganizationAdminGoalBranchConfigUpdateInput = {
  branchId: Scalars['ID'];
  adminIds: Array<Scalars['ID']>;
  rewards: AdminGoalRewardsInput;
  target: AdminGoalTargetInput;
};

export enum OrganizationCandidateStepRewardType {
  Points = 'POINTS',
  DrawTickets = 'DRAW_TICKETS',
  ManualMonthlyRaffle = 'MANUAL_MONTHLY_RAFFLE'
}

export type OrganizationDrawSettings = {
  __typename?: 'OrganizationDrawSettings';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  automatedDrawConfig: AutomatedDrawConfig;
};

export type OrganizationFirstShiftSurveySettings = {
  __typename?: 'OrganizationFirstShiftSurveySettings';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  sendToEmails: Array<Scalars['String']>;
  /**
   * Sets the survey answer score threshold for triggering an email to Admins.
   * If at least one survey answer score is less than or equal to this value,
   * an email will be sent. Defaults to 2.
   * Answer scores range from 1 (strongly disagree) to 5 (strongly agree).
   */
  negativeAnswerScoreThresholdInclusive: Scalars['Int'];
  /**
   * Whether to segment negative response emails by the user's branch.
   * See UpdateOrganizationFirstShiftSurveySettingsInput for detailed behavior.
   */
  segmentByBranch: Scalars['Boolean'];
  /**
   * Optional reward override for completing the first shift survey.
   * If null, no reward is given for completing the survey.
   */
  rewardOverride?: Maybe<RewardOverride>;
};

export type OrganizationGoalConfig = {
  __typename?: 'OrganizationGoalConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  enabledAt?: Maybe<Scalars['Timestamp']>;
  distributionType: GoalDistributionType;
  goalUpdateStatus: GoalUpdateStatus;
  updateRewardOverrideGoalUpdatePolicy?: Maybe<GoalRewardUpdatePolicy>;
  disableDistributionGoalUpdatePolicy?: Maybe<GoalDistributionUpdatePolicy>;
  jobShareGoalDistributionConfig?: Maybe<JobShareGoalDistributionConfig>;
  welcomeVideoGoalDistributionConfig?: Maybe<WelcomeVideoGoalDistributionConfig>;
  evvGoalDistributionConfig?: Maybe<EvvGoalDistributionConfig>;
  pulseCheckSurveyGoalDistributionConfig?: Maybe<PulseCheckSurveyGoalDistributionConfig>;
  quickCheckSurveyGoalDistributionConfig?: Maybe<QuickCheckSurveyGoalDistributionConfig>;
  weekendShiftGoalDistributionConfig?: Maybe<WeekendShiftGoalDistributionConfig>;
  lastMinuteShiftGoalDistributionConfig?: Maybe<LastMinuteShiftGoalDistributionConfig>;
  completeTrainingGoalDistributionConfig?: Maybe<CompleteTrainingGoalDistributionConfig>;
  billableHoursGoalDistributionConfig?: Maybe<BillableHoursGoalDistributionConfig>;
  welcomeGoalDistributionConfig?: Maybe<WelcomeGoalDistributionConfig>;
  birthdayGoalDistributionConfig?: Maybe<BirthdayGoalDistributionConfig>;
  anniversaryGoalDistributionConfig?: Maybe<AnniversaryGoalDistributionConfig>;
};

export type OrganizationLaunchMetrics = {
  __typename?: 'OrganizationLaunchMetrics';
  id: Scalars['ID'];
  organization: RewardsOrganization;
  numActiveUsers: Scalars['Int'];
  /** Yields `null` if the organization has not launched yet. */
  notificationDeliveryMetrics?: Maybe<NotificationDeliveryMetrics>;
  numUsersLoggedIn: Scalars['Int'];
};

export type OrganizationMilestoneReward = {
  __typename?: 'OrganizationMilestoneReward';
  id: Scalars['ID'];
  pointValue: Scalars['Int'];
  enabled: Scalars['Boolean'];
  goal: MilestoneGoal;
};

export type OrganizationMilestoneRewardBackfillConfigInput = {
  shouldBackfill: Scalars['Boolean'];
};

export type OrganizationMilestoneRewardInput = {
  id: Scalars['ID'];
  pointValue: Scalars['Int'];
  enabled: Scalars['Boolean'];
};

export type OrganizationMilestoneRewardSettings = {
  __typename?: 'OrganizationMilestoneRewardSettings';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  originallyEnabledAt?: Maybe<Scalars['Date']>;
  stoppedAt?: Maybe<Scalars['Date']>;
  milestones: Array<OrganizationMilestoneReward>;
  evvComplianceEnforced: Scalars['Boolean'];
  backfillConfig?: Maybe<MilestoneRewardsBackfillConfig>;
};

export type OrganizationSocialFeedSettings = {
  __typename?: 'OrganizationSocialFeedSettings';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  disabledPostTypes: Array<SocialPostType>;
};

export type PhiAddress = {
  __typename?: 'PHIAddress';
  addressLine1?: Maybe<Scalars['PHIString']>;
  addressLine2?: Maybe<Scalars['PHIString']>;
  city?: Maybe<Scalars['PHIString']>;
  stateAbbreviation?: Maybe<UsStateAbbreviation>;
  zip5?: Maybe<Scalars['PHIString']>;
};


export type PhiCaregiverShiftPostingMatch = {
  __typename?: 'PHICaregiverShiftPostingMatch';
  id: Scalars['ID'];
  user: RewardsUser;
  /**
   * If `true`, the user is a match for the shift posting.
   * If `false`, the user _used_ to be a match for the shift posting, but is no longer a match
   * (based on the factors changing)
   */
  isMatch: Scalars['Boolean'];
  /**
   * A match score between 0 and 10, where 0 is a low match and 10 is a high match.
   * - Caregivers (rewards user) may be ranked by this score to find the top matches for a given shift posting.
   * - Similarly, shift postings may be ranked by this score to find the top matches for a given caregiver.
   */
  matchScore: Scalars['Float'];
  /**
   * A list of factors that contributed to the match score.
   *
   * These can be used to understand the match score in more detail, and to
   * understand which factors contributed higher or lower towards the score.
   * @deprecated Use PHICaregiverShiftPostingMatchContext instead
   */
  phiFactorScoresAndWeights: Array<PhiCaregiverShiftPostingMatchFactorScoreAndWeights>;
  /**
   * Additional details (if applicable) about the match. These factors
   * were used as inputs to the factor scores.
   *
   * Note that these are only updated when the match score is updated.
   * If the caregiver is no longer a match, these may not be up-to-date.
   * @deprecated Use PHICaregiverShiftPostingMatchContext instead
   */
  phiFactors: PhiCaregiverShiftPostingMatchFactors;
  /**
   * Returns the travel distance from the caregiver's scheduled work location to the soonest
   * shift they are available to work, if applicable.
   * This will be `null` if the caregiver is not scheduled within 6 hours of the soonest shift
   * or if they are within their travel distance preference from home (`phiTravelDistanceFromHomeInMinutes`).
   * @deprecated Performance is too low; this will always return null now
   */
  phiTravelDistanceFromWorkToSoonestAvailableShift?: Maybe<PhiCaregiverTravelDistanceFromWorkToSoonestShift>;
  /**
   * Indicates the number of hours scheduled (or worked)
   *
   * This is computed lazily when called, to ensure that the most up-to-date
   * data is visible for the admin.
   */
  numVisitHoursDuringShiftPostingVisits: Array<PhiCaregiverShiftPostingMatchNumVisitHoursDuringShiftPostingVisits>;
  /** The IDs of the shift posting visits that the caregiver is interested in, if any */
  interestedShiftPostingVisitIds: Array<Scalars['ID']>;
};

/**
 * This type is computed on-the-fly when queried
 * (as opposed to `PHICaregiverShiftPostingMatch`, which is a pre-computed type).
 *
 * This type is a catch-all join record about the match between a caregiver and a shift posting,
 * and contains up-to-date information (based on their schedule, etc).
 *
 * Often, we will query the pre-computed `PHICaregiverShiftPostingMatch` type to find the top
 * matches (ordered by match score), and then use the `PHICaregiverShiftPostingMatchContext` type
 * to compute live information about the match.
 *
 * We must maintain caution querying this type, as it loads the user's schedule and may
 * be expensive to query for many caregivers at a time.
 */
export type PhiCaregiverShiftPostingMatchContext = {
  __typename?: 'PHICaregiverShiftPostingMatchContext';
  id: Scalars['ID'];
  /**
   * If `true`, the user is a match for the shift posting.
   * If `false`, the user is not a match for the shift posting.
   */
  isMatch: Scalars['Boolean'];
  /** If applicable, indicates the reason for the match (e.g. why it's a good or bad match). */
  matchIndicator?: Maybe<PhiMatchIndicator>;
  /**
   * A list of factors that contributed to the match score.
   *
   * These can be used to understand the match score in more detail, and to
   * understand which factors contributed higher or lower towards the score.
   *
   * This may be `null` if they are not a match.
   *
   * At the time of writing, this is exposed only for superusers (for debugging purposes).
   */
  phiFactorScoresAndWeights?: Maybe<Array<PhiCaregiverShiftPostingMatchFactorScoreAndWeights>>;
  /** Whether the caregiver has worked with the patient before. */
  phiWorkedWithPatient?: Maybe<Scalars['PHIBoolean']>;
  /**
   * Context about the travel distance from the caregiver's home to the shift posting.
   *
   * If `null`, we are missing either the patient's or caregiver's home location.
   */
  phiTravelDistanceFromHome?: Maybe<CaregiverTravelDistance>;
  /**
   * Match context per open shift.
   *
   * This includes information such as travel distance, availability, and conflicts.
   */
  phiPerOpenShiftMatchContext: Array<PhiCaregiverShiftPostingMatchPerOpenShiftContext>;
  /** Indicates the number of hours scheduled (or worked) during the shift posting visits. */
  numVisitHoursDuringShiftPostingVisits: Array<PhiCaregiverShiftPostingMatchNumVisitHoursDuringShiftPostingVisits>;
  /** The IDs of the shift posting visits that the caregiver is interested in, if any */
  interestedShiftPostingVisitIds: Array<Scalars['ID']>;
  /** The caregiver's most recent voice callback request for this shift posting, if any */
  caregiverVoiceCallback?: Maybe<PhiCaregiverVoiceCallback>;
  /** The channel through which the caregiver's interest was last submitted. */
  lastSubmittedBy?: Maybe<CaregiverShiftPostingInterestSubmittedBy>;
};

export enum PhiCaregiverShiftPostingMatchFactorName {
  AvailabilityMatch = 'AVAILABILITY_MATCH',
  WorkedWithPatientBefore = 'WORKED_WITH_PATIENT_BEFORE',
  ClosenessToPatientLocation = 'CLOSENESS_TO_PATIENT_LOCATION',
  Language = 'LANGUAGE',
  UtilizedCapacity = 'UTILIZED_CAPACITY',
  ShiftConflict = 'SHIFT_CONFLICT',
  AlreadyScheduledOnShiftDays = 'ALREADY_SCHEDULED_ON_SHIFT_DAYS',
  OkWithBedBound = 'OK_WITH_BED_BOUND',
  HighTenure = 'HIGH_TENURE',
  OkWithHoyerLift = 'OK_WITH_HOYER_LIFT',
  LowTenure = 'LOW_TENURE',
  OpenToShortShifts = 'OPEN_TO_SHORT_SHIFTS',
  OkWithPets = 'OK_WITH_PETS',
  PostingHasShifts = 'POSTING_HAS_SHIFTS'
}

export type PhiCaregiverShiftPostingMatchFactorScoreAndWeights = {
  __typename?: 'PHICaregiverShiftPostingMatchFactorScoreAndWeights';
  /**
   * The name of the factor that contributed to the match score.
   *
   * These values can be found in the `PHICaregiverShiftPostingMatchFactorName` enum.
   */
  phiFactorName: Scalars['PHIString'];
  /** The weight of the factor that contributed to the match score. */
  phiOriginalFactorWeight: Scalars['PHINumber'];
  /** The normalized weight of the factor that contributed to the match score. */
  phiNormalizedFactorWeight: Scalars['PHINumber'];
  /** A number between 0 and 1, where 0 is a lower-contributing factor to the score, and 1 is a higher-contributing factor. */
  phiOriginalFactorScore: Scalars['PHINumber'];
  /** A number between 0 and 10, where 0 is a lower-contributing factor to the score, and 10 is a higher-contributing factor. */
  phiNormalizedFactorScore: Scalars['PHINumber'];
};

export type PhiCaregiverShiftPostingMatchFactors = {
  __typename?: 'PHICaregiverShiftPostingMatchFactors';
  phiWorkedWithPatient?: Maybe<Scalars['PHIBoolean']>;
  /** @deprecated Use phiTravelDistanceFromHomeInMinutes to be more explicit */
  phiTravelDistanceInMinutes?: Maybe<Scalars['PHINumber']>;
  phiTravelDistanceFromHomeInMinutes?: Maybe<Scalars['PHINumber']>;
  phiClosestDistanceFromClosestShift?: Maybe<Scalars['PHINumber']>;
};

export type PhiCaregiverShiftPostingMatchNumVisitHoursDuringShiftPostingVisits = {
  __typename?: 'PHICaregiverShiftPostingMatchNumVisitHoursDuringShiftPostingVisits';
  weekStart: Scalars['Date'];
  numVisitHours: Scalars['Int'];
};

export type PhiCaregiverShiftPostingMatchPerOpenShiftContext = {
  __typename?: 'PHICaregiverShiftPostingMatchPerOpenShiftContext';
  id: Scalars['ID'];
  caregiverShiftConflictStatus: CaregiverShiftConflictStatus;
  caregiverAvailability: CaregiverShiftPostingMatchShiftAvailability;
  caregiverTravelDistance?: Maybe<CaregiverTravelDistance>;
};

export type PhiCaregiverTravelDistanceFromWorkToSoonestShift = {
  __typename?: 'PHICaregiverTravelDistanceFromWorkToSoonestShift';
  soonestAvailableShift: PhiShiftPostingVisit;
  phiDistanceInMinutes: Scalars['PHINumber'];
};

export type PhiCaregiverVoiceCallback = {
  __typename?: 'PHICaregiverVoiceCallback';
  id: Scalars['ID'];
  requestedAt: Scalars['Timestamp'];
  dismissedAt?: Maybe<Scalars['Timestamp']>;
  status: PhiCaregiverVoiceCallbackStatus;
  phiDescriptionContext: Scalars['PHIString'];
};

export enum PhiCaregiverVoiceCallbackStatus {
  Requested = 'REQUESTED',
  Dismissed = 'DISMISSED'
}

export type PhiMatchIndicator = {
  __typename?: 'PHIMatchIndicator';
  /**
   * The type enum of the match indicator (e.g. why it's a good or bad match).
   * This can be used to understand the match in more detail.
   */
  type: PhiMatchIndicatorType;
  /**
   * The level of the match indicator (e.g. whether it prevents a match or reduces the match score).
   * This can be used to determine which colour to display the match indicator in.
   */
  level: PhiMatchIndicatorLevel;
};

export enum PhiMatchIndicatorLevel {
  PreventsMatch = 'PREVENTS_MATCH',
  ReducesMatchScore = 'REDUCES_MATCH_SCORE'
}

export enum PhiMatchIndicatorType {
  CaregiverNotActive = 'CAREGIVER_NOT_ACTIVE',
  CaregiverDoesNotMatchShiftPostingExternalIntegration = 'CAREGIVER_DOES_NOT_MATCH_SHIFT_POSTING_EXTERNAL_INTEGRATION',
  CaregiverDoesNotMatchShiftPostingOrganization = 'CAREGIVER_DOES_NOT_MATCH_SHIFT_POSTING_ORGANIZATION',
  PatientNotActive = 'PATIENT_NOT_ACTIVE',
  ShiftPostingHasNoOpenShifts = 'SHIFT_POSTING_HAS_NO_OPEN_SHIFTS',
  CaregiverDoesNotMatchPatientDisciplines = 'CAREGIVER_DOES_NOT_MATCH_PATIENT_DISCIPLINES',
  CaregiverDoesNotMatchPatientLanguages = 'CAREGIVER_DOES_NOT_MATCH_PATIENT_LANGUAGES',
  CaregiverDoesNotMatchPatientRequestedGender = 'CAREGIVER_DOES_NOT_MATCH_PATIENT_REQUESTED_GENDER',
  CaregiverDoesNotMatchFemalePatientWhenNoPatientRequestedGender = 'CAREGIVER_DOES_NOT_MATCH_FEMALE_PATIENT_WHEN_NO_PATIENT_REQUESTED_GENDER',
  CaregiverDoesNotHaveUsZipCode = 'CAREGIVER_DOES_NOT_HAVE_US_ZIP_CODE',
  PatientDoesNotHaveUsZipCode = 'PATIENT_DOES_NOT_HAVE_US_ZIP_CODE',
  ZipCodeNotFoundInSystem = 'ZIP_CODE_NOT_FOUND_IN_SYSTEM',
  CaregiverTravelDistanceTooFar = 'CAREGIVER_TRAVEL_DISTANCE_TOO_FAR',
  CaregiverHasConflictsWithEveryOpenShift = 'CAREGIVER_HAS_CONFLICTS_WITH_EVERY_OPEN_SHIFT',
  CaregiverExceeds_40HoursPerWeek = 'CAREGIVER_EXCEEDS_40_HOURS_PER_WEEK',
  CaregiverExceedsDesiredHoursPerWeek = 'CAREGIVER_EXCEEDS_DESIRED_HOURS_PER_WEEK',
  CaregiverIsNotAvailableForAnyShifts = 'CAREGIVER_IS_NOT_AVAILABLE_FOR_ANY_SHIFTS',
  CaregiverDoesNotWantShift = 'CAREGIVER_DOES_NOT_WANT_SHIFT',
  CaregiverLacksRequiredExperience = 'CAREGIVER_LACKS_REQUIRED_EXPERIENCE',
  CaregiverExpressedInterestByMistake = 'CAREGIVER_EXPRESSED_INTEREST_BY_MISTAKE',
  CaregiverDeclinedByPatient = 'CAREGIVER_DECLINED_BY_PATIENT',
  MatchRemoved = 'MATCH_REMOVED',
  ShiftAssignedToSomeoneElse = 'SHIFT_ASSIGNED_TO_SOMEONE_ELSE',
  SeemsFar = 'SEEMS_FAR',
  CaregiverLocationUnknown = 'CAREGIVER_LOCATION_UNKNOWN',
  CaregiverUnavailabilityUnknown = 'CAREGIVER_UNAVAILABILITY_UNKNOWN',
  CaregiverLanguagesUnknown = 'CAREGIVER_LANGUAGES_UNKNOWN',
  NotOpenToShortShifts = 'NOT_OPEN_TO_SHORT_SHIFTS',
  NotOkWithPets = 'NOT_OK_WITH_PETS',
  NotOkWithBedBound = 'NOT_OK_WITH_BED_BOUND',
  CaregiverDoesNotMatchPatientOffice = 'CAREGIVER_DOES_NOT_MATCH_PATIENT_OFFICE',
  CaregiverNotEligibleForShiftBooking = 'CAREGIVER_NOT_ELIGIBLE_FOR_SHIFT_BOOKING'
}


/**
 * Note that no `ID` is returned for this type as it is considered PHI
 * and is not properly handled by the front-end for cacheing.
 */
export type PhiPatient = {
  __typename?: 'PHIPatient';
  phiPatientId: Scalars['PHIString'];
  active: Scalars['Boolean'];
  doNotAutomaticallyStaff: Scalars['Boolean'];
  phiFirstName?: Maybe<Scalars['PHIString']>;
  phiLastName?: Maybe<Scalars['PHIString']>;
  /** One of "male" or "female" */
  phiGender?: Maybe<Scalars['PHIString']>;
  phiZipCode?: Maybe<Scalars['PHIString']>;
  /** Format: 2-character language code */
  phiPreferredCaregiverLanguage?: Maybe<Scalars['PHIString']>;
  /** Format: list of 2-character language codes */
  phiAlternatePreferredCaregiverLanguages?: Maybe<Array<Scalars['PHIString']>>;
  phiAlerts?: Maybe<Scalars['PHIString']>;
  /** Whether the patient has dogs, parsed from `phiAlerts`. */
  phiHasDogs?: Maybe<Scalars['PHIBoolean']>;
  /** Whether the patient has cats, parsed from `phiAlerts`. */
  phiHasCats?: Maybe<Scalars['PHIBoolean']>;
  /** Whether the patient is bed-bound, parsed from `phiAlerts`. */
  phiIsBedBound?: Maybe<Scalars['PHIBoolean']>;
  primaryCoordinator?: Maybe<HhaxCoordinator>;
  alternateCoordinators: Array<HhaxCoordinator>;
  /**
   * The disciplines that the patient accepts.
   * We will only have this information for patients originating from HHAX.
   */
  phiAcceptedCaregiverDisciplines: Array<Scalars['PHIString']>;
  /**
   * A link to the patient in the scheduling system.
   *
   * This may return `null`, for e.g. if the integration is not configured
   * correctly (e.g. HHAXIntegration is missing entId), or if the patient
   * is not associated with an integration that supports this feature.
   */
  phiLinkToPatientInSchedulingSystem?: Maybe<Scalars['PHIString']>;
  /**
   * If `true`, the mutation `syncShiftsForPHIPatients` can be called for this patient
   * to resync their shifts from the external scheduling software.
   */
  canSyncShifts: Scalars['Boolean'];
};

/**
 * This is a subset of the PHIPatient type that is allowed to be accessed by an
 * authenticated caregiver.
 */
export type PhiPatientForCaregiver = {
  __typename?: 'PHIPatientForCaregiver';
  phiPatientId: Scalars['PHIString'];
  phiFirstName?: Maybe<Scalars['PHIString']>;
  phiLastName?: Maybe<Scalars['PHIString']>;
  phiAddress?: Maybe<PhiAddress>;
  phiHasDogs?: Maybe<Scalars['PHIBoolean']>;
  phiHasCats?: Maybe<Scalars['PHIBoolean']>;
  coordinatorName?: Maybe<Scalars['String']>;
};

export type PhiShiftCaregiverSummary = {
  __typename?: 'PHIShiftCaregiverSummary';
  id: Scalars['ID'];
  shiftId: Scalars['String'];
  shiftCreatedAt: Scalars['Timestamp'];
  shiftStartDate: Scalars['Timestamp'];
  shiftEndDate: Scalars['Timestamp'];
  phiPatientFirstName?: Maybe<Scalars['PHIString']>;
  phiPatientLastName?: Maybe<Scalars['PHIString']>;
  caregiverUserName: Scalars['String'];
  lastNotifiedBy?: Maybe<Scalars['String']>;
  firstNotifiedAt?: Maybe<Scalars['Timestamp']>;
  lastNotifiedAt?: Maybe<Scalars['Timestamp']>;
  firstViewedAt?: Maybe<Scalars['Timestamp']>;
  lastViewedAt?: Maybe<Scalars['Timestamp']>;
  firstInterestedAt?: Maybe<Scalars['Timestamp']>;
  lastInterestedAt?: Maybe<Scalars['Timestamp']>;
  assignedBy?: Maybe<Scalars['String']>;
  assignedAt?: Maybe<Scalars['Timestamp']>;
  acknowledgedAt?: Maybe<Scalars['Timestamp']>;
  isVisitConfirmed: Scalars['Boolean'];
};

export type PhiShiftPosting = {
  __typename?: 'PHIShiftPosting';
  id: Scalars['ID'];
  archived: Scalars['Boolean'];
  /** All non-removed visits associated with the shift posting, sorted by earliest rangeStart. */
  nonRemovedVisits: Array<PhiShiftPostingVisit>;
  phiPatient?: Maybe<PhiPatient>;
  urgency: ShiftPostingUrgency;
  phiUrgencyReasons?: Maybe<Array<ShiftPostingUrgencyReason>>;
  /** Number of caregivers that have active interest in open shifts for this shift posting. */
  numInterested: Scalars['Int'];
  /**
   * Number of caregivers that have been notified about this shift posting (via SMS),
   * and that do not have active interest in the shift posting.
   */
  numNotified: Scalars['Int'];
  /** Number of voice callbacks with active interest in open shifts for this shift posting. */
  numVoiceCallbacksWithInterest: Scalars['Int'];
  /** If true, admins can set rewards per visit on this shift posting. */
  eligibleForRewards: Scalars['Boolean'];
  /**
   * The total point rewards for open shifts on this shift posting.
   * This will be 0 if the shift posting is not eligible for rewards or no visits have rewards set.
   */
  totalPointRewardsForOpenShifts: Scalars['Int'];
  /** The 6-character active shift key for this posting. Can be used to lookup the shift posting by shift key. */
  activeShiftKey?: Maybe<Scalars['String']>;
  /** Computes match & details for a caregiver for this shift posting. */
  phiComputeMatchForCaregiver: PhiCaregiverShiftPostingMatchContext;
};


export type PhiShiftPostingPhiPatientArgs = {
  phiAccessReason: Scalars['String'];
};


export type PhiShiftPostingPhiComputeMatchForCaregiverArgs = {
  caregiverUserId: Scalars['ID'];
};

export type PhiShiftPostingVisit = {
  __typename?: 'PHIShiftPostingVisit';
  id: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
  assigned: Scalars['Boolean'];
  permanent: Scalars['Boolean'];
  /**
   * The caregiver that is assigned to the shift posting visit.
   * This will be `null` if the shift posting visit is not assigned, or if the caregiver
   * does not have a rewards user account
   */
  assignedCaregiver?: Maybe<RewardsUser>;
  /** The points to be earned by the caregiver who works this shift, if any. */
  shiftRewardPoints?: Maybe<Scalars['Int']>;
  /** Scheduling software that this Visit originates from. */
  schedulingSoftware: SchedulingSoftware;
  pendingConfirmation: Scalars['Boolean'];
  /**
   * A caregiver must have one of these disciplines to be assigned to this visit.
   * This may be `null` if the service code information for the visit is not available,
   * in which case we assume any caregiver is eligible.
   * We will only have this information for visits originating from HHAX.
   */
  phiCaregiverDisciplines?: Maybe<Array<Scalars['PHIString']>>;
};


export type ParadoxIntegration = {
  __typename?: 'ParadoxIntegration';
  id: Scalars['ID'];
  externalId: Scalars['String'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type ParentRewardsOrganization = {
  __typename?: 'ParentRewardsOrganization';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PartialUpdateOrganizationJobShareStructureInput = {
  reward: JobShareStructureRewardInput;
};

export type ParticipationInsightMetric = {
  __typename?: 'ParticipationInsightMetric';
  id: Scalars['ID'];
  numUsersWhoParticipated: Scalars['Int'];
  activeUserCount: Scalars['Int'];
};

export type PayCodesForCaregiverShiftAssignmentResponse = {
  __typename?: 'PayCodesForCaregiverShiftAssignmentResponse';
  payCodes: Array<CaregiverPayCodeInfo>;
  defaultPayCode?: Maybe<CaregiverPayCodeInfo>;
};

export type PointTransaction = {
  __typename?: 'PointTransaction';
  id: Scalars['ID'];
  signedPointValue: Scalars['Int'];
  unsignedPointValue: Scalars['Int'];
  occurredAt: Scalars['Timestamp'];
  description: Scalars['String'];
  type: PointTransactionType;
  reason: PointTransactionReason;
};

export type PointTransactionAwardedAssignedAsCandidateReferrerReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedAssignedAsCandidateReferrerReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedCustomPointsAwardedReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedCustomPointsAwardedReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedDailyRewardAchievedReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedDailyRewardAchievedReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedDrawPrizeWinnerReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedDrawPrizeWinnerReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedJobPostingSharedReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedJobPostingSharedReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedOptInReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedOptInReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedRecognitionPointsReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedRecognitionPointsReason';
  id: Scalars['ID'];
  recognitionPointsId?: Maybe<Scalars['ID']>;
};

export type PointTransactionAwardedReferralAppliedReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralAppliedReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedReferralCompletedFirstShiftReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralCompletedFirstShiftReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedReferralCompletedOrientationReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralCompletedOrientationReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedReferralHiredReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralHiredReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedReferralPassedInterviewReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralPassedInterviewReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedReferralReachedHourlyRetentionMilestoneReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralReachedHourlyRetentionMilestoneReason';
  id: Scalars['ID'];
  durationHours?: Maybe<Scalars['Int']>;
};

export type PointTransactionAwardedReferralReachedRetentionMilestoneReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralReachedRetentionMilestoneReason';
  id: Scalars['ID'];
  durationMonths?: Maybe<Scalars['Int']>;
};

export type PointTransactionAwardedReferralStartedOrientationReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedReferralStartedOrientationReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedRewardOfferCompletedReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedRewardOfferCompletedReason';
  id: Scalars['ID'];
  rewardOfferId: Scalars['ID'];
};

export type PointTransactionAwardedShiftMilestoneCompletedReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedShiftMilestoneCompletedReason';
  id: Scalars['ID'];
};

export type PointTransactionAwardedWelcomeOfferCompletedReason = PointTransactionReason & {
  __typename?: 'PointTransactionAwardedWelcomeOfferCompletedReason';
  id: Scalars['ID'];
};

export type PointTransactionDeductedCustomPointsDeductedReason = PointTransactionReason & {
  __typename?: 'PointTransactionDeductedCustomPointsDeductedReason';
  id: Scalars['ID'];
};

export type PointTransactionDeductedDuplicateReferralReason = PointTransactionReason & {
  __typename?: 'PointTransactionDeductedDuplicateReferralReason';
  id: Scalars['ID'];
};

export type PointTransactionDeductedHourlyRetentionMilestoneReversedReason = PointTransactionReason & {
  __typename?: 'PointTransactionDeductedHourlyRetentionMilestoneReversedReason';
  id: Scalars['ID'];
};

export type PointTransactionDeductedRecruitmentStepReversedReason = PointTransactionReason & {
  __typename?: 'PointTransactionDeductedRecruitmentStepReversedReason';
  id: Scalars['ID'];
};

export type PointTransactionDeductedRetentionMilestoneReversedReason = PointTransactionReason & {
  __typename?: 'PointTransactionDeductedRetentionMilestoneReversedReason';
  id: Scalars['ID'];
};

export type PointTransactionDeductedUnassignedAsCandidateReferrerReason = PointTransactionReason & {
  __typename?: 'PointTransactionDeductedUnassignedAsCandidateReferrerReason';
  id: Scalars['ID'];
};

export type PointTransactionFraudulentCandidateArchivedReason = PointTransactionReason & {
  __typename?: 'PointTransactionFraudulentCandidateArchivedReason';
  id: Scalars['ID'];
};

export type PointTransactionGoalAchievedReason = PointTransactionReason & {
  __typename?: 'PointTransactionGoalAchievedReason';
  id: Scalars['ID'];
};

export type PointTransactionReason = {
  id: Scalars['ID'];
};

export enum PointTransactionType {
  Awarded = 'AWARDED',
  Deducted = 'DEDUCTED'
}

export type PointsAwardedInsightMetric = {
  __typename?: 'PointsAwardedInsightMetric';
  id: Scalars['ID'];
  /**
   * Many point values are non-negative across the app, however this may be zero / negative,
   * for example, if the organization had a net point loss in a given period.
   */
  pointsAwarded: Scalars['Int'];
};

export type PointsRedeemedInsightMetric = {
  __typename?: 'PointsRedeemedInsightMetric';
  id: Scalars['ID'];
  pointsRedeemed: Scalars['Int'];
};

export type PowerHoursHourCondition = PowerHoursWeekendHoursCondition;

export type PowerHoursLevel = {
  __typename?: 'PowerHoursLevel';
  id: Scalars['ID'];
  /**
   * The index of this level within the offer.
   *
   * It is a 1-based index (the first level is `1`).
   */
  levelNumber: Scalars['Int'];
  /** The total number of hours required to finish this level. */
  hours: Scalars['Int'];
  /**
   * The total number of points that the user will earn if this is the level
   * that they end on.
   */
  pointValue: Scalars['Int'];
  /** If `true`, the user has finished this level. */
  finished: Scalars['Boolean'];
  /**
   * This is the current level that the user is trying to complete.
   * If `true`, this is the first level that the user has not finished.
   */
  current: Scalars['Boolean'];
  /**
   * If `true`, the user has acknowledged that they finished this level
   * (via the UI).
   */
  acknowledgedLevelFinished: Scalars['Boolean'];
};

export type PowerHoursOffer = {
  __typename?: 'PowerHoursOffer';
  id: Scalars['ID'];
  hourCondition?: Maybe<PowerHoursHourCondition>;
  /** The start of the range in which hours count towards this offer. */
  rangeStart: Scalars['Timestamp'];
  /**
   * The end of the range in which hours count towards this offer.
   *
   * This is also the timestamp at which the offer ends, and the user
   * earns their reward (if any).
   */
  rangeEnd: Scalars['Timestamp'];
  /** The total number of levels the user can complete for this offer. */
  totalNumLevels: Scalars['Int'];
  /**
   * The "current" level that the user is on.
   * If the user hasn't finished any levels yet, this will be `1`.
   * If `null`, the user has completed all levels.
   */
  currentLevelNumber?: Maybe<Scalars['Int']>;
  /** All levels for this offer. */
  levels: Array<PowerHoursLevel>;
  /** The number of hours the user has completed towards this offer. */
  trackedNumCompletedHours: Scalars['Int'];
  /**
   * If `true`, the offer has ended (likely because the `rangeEnd` has elapsed),
   * and the user should have been awarded their points.
   */
  ended: Scalars['Boolean'];
};

/** @deprecated */
export enum PowerHoursPeriodFrequency {
  Weekly = 'WEEKLY'
}

/** @deprecated */
export type PowerHoursProgress = {
  __typename?: 'PowerHoursProgress';
  userId: Scalars['ID'];
  /** Number between 0 and 100 */
  percentageCompleted: Scalars['Float'];
  hoursWorked: Scalars['Float'];
  hoursLeftToComplete: Scalars['Float'];
  hoursRequired: Scalars['Float'];
  periodFrequency: PowerHoursPeriodFrequency;
  pointsToEarn: Scalars['Int'];
};

export type PowerHoursWeekendHoursCondition = {
  __typename?: 'PowerHoursWeekendHoursCondition';
  id: Scalars['ID'];
};

export enum PulseCheckSurveyCadenceFrequency {
  Quarterly = 'QUARTERLY'
}

export type PulseCheckSurveyCadenceOverride = {
  __typename?: 'PulseCheckSurveyCadenceOverride';
  frequency: PulseCheckSurveyCadenceFrequency;
  startDate: Scalars['Timestamp'];
};

export type PulseCheckSurveyCadenceOverrideInput = {
  frequency: PulseCheckSurveyCadenceFrequency;
  startDate: Scalars['Timestamp'];
};

export type PulseCheckSurveyGoalDistributionConfig = {
  __typename?: 'PulseCheckSurveyGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  surveyRewardOverride?: Maybe<GoalConfigRewardOverride>;
  surveyCadenceOverride?: Maybe<PulseCheckSurveyCadenceOverride>;
  surveyDaysUntilExpirationOverride?: Maybe<Scalars['Int']>;
  sendInitialSurveyOnLaunch?: Maybe<Scalars['Boolean']>;
  selectedSurveyQuestions: Array<SurveyQuestionType>;
  anonymousSubmission?: Maybe<Scalars['Boolean']>;
};

export type PulseCheckSurveyGoalDistributionConfigAdminInput = {
  sendInitialSurveyOnLaunch?: Maybe<Scalars['Boolean']>;
  surveyRewardOverride?: Maybe<GoalRewardsInput>;
  surveyCadenceOverride?: Maybe<PulseCheckSurveyCadenceOverrideInput>;
  surveyDaysUntilExpirationOverride?: Maybe<Scalars['Int']>;
  /** The questions to be included in all surveys sent. */
  selectedSurveyQuestions?: Maybe<Array<SurveyQuestionType>>;
  /** Note: this will default to false (identifiable) if not provided on a new config. */
  anonymousSubmission?: Maybe<Scalars['Boolean']>;
};

export type PulseCheckSurveyGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  sendInitialSurveyOnLaunch?: Maybe<Scalars['Boolean']>;
  surveyRewardOverride?: Maybe<GoalRewardsInput>;
  surveyCadenceOverride?: Maybe<PulseCheckSurveyCadenceOverrideInput>;
  surveyDaysUntilExpirationOverride?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  getBulkImportStatus?: Maybe<BulkImportStatusResponse>;
  status?: Maybe<Status>;
  getTimezoneOptions: Array<TimezoneOption>;
  /**
   * Resolves with information about the logged in user's identity.
   * This includes all roles that the identity has.
   */
  getMyIdentity?: Maybe<Identity>;
  /**
   * Resolves with information about the role of the logged in user.
   * If the user is not logged in, resolves with `null`.
   */
  getMyAssumedRole: IdentityAssumedRole;
  /** @deprecated Replaced by `getMyAssumedRole` and `getMyIdentity` */
  getMyUserIdentity?: Maybe<UserIdentity>;
  /**
   * For rewards superusers, resolves with a list of active superuser phi access grants.
   *
   * For any tenants that grants are returned for, the user is able to view PHI data
   * for that organization.
   *
   * As of writing, these grants can only be created by an engineer (superuser), and
   * must only be granted for specific reasons (e.g. debugging).
   */
  getMyActiveRewardsSuperuserPHIAccessGrants: Array<RewardsSuperuserPhiAccessGrant>;
  /**
   * Resolves with the authenticated admin's user.
   * If the authenticated user is not a REWARDS_ADMIN, `null` will be returned.
   */
  getMyRewardsAdminUser?: Maybe<RewardsAdminUser>;
  getRewardsAdminById?: Maybe<RewardsAdminUser>;
  listRewardsAdmins: ListRewardsAdminsResponse;
  /**
   * Allows a rewards admin or rewards superuser to view
   * their MFA status.
   */
  getMyRewardsAdminMfaStatus: GetMyRewardsAdminMfaStatusResponse;
  /** @deprecated This is no longer needed */
  searchForRewardsAdminUsers: Array<RewardsAdminUser>;
  getRewardsAdminAuthStatus: GetRewardsAdminAuthStatusResponse;
  /**
   * Returns all admin goal configs at the organization, for all goal types,
   * where the end date has not yet passed.
   */
  getCurrentAdminGoalConfigs: Array<AdminGoalConfig>;
  /**
   * Returns a specific admin goal config by ID.
   * Returns null if the config doesn't exist or if the user doesn't have access to it.
   */
  getAdminGoalConfig?: Maybe<AdminGoalConfig>;
  /**
   * Returns all available, achieved, and failed goals for the authenticated admin user.
   * If the authenticated user is a REWARDS_SUPERUSER this will return an empty array.
   */
  getMyAdminGoals: Array<AdminGoal>;
  getEnabledAlayaCareIntegrations: Array<AlayaCareIntegration>;
  getCaribouUserSyncFilterOptionsForAlayaCareIntegration?: Maybe<AlayaCareCaribouUserSyncFilters>;
  getEnabledApploiIntegrations: Array<ApploiIntegration>;
  getRewardsAppBaseUrls: RewardsBaseUrls;
  /** Return a list of all the unique senders (from) */
  getAllRecognitionSendersForOrganization?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Allows a rewards admin to get bonus points by its id
   * @deprecated Use `getRecognitionPointsById` instead
   */
  getAwardedBonusPointsById?: Maybe<AwardedBonusPoints>;
  /** Allows a rewards admin to get recognition points by its id */
  getRecognitionById?: Maybe<Recognition>;
  /**
   * Allows a rewards admin to get recognition points by its id
   * @deprecated Use `getRecognitionById` instead
   */
  getRecognitionPointsById?: Maybe<RecognitionPoints>;
  /**
   * Allows a rewards admin to list all bonus points that have been SENT
   * @deprecated Use `listSentRecognitionPoints` instead
   */
  listAwardedBonusPoints?: Maybe<ListAwardedBonusPointsResponse>;
  /** Allows a rewards admin to list all bonus points that have been SENT */
  listSentRecognition: ListSentRecognitionResponse;
  /**
   * Allows a rewards admin to list all bonus points that have been SENT
   * @deprecated Use `listSentRecognition` instead
   */
  listSentRecognitionPoints: ListSentRecognitionPointsResponse;
  /**
   * Allows a rewards admin to list all bonus poinst that are SCHEDULED,
   * and are assigned to the admin to add a message.
   */
  listMyManagerScheduledRecognitionPoints: ListMyManagerScheduledRecognitionPointsResponse;
  /**
   * Allows a rewards user to get any currently claimable bonus points
   * @deprecated Use `getMyEmployeeClaimableRecognitionPoints` instead
   */
  getClaimableBonusPoints: Array<AwardedBonusPoints>;
  /**
   * Allows a rewards user to get any currently claimable recognition points
   * @deprecated claiming feature is deprecated
   */
  getMyEmployeeClaimableRecognitionPoints: Array<RecognitionPoints>;
  /** Allows a rewards user to get all of their sent recognition points */
  getMyEmployeeSentRecognition: Array<Recognition>;
  /**
   * Allows a rewards user to get all of their sent recognition points
   * @deprecated Use `getMyEmployeeSentRecognition` instead
   */
  getMyEmployeeSentRecognitionPoints: Array<RecognitionPoints>;
  /**
   * Allows a rewards user to get any scheduled recognition points
   * that are currently scheduled to be sent, or have already been sent.
   */
  getMyEmployeePendingAndSentScheduledRecognitionPoints: Array<RecognitionPoints>;
  /** @deprecated Use getMyRewardsOrganizationRecognitionCategories instead */
  getMyRewardsOrganizationBonusPointCategories: Array<RewardsBonusPointCategory>;
  getMyRewardsOrganizationRecognitionCategories: Array<RecognitionCategory>;
  listRecognitionCategories: ListRecognitionCategoriesResponse;
  /**
   * Gets a recognition category by ID.
   * Returns `null` if the category doesn't exist.
   */
  getRecognitionCategoryById?: Maybe<RecognitionCategory>;
  /**
   * Allows a rewards admin to get stats for recognition points sent by them,
   * including information about their budget.
   * @deprecated Use `getMyRecognitionPointsSentSummaryV2` instead
   */
  getMyRecognitionPointsSentSummary: GetMyRecognitionPointsSentSummaryResponse;
  /**
   * Allows a rewards admin to get stats for recognition points sent by them,
   * including information about their budget.
   */
  getMyRecognitionPointsSentSummaryV2: GetMyRecognitionPointsSentSummaryV2Response;
  /**
   * Allows a rewards admin to get stats for recognition points received by
   * their managed employees.
   * @deprecated Use `getMyManagedEmployeesRecognitionPointsReceivedSummaryV2` instead
   */
  getMyManagedEmployeesRecognitionPointsReceivedSummary: GetMyManagedEmployeesRecognitionPointsReceivedSummary;
  /**
   * Allows a rewards admin to get stats for recognition points received by
   * their managed employees.
   */
  getMyManagedEmployeesRecognitionPointsReceivedSummaryV2: GetMyManagedEmployeesRecognitionPointsReceivedSummaryV2Response;
  /**
   * Allows a rewards admin to page through recognition stats per employee
   * for their managed employees.
   * @deprecated Use `listMyManagedEmployeesRecognitionSummaryV2` instead
   */
  listMyManagedEmployeesRecognitionSummary: ListMyManagedEmployeesRecognitionSummaryResponse;
  /**
   * Allows a rewards admin to page through recognition stats per employee
   * for their managed employees.
   */
  listMyManagedEmployeesRecognitionSummaryV2: ListMyManagedEmployeesRecognitionSummaryV2Response;
  /**
   * Allows a rewards admin to page through recognition stats per employee
   * for their managed employees.
   */
  listMyRecognitionBudgetPeriods: ListMyRecognitionBudgetPeriodsResponse;
  /**
   * Allows REWARDS_ADMIN to get all possible next steps for candidates.
   * This is used to populate the admin dashboard Candidates page filter.
   */
  getCandidateNextStepFilterOptions: Array<CandidateNextStepFilterOption>;
  /** @deprecated Use listCandidatesV2 instead */
  listCandidates: ListCandidatesResponse;
  listCandidatesV2: ListCandidatesResponse;
  /**
   * Allows a rewards admin to get a candidate by its id.
   *
   * Returns null if the candidate does not exist.
   */
  getCandidateById?: Maybe<Candidate>;
  /** @deprecated Use getNumActiveCandidatesByJobPostingAndNextStep instead */
  getNumActiveCandidatesByJobPostingAndStatus: NumActiveCandidatesByJobPostingAndStatus;
  /**
   * Summarized the number of active candidates by job posting and _next_ step
   * (the next step that the candidate is able to complete).
   *
   * The job postings are ordered by total number of non-archived candidates
   * in the pipeline, descending.
   */
  getNumActiveCandidatesByJobPostingAndNextStep: NumActiveCandidatesByJobPostingAndNextStep;
  /** @deprecated Use getMyReferralsProgressV2 */
  getMyReferralsProgress: ReferralsProgressResponse;
  /** Allows a rewards user to view the progress of all of their active referrals. */
  getMyReferralsProgressV2: ReferralsProgressV2Response;
  listMyCaregiverImpactMonthsByCursor: ListMyCaregiverImpactMonthsByCursorResponse;
  getCaregiverImpactMonthById?: Maybe<CaregiverImpactMonth>;
  customerIOListNewUsersToScheduleForAdmin: CustomerIoListNewUsersToScheduleResponse;
  customerIOListUsersInterestedInLastMinuteShifts: CustomerIoListUsersInterestedLastMinuteShiftsResponse;
  customerIOListUsersInterestedInWeekendShifts: CustomerIoListUsersInterestedWeekendShiftsResponse;
  customerIOListUsersInterestedInMoreBillableHours: CustomerIoListUsersInterestedInMoreBillableHoursResponse;
  /**
   * Gets the "current" draw for the authenticated REWARDS_USER
   * at their organization.
   *
   * The "current draw" is one of the following:
   *   - The running draw
   *   - The next draw that is scheduled
   *   - The last draw that closed (if there are no scheduled draws)
   */
  getMyCurrentDraw?: Maybe<Draw>;
  /**
   * Gets the currently-running Caribou-sponsored draw.
   * This draw runs monthly, across all orgs.
   * As of writing, draws run monthly.
   */
  getMyCurrentCaribouSponsoredDraw?: Maybe<CaribouSponsoredDraw>;
  /** Gets the most recent draw that closed at the organization. */
  getLastDraw?: Maybe<Draw>;
  /**
   * Allows a rewards user to query the number of tickets
   * that they have spent on the provided draw.
   */
  countMyTicketsInDraw: CountMyTicketsInDrawResponse;
  /**
   * Allows a rewards user to query the ways that
   * they are able to earn draw tickets
   */
  getMyDrawWaysToEarn: Array<DrawWayToEarn>;
  /** @deprecated Use `getAllDraws` instead, and transform client-side */
  getAllDrawsByScheduleStatus: GetAllDrawsByScheduleStatusResponse;
  /**
   * Gets a draw by its ID.
   * Resolves with `null` if the draw doesn't exist on the schedule.
   */
  getDrawById?: Maybe<Draw>;
  /** Allows an admin to view all of the draws at their org */
  getAllDraws: Array<Draw>;
  /**
   * Allows a rewards user to view all past draws at their org.
   * This is useful so they can navigate to the winners of past draws.
   */
  getAllPastDraws: Array<Draw>;
  /**
   * Gets the total number of unclaimed draws for the user.
   * This query requires the rewards users to be authenticated.
   */
  getMyTotalUnclaimedDraws: GetMyTotalUnclaimedDrawsResponse;
  /**
   * Gets the latest unclaimed draw for the user.
   * This query requires the rewards users to be authenticated.
   */
  getMyLatestUnclaimedDraw?: Maybe<Draw>;
  /**
   * Allows an admin to list draw ticket transactions for a user.
   *
   * This only includes tickets that were awarded to the user,
   * and does not include tickets that were spent on a draw.
   */
  listAwardedDrawTicketTransactionsForUser: ListAwardedDrawTicketTransactionsForUserResponse;
  /** Gets the organization draw settings. */
  getOrganizationDrawSettings: OrganizationDrawSettings;
  getEVVCompletionRateOfferById?: Maybe<EvvCompletionRateOffer>;
  /**
   * Allows a rewards user to list their EVV completion rate offers.
   * This only includes EVV completion rate offers which are not deleted.
   */
  listMyEVVCompletionRateOffers: Array<EvvCompletionRateOffer>;
  /**
   * Resolves all of the `AVAILABLE` goals for the authenticated Rewards User.
   * These can be displayed on the home screen.
   */
  getMyRewardsUserAvailableGoals: Array<Goal>;
  /**
   * Resolves the _next_ `LOCKED` goals for the authenticated Rewards User.
   * There may be _more_ locked goals other than these - but these are
   * the goals that are unlocked soon (based on time, or when an available goal is completed)
   */
  getMyRewardsUserNextLockedGoals: Array<Goal>;
  /**
   * Resolves a subset of achieved goals for the authenticated Rewards User to be displayed on the home page.
   * As of writing, this includes the welcome video.
   */
  getMyRewardsUserAchievedGoalsForHomePage: Array<Goal>;
  /**
   * Resolves with the goal track for the authenticated Rewards User
   * matching the given `trackName`.
   */
  getMyRewardsUserGoalTrack: GetMyRewardsUserGoalTrackResponse;
  /** Resolves all achieved goals for a user that have not yet been acknowledged as achieved. */
  getMyRewardsUserGoalsWithUnacknowledgedAchievement: Array<Goal>;
  /** Resolves achieved goals for the authenticated Rewards User, with optional filtering by goal types. */
  getMyRewardsUserAchievedGoals: Array<Goal>;
  /** Resolves goals with EXPIRED_WAITING_FOR_LATE_ARRIVING_DATA status for the authenticated Rewards User. */
  getMyRewardsUserExpiredWaitingForLateArrivingDataGoals: Array<Goal>;
  /**
   * For Rewards Users to query:
   *
   * Given a `videoId` (the ID for a `Video`),
   * resolves an available `Goal` that will be achieved
   * once this video is watched.
   */
  getMyAvailableGoalForVideoId?: Maybe<Goal>;
  /** Resolves the organization goal config and related properties for superuser/retool users. */
  retoolGetOrganizationGoalConfigById?: Maybe<OrganizationGoalConfig>;
  /** Allows admins to get their organization goal config. */
  getMyOrganizationGoalConfig?: Maybe<OrganizationGoalConfig>;
  /** Resolves a goal by ID for the authenticated Rewards User. */
  getGoalById?: Maybe<Goal>;
  /** Resolves whether a user's organization has available goals of a given type. */
  getMyOrganizationHasAvailableGoals: HasAvailableGoalsResponse;
  /**
   * Lists rewards tags
   * Tags are generic first-class thing that any resource in Caribou system can have.
   */
  listRewardsTags: ListRewardsTagsResponse;
  /** Lists rewards tags grouped by type for integration */
  listRewardsTagsGroupedByTypeForIntegration?: Maybe<Array<TagGroup>>;
  /**
   * Lists rewards groups
   * Groups have a config of tags to evaluate membership of entities in the Caribou system.
   */
  listRewardsGroups: ListRewardsGroupsResponse;
  getEnabledHHAXIntegrations: Array<HhaxIntegration>;
  getCaregiversToSyncForHHAXIntegration?: Maybe<GetHhaxCaregiversToSyncResponse>;
  getCaribouUserSyncFilterOptionsForHHAXIntegration?: Maybe<HhaxCaribouUserSyncFilters>;
  getHHAXCaribouUserSyncById: HhaxCaribouUserSync;
  getEnabledHHAXIntegrationsByOrganizationId: Array<HhaxIntegration>;
  /** Returns all HHAX coordinators for an organization, including inactive ones. */
  getHHAXCoordinators: Array<HhaxCoordinator>;
  /** Returns count of open shift postings with no assigned coordinator for an organization. */
  getHHAXOrganizationShiftPostingCountWithNoAssignedCoordinator: HhaxOrganizationShiftPostingCountWithNoAssignedCoordinator;
  /** Allows a REWARDS_ADMIN to view all HHAX coordinator accounts that they are connected to, if any. */
  getMyConnectedHHAXCoordinators: Array<HhaxCoordinator>;
  /**
   * Allows admins to view the date ranges for which insights data is available,
   * ordered by most recent (current date) to the oldest (organization launch date).
   */
  getAvailableInsightDateRanges: InsightDateRanges;
  /**
   * Allows admins to get the number of active users at a given date.
   * For metrics over a date range, this is the date range end.
   */
  getActiveUsersInsightMetric: ActiveUsersInsightMetric;
  /**
   * Allows admins to get the number of users who logged in at least once during a given date range.
   * Also returns the total number of active users at the point in time of the given end date, so the two metrics can be compared.
   */
  getLoggedInUsersInsightMetric: LoggedInUsersInsightMetric;
  /** Allows admins to get the total number of points awarded during a given date range. Does not include unclaimed points. */
  getPointsAwardedInsightMetric: PointsAwardedInsightMetric;
  /** Allows admins to get the total number of points redeemed during a given date range. Does not include unclaimed points. */
  getPointsRedeemedInsightMetric: PointsRedeemedInsightMetric;
  /** Allows admins to get the total number of candidates hired during a given date range. */
  getTotalHiresInsightMetric: TotalHiresInsightMetric;
  /**
   * Allows admins to get the cost of referrals worked in a given date range by hired candidates.
   * Candidates do not necessarily need to have been hired during the date range.
   */
  getCostOfReferralsInsightMetric: CostOfReferralsInsightMetric;
  /**
   * Allows admins to get the hours worked in a given date range by hired candidates.
   * Hired candidates include those hired before the start of the date range.
   */
  getReferralHoursWorkedInsightMetric: ReferralHoursWorkedInsightMetric;
  /**
   * Allows admins to get the number of recognized employees during a given date range.
   * A recognized employee is an employee who received recognition bonus points at least once.
   */
  getRecognizedEmployeesInsightMetric: RecognizedEmployeesInsightMetric;
  /** Allows admins to get the total recognition points awarded to employees during a given date range. */
  getRecognitionAwardedInsightMetric: RecognitionPointsInsightMetric;
  /** Allows admins to get bonus points sent by admins with budgets and the admin budget total during a given date range. */
  getBudgetUsageInsightMetric: BudgetUsageInsightMetric;
  /** Allows admins to get the number of admins who have used any of their budget during a given date range. */
  getAdminsUsingRecognitionInsightMetric: AdminsUsingRecognitionInsightMetric;
  /** Allows admins to get the number of users who have shared a job during a given date range. */
  getJobSharesInsightMetric: JobSharesInsightMetric;
  /** Allows admins to get the number of applicants during a given date range. */
  getApplicantsInsightMetric: ApplicantsInsightMetric;
  /**
   * Allows admins to get the number of 'goals' achieved during a given date range.
   * A 'goal' achievement is any goal aggregate achieved, or rewards offer completed.
   */
  getGoalsAchievedInsightMetric: GoalsAchievedInsightMetric;
  /**
   * Allows admins to get the number of users who participated in the rewards program during a given date range.
   * A user is considered to have participated if they have any 'goal' achievements during that date range.
   *
   * Similar to the goals achieved metric, the definition of a 'goal' achievement is any
   * goal aggregate achieved, or rewards offer completed.
   */
  getParticipationInsightMetric: ParticipationInsightMetric;
  /**
   * Allows admins to get the number of users who started working during a given date range,
   * and of the users with a first shift, the average time between start date and their first shift
   */
  getTimeToFirstShiftInsightMetric: TimeToFirstShiftInsightMetric;
  /** Allows admins to get the response rate of the first shift survey in a given date range. */
  getFirstShiftSurveyResponseRateInsightMetric: FirstShiftSurveyResponseRateInsightMetric;
  /** Allows admins to get the average score of the first shift survey in a given date range. */
  getFirstShiftSurveyAverageInsightMetric: FirstShiftSurveyAverageInsightMetric;
  /**
   * Public query which allows an applicant to see if a resume has been uploaded
   * Either `applicationSubmissionId` or `candidateId` must be provided
   */
  getApplicantHasUploadedResume: Scalars['Boolean'];
  /**
   * Public query which allows an applicant to see if a referral link is enabled
   * Either `jobShareId` or `userId` and `organizationId` must be provided
   */
  getJobShareLinkDisabledForUser: GetJobShareLinkDisabledForUserResponse;
  /**
   * For Rewards Users only.
   * Lists shareable (open) job postings for the user's organizaiton.
   */
  listShareableJobPostings?: Maybe<JobPostingListResponse>;
  getSharableJobPostingFilterOptions: GetSharableJobPostingFilterOptions;
  /** Public query. Gets a job posting by its id. */
  getJobPostingById?: Maybe<JobPosting>;
  /**
   * Public query.
   * Gets a job posting by a job share id.
   */
  getJobPostingByShareId?: Maybe<JobPosting>;
  /**
   * Public query.
   * Allows an applicant to search for a different job to apply for at the organization.
   */
  listOpenJobPostings: JobPostingListResponse;
  /**
   * Public query.
   * Gets a job posting by an application submission id or candidate id.
   */
  getJobPostingByApplicationSubmission?: Maybe<JobPosting>;
  /**
   * For Rewards Admins only.
   * Lists all job postings (including closed job postings).
   */
  listJobPostings: JobPostingListResponse;
  /** Lists unique candidate alert emails currently assigned to job postings. */
  listUniqueCandidateAlertEmails: ListUniqueCandidateAlertEmailsResponse;
  /** @deprecated Use listJobPostings instead */
  searchForOpenJobPostings: Array<JobPosting>;
  /**
   * Validates an ATS job and returns team information.
   * This is to be called before creating a new job posting with an external ATS connection,
   * to ensure the connection is valid. If updating an existing job posting, use `connectJobPostingToATSJob`.
   * Supports multiple ATS integrations based on externalAtsIntegrationId.
   */
  validateATSJob: ValidateAtsJobResult;
  /**
   * For rewards users.
   * Returns the number of jobs shared by the user this month.
   */
  countMyJobSharesThisMonth: CountMyJobSharesForRange;
  /** @deprecated This was used for the draws MVP to count tickets earned from job shares. It has been replaced by the `countMyTicketsInDraw` query, which includes the draw ticket count. This query always resolves with `0`, and is only here for API backwards compatibility. */
  countMyJobSharesInRange: CountMyJobSharesForRange;
  getRewardsLeaderboard: RewardsLeaderboard;
  getMyRewardsUserMilestoneRewards?: Maybe<UserMilestoneRewards>;
  getOrganizationMilestoneRewardSettings?: Maybe<OrganizationMilestoneRewardSettings>;
  /**
   * Poll this to get the status and result of a backfill preview calculation
   * after you call `triggerBackfillRewardsPreviewCalculation`, you canrepeatedly call this
   * until the returned status is COMPLETED or FAILED.
   */
  getFinalResultForEligibleUsersMilestoneRewardsForOrganization: MilestoneRewardsBackfillRewardsPreviewResult;
  listMyRewardNotifications: Array<RewardNotification>;
  /**
   * Allows a rewards user to list their reward active offers.
   * Revoked offers are not included.
   */
  listMyRewardOffers: Array<RewardOffer>;
  /** Allows a superuser to list reward offers */
  adminListRewardOffers: AdminlistRewardOffersResponse;
  adminGetRewardOfferStats?: Maybe<AdminGetRewardOfferStatsResponse>;
  listUserEligibilitySettingsForMyOrganization: Array<UserEligibilitySettings>;
  getForMyOrganizationAndExternalIntegrationId?: Maybe<UserEligibilitySettings>;
  listExternalIntegrationIdsForMyOrganization: Array<Scalars['String']>;
  listRewardsUsersToSyncForMyOrganization: RewardsUsersToSyncListResponse;
  getUserEligibilitySummaryForMyOrganization: GetUserEligibilitySummaryResponse;
  /** Public query (although many organization fields are private) */
  getRewardsOrganizationById?: Maybe<RewardsOrganization>;
  /** Public query (although many organization fields are private) */
  getRewardsOrganizationsByIds?: Maybe<Array<Maybe<RewardsOrganization>>>;
  getMyRewardsOrganization: RewardsOrganization;
  /**
   * Allows a REWARDS_ADMIN or REWARDS_SUPERUSER to fetch a list of all organizations they have access to.
   *
   * For REWARDS_ADMIN roles, this will resolve with all organizations that they are active in.
   * For REWARDS_SUPERUSER roles, this will resolve with all organizations
   */
  getMyRewardsOrganizations: Array<RewardsOrganization>;
  getMyRewardsOrganizationBranch: RewardsOrganizationBranch;
  /**
   * Fetches an opt-in promo for a given organization id and work email (if exists)
   *
   * This is a public query (doesn't require authentication).
   */
  getRewardsOrganizationOptInPromo?: Maybe<RewardsOrganizationOptInPromo>;
  adminListRewardsOrganizations: AdminListRewardsOrganizationsResponse;
  /**
   * Public query to fetch a rewards organization.
   * `applicationSubmissionId` or `candidateId` is required.
   */
  getRewardsOrganizationByApplicationSubmission?: Maybe<RewardsOrganization>;
  /** Public query to fetch a rewards organization for a given work email. */
  getRewardsOrganizationByWorkEmail?: Maybe<RewardsOrganization>;
  /**
   * For rewards admins only.
   * Fetches stats about the organization.
   */
  getRewardsOrganizationStats?: Maybe<RewardsOrganizationStats>;
  /**
   * Query to retrieve the EVV rules for the organization.
   * The `evvRules` field will always return a non-null `RewardsOrganizationEVVRules` object.
   */
  getMyRewardsOrganizationEVVRules: RewardsOrganizationEvvRules;
  /** @deprecated Use RewardsOrganization.referralRewardStructure instead */
  getDefaultRewardsOrganizationReferralStructure: Array<ReferralRewardStructureItem>;
  /**
   * Fetches metrics about the organization's launch, which can be used
   * to monitor that invitations are being sent out to new users.
   */
  retoolGetOrganizationLaunchMetrics: OrganizationLaunchMetrics;
  /** Allows Retool to list all parent organizations. */
  retoolListParentOrganizations: Array<ParentRewardsOrganization>;
  /**
   * Search caregiver accounts across scheduling integrations for an organization.
   * Requires at least one of: firstName, lastName, email, or phone.
   * Returns at most the first 50 matches per integration.
   */
  retoolSearchCaregiverAccounts: Array<RetoolSearchCaregiverAccountsResult>;
  getEnabledParadoxIntegrations: Array<ParadoxIntegration>;
  getPowerHoursOfferById?: Maybe<PowerHoursOffer>;
  /**
   * Allows a rewards user to list their power hours.
   * This only includes power hours which are not deleted.
   */
  listMyPowerHoursOffers: Array<PowerHoursOffer>;
  /** @deprecated This is no longer used */
  getMyPowerHoursProgress?: Maybe<PowerHoursProgress>;
  /** Lists top gift cards in Tango */
  listGiftCardOptions?: Maybe<ListGiftCardOptionsResponseResponse>;
  /** Lists redemptions ordered by date created (descending) */
  listRedemptions: RedemptionsResponse;
  /**
   * Allows a REWARDS_USER to view their redemptions,
   * ordered by most recently requested
   */
  getMyRewardsUserRedemptions: GetMyRewardsUserRedemptionsResponse;
  /** Lists redemptions with transactions */
  retoolListRedemptionsByCursor: ListRedemptionsByCursorResponse;
  /** Returns redemption exports with given Ids */
  retoolGetRedemptionExportsByIds: RetoolGetRedemptionExportsByIdsResponse;
  /**
   * Allows a rewards user to get available redemption catalog items.
   *
   * Note that the organization must include CATALOG as an allowed redemption method
   * in order to redeem one of these items.
   *
   * Also, the user must have enough points, and exceed the minimum point value
   * for redemptions.
   */
  getMyAvailableRedemptionCatalogItems: Array<RedemptionCatalogItem>;
  /** Returns a redemption catalog item by ID, if exists and is available. */
  getAvailableRedemptionCatalogItem?: Maybe<RedemptionCatalogItem>;
  /**
   * Allows a rewards admin to get all referral structures for an organization.
   *
   * The default structure shows first, followed by all other structures (by name ascending).
   */
  getAllReferralStructures: Array<ReferralStructure>;
  /**
   * Allows a rewards admin to get a referral structure by its ID.
   *
   * If it doesn't exist, it will return null.
   */
  getReferralStructureById?: Maybe<ReferralStructure>;
  /**
   * Lists all transactions for a rewards account, including redemption transactions.
   *
   * Note: transactions are sorted by most to least recent.
   */
  listTransactionsForRewardsAccount: ListTransactionsForRewardsAccountResponse;
  /**
   * Lists all transactions for a rewards account using cursor-based pagination, including redemption transactions.
   *
   * Note: transactions are sorted by most to least recent.
   */
  listMyRewardsUserPointTransactionsByCursor: ListMyRewardsUserPointTransactionsByCursorResponse;
  /**
   * For admin use only.
   *
   * Gets the period summary for the current admin's shift reward budget,
   * or `null` if the admin does not have a shift reward budget.
   */
  getMyAdminShiftRewardBudgetPeriodSummary: GetMyAdminShiftRewardBudgetPeriodSummaryResponse;
  /**
   * Gets the given visit by ID.
   *
   * If the visit is no longer an open shift, will return `null`
   */
  getOpenShiftById?: Maybe<Visit>;
  /** Gets the current user's caregiver profile, if it exists. */
  getMyCaregiverProfile?: Maybe<CaregiverProfile>;
  /**
   * Returns whether the current user can access shift booking. True only when
   * ALL of the following conditions are met:
   * - the user is eligible for shift booking
   * - shift booking has been launched to caregivers at the organization
   * - the agency has enabled shift booking at the org level
   * launched to caregivers at the organization. Use this in the application
   * instead of checking both conditions separately.
   */
  getUserShiftBookingAccess: UserShiftBookingAccess;
  /** Returns HHAX discipline compatibility mappings used by shift booking. */
  getHHAXDisciplineCompatibilityMappings: Array<HhaxDisciplineCompatibility>;
  /**
   * Gets the open shift postings for the given coordinator.
   * @deprecated Use `listOpenShiftPostings` instead.
   */
  getOpenShiftPostingsByCoordinator: Array<PhiShiftPosting>;
  /**
   * Lists open shift postings for multiple coordinators with pagination and optional date range filtering.
   * @deprecated Use `listOpenShiftPostings` instead.
   */
  listOpenShiftPostingsForCoordinators: ListOpenShiftPostingsForCoordinatorsResponse;
  /**
   * Lists shift posting IDs for the given organization and filters.
   *
   * By default, it is sorted by soonest open shift start date in the shift posting (ascending).
   * Note that the filtering can change the sorting behaviour - see below.
   *
   * - If no filters are provided, returns all shift postings.
   * - If a date range is provided, filters shifts to only those where the earliest
   *   open shift starts within the provided date range.
   * - If a caregiver ID filter is provided, returns shift postings ordered by
   *   match score descending for that caregiver. If they are not matched,
   *   orders remaining shifts by soonest start date.
   * - If a coordinator external ID filter is provided, returns shift postings
   *   with at least one of the provided coordinator external IDs assigned to the
   *   patient of those shift postings.
   */
  listOpenShiftPostings: ListOpenShiftPostingsResponse;
  /**
   * Gets the PHI shift posting by ID.
   * Returns `null` if the shift posting is not found or has been archived.
   */
  getOpenShiftPostingById?: Maybe<PhiShiftPosting>;
  /**
   * Gets the PHI shift posting by ID (including archived shift postings).
   * Returns `null` if the shift posting is not found.
   */
  getShiftPostingById?: Maybe<PhiShiftPosting>;
  /** @deprecated Use listPHITopRecommendedCaregiversToReachOutToForShiftPosting instead. */
  listPHICaregiverMatchesForShiftPosting: ListPhiCaregiverMatchesForShiftPostingResponse;
  /** @deprecated Use listPHIInterestedCaregiversForShiftPostingV2 instead. */
  listPHIInterestedCaregiversForShiftPosting: ListPhiInterestedCaregiversForShiftPostingResponse;
  /** @deprecated Use listPHINotifiedCaregiversForShiftPostingV2 instead. */
  listPHINotifiedCaregiversForShiftPosting: ListPhiNotifiedCaregiversForShiftPostingResponse;
  /** @deprecated Use listPHITopRecommendedCaregiversToReachOutToForShiftPostingV2 instead. */
  listPHITopRecommendedCaregiversToReachOutToForShiftPosting: ListPhiTopRecommendedCaregiversToReachOutToForShiftPostingResponse;
  /**
   * Lists the caregivers that have expressed interest in the given shift posting,
   * ordered by the highest match score first and paginated.
   */
  listInterestedCaregiversForShiftPostingV2: ListInterestedCaregiversForShiftPostingResponseV2;
  /**
   * Lists the caregivers that have been notified about the given shift posting,
   * ordered by the highest match score first and paginated.
   */
  listNotifiedCaregiversForShiftPostingV2: ListNotifiedCaregiversForShiftPostingResponseV2;
  /**
   * Lists the top recommended caregivers to reach out to for the given shift posting.
   *
   * These are the top matches, excluding those that have been notified or expressed interest.
   * @deprecated Use listTopRecommendedCaregiversToReachOutToForShiftPostingV3 instead
   */
  listTopRecommendedCaregiversToReachOutToForShiftPostingV2: ListTopRecommendedCaregiversToReachOutToForShiftPostingResponseV2;
  /**
   * Lists the top recommended caregivers to reach out to for the given shift posting.
   * These are the top matches, excluding those that have been notified or expressed interest.
   * Supports cursor-based pagination and userIdNotIn filter.
   */
  listTopRecommendedCaregiversToReachOutToForShiftPostingV3: ListTopRecommendedCaregiversToReachOutToForShiftPostingResponseV3;
  /**
   * Lists broadcast history for a shift posting, reading from both
   * the new CaregiverShiftPostingBroadcasts table and legacy CaregiverShiftPostingNotifications table.
   *
   * Results are sorted by sentAt descending (most recent first) and paginated.
   */
  listBroadcastsForShiftPosting: ListBroadcastsForShiftPostingResponse;
  /**
   * Gets the given caregiver shift posting match by shift posting and caregiver.
   *
   * If there was never a match, will return `null`.
   * If there was a match, but it is no longer a match, will return a record
   * with `isMatch` set to `false`.
   */
  getPHICaregiverShiftPostingMatchByShiftPostingAndCaregiver?: Maybe<PhiCaregiverShiftPostingMatch>;
  /**
   * Gets the total visit hours for the current user by week, for the authenticated `REWARDS_USER`
   *
   * It will factor in the agency's payroll start date to determine the week start date.
   */
  getMyUpcomingTotalVisitHoursByWeek: Array<TotalVisitHoursByWeek>;
  /**
   * Gets the total visit hours for the given caregiver by week, for the given caregiver ID. (Rewards user ID)
   *
   * It will factor in the agency's payroll start date to determine the week start date.
   */
  getUpcomingTotalVisitHoursByWeekForCaregiver: Array<TotalVisitHoursByWeek>;
  /**
   * Gets the non-PHI shift posting by ID.
   * Returns `null` if the shift posting is not found or has been archived.
   * @deprecated Use getNonPHIOpenShiftCardById instead.
   */
  getNonPHIOpenShiftPostingById?: Maybe<NonPhiShiftPosting>;
  /**
   * Returns non-PHI shift posting cards for the caregiver's top picks,
   * excluding dismissed picks and shifts the caregiver has already expressed interest in.
   * When `broadcastedShiftId` is provided, that shift is prepended as the first result
   * even if it is not a top pick or the shift posting is now closed (if a card can be returned).
   */
  getNonPHITopShiftPostings: Array<NonPhiShiftPostingCard>;
  /**
   * Gets the non-PHI shift posting card by ID.
   * Returns `null` if the shift posting card is not found or has been archived.
   */
  getNonPHIOpenShiftPostingCardById?: Maybe<NonPhiShiftPostingCard>;
  /**
   * Lists the matches for the current user.
   * @deprecated Use listMyNonPHIShiftPostingCardMatches instead. The V2 version provides better functionality by distinguishing between temporary and permanent shifts, grouping recurring shifts by pattern, and surfacing urgent permanent shifts as separate temporary cards.
   */
  listMyNonPHIShiftPostingMatches: ListMyNonPhiShiftPostingMatchesResponse;
  /**
   * V2 version of listMyNonPHIShiftPostingMatches that returns shift posting cards.
   *
   * Returns NonPHIShiftPostingCard union types instead of NonPHIShiftPosting objects.
   * Uses the same matching logic and filters as listMyNonPHIShiftPostingMatches.
   *
   * Cards distinguish between temporary and permanent shift postings:
   * - Temporary cards (NonPHIShiftPostingCardTemporary): Show individual visits
   * - Permanent cards (NonPHIShiftPostingCardPermanent): Group recurring shifts by
   *   day-of-week and time pattern
   *
   * For permanent shift postings with urgent shifts, both card types are returned:
   * a permanent card with recurring patterns and a separate temporary card containing
   * only the urgent shifts, increasing engagement with time-sensitive shifts.
   */
  listMyNonPHIShiftPostingCardMatches: ListMyNonPhiShiftPostingCardMatchesResponse;
  /**
   * Gets the shift postings that the current user has expressed interest in
   * for upcoming shifts, whether they are still open or not.
   *
   * This excludes shift postings that have been assigned to the current user.
   * @deprecated Use getMyInterestedFutureNonPHIShiftPostingCards instead.
   */
  getMyInterestedFutureNonPHIShiftPostings: Array<NonPhiShiftPosting>;
  /**
   * Returns shift posting cards for shift postings the current user has expressed interest in.
   * The card type (permanent or temporary) is determined by the interest type:
   * - If interest was submitted via permanent card, returns permanent card
   * - If interest was submitted via temporary card, or from the legacy open shift card,
   *   returns temporary card
   */
  getMyInterestedFutureNonPHIShiftPostingCards: Array<NonPhiShiftPostingCard>;
  /**
   * Gets the unread shift posting match summary for the current user.
   *
   * This is used to determine if the current user has any unread shift posting matches.
   */
  getMyUnreadShiftPostingMatchSummary: UnreadShiftPostingMatchSummary;
  /**
   * Gets the pay codes available for a specific caregiver.
   *
   * This is used to retrieve the pay codes that a caregiver is authorized to use
   * when working shifts, which is needed for visit assignment.
   * @deprecated Use getPayCodesForCaregiverShiftAssignment instead
   */
  getCaregiverPayCodes: Array<CaregiverPayCodeInfo>;
  /**
   * Gets the pay codes available for a caregiver being assigned to specific shift posting visits.
   * Also determines a default pay code based on the organization's configuration and the visits' disciplines.
   */
  getPayCodesForCaregiverShiftAssignment: PayCodesForCaregiverShiftAssignmentResponse;
  /**
   * Returns an array of shift posting visit IDs that the given caregiver has conflicts with.
   *
   * A conflict can be either an existing scheduled visit that overlaps,
   * or a scheduled unavailability on the same day as the visit.
   *
   * To be used by REWARDS_ADMIN before assigning visits to a caregiver.
   */
  getCaregiverShiftPostingVisitConflicts: Array<Scalars['ID']>;
  /**
   * Lists the "assigned" shift postings for the given coordinator from the past 30 days.
   *
   * These are shift postings that are archived and have at least one non-removed visit
   * assigned by our system.
   */
  listAssignedShiftPostingsForCoordinator: ListAssignedShiftPostingsForCoordinatorResponse;
  /**
   * Lists the "assigned" shift postings for multiple coordinators with pagination.
   *
   * These are shift postings that are archived and have at least one non-removed visit
   * assigned by our system.
   */
  listArchivedAssignedShiftPostingsForCoordinators: ListArchivedAssignedShiftPostingsForCoordinatorsResponse;
  /**
   * Allows a REWARDS_ADMIN to search for PHI patients by name.
   *
   * This only includes ACTIVE patients.
   */
  searchForPHIPatients: Array<PhiPatient>;
  /** Allows a REWARDS_ADMIN to get a PHI patient by ID. */
  getPHIPatientById?: Maybe<PhiPatient>;
  /** Lists shift caregiver summaries with pagination and filtering. */
  listPHIShiftCaregiverSummaries: ListPhiShiftCaregiverSummariesResponse;
  /**
   * Gets the shift postings that have visits which the current user is pending confirmation for.
   * This happens when the visit is assigned to the caregiver but requires confirmation.
   * Once all visits for a shift posting have been confirmed, it will no longer be included in the result.
   */
  getMyNonPHIShiftPostingsPendingConfirmation: Array<NonPhiShiftPosting>;
  /**
   * For Retool use only.
   *
   * Lists shift posting matches for an organization.
   * Returns data formatted for either temporary or permanent shift postings based on the permanentOrTemporary parameter.
   */
  retoolListMatchesForShiftPostings: RetoolListMatchesForShiftPostingsResponse;
  /**
   * For Retool use only.
   *
   * Lists open shift postings for an organization within a date range.
   * Returns simplified data with organization ID and shift posting ID.
   */
  retoolListOpenShiftPostings: RetoolListOpenShiftPostingsResponse;
  /**
   * For Retool use only.
   *
   * Gets the shift booking settings for an organization.
   */
  retoolGetShiftBookingSetting?: Maybe<RetoolShiftBookingSetting>;
  /**
   * Allows a rewards user to get their latest shift milestone details.
   * If null is returned, shift mielstones are disabled for this user.
   */
  getMyShiftMilestones?: Maybe<RewardsUserShiftMilestoneDetails>;
  /**
   * Allows a Rewards User to cursor-paginate social feed
   * posts that are visible to them
   */
  listMySocialFeedPostsByCursor: ListMySocialFeedPostsByCursorResponse;
  /** Allows a Rewards User or Admin to query a post by ID */
  getSocialPostById?: Maybe<SocialPost>;
  /** Returns a summary of unread posts for the logged in Rewards User */
  getMyUnreadSocialPostSummary: UnreadSocialPostSummary;
  /** Returns the social feed settings for an organization. */
  getMyOrganizationSocialFeedSettings: OrganizationSocialFeedSettings;
  /**
   * Allows admins to get their organization's first shift survey settings.
   * Returns null if the organization has not configured first shift surveys.
   */
  getMyOrganizationFirstShiftSurveySettings?: Maybe<OrganizationFirstShiftSurveySettings>;
  /**
   * Allows admins to view a summary of survey engagement at their organization,
   * for a specific survey type and date range.
   * If no date range is provided, will return all-time engagement data.
   */
  getSurveyEngagement: SurveyEngagementResponse;
  /**
   * Allows admins to view the average overall score (average of all questions)
   * at their organization, for a specific survey type and date range.
   * Includes comparison to the date range previous to the one requested, if available.
   * If no date range is provided, will return all-time average.
   */
  getSurveyAverageScore: SurveyAverageScoreResponse;
  /**
   * Allows admins to view overall results for a specific question and survey type
   * at their organization, for a given date range.
   * Repsonse includes the average score for the question from up to 5 date ranges
   * prior to the requested date range, if available.
   * If no date range is provided, will return all-time average and no comparisons.
   */
  getSurveyQuestionResults: SurveyQuestionResultsResponse;
  /**
   * Allows admins to view all comments (with the associated score) for a given question
   * and survey type at their organization, with an optional filters on score value and/or
   * date range.
   * Responses are paginated and returned by most recent first.
   *
   * Note: NPS is not a supported question type for this query, as there is no associated comment.
   */
  listCommentsForSurveyQuestion: ListSurveyCommentsResponse;
  /**
   * Allows admins to view the number of responses that awarded each score to a specific question,
   * for the given survey type at their organization, in a given date range.
   * Response is ordered by highest to lowest score.
   * If no date range is provided, will return all-time score distribution.
   */
  getScoreDistributionForSurveyQuestion: Array<SurveyQuestionScoreCount>;
  /**
   * Allows admins to view the date ranges for which survey insights data
   * is available, ordered by most recent (current date) to the oldest (organization launch date).
   */
  getAvailableSurveyDateRanges: Array<SurveyInsightsDateRange>;
  /**
   * Allows admins to view the NPS score for a given survey type at their organization,
   * for a given date range.
   */
  getSurveyNPSScore: SurveyNpsScoreResponse;
  /**
   * Allows a rewards user to get their obscured phone number
   * when re-authing (after a login link failed to authenticate them)
   *
   * A `loginTokenId` or `userId` can be provided in order to
   * identify the user to be logged in.
   */
  getRewardsUserLoginTokenDetails: GetRewardsUserLoginTokenDetailsResponse;
  getMyRewardsUser: RewardsUser;
  /** Allows a rewards Admin to search for rewards users in their organization. */
  searchForRewardsUsers: Array<RewardsUser>;
  listRewardsUsers: ListRewardsUsersResponse;
  getRewardsUserById?: Maybe<RewardsUser>;
  listEmployeeSummariesByCursor: ListEmployeeSummariesByCursorResponse;
  /** Determines if the given user id exists in the given organization. */
  getRewardsUserExistsForOrganization?: Maybe<GetRewardsUserExistsForIdAndOrganizationResponse>;
  /** Yields referral-related stats for a given rewards user */
  getReferralStatsForUser: RewardsUserReferralStats;
  listRewardsUserGroups: ListRewardsUserGroupResponse;
  getRewardVideoById?: Maybe<RewardVideo>;
  getLatestWelcomeVideo?: Maybe<RewardVideo>;
  getRewardVideoOfferById?: Maybe<RewardVideoOffer>;
  /** Allows a superuser to list reward video offers */
  adminListRewardVideoOffers: AdminListRewardOffersResponse;
  /**
   * Lists a reward user's visits starting from a specified date.
   * Supports pagination with a cursor.
   */
  listMyVisitsAsOfStartDate: ListMyVisitsAsOfStartDateResponse;
  /**
   * Allows a REWARDS_ADMIN to get a visit by ID.
   *
   * If the visit does not exist, or the user does not have access to the visit,
   * the result will be `null`.
   */
  getVisitById?: Maybe<Visit>;
  getSchoolsEmployerById?: Maybe<SchoolsEmployer>;
  getSchoolsEmployerSurveyById?: Maybe<SchoolsEmployerSurvey>;
  listSchoolsEmployerSurveys: ListSchoolsEmployerSurveysResponse;
  getMySchoolsStudent: SchoolsStudent;
};


export type QueryGetBulkImportStatusArgs = {
  bulkImportId: Scalars['ID'];
};


export type QueryGetRewardsAdminByIdArgs = {
  id: Scalars['ID'];
};


export type QueryListRewardsAdminsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<RewardsAdminListFilterInput>;
};


export type QuerySearchForRewardsAdminUsersArgs = {
  limit: Scalars['Int'];
};


export type QueryGetRewardsAdminAuthStatusArgs = {
  adminId: Scalars['ID'];
};


export type QueryGetAdminGoalConfigArgs = {
  id: Scalars['ID'];
};


export type QueryGetCaribouUserSyncFilterOptionsForAlayaCareIntegrationArgs = {
  alayaCareIntegrationId: Scalars['ID'];
};


export type QueryGetAwardedBonusPointsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetRecognitionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetRecognitionPointsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryListAwardedBonusPointsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<ListAwardedBonusPointsFilter>;
};


export type QueryListSentRecognitionArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<ListSentRecognitionFilter>;
};


export type QueryListSentRecognitionPointsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<ListSentRecognitionPointsFilter>;
};


export type QueryListMyManagerScheduledRecognitionPointsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<ListMyManagerScheduledRecognitionPointsFilter>;
};


export type QueryGetMyRewardsOrganizationRecognitionCategoriesArgs = {
  filter?: Maybe<GetMyRewardsOrganizationRecognitionCategoriesFilter>;
};


export type QueryListRecognitionCategoriesArgs = {
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetRecognitionCategoryByIdArgs = {
  recognitionCategoryId: Scalars['ID'];
};


export type QueryGetMyRecognitionPointsSentSummaryArgs = {
  month: Scalars['MonthAndYear'];
};


export type QueryGetMyRecognitionPointsSentSummaryV2Args = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type QueryGetMyManagedEmployeesRecognitionPointsReceivedSummaryArgs = {
  month: Scalars['MonthAndYear'];
};


export type QueryGetMyManagedEmployeesRecognitionPointsReceivedSummaryV2Args = {
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type QueryListMyManagedEmployeesRecognitionSummaryArgs = {
  filter: ListMyManagedEmployeesRecognitionSummaryFilterInput;
  page: ListMyManagedEmployeesRecognitionSummaryPageInput;
};


export type QueryListMyManagedEmployeesRecognitionSummaryV2Args = {
  filter?: Maybe<ListMyManagedEmployeesRecognitionSummaryV2FilterInput>;
  page: ListMyManagedEmployeesRecognitionSummaryV2PageInput;
};


export type QueryListCandidatesArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter: ListCandidatesFilterInput;
};


export type QueryListCandidatesV2Args = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  order?: Maybe<ListCandidatesV2OrderInput>;
  filter?: Maybe<ListCandidatesV2FilterInput>;
};


export type QueryGetCandidateByIdArgs = {
  candidateId: Scalars['ID'];
};


export type QueryGetNumActiveCandidatesByJobPostingAndStatusArgs = {
  branchIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryGetNumActiveCandidatesByJobPostingAndNextStepArgs = {
  branchIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryGetMyReferralsProgressV2Args = {
  limit?: Maybe<Scalars['Int']>;
  statusIn?: Maybe<Array<ReferralStatusV2>>;
  discludeInactiveNotHired?: Maybe<Scalars['Boolean']>;
};


export type QueryListMyCaregiverImpactMonthsByCursorArgs = {
  cursor?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


export type QueryGetCaregiverImpactMonthByIdArgs = {
  caregiverImpactMonthId: Scalars['ID'];
};


export type QueryCustomerIoListNewUsersToScheduleForAdminArgs = {
  adminId: Scalars['ID'];
  limit: Scalars['Int'];
  rotatingCursor?: Maybe<Scalars['String']>;
};


export type QueryCustomerIoListUsersInterestedInLastMinuteShiftsArgs = {
  adminId: Scalars['ID'];
  limit: Scalars['Int'];
  rotatingCursor?: Maybe<Scalars['String']>;
};


export type QueryCustomerIoListUsersInterestedInWeekendShiftsArgs = {
  adminId: Scalars['ID'];
  limit: Scalars['Int'];
  rotatingCursor?: Maybe<Scalars['String']>;
};


export type QueryCustomerIoListUsersInterestedInMoreBillableHoursArgs = {
  adminId: Scalars['ID'];
  limit: Scalars['Int'];
  rotatingCursor?: Maybe<Scalars['String']>;
};


export type QueryCountMyTicketsInDrawArgs = {
  drawId: Scalars['ID'];
};


export type QueryGetDrawByIdArgs = {
  drawId: Scalars['ID'];
};


export type QueryListAwardedDrawTicketTransactionsForUserArgs = {
  userId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryGetEvvCompletionRateOfferByIdArgs = {
  evvCompletionRateOfferId: Scalars['ID'];
};


export type QueryListMyEvvCompletionRateOffersArgs = {
  filter?: Maybe<ListMyEvvCompletionRateOffersFilter>;
};


export type QueryGetMyRewardsUserGoalTrackArgs = {
  trackName: GoalTrackName;
};


export type QueryGetMyRewardsUserAchievedGoalsArgs = {
  goalTypes?: Maybe<Array<GoalType>>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMyAvailableGoalForVideoIdArgs = {
  videoId: Scalars['ID'];
};


export type QueryRetoolGetOrganizationGoalConfigByIdArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetGoalByIdArgs = {
  goalId: Scalars['ID'];
};


export type QueryGetMyOrganizationHasAvailableGoalsArgs = {
  goalType: GoalType;
  filter?: Maybe<HasAvailableGoalsFilter>;
};


export type QueryListRewardsTagsArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryListRewardsTagsGroupedByTypeForIntegrationArgs = {
  externalIdPrefix: Scalars['String'];
};


export type QueryListRewardsGroupsArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetCaregiversToSyncForHhaxIntegrationArgs = {
  hhaxIntegrationId: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filters: HhaxCaribouUserSyncFiltersInput;
};


export type QueryGetCaribouUserSyncFilterOptionsForHhaxIntegrationArgs = {
  hhaxIntegrationId: Scalars['ID'];
};


export type QueryGetHhaxCaribouUserSyncByIdArgs = {
  userSyncId: Scalars['ID'];
};


export type QueryGetEnabledHhaxIntegrationsByOrganizationIdArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetActiveUsersInsightMetricArgs = {
  endDate: Scalars['Timestamp'];
};


export type QueryGetLoggedInUsersInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetPointsAwardedInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetPointsRedeemedInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetTotalHiresInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetCostOfReferralsInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetReferralHoursWorkedInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetRecognizedEmployeesInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetRecognitionAwardedInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetBudgetUsageInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetAdminsUsingRecognitionInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetJobSharesInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetApplicantsInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetGoalsAchievedInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetParticipationInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetTimeToFirstShiftInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetFirstShiftSurveyResponseRateInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetFirstShiftSurveyAverageInsightMetricArgs = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
};


export type QueryGetApplicantHasUploadedResumeArgs = {
  applicationSubmissionId?: Maybe<Scalars['ID']>;
  candidateId?: Maybe<Scalars['ID']>;
  applicantUploadToken: Scalars['String'];
};


export type QueryGetJobShareLinkDisabledForUserArgs = {
  jobShareId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
};


export type QueryListShareableJobPostingsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filters?: Maybe<ListShareableJobPostingsFilters>;
  searchQuery?: Maybe<Scalars['String']>;
};


export type QueryGetJobPostingByIdArgs = {
  jobPostingId: Scalars['ID'];
};


export type QueryGetJobPostingByShareIdArgs = {
  jobShareId: Scalars['ID'];
};


export type QueryListOpenJobPostingsArgs = {
  organizationId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<OpenJobPostingFilterInput>;
};


export type QueryGetJobPostingByApplicationSubmissionArgs = {
  applicationSubmissionId?: Maybe<Scalars['ID']>;
  candidateId?: Maybe<Scalars['ID']>;
};


export type QueryListJobPostingsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<JobPostingFilterInput>;
  includeFromSiblingOrganizations?: Maybe<Scalars['Boolean']>;
};


export type QuerySearchForOpenJobPostingsArgs = {
  searchQuery?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryValidateAtsJobArgs = {
  externalJobId: Scalars['String'];
  externalAtsIntegrationId: Scalars['String'];
};


export type QueryCountMyJobSharesInRangeArgs = {
  start: Scalars['Timestamp'];
  end: Scalars['Timestamp'];
};


export type QueryListMyRewardOffersArgs = {
  filter?: Maybe<ListMyRewardOffersFilter>;
};


export type QueryAdminListRewardOffersArgs = {
  userId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  externalOfferId?: Maybe<Scalars['ID']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryAdminGetRewardOfferStatsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetForMyOrganizationAndExternalIntegrationIdArgs = {
  externalIntegrationId: Scalars['String'];
};


export type QueryListRewardsUsersToSyncForMyOrganizationArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  operationType: SyncOperationType;
  externalIntegrationId: Scalars['String'];
  filters: UserEligibilityFiltersInput;
  search?: Maybe<RewardsUsersToSyncSearch>;
};


export type QueryGetUserEligibilitySummaryForMyOrganizationArgs = {
  externalIntegrationId: Scalars['String'];
  filters: UserEligibilityFiltersInput;
};


export type QueryGetRewardsOrganizationByIdArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetRewardsOrganizationsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetMyRewardsOrganizationBranchArgs = {
  branchId: Scalars['String'];
};


export type QueryGetRewardsOrganizationOptInPromoArgs = {
  workEmail: Scalars['String'];
};


export type QueryGetRewardsOrganizationByApplicationSubmissionArgs = {
  applicationSubmissionId?: Maybe<Scalars['ID']>;
  candidateId?: Maybe<Scalars['ID']>;
};


export type QueryGetRewardsOrganizationByWorkEmailArgs = {
  workEmail: Scalars['String'];
};


export type QueryRetoolGetOrganizationLaunchMetricsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryRetoolSearchCaregiverAccountsArgs = {
  input: RetoolSearchCaregiverAccountsInput;
};


export type QueryGetPowerHoursOfferByIdArgs = {
  powerHoursOfferId: Scalars['ID'];
};


export type QueryListMyPowerHoursOffersArgs = {
  filter?: Maybe<ListMyPowerHoursFilter>;
};


export type QueryListRedemptionsArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter: RedemptionsFilterInput;
};


export type QueryRetoolListRedemptionsByCursorArgs = {
  limit: Scalars['Int'];
  filter?: Maybe<ListRedemptionsByCursorFilterInput>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryRetoolGetRedemptionExportsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetMyAvailableRedemptionCatalogItemsArgs = {
  categoryIn: Array<RedemptionCatalogItemCategory>;
};


export type QueryGetAvailableRedemptionCatalogItemArgs = {
  id: Scalars['ID'];
};


export type QueryGetReferralStructureByIdArgs = {
  referralStructureId: Scalars['ID'];
};


export type QueryListTransactionsForRewardsAccountArgs = {
  userId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListMyRewardsUserPointTransactionsByCursorArgs = {
  limit: Scalars['Int'];
  cursor?: Maybe<Scalars['String']>;
  category?: Maybe<FilterableTransactionMetadataCategory>;
};


export type QueryGetOpenShiftByIdArgs = {
  visitId: Scalars['String'];
};


export type QueryGetOpenShiftPostingsByCoordinatorArgs = {
  externalCoordinatorId?: Maybe<Scalars['String']>;
  phiAccessReason: Scalars['String'];
};


export type QueryListOpenShiftPostingsForCoordinatorsArgs = {
  externalCoordinatorIds: Array<Maybe<Scalars['String']>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  phiAccessReason: Scalars['String'];
  dateRange?: Maybe<ShiftPostingDateRangeInput>;
};


export type QueryListOpenShiftPostingsArgs = {
  externalCoordinatorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  caregiverUserId?: Maybe<Scalars['ID']>;
  phiPatientId?: Maybe<Scalars['ID']>;
  dateRange?: Maybe<ShiftPostingDateRangeInput>;
  mustHaveVisitWithInterest?: Maybe<Scalars['Boolean']>;
  mustHaveVisitPendingConfirmation?: Maybe<Scalars['Boolean']>;
  shiftKey?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  phiAccessReason: Scalars['String'];
};


export type QueryGetOpenShiftPostingByIdArgs = {
  id: Scalars['ID'];
  phiAccessReason: Scalars['String'];
};


export type QueryGetShiftPostingByIdArgs = {
  id: Scalars['ID'];
  phiAccessReason: Scalars['String'];
};


export type QueryListPhiCaregiverMatchesForShiftPostingArgs = {
  phiAccessReason: Scalars['String'];
  shiftPostingId: Scalars['ID'];
};


export type QueryListPhiInterestedCaregiversForShiftPostingArgs = {
  phiAccessReason: Scalars['String'];
  shiftPostingId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListPhiNotifiedCaregiversForShiftPostingArgs = {
  phiAccessReason: Scalars['String'];
  shiftPostingId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListPhiTopRecommendedCaregiversToReachOutToForShiftPostingArgs = {
  phiAccessReason: Scalars['String'];
  shiftPostingId: Scalars['ID'];
  limit: Scalars['Int'];
};


export type QueryListInterestedCaregiversForShiftPostingV2Args = {
  shiftPostingId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListNotifiedCaregiversForShiftPostingV2Args = {
  shiftPostingId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListTopRecommendedCaregiversToReachOutToForShiftPostingV2Args = {
  shiftPostingId: Scalars['ID'];
  limit: Scalars['Int'];
};


export type QueryListTopRecommendedCaregiversToReachOutToForShiftPostingV3Args = {
  shiftPostingId: Scalars['ID'];
  phiAccessReason: Scalars['String'];
  limit: Scalars['Int'];
  cursor?: Maybe<Scalars['String']>;
  userIdNotIn?: Maybe<Array<Scalars['ID']>>;
};


export type QueryListBroadcastsForShiftPostingArgs = {
  shiftPostingId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryGetPhiCaregiverShiftPostingMatchByShiftPostingAndCaregiverArgs = {
  phiAccessReason: Scalars['String'];
  shiftPostingId: Scalars['ID'];
  caregiverUserId: Scalars['ID'];
};


export type QueryGetMyUpcomingTotalVisitHoursByWeekArgs = {
  numWeeksIncludingCurrentWeek: Scalars['Int'];
};


export type QueryGetUpcomingTotalVisitHoursByWeekForCaregiverArgs = {
  caregiverUserId: Scalars['ID'];
  dateRange?: Maybe<ShiftPostingDateRangeInput>;
};


export type QueryGetNonPhiOpenShiftPostingByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetNonPhiTopShiftPostingsArgs = {
  broadcastedShiftId?: Maybe<Scalars['ID']>;
};


export type QueryGetNonPhiOpenShiftPostingCardByIdArgs = {
  shiftPostingId: Scalars['ID'];
  cardType?: Maybe<CaregiverProfileShiftTypePreference>;
};


export type QueryListMyNonPhiShiftPostingMatchesArgs = {
  limit: Scalars['Int'];
  cursor?: Maybe<Scalars['String']>;
  filter?: Maybe<ListMyNonPhiShiftPostingMatchesFilterInput>;
};


export type QueryListMyNonPhiShiftPostingCardMatchesArgs = {
  limit: Scalars['Int'];
  cursor?: Maybe<Scalars['String']>;
  filter?: Maybe<ListMyNonPhiShiftPostingCardMatchesFilterInput>;
};


export type QueryGetCaregiverPayCodesArgs = {
  caregiverUserId: Scalars['ID'];
};


export type QueryGetPayCodesForCaregiverShiftAssignmentArgs = {
  shiftPostingId: Scalars['ID'];
  shiftPostingVisitIds: Array<Scalars['ID']>;
  caregiverUserId: Scalars['ID'];
};


export type QueryGetCaregiverShiftPostingVisitConflictsArgs = {
  shiftPostingId: Scalars['ID'];
  caregiverUserId: Scalars['ID'];
};


export type QueryListAssignedShiftPostingsForCoordinatorArgs = {
  externalCoordinatorId?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  phiAccessReason: Scalars['String'];
};


export type QueryListArchivedAssignedShiftPostingsForCoordinatorsArgs = {
  externalCoordinatorIds: Array<Maybe<Scalars['String']>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  phiAccessReason: Scalars['String'];
};


export type QuerySearchForPhiPatientsArgs = {
  searchQuery?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  phiAccessReason: Scalars['String'];
};


export type QueryGetPhiPatientByIdArgs = {
  phiPatientId: Scalars['ID'];
  phiAccessReason: Scalars['String'];
};


export type QueryListPhiShiftCaregiverSummariesArgs = {
  caregiverUserId?: Maybe<Scalars['ID']>;
  phiPatientId?: Maybe<Scalars['ID']>;
  shiftStartDateRange: ShiftPostingDateRangeInput;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  phiAccessReason: Scalars['String'];
};


export type QueryRetoolListMatchesForShiftPostingsArgs = {
  organizationId: Scalars['ID'];
  shiftPostingIds: Array<Scalars['String']>;
  permanentOrTemporary: CaregiverProfileShiftTypePreference;
};


export type QueryRetoolListOpenShiftPostingsArgs = {
  organizationId: Scalars['ID'];
  dateRange: ShiftPostingDateRangeInput;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryRetoolGetShiftBookingSettingArgs = {
  organizationId: Scalars['ID'];
};


export type QueryListMySocialFeedPostsByCursorArgs = {
  limit: Scalars['Int'];
  cursor?: Maybe<Scalars['String']>;
  postTypes?: Maybe<Array<SocialPostType>>;
};


export type QueryGetSocialPostByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetSurveyEngagementArgs = {
  surveyType: SurveyType;
  dateRange?: Maybe<SurveyInsightsDateRangeInput>;
};


export type QueryGetSurveyAverageScoreArgs = {
  surveyType: SurveyType;
  dateRange?: Maybe<SurveyInsightsDateRangeInput>;
};


export type QueryGetSurveyQuestionResultsArgs = {
  surveyType: SurveyType;
  questionType: SurveyQuestionType;
  dateRange?: Maybe<SurveyInsightsDateRangeInput>;
};


export type QueryListCommentsForSurveyQuestionArgs = {
  surveyType: SurveyType;
  questionType: SurveyQuestionType;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<SurveyCommentsFiltersInput>;
};


export type QueryGetScoreDistributionForSurveyQuestionArgs = {
  surveyType: SurveyType;
  questionType: SurveyQuestionType;
  dateRange?: Maybe<SurveyInsightsDateRangeInput>;
};


export type QueryGetAvailableSurveyDateRangesArgs = {
  surveyType: SurveyType;
};


export type QueryGetSurveyNpsScoreArgs = {
  surveyType: SurveyType;
  dateRange?: Maybe<SurveyInsightsDateRangeInput>;
};


export type QueryGetRewardsUserLoginTokenDetailsArgs = {
  loginTokenId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};


export type QuerySearchForRewardsUsersArgs = {
  searchQuery?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  filter?: Maybe<SearchForRewardsUsersFilterInput>;
};


export type QueryListRewardsUsersArgs = {
  searchQuery?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<ListRewardsUsersFilterInput>;
};


export type QueryGetRewardsUserByIdArgs = {
  userId: Scalars['ID'];
};


export type QueryListEmployeeSummariesByCursorArgs = {
  limit: Scalars['Int'];
  sort: ListEmployeeSummariesByCursorSortInput;
  filter?: Maybe<ListEmployeeSummariesByCursorFilterInput>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryGetRewardsUserExistsForOrganizationArgs = {
  userId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryGetReferralStatsForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetRewardVideoByIdArgs = {
  videoId: Scalars['ID'];
};


export type QueryGetRewardVideoOfferByIdArgs = {
  videoOfferId: Scalars['ID'];
};


export type QueryAdminListRewardVideoOffersArgs = {
  userId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  externalOfferId?: Maybe<Scalars['ID']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListMyVisitsAsOfStartDateArgs = {
  page: ListMyVisitsAsOfStartDatePageInput;
};


export type QueryGetVisitByIdArgs = {
  visitId: Scalars['ID'];
};


export type QueryGetSchoolsEmployerByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetSchoolsEmployerSurveyByIdArgs = {
  id: Scalars['ID'];
};

export enum QuickCheckSurveyCadenceFrequency {
  Weekly = 'WEEKLY',
  Biweekly = 'BIWEEKLY'
}

export type QuickCheckSurveyCadenceOverride = {
  __typename?: 'QuickCheckSurveyCadenceOverride';
  frequency: QuickCheckSurveyCadenceFrequency;
  startDate: Scalars['Timestamp'];
};

export type QuickCheckSurveyCadenceOverrideInput = {
  frequency: QuickCheckSurveyCadenceFrequency;
  startDate: Scalars['Timestamp'];
};

export type QuickCheckSurveyGoalDistributionConfig = {
  __typename?: 'QuickCheckSurveyGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  surveyCadenceOverride?: Maybe<QuickCheckSurveyCadenceOverride>;
  surveyDaysUntilExpirationOverride?: Maybe<Scalars['Int']>;
  surveyRewardOverride?: Maybe<GoalConfigRewardOverride>;
  /** @deprecated See `surveyQuestionsConfig` instead */
  selectedSurveyQuestions: Array<SurveyQuestionType>;
  surveyQuestionsConfig: RotatingSurveyQuestionsConfig;
  anonymousSubmission?: Maybe<Scalars['Boolean']>;
};

export type QuickCheckSurveyGoalDistributionConfigAdminInput = {
  surveyRewardOverride?: Maybe<GoalRewardsInput>;
  surveyCadenceOverride?: Maybe<QuickCheckSurveyCadenceOverrideInput>;
  surveyDaysUntilExpirationOverride?: Maybe<Scalars['Int']>;
  surveyQuestionsConfig?: Maybe<RotatingSurveyQuestionsConfigInput>;
  /** Note: this will default to false (identifiable) if not provided on a new config. */
  anonymousSubmission?: Maybe<Scalars['Boolean']>;
};

export enum ReactionType {
  Love = 'LOVE',
  Celebrate = 'CELEBRATE',
  Applaud = 'APPLAUD'
}

export type ReactionsSummary = {
  __typename?: 'ReactionsSummary';
  type: ReactionType;
  numReactions: Scalars['Int'];
};

export type Recognition = {
  __typename?: 'Recognition';
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  employee: RewardsUser;
  reward: RecognitionReward;
  /** @deprecated Use `reward.numPoints` instead. This value may be 0 if draw tickets are awarded. */
  pointValue: Scalars['Int'];
  from?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  defaultMessage?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Timestamp']>;
  status: BonusPointsStatus;
  category?: Maybe<RecognitionCategory>;
  mustBeClaimed: Scalars['Boolean'];
  claimed: Scalars['Boolean'];
  claimedAt?: Maybe<Scalars['Timestamp']>;
  reminders: Array<BonusPointsReminder>;
  scheduledToSendOn?: Maybe<Scalars['Date']>;
  likedAt?: Maybe<Scalars['Timestamp']>;
  firstViewedAt?: Maybe<Scalars['Timestamp']>;
};

export type RecognitionBudgetPeriod = {
  __typename?: 'RecognitionBudgetPeriod';
  id: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  current: Scalars['Boolean'];
};

export type RecognitionBudgetUtilizationByAdminParameters = {
  /** The start month is _inclusive_ of the months covered by the report. */
  startMonth: Scalars['MonthAndYear'];
  /** The end month is _exclusive_ of the months covered by the report. */
  endMonth: Scalars['MonthAndYear'];
};

export type RecognitionCategory = {
  __typename?: 'RecognitionCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  defaultPointAmount?: Maybe<Scalars['Int']>;
  disableSendFromManagers: Scalars['Boolean'];
};

/** Deprecated - old API response type using pointValue. Use Recognition instead. */
export type RecognitionPoints = {
  __typename?: 'RecognitionPoints';
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  employee: RewardsUser;
  pointValue: Scalars['Int'];
  from?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  defaultMessage?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Timestamp']>;
  status: BonusPointsStatus;
  category?: Maybe<RecognitionCategory>;
  mustBeClaimed: Scalars['Boolean'];
  claimed: Scalars['Boolean'];
  claimedAt?: Maybe<Scalars['Timestamp']>;
  reminders: Array<BonusPointsReminder>;
  scheduledToSendOn?: Maybe<Scalars['Date']>;
  likedAt?: Maybe<Scalars['Timestamp']>;
  firstViewedAt?: Maybe<Scalars['Timestamp']>;
};

export type RecognitionPointsInsightMetric = {
  __typename?: 'RecognitionPointsInsightMetric';
  id: Scalars['ID'];
  bonusPointsAwarded: Scalars['Int'];
};

export type RecognitionReward = {
  __typename?: 'RecognitionReward';
  numPoints?: Maybe<Scalars['Int']>;
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
};

export type RecognitionRewardInput = {
  numPoints?: Maybe<Scalars['Int']>;
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
};

export enum RecognitionRewardType {
  Points = 'POINTS',
  DrawTickets = 'DRAW_TICKETS'
}

export type RecognizedEmployeesInsightMetric = {
  __typename?: 'RecognizedEmployeesInsightMetric';
  id: Scalars['ID'];
  recognizedEmployeeCount: Scalars['Int'];
  activeUserCount: Scalars['Int'];
};

export type RecordVideoWatchByMeResponse = {
  __typename?: 'RecordVideoWatchByMeResponse';
  videoWatchId: Scalars['ID'];
};

export type RecordedCandidateHourlyRetentionStep = {
  __typename?: 'RecordedCandidateHourlyRetentionStep';
  durationHours: Scalars['Int'];
  recordedAt: Scalars['Timestamp'];
};

export type RecordedCandidateMonthlyRetentionStep = {
  __typename?: 'RecordedCandidateMonthlyRetentionStep';
  durationMonths: Scalars['Int'];
  recordedAt: Scalars['Timestamp'];
};

export type RecordedCandidateRecruitmentStep = {
  __typename?: 'RecordedCandidateRecruitmentStep';
  stepName: CandidateRecruitmentStepName;
  recordedAt: Scalars['Timestamp'];
};

export type RecordedCandidateRetentionStep = {
  __typename?: 'RecordedCandidateRetentionStep';
  durationMonths: Scalars['Int'];
  recordedAt: Scalars['Timestamp'];
};

export type RecordedCandidateStep = RecordedCandidateRecruitmentStep | RecordedCandidateRetentionStep;

export type RecordedCandidateStepV2 = RecordedCandidateRecruitmentStep | RecordedCandidateMonthlyRetentionStep | RecordedCandidateHourlyRetentionStep;

export type Redemption = {
  __typename?: 'Redemption';
  id: Scalars['ID'];
  method: RedemptionMethod;
  status: RedemptionStatus;
  dollars: Scalars['Float'];
  points: Scalars['Int'];
  user: RewardsUser;
  createdAt: Scalars['Timestamp'];
  markedAsPaidAt?: Maybe<Scalars['Timestamp']>;
  markedAsSentToPayrollAt?: Maybe<Scalars['Timestamp']>;
  markedAsGenericGiftCardSentAt?: Maybe<Scalars['Timestamp']>;
  markedAsGenericGiftCardFulfillmentRequestedAt?: Maybe<Scalars['Timestamp']>;
  markedAsGenericGiftCardFulfillmentFailedAt?: Maybe<Scalars['Timestamp']>;
  pointTransactions: Array<PointTransaction>;
  organization: RewardsOrganization;
  redeemedItems?: Maybe<Array<RedemptionItem>>;
};

export type RedemptionCatalogItem = {
  __typename?: 'RedemptionCatalogItem';
  id: Scalars['ID'];
  provider: RedemptionCatalogItemProvider;
  category: RedemptionCatalogItemCategory;
  subCategories?: Maybe<Array<RedemptionCatalogItemSubCategory>>;
  displayName: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  /** @deprecated Use `price` instead */
  priceInPoints: Scalars['Int'];
  minPointsToRedeem: Scalars['Int'];
  maxPointsRedeemable: Scalars['Int'];
  price: RedemptionCatalogItemPrice;
  /**
   * If the item's provider is Snappy, and the collection ID is present,
   * resolves with the collection ID.
   *
   * This is exposed to support fulfillment of Snappy item redemptions.
   */
  snappyCollectionId?: Maybe<Scalars['String']>;
};

export enum RedemptionCatalogItemCategory {
  Gift = 'GIFT',
  GiftCard = 'GIFT_CARD'
}

export type RedemptionCatalogItemFixedPrice = {
  __typename?: 'RedemptionCatalogItemFixedPrice';
  priceInPoints: Scalars['Int'];
};

export type RedemptionCatalogItemInput = {
  catalogItemId: Scalars['ID'];
  pointValue: Scalars['Int'];
};

/** At least one of fixedPricesInPoints or variablePrice will be defined. It is possible to have both. */
export type RedemptionCatalogItemMultipleValuesPrice = {
  __typename?: 'RedemptionCatalogItemMultipleValuesPrice';
  /** If fixed gift card amount is supported, this will be a list of the fixed amounts in points. */
  fixedPricesInPoints: Array<Scalars['Int']>;
  /** If a variable gift card amount is supported, this will be defined with a mininum and maximum. */
  variableAmount?: Maybe<RedemptionCatalogItemVariablePrice>;
};

export type RedemptionCatalogItemPrice = RedemptionCatalogItemFixedPrice | RedemptionCatalogItemMultipleValuesPrice;

export type RedemptionCatalogItemProvider = RedemptionCatalogItemTangoProvider | RedemptionCatalogItemSnappyProvider;

export type RedemptionCatalogItemSnappyProvider = {
  __typename?: 'RedemptionCatalogItemSnappyProvider';
  snappyProductId: Scalars['String'];
  snappyCollectionId?: Maybe<Scalars['String']>;
};

export enum RedemptionCatalogItemSubCategory {
  Specialty = 'SPECIALTY',
  MarketplacesDepartmentStores = 'MARKETPLACES_DEPARTMENT_STORES',
  Fuel = 'FUEL',
  Fashion = 'FASHION',
  AutoCare = 'AUTO_CARE',
  Travel = 'TRAVEL',
  Grocery = 'GROCERY',
  Technology = 'TECHNOLOGY',
  Entertainment = 'ENTERTAINMENT',
  Donation = 'DONATION',
  DigitalMedia = 'DIGITAL_MEDIA',
  Dining = 'DINING',
  SportingGoods = 'SPORTING_GOODS',
  ForTheHome = 'FOR_THE_HOME',
  Gaming = 'GAMING',
  Beauty = 'BEAUTY',
  KidsBaby = 'KIDS_BABY',
  PetCare = 'PET_CARE',
  HealthWellness = 'HEALTH_WELLNESS',
  Beverage = 'BEVERAGE',
  PrepaidCashTransfer = 'PREPAID_CASH_TRANSFER',
  SelfCare = 'SELF_CARE',
  Unknown = 'UNKNOWN'
}

export type RedemptionCatalogItemTangoProvider = {
  __typename?: 'RedemptionCatalogItemTangoProvider';
  tangoBrandKey: Scalars['String'];
  tangoBrandName: Scalars['String'];
  alwaysShowDisclaimer: Scalars['Boolean'];
  disclaimerHTML?: Maybe<Scalars['String']>;
  termsHTML?: Maybe<Scalars['String']>;
};

export type RedemptionCatalogItemVariablePrice = {
  __typename?: 'RedemptionCatalogItemVariablePrice';
  minAmountInPoints: Scalars['Int'];
  maxAmountInPoints: Scalars['Int'];
  /** If true, the user must enter a point amount that is equivalent to a whole dollar amount. */
  isWholeAmountValueRequired: Scalars['Boolean'];
};

export type RedemptionExport = {
  __typename?: 'RedemptionExport';
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  status: RedemptionExportStatus;
};

export enum RedemptionExportStatus {
  Pending = 'PENDING',
  Queued = 'QUEUED',
  Generated = 'GENERATED',
  Failed = 'FAILED',
  Error = 'ERROR'
}

export type RedemptionItem = {
  __typename?: 'RedemptionItem';
  id: Scalars['ID'];
  redemptionId: Scalars['ID'];
  catalogItem: RedemptionCatalogItem;
  status: RedemptionItemStatus;
  pointValue: Scalars['Int'];
  fulfilledAt?: Maybe<Scalars['Timestamp']>;
  fulfilmentFailureReason?: Maybe<Scalars['String']>;
  /** @deprecated Use `snappyCollectionId` instead */
  linkToManuallyFulfillRedemption?: Maybe<Scalars['String']>;
};

export enum RedemptionItemStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SentToFulfillment = 'SENT_TO_FULFILLMENT',
  FulfilmentFailed = 'FULFILMENT_FAILED',
  Fulfilled = 'FULFILLED'
}

export enum RedemptionMethod {
  GenericGiftCardLink = 'GENERIC_GIFT_CARD_LINK',
  Payroll = 'PAYROLL',
  Hsa = 'HSA',
  Catalog = 'CATALOG'
}

export enum RedemptionSocialPostCopyVariant {
  SingleCaregiverCheers = 'SINGLE_CAREGIVER_CHEERS',
  SingleCaregiverGreatWork = 'SINGLE_CAREGIVER_GREAT_WORK',
  MultipleCaregiversCheers = 'MULTIPLE_CAREGIVERS_CHEERS',
  MultipleCaregiversGreatWork = 'MULTIPLE_CAREGIVERS_GREAT_WORK',
  MultipleCaregiversAmazingWork = 'MULTIPLE_CAREGIVERS_AMAZING_WORK',
  MultipleCaregiversShoutOut = 'MULTIPLE_CAREGIVERS_SHOUT_OUT'
}

export type RedemptionSocialPostDetails = {
  __typename?: 'RedemptionSocialPostDetails';
  id: Scalars['ID'];
  /**
   * @deprecated use taggedUsers instead
   * Number of users who redeemed the points.
   */
  numUsersRedeemed: Scalars['Int'];
  totalPointsRedeemed: Scalars['Int'];
  imageVariant: RedemptionSocialPostImageVariant;
  copyVariant: RedemptionSocialPostCopyVariant;
};

export enum RedemptionSocialPostImageVariant {
  GiftBox = 'GIFT_BOX',
  Coins = 'COINS',
  Fireworks = 'FIREWORKS',
  PartyHat = 'PARTY_HAT'
}

export enum RedemptionStatus {
  Requested = 'REQUESTED',
  Approved = 'APPROVED',
  Fulfilled = 'FULFILLED',
  SentGenericGiftCardLink = 'SENT_GENERIC_GIFT_CARD_LINK',
  SentToPayroll = 'SENT_TO_PAYROLL',
  GenericGiftCardFulfillmentRequested = 'GENERIC_GIFT_CARD_FULFILLMENT_REQUESTED',
  GenericGiftCardFulfillmentFailed = 'GENERIC_GIFT_CARD_FULFILLMENT_FAILED',
  Paid = 'PAID'
}

export type RedemptionsFilterInput = {
  /**
   * If provided, will filter the list to return only redemptions
   * by the provided user (employee) ID.
   */
  userId?: Maybe<Scalars['ID']>;
  /**
   * Allows filtering by organization branch ID.
   * If provided, will only show results from given branch(es)
   * If not provided, will show results from all branches
   * If [null] is provided, will show results that have no branch assigned
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /**
   * This doesn't do anything anymore - it was removed since it wasn't used
   * by the frontend, and was no longer supported architecturally.
   */
  searchQuery?: Maybe<Scalars['String']>;
};

export type RedemptionsResponse = {
  __typename?: 'RedemptionsResponse';
  total: Scalars['Int'];
  items: Array<Redemption>;
};

/**
 * Represents a Candidate from the perspective of a rewards user
 * who referred the Candidate.
 */
export type Referral = {
  __typename?: 'Referral';
  id: Scalars['ID'];
  candidateDisplayName: Scalars['String'];
  candidateEmail?: Maybe<Scalars['String']>;
  pointsAwarded: Scalars['Int'];
  pointsAwardable: Scalars['Int'];
  /** @deprecated Use statusV2 instead */
  status: ReferralStatus;
  statusV2: ReferralStatusV2;
  /** @deprecated Use stepsV2 instead */
  steps?: Maybe<Array<ReferralStep>>;
  stepsV2: Array<ReferralStepV2>;
  assignedToJobPosting?: Maybe<JobPosting>;
  /**
   * Indicates if the referral has been hired.
   * If `false`, then they haven't progressed beyond being an applicant.
   */
  wasHired: Scalars['Boolean'];
};

export type ReferralHoursWorkedInsightMetric = EligibleReferralHoursWorkedInsightMetric | IneligibleReferralHoursWorkedInsightMetric;

export type ReferralRewardStructure = {
  __typename?: 'ReferralRewardStructure';
  id: Scalars['ID'];
  jobShareStructure: ReferralRewardStructureJobShareItem;
  /** @deprecated Use referral structure APIs instead */
  items: Array<ReferralRewardStructureItem>;
  /** @deprecated Use referral structure APIs instead */
  referralRecruitmentStructure: Array<ReferralRewardStructureReferralRecruitmentItem>;
  /** @deprecated Use referral structure APIs instead */
  referralRetentionStructure: Array<ReferralRewardStructureReferralRetentionItem>;
};

export type ReferralRewardStructureDrawTicketReward = {
  __typename?: 'ReferralRewardStructureDrawTicketReward';
  numTickets: Scalars['Int'];
};

export type ReferralRewardStructureItem = ReferralRewardStructureJobShareItem | ReferralRewardStructureReferralRecruitmentItem | ReferralRewardStructureReferralRetentionItem;

export type ReferralRewardStructureJobShareItem = {
  __typename?: 'ReferralRewardStructureJobShareItem';
  maxAwardableJobSharesPerMonth: Scalars['Int'];
  reward: ReferralRewardStructureReward;
};

export type ReferralRewardStructureManualMonthlyRaffleReward = {
  __typename?: 'ReferralRewardStructureManualMonthlyRaffleReward';
  numTickets: Scalars['Int'];
  numWinnersSelectedPerMonth: Scalars['Int'];
  prizeText: Scalars['String'];
};

export type ReferralRewardStructurePointReward = {
  __typename?: 'ReferralRewardStructurePointReward';
  pointValue: Scalars['Int'];
};

export type ReferralRewardStructureReferralRecruitmentItem = {
  __typename?: 'ReferralRewardStructureReferralRecruitmentItem';
  step: CandidateRecruitmentStepName;
  reward: ReferralRewardStructureReward;
};

export type ReferralRewardStructureReferralRetentionItem = {
  __typename?: 'ReferralRewardStructureReferralRetentionItem';
  duration: ReferralRewardStructureReferralRetentionItemDuration;
  reward: ReferralRewardStructureReward;
};

export type ReferralRewardStructureReferralRetentionItemDuration = {
  __typename?: 'ReferralRewardStructureReferralRetentionItemDuration';
  unit: ReferralRewardStructureReferralRetentionItemDurationUnit;
  amount: Scalars['Int'];
};

export enum ReferralRewardStructureReferralRetentionItemDurationUnit {
  Months = 'MONTHS',
  Hours = 'HOURS'
}

export type ReferralRewardStructureReward = ReferralRewardStructurePointReward | ReferralRewardStructureDrawTicketReward | ReferralRewardStructureManualMonthlyRaffleReward;

export type ReferralRewardStructureStepItem = ReferralRewardStructureReferralRecruitmentItem | ReferralRewardStructureReferralRetentionItem;

export enum ReferralStatus {
  Active = 'ACTIVE',
  LeftCompany = 'LEFT_COMPANY',
  Completed = 'COMPLETED'
}

/**
 * Candidate status is ACTIVE when they have pending recruitment steps or retention milestones for which their referrer can earn points, after being hired.
 * Candidate status is INACTIVE when they were archived before completing all recruitment steps.
 * Candidate status is COMPLETED when they have completed all recruitment steps, after being hired.
 */
export enum ReferralStatusV2 {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Completed = 'COMPLETED'
}

/** Deprecated: Use ReferralStepV2 instead */
export type ReferralStep = {
  __typename?: 'ReferralStep';
  step: CandidateStep;
  pointValue: Scalars['Int'];
  date?: Maybe<Scalars['String']>;
  completed: Scalars['Boolean'];
};

export type ReferralStepV2 = {
  __typename?: 'ReferralStepV2';
  step: ReferralRewardStructureStepItem;
  pointValue: Scalars['Int'];
  date?: Maybe<Scalars['String']>;
  completed: Scalars['Boolean'];
};

export type ReferralStructure = {
  __typename?: 'ReferralStructure';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Represents the combined recruitment & referral steps in a single array, for convenience. */
  items: Array<ReferralRewardStructureItem>;
  referralRecruitmentStructure: Array<ReferralRewardStructureReferralRecruitmentItem>;
  referralRetentionStructure: Array<ReferralRewardStructureReferralRetentionItem>;
  /**
   * Represents the total awardable point value of the referral structure
   * (if a candidate were to complete every step in the structure).
   */
  totalAwardablePointValue: Scalars['Int'];
  /** Represents the number of open jobs that currently have this referral structure. */
  numberOfOpenJobsWithStructure: Scalars['Int'];
};

export type ReferralStructureInput = {
  recruitmentSteps: Array<ReferralStructureRecruitmentStepInput>;
  retentionMilestones: Array<ReferralStructureRetentionMilestoneInput>;
};

export type ReferralStructureRecruitmentStepInput = {
  step: CandidateRecruitmentStepName;
  pointValue: Scalars['Int'];
};

export type ReferralStructureRetentionMilestoneInput = {
  pointValue: Scalars['Int'];
  durationHours?: Maybe<Scalars['Int']>;
  durationMonths?: Maybe<Scalars['Int']>;
};

export type ReferralsProgressResponse = {
  __typename?: 'ReferralsProgressResponse';
  id: Scalars['ID'];
  referrals?: Maybe<Array<Referral>>;
};

export type ReferralsProgressV2Response = {
  __typename?: 'ReferralsProgressV2Response';
  referrals?: Maybe<Array<Referral>>;
};

export type RejectRedemptionAndDeductPointInput = {
  redemptionId: Scalars['String'];
  deductPoints?: Maybe<RejectRedemptionDeductPointDetails>;
};

export type RejectRedemptionDeductPointDetails = {
  amount: Scalars['Int'];
  explanationToUser: Scalars['String'];
};

export type ReportCheckInSurveyReportByCaregiverParameters = {
  dateRangeStart: Scalars['Timestamp'];
  dateRangeEnd: Scalars['Timestamp'];
};

/** Note: visits are included based on the visit "end" date (not the "start" date) */
export type ReportEvvComplianceByCaregiverParameters = {
  dateRangeStart: Scalars['Timestamp'];
  dateRangeEnd: Scalars['Timestamp'];
};

export type ReportEngagementByCaregiverParameters = {
  dateRangeStart: Scalars['Timestamp'];
  dateRangeEnd: Scalars['Timestamp'];
};

export type ReportLoginSummaryByAdminParameters = {
  dateRangeStart: Scalars['Timestamp'];
  dateRangeEnd: Scalars['Timestamp'];
};

export type ReportPointTotalsByCaregiverParameters = {
  dateRangeStart: Scalars['Timestamp'];
  dateRangeEnd: Scalars['Timestamp'];
};

export type ReportSurveyReportByCaregiverParameters = {
  dateRangeStart: Scalars['Timestamp'];
  dateRangeEnd: Scalars['Timestamp'];
};

export type ResyncMyVisitsForPhiPatientResult = {
  __typename?: 'ResyncMyVisitsForPHIPatientResult';
  phiPatient: PhiPatientForCaregiver;
  visits: Array<Visit>;
};

export type ResyncShiftsForPhiPatientsResult = {
  __typename?: 'ResyncShiftsForPHIPatientsResult';
  phiPatientId: Scalars['PHIString'];
  success: Scalars['Boolean'];
  unarchivedShiftPosting?: Maybe<PhiShiftPosting>;
};

export type RetoolCreateQaVisitResult = {
  __typename?: 'RetoolCreateQAVisitResult';
  externalVisitId: Scalars['String'];
};

export type RetoolGetRedemptionExportsByIdsResponse = {
  __typename?: 'RetoolGetRedemptionExportsByIdsResponse';
  items: Array<RedemptionExport>;
};

export type RetoolListMatchesForShiftPostingsResponse = {
  __typename?: 'RetoolListMatchesForShiftPostingsResponse';
  items: Array<RetoolShiftPostingMatch>;
};

export type RetoolListOpenShiftPostingsResponse = {
  __typename?: 'RetoolListOpenShiftPostingsResponse';
  total: Scalars['Int'];
  items: Array<RetoolOpenShiftPosting>;
};

export type RetoolOpenShiftPosting = {
  __typename?: 'RetoolOpenShiftPosting';
  shiftPostingId: Scalars['ID'];
};

export type RetoolPermanentShiftPostingMatch = RetoolShiftPostingMatchBase & {
  __typename?: 'RetoolPermanentShiftPostingMatch';
  organizationId: Scalars['ID'];
  shiftPostingId: Scalars['ID'];
  temporaryOrPermanent: CaregiverProfileShiftTypePreference;
  caregiverPhone?: Maybe<Scalars['String']>;
  caregiverName: Scalars['String'];
  caregiverUserId: Scalars['ID'];
  coordinatorName?: Maybe<Scalars['String']>;
  commuteTimeFromUsersHouseTransit: Scalars['String'];
  commuteTimeFromUsersHouseCar: Scalars['String'];
  nonPhiLocation: Scalars['String'];
  nonPhiHasDogs: Scalars['String'];
  nonPhiHasCats: Scalars['String'];
  nonPhiIsBedBound: Scalars['String'];
  linkToShiftPosting: Scalars['String'];
  nextVisitStartDate?: Maybe<Scalars['String']>;
  visits: Array<RetoolPermanentShiftPostingMatchVisit>;
};

export type RetoolPermanentShiftPostingMatchVisit = {
  __typename?: 'RetoolPermanentShiftPostingMatchVisit';
  shiftPostingId: Scalars['ID'];
  recurringShiftId: Scalars['ID'];
  startTimeOfDay: Scalars['String'];
  endTimeOfDay: Scalars['String'];
  dayOfWeek: Scalars['String'];
  isOvernight: Scalars['Boolean'];
};

export type RetoolQaVisitInput = {
  startDate: Scalars['Timestamp'];
  endDate: Scalars['Timestamp'];
  scheduledStartDate?: Maybe<Scalars['Timestamp']>;
  scheduledEndDate?: Maybe<Scalars['Timestamp']>;
  clockIn?: Maybe<VisitClockDetails>;
  clockOut?: Maybe<VisitClockDetails>;
  result?: Maybe<VistResult>;
  /**
   * Optional field.
   * Some source data may expose the confirmed payroll minutes
   * as a separate field, which may or may not be equal to the
   * difference between `startDate` and `endDate`.
   */
  minutesWorkedForPayroll?: Maybe<Scalars['Int']>;
};

export type RetoolSearchCaregiverAccountsInput = {
  organizationId: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type RetoolSearchCaregiverAccountsResult = {
  __typename?: 'RetoolSearchCaregiverAccountsResult';
  externalIntegrationId: Scalars['String'];
  externalEmployeeId: Scalars['String'];
  schedulingSoftware: SchedulingSoftware;
  schedulingStatus?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** Provider-specific metadata (e.g. caregiverCode for HHAX, siteId for AxisCare). */
  providerMetadata: Scalars['JSONObject'];
  relatedCaribouUser?: Maybe<RewardsUser>;
};

/** Shift booking settings for an organization. For Retool use only. */
export type RetoolShiftBookingSetting = {
  __typename?: 'RetoolShiftBookingSetting';
  organizationId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  enabledNonPHIShiftPostingFieldsForCaregivers: Array<Scalars['String']>;
  shiftConsiderationLookAheadDays: Scalars['Int'];
  /** Day of week payroll week starts on. */
  payrollWeekStartsOn: DayOfWeek;
  restrictMatchesByHHAXOffice: Scalars['Boolean'];
  hasOvernightShiftCombination: Scalars['Boolean'];
  allowedDisplayableLanguagesForCaregivers: Array<Scalars['String']>;
  defaultPayCodeConfiguration: Array<DefaultPayCodeConfigurationItem>;
  /** Caregiver eligibility filter criteria (tag-based). Schema v1 structure. */
  caregiverEligibilityFilters?: Maybe<RewardsGroupTagsConfig>;
  shiftBookingLaunchedToCaregivers: Scalars['Boolean'];
  shiftBookingLaunchedToCaregiversAt?: Maybe<Scalars['Timestamp']>;
  shiftBookingLaunchedToCoordinators: Scalars['Boolean'];
  shiftBookingLaunchedToCoordinatorsAt?: Maybe<Scalars['Timestamp']>;
  /** Number of active caregivers with CaregiverShiftBookingSettings where isEligibleForShiftBooking is true. */
  eligibleCaregiversCount: Scalars['Int'];
};

export type RetoolShiftPostingMatch = RetoolTemporaryShiftPostingMatch | RetoolPermanentShiftPostingMatch;

export type RetoolShiftPostingMatchBase = {
  organizationId: Scalars['ID'];
  shiftPostingId: Scalars['ID'];
  temporaryOrPermanent: CaregiverProfileShiftTypePreference;
  caregiverPhone?: Maybe<Scalars['String']>;
  caregiverName: Scalars['String'];
  caregiverUserId: Scalars['ID'];
  coordinatorName?: Maybe<Scalars['String']>;
  commuteTimeFromUsersHouseTransit: Scalars['String'];
  commuteTimeFromUsersHouseCar: Scalars['String'];
  nonPhiLocation: Scalars['String'];
  nonPhiHasDogs: Scalars['String'];
  nonPhiHasCats: Scalars['String'];
  nonPhiIsBedBound: Scalars['String'];
  linkToShiftPosting: Scalars['String'];
};

export type RetoolSignalVisitLoadCompleteResponse = {
  __typename?: 'RetoolSignalVisitLoadCompleteResponse';
  success: Scalars['Boolean'];
};

export type RetoolTemporaryShiftPostingMatch = RetoolShiftPostingMatchBase & {
  __typename?: 'RetoolTemporaryShiftPostingMatch';
  organizationId: Scalars['ID'];
  shiftPostingId: Scalars['ID'];
  temporaryOrPermanent: CaregiverProfileShiftTypePreference;
  caregiverPhone?: Maybe<Scalars['String']>;
  caregiverName: Scalars['String'];
  caregiverUserId: Scalars['ID'];
  coordinatorName?: Maybe<Scalars['String']>;
  commuteTimeFromUsersHouseTransit: Scalars['String'];
  commuteTimeFromUsersHouseCar: Scalars['String'];
  nonPhiLocation: Scalars['String'];
  nonPhiHasDogs: Scalars['String'];
  nonPhiHasCats: Scalars['String'];
  nonPhiIsBedBound: Scalars['String'];
  linkToShiftPosting: Scalars['String'];
  visits: Array<RetoolTemporaryShiftPostingMatchVisit>;
};

export type RetoolTemporaryShiftPostingMatchVisit = {
  __typename?: 'RetoolTemporaryShiftPostingMatchVisit';
  shiftPostingId: Scalars['ID'];
  shiftPostingVisitId: Scalars['ID'];
  shiftStartTimestamp: Scalars['String'];
  shiftEndTimestamp: Scalars['String'];
  temporaryOrPermanent: CaregiverProfileShiftTypePreference;
};

export type RewardNotification = {
  __typename?: 'RewardNotification';
  id: Scalars['ID'];
  userId: Scalars['String'];
  rewardsOrganizationId: Scalars['Int'];
  messageTitle: Scalars['String'];
  messageBody?: Maybe<Scalars['String']>;
  /**
   * If the reward notification is due to the user earning points,
   * this will be popualted with the number of points earned.
   */
  pointsEarned?: Maybe<Scalars['Int']>;
  pointsDeducted?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Timestamp'];
};

export type RewardNotificationListResponse = {
  __typename?: 'RewardNotificationListResponse';
  total: Scalars['Int'];
  items: Array<JobPosting>;
};

export type RewardOffer = {
  __typename?: 'RewardOffer';
  id: Scalars['ID'];
  externalId?: Maybe<Scalars['ID']>;
  completed: Scalars['Boolean'];
  revoked: Scalars['Boolean'];
  numCompletions: Scalars['Int'];
  completions: Array<RewardOfferCompletion>;
  cardTitle: Scalars['String'];
  cardButtonLabel: Scalars['String'];
  cardPointsText?: Maybe<Scalars['String']>;
  cardCompletedPointsText?: Maybe<Scalars['String']>;
  cardGraphicKey: RewardOfferCardGraphicKey;
  /**
   * Details about the next reward that can be earned from
   * this reward offer.
   */
  nextReward?: Maybe<RewardOfferNextReward>;
  structure: RewardOfferStructure;
  action: RewardOfferAction;
  user: RewardsUser;
  organization: RewardsOrganization;
};

export type RewardOfferAction = RewardOfferModalAction | RewardOfferInAppLinkAction | RewardOfferExternalLinkAction;

export enum RewardOfferCardGraphicKey {
  PeopleInClassroom = 'people_in_classroom',
  CirclingDateOnCalendar = 'circling_date_on_calendar',
  PeopleInPhones = 'people_in_phones',
  WomanWalletCelebration = 'woman_wallet_celebration',
  WomenGiftsCelebration = 'women_gifts_celebration',
  PersonOnTrophyGifts = 'person_on_trophy_gifts',
  WomanWalkingOnCoins = 'woman_walking_on_coins',
  Evv = 'evv',
  WomanLoggingIn = 'woman_logging_in',
  ReferAndEarn = 'refer_and_earn',
  PeopleCommunicatingOffice = 'people_communicating_office',
  WomanGivingPresentation = 'woman_giving_presentation',
  PeopleTrophyCelebration = 'people_trophy_celebration',
  PeopleCoinsInJar = 'people_coins_in_jar',
  PlayVideo = 'play_video',
  VacantDesk = 'vacant_desk',
  WomanChecklist = 'woman_checklist',
  ManCirclingDateOnCalendar = 'man_circling_date_on_calendar',
  RecognizingEmployees = 'recognizing_employees',
  PhoneChatApp = 'phone_chat_app',
  ChecklistClipboard = 'checklist_clipboard',
  HealthChecklistClipboard = 'health_checklist_clipboard',
  WomanSchedulingOnPhone = 'woman_scheduling_on_phone',
  MailNotification = 'mail_notification',
  FolksWorkingOutside = 'folks_working_outside'
}

export type RewardOfferCompletion = {
  __typename?: 'RewardOfferCompletion';
  id: Scalars['ID'];
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
  awarded: Scalars['Boolean'];
  acknowledged: Scalars['Boolean'];
};

export type RewardOfferExternalLinkAction = {
  __typename?: 'RewardOfferExternalLinkAction';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type RewardOfferInAppLinkAction = {
  __typename?: 'RewardOfferInAppLinkAction';
  id: Scalars['ID'];
  linkPath: Scalars['String'];
};

export type RewardOfferModalAction = {
  __typename?: 'RewardOfferModalAction';
  id: Scalars['ID'];
  modalContentsHtml: Scalars['String'];
};

export type RewardOfferNextReward = RewardOfferStructureReward & {
  __typename?: 'RewardOfferNextReward';
  id: Scalars['ID'];
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
};

export type RewardOfferStructure = RewardOfferStructureUnlimited | RewardOfferStructureOneTime | RewardOfferStructurePeriodic | RewardOfferStructureDiscreteProgress | RewardOfferStructurePunchCard;

export type RewardOfferStructureDiscreteProgress = {
  __typename?: 'RewardOfferStructureDiscreteProgress';
  id: Scalars['ID'];
  steps: Array<RewardOfferStructureDiscreteProgressStep>;
};

export type RewardOfferStructureDiscreteProgressStep = RewardOfferStructureReward & {
  __typename?: 'RewardOfferStructureDiscreteProgressStep';
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
};

export type RewardOfferStructureOneTime = RewardOfferStructureReward & {
  __typename?: 'RewardOfferStructureOneTime';
  id: Scalars['ID'];
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
};

export type RewardOfferStructurePeriodic = RewardOfferStructureReward & {
  __typename?: 'RewardOfferStructurePeriodic';
  id: Scalars['ID'];
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
  frequency: RewardOfferStructurePeriodicFrequency;
};

export enum RewardOfferStructurePeriodicFrequency {
  Weekly = 'WEEKLY'
}

export type RewardOfferStructurePunchCard = RewardOfferStructureReward & {
  __typename?: 'RewardOfferStructurePunchCard';
  id: Scalars['ID'];
  numPunchesPerCard: Scalars['Int'];
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
};

export type RewardOfferStructureReward = {
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
};

export enum RewardOfferStructureType {
  OneTime = 'one_time',
  Unlimited = 'unlimited',
  PunchCard = 'punch_card'
}

export type RewardOfferStructureUnlimited = RewardOfferStructureReward & {
  __typename?: 'RewardOfferStructureUnlimited';
  id: Scalars['ID'];
  pointValue?: Maybe<Scalars['Int']>;
  numDrawTickets?: Maybe<Scalars['Int']>;
};

export type RewardOverride = {
  __typename?: 'RewardOverride';
  numPoints?: Maybe<Scalars['Int']>;
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
};

export type RewardOverrideInput = {
  numPoints?: Maybe<Scalars['Int']>;
  numOrganizationDrawTickets?: Maybe<Scalars['Int']>;
};

export type RewardReport = {
  __typename?: 'RewardReport';
  id: Scalars['ID'];
};

export type RewardReportDataSetConfigInput = {
  /**
   * The type of the dataset.
   *
   * Depending on the type, the corresponding input parameters must be provided.
   */
  type: RewardReportDataSetType;
  engagementByCaregiverParameters?: Maybe<ReportEngagementByCaregiverParameters>;
  evvComplianceByCaregiverParameters?: Maybe<ReportEvvComplianceByCaregiverParameters>;
  surveyReportByCaregiverParameters?: Maybe<ReportSurveyReportByCaregiverParameters>;
  checkInSurveyReportByCaregiverParameters?: Maybe<ReportCheckInSurveyReportByCaregiverParameters>;
  loginSummaryByAdminParameters?: Maybe<ReportLoginSummaryByAdminParameters>;
  recognitionBudgetUtilizationByAdminParameters?: Maybe<RecognitionBudgetUtilizationByAdminParameters>;
};

export enum RewardReportDataSetType {
  EngagementByCaregiver = 'ENGAGEMENT_BY_CAREGIVER',
  EvvComplianceByCaregiver = 'EVV_COMPLIANCE_BY_CAREGIVER',
  SurveyReportByCaregiver = 'SURVEY_REPORT_BY_CAREGIVER',
  CheckInSurveyReportByCaregiver = 'CHECK_IN_SURVEY_REPORT_BY_CAREGIVER',
  LoginSummaryByAdmin = 'LOGIN_SUMMARY_BY_ADMIN',
  RecognitionBudgetUtilizationByAdmin = 'RECOGNITION_BUDGET_UTILIZATION_BY_ADMIN',
  EmployeeExport = 'EMPLOYEE_EXPORT'
}

export type RewardVideo = {
  __typename?: 'RewardVideo';
  id: Scalars['ID'];
  title: Scalars['String'];
  file: RewardVideoFile;
  url?: Maybe<Scalars['String']>;
  status: VideoStatus;
};

export type RewardVideoFile = RewardVideoUrlFile | RewardVideoManagedFile;

export type RewardVideoManagedFile = {
  __typename?: 'RewardVideoManagedFile';
  id: Scalars['ID'];
  originalFilename: Scalars['String'];
};

export type RewardVideoOffer = {
  __typename?: 'RewardVideoOffer';
  id: Scalars['ID'];
  externalId?: Maybe<Scalars['ID']>;
  video: RewardVideo;
  pointValue: Scalars['Int'];
  watched: Scalars['Boolean'];
  deleted: Scalars['Boolean'];
  user: RewardsUser;
  organization: RewardsOrganization;
};

export type RewardVideoUrlFile = {
  __typename?: 'RewardVideoUrlFile';
  id: Scalars['ID'];
  /** @deprecated Use 'url' field on RewardVideo instead */
  url: Scalars['String'];
};

export type RewardsAccountTransaction = {
  __typename?: 'RewardsAccountTransaction';
  id: Scalars['ID'];
  occurredAt: Scalars['Timestamp'];
  unsignedPointValue: Scalars['Int'];
  signedPointValue: Scalars['Int'];
  metadata: TransactionMetadata;
};

export enum RewardsAdminAuthStatus {
  InitialPasswordRequiredByUser = 'INITIAL_PASSWORD_REQUIRED_BY_USER',
  PasswordSetByUser = 'PASSWORD_SET_BY_USER',
  Unknown = 'UNKNOWN'
}

export type RewardsAdminAutomaticRecognitionBudgetConfig = {
  __typename?: 'RewardsAdminAutomaticRecognitionBudgetConfig';
  enabled: Scalars['Boolean'];
  defaultAmount?: Maybe<Scalars['Int']>;
};

export type RewardsAdminAutomaticRecognitionBudgetConfigInput = {
  enabled: Scalars['Boolean'];
  defaultAmount?: Maybe<Scalars['Int']>;
};

export type RewardsAdminFullAccessPermissions = {
  __typename?: 'RewardsAdminFullAccessPermissions';
  type: RewardsAdminPermissionsType;
};

export type RewardsAdminListFilterInput = {
  /** Filters admins by the given search query. */
  searchQuery?: Maybe<Scalars['String']>;
  /**
   * Allows filtering by organization branch ID.
   * It always includes Admins that have no branches assigned to them
   * If provided, will only show results from given branch(es)
   * If not provided, will show all admins
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Scalars['ID']>>;
  /** Allows filtering admins by whether they have budgets enabled. */
  budgetsEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Allows filtering admins based on 'active' status.
   * Note: this is only permitted when querying with full-access permissions.
   * If querying with restricted permissions, this will default to TRUE.
   */
  active?: Maybe<Scalars['Boolean']>;
};

export type RewardsAdminPermissions = RewardsAdminFullAccessPermissions | RewardsAdminRestrictedAccessPermissions;

export type RewardsAdminPermissionsInput = {
  type: RewardsAdminPermissionsType;
  /** Deprecated - use `RewardsAdminRestrictedAccessPermissionsInputV2` */
  permissions?: Maybe<RewardsAdminRestrictedAccessPermissionsInput>;
  /** This should only be provided if `type` is `RESTRICTED_ACCESS` */
  permissionsV2?: Maybe<RewardsAdminRestrictedAccessPermissionsInputV2>;
};

export enum RewardsAdminPermissionsType {
  FullAccess = 'FULL_ACCESS',
  RestrictedAccess = 'RESTRICTED_ACCESS'
}

export type RewardsAdminRestrictedAccessAdministratorsPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessAdministratorsPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessCandidatesPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessCandidatesPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessDrawsPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessDrawsPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessEmployeesPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessEmployeesPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
  /**
   * If `permissionLevel` is `FULL_ACCESS`, this value will be populated.
   * If `true`, the admin can redeem or remove points for employees.
   */
  canRedeemOrRemovePoints?: Maybe<Scalars['Boolean']>;
};

export type RewardsAdminRestrictedAccessJobsPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessJobsPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export enum RewardsAdminRestrictedAccessPermissionLevel {
  FullAccess = 'FULL_ACCESS',
  ReadOnly = 'READ_ONLY'
}

export type RewardsAdminRestrictedAccessPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessPermissions';
  type: RewardsAdminPermissionsType;
  /** @deprecated Use `permissionsV2` instead */
  permissions?: Maybe<RewardsAdminRestrictedAccessPermissionsMap>;
  permissionsV2?: Maybe<RewardsAdminRestrictedAccessPermissionsMapV2>;
};

export type RewardsAdminRestrictedAccessPermissionsAdministratorsInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessPermissionsCandidatesInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessPermissionsDrawsPermissionsInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessPermissionsEmployeesInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
  /** This should only be populated if the admin has `FULL_ACCESS` to employees. */
  canRedeemOrRemovePoints?: Maybe<Scalars['Boolean']>;
};

export type RewardsAdminRestrictedAccessPermissionsInput = {
  jobs?: Maybe<RewardsAdminRestrictedAccessPermissionsValue>;
  candidates?: Maybe<RewardsAdminRestrictedAccessPermissionsValue>;
  redemptions?: Maybe<RewardsAdminRestrictedAccessPermissionsValue>;
  bonusPoints?: Maybe<RewardsAdminRestrictedAccessPermissionsValue>;
  employees?: Maybe<RewardsAdminRestrictedAccessPermissionsValue>;
  administrators?: Maybe<RewardsAdminRestrictedAccessPermissionsValue>;
};

export type RewardsAdminRestrictedAccessPermissionsInputV2 = {
  jobs?: Maybe<RewardsAdminRestrictedAccessPermissionsJobsInput>;
  candidates?: Maybe<RewardsAdminRestrictedAccessPermissionsCandidatesInput>;
  redemptions?: Maybe<RewardsAdminRestrictedAccessPermissionsRedemptionsInput>;
  recognitionPoints?: Maybe<RewardsAdminRestrictedAccessPermissionsRecognitionPointsInput>;
  employees?: Maybe<RewardsAdminRestrictedAccessPermissionsEmployeesInput>;
  administrators?: Maybe<RewardsAdminRestrictedAccessPermissionsAdministratorsInput>;
  surveys?: Maybe<RewardsAdminRestrictedAccessPermissionsSurveysInput>;
  socialFeed?: Maybe<RewardsAdminRestrictedAccessPermissionsSocialFeedInput>;
  draws?: Maybe<RewardsAdminRestrictedAccessPermissionsDrawsPermissionsInput>;
  shiftBooking?: Maybe<RewardsAdminRestrictedAccessPermissionsShiftBookingInput>;
};

export type RewardsAdminRestrictedAccessPermissionsJobsInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

/** This is deprecated in favour of `RewardsAdminRestrictedAccessPermissionsV2` */
export type RewardsAdminRestrictedAccessPermissionsMap = {
  __typename?: 'RewardsAdminRestrictedAccessPermissionsMap';
  jobs: RewardsAdminRestrictedAccessPermissionsValue;
  candidates: RewardsAdminRestrictedAccessPermissionsValue;
  redemptions: RewardsAdminRestrictedAccessPermissionsValue;
  bonusPoints: RewardsAdminRestrictedAccessPermissionsValue;
  employees: RewardsAdminRestrictedAccessPermissionsValue;
  administrators: RewardsAdminRestrictedAccessPermissionsValue;
};

export type RewardsAdminRestrictedAccessPermissionsMapV2 = {
  __typename?: 'RewardsAdminRestrictedAccessPermissionsMapV2';
  jobs?: Maybe<RewardsAdminRestrictedAccessJobsPermissions>;
  candidates?: Maybe<RewardsAdminRestrictedAccessCandidatesPermissions>;
  redemptions?: Maybe<RewardsAdminRestrictedAccessRedemptionsPermissions>;
  recognitionPoints?: Maybe<RewardsAdminRestrictedAccessRecognitionPointsPermissions>;
  employees?: Maybe<RewardsAdminRestrictedAccessEmployeesPermissions>;
  administrators?: Maybe<RewardsAdminRestrictedAccessAdministratorsPermissions>;
  socialFeed?: Maybe<RewardsAdminRestrictedAccessSocialFeedPermissions>;
  surveys?: Maybe<RewardsAdminRestrictedAccessSurveysPermissions>;
  shiftBooking?: Maybe<RewardsAdminRestrictedAccessShiftBookingPermissions>;
  draws?: Maybe<RewardsAdminRestrictedAccessDrawsPermissions>;
};

export type RewardsAdminRestrictedAccessPermissionsRecognitionPointsInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
  /** These should only be populated if the admin has `FULL_ACCESS` to recognition. */
  canOverrideRecognitionCategoryDefaultAmounts?: Maybe<Scalars['Boolean']>;
  canOverrideBudget?: Maybe<Scalars['Boolean']>;
};

export type RewardsAdminRestrictedAccessPermissionsRedemptionsInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessPermissionsShiftBookingInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessPermissionsSocialFeedInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessPermissionsSurveysInput = {
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

/** This is deprecated in favour of `RewardsAdminRestrictedAccessPermissionLevel` */
export enum RewardsAdminRestrictedAccessPermissionsValue {
  FullAccess = 'FULL_ACCESS',
  ReadOnly = 'READ_ONLY',
  None = 'NONE'
}

export type RewardsAdminRestrictedAccessRecognitionPointsPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessRecognitionPointsPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
  /**
   * If `permissionLevel` is `FULL_ACCESS`, this value will be populated.
   * If `true`, the admin can override recognition category default amounts.
   */
  canOverrideRecognitionCategoryDefaultAmounts?: Maybe<Scalars['Boolean']>;
  /**
   * If `permissionLevel` is `FULL_ACCESS`, this value will be populated.
   * If `true`, the admin can override budget.
   */
  canOverrideBudget?: Maybe<Scalars['Boolean']>;
};

export type RewardsAdminRestrictedAccessRedemptionsPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessRedemptionsPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessShiftBookingPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessShiftBookingPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessSocialFeedPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessSocialFeedPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export type RewardsAdminRestrictedAccessSurveysPermissions = {
  __typename?: 'RewardsAdminRestrictedAccessSurveysPermissions';
  permissionLevel: RewardsAdminRestrictedAccessPermissionLevel;
};

export enum RewardsAdminRoleType {
  ProgramManager = 'PROGRAM_MANAGER',
  Executive = 'EXECUTIVE',
  Coordinator = 'COORDINATOR',
  Finance = 'FINANCE',
  HumanResources = 'HUMAN_RESOURCES'
}

export type RewardsAdminShiftRewardBudgetConfig = {
  __typename?: 'RewardsAdminShiftRewardBudgetConfig';
  enabled: Scalars['Boolean'];
  defaultAmount?: Maybe<Scalars['Int']>;
};

export type RewardsAdminShiftRewardBudgetConfigInput = {
  enabled: Scalars['Boolean'];
  defaultAmount?: Maybe<Scalars['Int']>;
};

export type RewardsAdminUser = RewardsUserIdentity & {
  __typename?: 'RewardsAdminUser';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  role?: Maybe<RewardsAdminRoleType>;
  /**
   * The permissions for the admin within the organization that the authenticated user is querying for.
   * This is only available if there is a selected tenant ID.
   *
   * Note: the admin may belong to other organizations and have different permissions for those organizations,
   * but only permissions for the organization that the authenticated user is querying for are returned.
   */
  permissions: RewardsAdminPermissions;
  /**
   * Whether the admin is active within the organization that the authenticated user is querying for.
   * This is only available if there is a selected tenant ID.
   *
   * Note: the admin may belong to other organizations and be active in some but not all of them,
   * but only the active status for the organization that the authenticated user is querying for is returned.
   */
  active: Scalars['Boolean'];
  /**
   * The branches for the admin within the organization that the authenticated user is querying for.
   * This is only available if there is a selected tenant ID.
   *
   * Note: the admin may belong to other organizations and have different branches for those organizations,
   * but only branches for the organization that the authenticated user is querying for are returned.
   *
   * Admins without a specific branch assigned should be interpreted as having access to all branches.
   * Recommended to use organization branches resolver for such admins.
   */
  branches: Array<RewardsOrganizationBranch>;
  /**
   * The automatic recognition budget config for the admin within the organization that the authenticated user is querying for.
   * This is only available if there is a selected tenant ID.
   *
   * Note: the admin may belong to other organizations and have different automatic recognition budget configs for those organizations,
   * but only the automatic recognition budget config for the organization that the authenticated user is querying for is returned.
   */
  automaticRecognitionBudgetConfig?: Maybe<RewardsAdminAutomaticRecognitionBudgetConfig>;
  /**
   * The shift reward budget config for the admin within the organization that the authenticated user is querying for.
   * This is only available if there is a selected tenant ID.
   *
   * Note: the admin may belong to other organizations and have different shift reward budget configs for those organizations,
   * but only the shift reward budget config for the organization that the authenticated user is querying for is returned.
   */
  shiftRewardBudgetConfig?: Maybe<RewardsAdminShiftRewardBudgetConfig>;
  /**
   * Whether the admin has available goals for the organization that the authenticated user is querying for.
   * This is only available if there is a selected tenant ID.
   *
   * Note: the admin may belong to other organizations and have different available goals for those organizations,
   * but only the available goals for the organization that the authenticated user is querying for are returned.
   */
  hasAvailableGoal: Scalars['Boolean'];
  /**
   * Whether the admin belongs to other active organizations besides the organization that the authenticated user is querying for.
   * This is only available if there is a selected tenant ID.
   *
   * Returns true if the admin has at least one active organization assignment other than the current tenant organization.
   */
  alsoBelongsToOtherOrganizations: Scalars['Boolean'];
};

export type RewardsBaseUrls = {
  __typename?: 'RewardsBaseUrls';
  rewardsAppBaseUrl: Scalars['String'];
  rewardsAdminAppBaseUrl: Scalars['String'];
  jobsAppBaseUrl: Scalars['String'];
};

/** Deprecated - use RecognitionCategory instead */
export type RewardsBonusPointCategory = {
  __typename?: 'RewardsBonusPointCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RewardsGroup = {
  __typename?: 'RewardsGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  tagsConfig: RewardsGroupTagsConfig;
};

export type RewardsGroupTagsConfig = RewardsGroupTagsConfigSchemaV1;

export type RewardsGroupTagsConfigSchemaV1 = {
  __typename?: 'RewardsGroupTagsConfigSchemaV1';
  schema: Scalars['String'];
  or: Array<RewardsGroupTagsConfigSchemaV1AndSchema>;
};

export type RewardsGroupTagsConfigSchemaV1AndSchema = {
  __typename?: 'RewardsGroupTagsConfigSchemaV1AndSchema';
  and: Array<RewardsTag>;
};

export type RewardsGroupTagsConfigSchemaV1AndSchemaInput = {
  and: Array<TagIdInput>;
};

export type RewardsGroupTagsConfigSchemaV1Input = {
  or: Array<RewardsGroupTagsConfigSchemaV1AndSchemaInput>;
};

export type RewardsLeaderboard = {
  __typename?: 'RewardsLeaderboard';
  items: Array<RewardsLeaderboardItem>;
  /**
   * 1-based index representing the authenticated user's place on the leaderboard.
   * e.g. if the user is in 1st place, this value will be `1`
   */
  myPlaceOnLeaderboard: Scalars['Int'];
};

export type RewardsLeaderboardItem = {
  __typename?: 'RewardsLeaderboardItem';
  id: Scalars['ID'];
  userDisplayName: Scalars['String'];
  pointsEarned: Scalars['Int'];
  /** 1-based indexing place of user */
  place: Scalars['Int'];
};

export type RewardsOrganization = {
  __typename?: 'RewardsOrganization';
  /** (Public) The rewards organization ID. Same as the identity tenant ID. */
  id: Scalars['ID'];
  branches: Array<RewardsOrganizationBranch>;
  isQA: Scalars['Boolean'];
  isDemo: Scalars['Boolean'];
  /** @deprecated Use `shortName` instead */
  name: Scalars['String'];
  /** (Public) The organization's short name. */
  shortName: Scalars['String'];
  /** (Public) URL-friendly slug identifier for the organization */
  slug?: Maybe<Scalars['String']>;
  /**
   * The organization's internal name.
   * This should only be exposed to Caribou employees (aka. superusers).
   */
  internalName?: Maybe<Scalars['String']>;
  /**
   * The organization's timezone in IANA format.
   * e.g "America/Toronto"
   */
  timezone: Scalars['String'];
  /** The organization's branch name (if there are other branches) */
  branchName?: Maybe<Scalars['String']>;
  country: RewardsOrganizationCountry;
  /** If `true`, admins can only manage permissions for their own branch (the logic is handled in the front-end) */
  limitingAdminPermissionsByBranch: Scalars['Boolean'];
  /** The organization's long name. Useful for mailing address purposes. */
  longName: Scalars['String'];
  /** The organization's mailing address */
  mailingAddress?: Maybe<MailingAddress>;
  /** The organization's website URL. This is displayed publicly for job postings. */
  websiteUrl?: Maybe<Scalars['String']>;
  /** (Public) The primary colour of the organization. Used for theming purposes. */
  themePrimaryColor?: Maybe<Scalars['String']>;
  /** (Public) The URL of the banner image to display on job postings. */
  themeJobPostingBannerImageUrl?: Maybe<Scalars['String']>;
  /** (Public) The square logo URL of the banner image to display on job postings. */
  themeSquareLogoUrl?: Maybe<Scalars['String']>;
  /**
   * (Admin only) Recruitment & retention steps that the candidate needs to go through.
   * @deprecated Use referral structure APIs instead
   */
  candidateSteps: Array<CandidateStep>;
  /** @deprecated Use referral structure APIs instead */
  candidateStepsV2: Array<CandidateStepV2>;
  /**
   * (Rewards User/Admin only) True if the organization is configured to use work devices.
   *   This means a user can be created using their work email and phone number,
   *   and then must opt-in with their personal information to receive an account.
   */
  usesWorkDevices: Scalars['Boolean'];
  /** (Rewards User or Admin only) Number of points which equate to a dollar. */
  pointsPerDollar: Scalars['Int'];
  /** (Rewards User or Admin only) Redemption methods an organization offers. */
  allowedRedemptionMethods: Array<RedemptionMethod>;
  /**
   * Redemption summary notification email if the organization has enabled automatic PAYROLL redemption processing via Retool App.
   * @deprecated Use redemptionSummaryNotificationEmails instead
   */
  redemptionSummaryNotificationEmail?: Maybe<Scalars['String']>;
  /** Redemption summary notification emails if the organization has enabled automatic PAYROLL redemption processing via Retool App. */
  redemptionSummaryNotificationEmails: Array<Scalars['String']>;
  /** (Rewards User or Admin only) Minimum points that the user can redeem at once. */
  minimumPointsNeededToRedeem: Scalars['Int'];
  /**
   * Maximum number of job shares per month which can be awarded points for
   * @deprecated Use referral structure APIs instead
   */
  maxAwardableJobSharesPerMonth: Scalars['Int'];
  /**
   * Maximum number of points that can be earned for a candidate,
   * accounting for the job share, recruitment milestones, and retention milestones
   */
  maxPointsEarnedPerCandidate: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForJobPostingShared: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForReferralApplied: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForReferralPassedInterview: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForReferralHired: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForReferralStartedOrientation: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForReferralCompletedOrientation: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForReferralCompletedFirstShift: Scalars['Int'];
  /**
   * (Rewards User or Admin only)
   * @deprecated Use referral structure APIs instead
   */
  pointsEarnedForReferralReachedTenureMilestone: Array<RewardsStructureTenureMilestone>;
  /** (Rewards User or Admin only) */
  referralRewardStructure: ReferralRewardStructure;
  /** (Rewards User or Admin only) */
  pointsEarnedForEarlyOptIn?: Maybe<Scalars['Int']>;
  /** One time reward offer that can be triggered by the api consumer. See completeWelcomeOffer mutation. */
  pointsEarnedForWelcomeOffer?: Maybe<Scalars['Int']>;
  /** (Rewards User only) */
  jobPostingLocationField: JobPostingLocationField;
  /**
   * (Public) The organization's email banner logo image url
   * @deprecated Use logoImageUrl instead
   */
  emailBannerLogoImageUrl?: Maybe<Scalars['String']>;
  /** (Public) The organization's email banner logo image url */
  logoImageUrl?: Maybe<Scalars['String']>;
  /** (Rewards User only) */
  workEmailDomain?: Maybe<Scalars['String']>;
  defaultCandidateAlertEmail?: Maybe<Scalars['String']>;
  /**
   * (Rewards admins only)
   *
   * True if the organization is integrated with AlayaCare.
   */
  integratedWithAlayaCare: Scalars['Boolean'];
  /** If `false`, the organization has not been 'launched' yet. */
  launched: Scalars['Boolean'];
  /** If the organization has launched, represents the date-time that the org launched. */
  launchedAt?: Maybe<Scalars['Timestamp']>;
  /** The completed launch steps for the organization. */
  completedLaunchSteps: Array<RewardsOrganizationCompletedLaunchStep>;
  payrollFrequency: RewardsOrganizationPayrollFrequency;
  leaderboardEmailContactName?: Maybe<Scalars['String']>;
  leaderboardEmailContactEmail?: Maybe<Scalars['String']>;
  bulkUserUploadIsProcessing: Scalars['Boolean'];
  /**
   * (Public) The white label config.
   *
   * If `null`, white labeling is not enabled for the organization
   */
  whiteLabelConfig?: Maybe<RewardsOrganizationWhiteLabelConfig>;
  /** If `true`, referrals are enabled for the organization */
  referralsEnabled: Scalars['Boolean'];
  /** If `true`, the organization wants to collect resumes from applicants. */
  referralResumesEnabled: Scalars['Boolean'];
  /** (Public) If defined, should be displayed on the opt-in page as a disclaimer */
  optInPageDisclaimer?: Maybe<Scalars['String']>;
  /** If `true`, managers are enabled for the organization. */
  managersEnabled: Scalars['Boolean'];
  /** If `true`, recognition budgets are enabled for the organization. */
  recognitionBudgetsEnabled: Scalars['Boolean'];
  /**
   * A file that contains a recognition rubric (if exists).
   * This rubric will show a rewards admin how they can award points
   */
  recognitionRubricFileUrl?: Maybe<Scalars['String']>;
  /** If `true`, leaderboard is enabled for the organization. */
  leaderboardEnabled: Scalars['Boolean'];
  /**
   * If `true`, the "Draws" feature is enabled for the organization.
   * This means that the organization manages and runs their owns draws.
   */
  drawsEnabled: Scalars['Boolean'];
  /**
   * If `true`, the "Goals" feature is enabled for the organization.
   *
   * This means that users are distributed goals instead of reward offers
   * (which is the legacy system for facilitating incentives).
   */
  goalsEnabled: Scalars['Boolean'];
  /**
   * If `true`, users in this organization can be aware of & earn tickets
   * for one of the Caribou-sponsored draws.
   */
  hasAccessToCaribouSponsoredDraws: Scalars['Boolean'];
  /** If `true`, the organization started as a trial. */
  startedAsTrial: Scalars['Boolean'];
  /** During onboarding, allows an admin to specify Caribou Rewards champions at their org */
  champions: Array<RewardsOrganizationOnboardingChampion>;
  /** The current state of onboarding for this rewards organization. */
  onboardingState: RewardsOrganizationOnboardingState;
  signUpContactInfoPreference: RewardsOrganizationSignUpContactInfoPreference;
  /** This config holds the frequency and related data for organization's recognition budget. */
  automaticRecognitionBudgetConfig: RewardsOrganizationAutomaticRecognitionBudgetConfig;
  /**
   * Returns true if the organization has visit data
   * (at least one visit pipeline has completed, indicating that visit data is accessible).
   */
  hasVisitData: Scalars['Boolean'];
  /** Returns true if the organization has enabled the social feed. */
  socialFeedEnabled: Scalars['Boolean'];
  /** Returns true if the organization has enabled the shift booking feature. */
  shiftBookingEnabled: Scalars['Boolean'];
  /** Returns true if shift booking has been launched to coordinators for this organization. */
  shiftBookingLaunchedToCoordinators: Scalars['Boolean'];
  /**
   * Returns true if the organization has enabled the caregiver impact feature.
   *
   * If this is `true`, then caregivers should be able to see a section in the app
   * that allows them to view the impact that they've made (monthly "wrapped" summaries).
   */
  caregiverImpactEnabled: Scalars['Boolean'];
  /**
   * Returns true if the organization uses the employment start date field
   * (at least one active user at the organization has this field set).
   */
  usesEmploymentStartDate: Scalars['Boolean'];
  /** If the organization uses gift cards, returns their current balance -- otherwise `null`. */
  giftCardProviderBalance?: Maybe<Scalars['Float']>;
  /**
   * The default gift card that would be used for forced redemptions.
   * Returns the gift card based on the organization's country:
   * - CA (Canada): Amazon gift card
   * - US: Mastercard gift card
   * Returns `null` if no suitable gift card is available.
   */
  forceRedemptionGiftCard?: Maybe<RedemptionCatalogItem>;
  /** Returns true if the organization has enabled the daily rewards feature. */
  dailyRewardsEnabled: Scalars['Boolean'];
};

export type RewardsOrganizationAutomaticRecognitionBudgetConfig = {
  __typename?: 'RewardsOrganizationAutomaticRecognitionBudgetConfig';
  frequency: RewardsOrganizationAutomaticRecognitionBudgetFrequency;
};

export type RewardsOrganizationAutomaticRecognitionBudgetConfigInput = {
  frequency: RewardsOrganizationAutomaticRecognitionBudgetFrequency;
};

export enum RewardsOrganizationAutomaticRecognitionBudgetFrequency {
  None = 'NONE',
  Monthly = 'MONTHLY'
}

export type RewardsOrganizationBranch = {
  __typename?: 'RewardsOrganizationBranch';
  id: Scalars['ID'];
  name: Scalars['String'];
  autoMembershipTagCriteria?: Maybe<RewardsGroupTagsConfig>;
  tags: Array<RewardsTag>;
  activeUserCount: Scalars['Int'];
  timezone?: Maybe<Scalars['String']>;
};

export type RewardsOrganizationCompletedLaunchStep = {
  __typename?: 'RewardsOrganizationCompletedLaunchStep';
  stepName: RewardsOrganizationLaunchStep;
  completedAt: Scalars['Timestamp'];
};

export enum RewardsOrganizationCountry {
  Ca = 'CA',
  Us = 'US'
}

export type RewardsOrganizationEvvRules = {
  __typename?: 'RewardsOrganizationEVVRules';
  id: Scalars['Int'];
  rules: EvvRules;
};

export enum RewardsOrganizationLaunchStep {
  LaunchStarted = 'LAUNCH_STARTED',
  LaunchProfileCompleted = 'LAUNCH_PROFILE_COMPLETED',
  JobPostingsAdded = 'JOB_POSTINGS_ADDED',
  RewardsUsersAdded = 'REWARDS_USERS_ADDED',
  RewardStructureConfirmed = 'REWARD_STRUCTURE_CONFIRMED',
  LaunchContestsReviewed = 'LAUNCH_CONTESTS_REVIEWED',
  QuestionnaireSubmitted = 'QUESTIONNAIRE_SUBMITTED'
}

export type RewardsOrganizationLeaderboardEmailContactInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export enum RewardsOrganizationOnboardingBusinessType {
  LimitedLiabilityCorporation = 'LIMITED_LIABILITY_CORPORATION',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  Partnership = 'PARTNERSHIP',
  Corporation = 'CORPORATION',
  NonProfitCorporation = 'NON_PROFIT_CORPORATION',
  Cooperative = 'COOPERATIVE'
}

export type RewardsOrganizationOnboardingChampion = {
  __typename?: 'RewardsOrganizationOnboardingChampion';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type RewardsOrganizationOnboardingChampionInput = {
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export enum RewardsOrganizationOnboardingCommitmentToSuccess {
  Ready = 'READY',
  NeedHelp = 'NEED_HELP',
  NotSure = 'NOT_SURE'
}

export type RewardsOrganizationOnboardingState = {
  __typename?: 'RewardsOrganizationOnboardingState';
  id: Scalars['ID'];
  /** Onboarding flow steps that have been marked as "completed" for this organization */
  completedSteps: Array<RewardsOrganizationOnboardingStepName>;
  /** During onboarding, allows an admin to specify the business type */
  businessType?: Maybe<RewardsOrganizationOnboardingBusinessType>;
  /** During onboarding, allows an admin to specify the business registration number */
  businessRegistrationNumber?: Maybe<Scalars['String']>;
  /** During onboarding, allows an admin to specify their level of commitment to success */
  commitmentToSuccess?: Maybe<RewardsOrganizationOnboardingCommitmentToSuccess>;
  /**
   * During onboarding, allows an admin to specify whether they would like to
   * utilize automated birthday recognition rewards
   */
  wantsAutomatedBirthdayRecognition?: Maybe<Scalars['Boolean']>;
  /**
   * During onboarding, allows an admin to specify whether they would like to
   * utilize automated anniversary recognition rewards
   */
  wantsAutomatedAnniversaryRecognition?: Maybe<Scalars['Boolean']>;
  /**
   * During onboarding, allows an admin to indicate a targeted launch date
   * for their organization.
   */
  targetLaunchDate?: Maybe<Scalars['Date']>;
  /**
   * Whether or not onboarding state should be disabled - if true, this
   * should prevent admins from interacting with the onboarding flow in the app
   */
  disabledOnboarding?: Maybe<Scalars['Boolean']>;
};

export enum RewardsOrganizationOnboardingStepName {
  Intro = 'INTRO',
  YourProfile = 'YOUR_PROFILE',
  CaregiverInvites = 'CAREGIVER_INVITES',
  EmployeeAutoSync = 'EMPLOYEE_AUTO_SYNC',
  ConfigureJobs = 'CONFIGURE_JOBS',
  JobSetting = 'JOB_SETTING',
  ReferralStructure = 'REFERRAL_STRUCTURE',
  EvvCompliance = 'EVV_COMPLIANCE',
  BookKickOff = 'BOOK_KICK_OFF',
  Champions = 'CHAMPIONS',
  Recognition = 'RECOGNITION',
  Redemption = 'REDEMPTION'
}

export type RewardsOrganizationOptInPromo = {
  __typename?: 'RewardsOrganizationOptInPromo';
  /**
   * The number of points earned for opting in.
   *
   * If no points will be earned for opting in, this value will be `null`
   */
  pointsEarnedForOptingIn?: Maybe<Scalars['Int']>;
};

export enum RewardsOrganizationPayrollFrequency {
  Weekly = 'WEEKLY',
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  Unknown = 'UNKNOWN'
}

export enum RewardsOrganizationSignUpContactInfoPreference {
  PersonalInfo = 'PERSONAL_INFO',
  WorkOrPersonal = 'WORK_OR_PERSONAL'
}

export type RewardsOrganizationStats = {
  __typename?: 'RewardsOrganizationStats';
  id: Scalars['ID'];
  totalNumberOfActiveUsers: Scalars['Int'];
  totalNumberOfActiveUsersWhoOptedIn: Scalars['Int'];
  totalNumberOfUsersWhoSharedAJob: Scalars['Int'];
  totalNumberOfShares: Scalars['Int'];
  totalNumberOfApplicants: Scalars['Int'];
  totalNumberOfCandidatesContacted: Scalars['Int'];
  totalNumberOfCandidatesScheduledInterview: Scalars['Int'];
  totalNumberOfCandidatesPassedInterview: Scalars['Int'];
  totalNumberOfCandidatesStartedWork: Scalars['Int'];
  totalNumberOfCandidatesHired: Scalars['Int'];
  totalNumberOfRetainedCandidatesAfter3Months: Scalars['Int'];
  totalNumberOfRetainedCandidatesAfter6Months: Scalars['Int'];
  totalPointsRedeemed: Scalars['Int'];
  totalPointsAwarded: Scalars['Int'];
  totalNumberOfCandidatesStartedOrientation: Scalars['Int'];
  totalNumberOfCandidatesCompletedOrientation: Scalars['Int'];
  totalNumberOfCandidatesCompletedFirstShift: Scalars['Int'];
};

export type RewardsOrganizationWhiteLabelConfig = {
  __typename?: 'RewardsOrganizationWhiteLabelConfig';
  /** The organization's id */
  id: Scalars['ID'];
  rewardsProgramShortName: Scalars['String'];
  rewardsProgramLongName: Scalars['String'];
  faviconImageUrl: Scalars['String'];
  optInPageLogoUrl: Scalars['String'];
  rewardsPageTabIconUrl: Scalars['String'];
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  fromEmail: Scalars['String'];
};

export type RewardsShiftMilestone = {
  __typename?: 'RewardsShiftMilestone';
  id: Scalars['ID'];
  totalShiftLengthHours: Scalars['Float'];
  pointValue: Scalars['Int'];
  completed: Scalars['Boolean'];
};

export type RewardsStructureTenureMilestone = {
  __typename?: 'RewardsStructureTenureMilestone';
  durationMonths: Scalars['Int'];
  pointValue: Scalars['Int'];
};

export type RewardsSuperuserPhiAccessGrant = {
  __typename?: 'RewardsSuperuserPHIAccessGrant';
  id: Scalars['ID'];
  tenantId: Scalars['ID'];
  expiresAt: Scalars['Timestamp'];
};

export type RewardsTag = {
  __typename?: 'RewardsTag';
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  externalId: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  activeUserCount: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

export type RewardsUser = RewardsUserIdentity & {
  __typename?: 'RewardsUser';
  /** The user's ID. Same as the user's identity ID. */
  id: Scalars['ID'];
  branch?: Maybe<RewardsOrganizationBranch>;
  /** External employee ID that the organization uses to associate the user */
  externalEmployeeId?: Maybe<Scalars['String']>;
  /** User groups that the user is assigned to (for categorization) */
  groups: Array<RewardsUserGroup>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /**
   * User's locale, formatted in `en` or `en-US`.
   * If not defined, a locale has not been explicitly set for this user.
   */
  locale?: Maybe<Locale>;
  /**
   * The locales that have been imported from an external system.
   *
   * These are locale codes (e.g. `en`).
   */
  externalLocales?: Maybe<Array<Scalars['String']>>;
  /**
   * Indicates whether the user has selected their locale. When a user is first created
   * we may automatically set their locale (ex. by syncing from an external source).
   */
  localeSetByUser: Scalars['Boolean'];
  /** The user's personal email/phone (the info they use to log in, and receive most comms on) */
  personalContactInfo?: Maybe<RewardsUserPersonalContactInfo>;
  workEmail?: Maybe<Scalars['String']>;
  workPhoneNumber?: Maybe<Scalars['String']>;
  employmentStartDate?: Maybe<Scalars['Date']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  active: Scalars['Boolean'];
  /** The user's display name (first name & last initial). */
  displayName: Scalars['String'];
  /**
   * The user's all-time point awarded (minus deductions).
   *
   * This discludes any points that were redeemed (or recredited due to a rejected redemption) -
   * see `pointsAvailableToRedeem` for the user's current point balance.
   */
  pointsEarnedAllTime: Scalars['Int'];
  /** The active point balance (points available to redeem). */
  pointsAvailableToRedeem: Scalars['Int'];
  /** The amount of points that the user has redeemed. */
  pointsRedeemed: Scalars['Int'];
  /** The latest points earned by the user. */
  latestPointsEarned?: Maybe<RewardsAccountTransaction>;
  /**
   * If there is a current draw running at the org, returns the number of tickets the user has
   * in the draw.
   *
   * Returns `null` if there is no current draw running at the org.
   */
  currentDrawTicketCount?: Maybe<Scalars['Int']>;
  /** The user's manager, if assigned */
  manager?: Maybe<RewardsAdminUser>;
  welcomeOfferCompleted?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not referrals are enabled for this user
   * (based on their branch or organization's settings)
   */
  referralsEnabled: Scalars['Boolean'];
  /** Whether or not referral links are disabled for this user. If true, the user is unable to share a job */
  userReferralLinkDisabled: Scalars['Boolean'];
  /** @deprecated Use `personalInformation` instead */
  email?: Maybe<Scalars['String']>;
  /** @deprecated Use `personalInformation` instead */
  phoneNumber?: Maybe<Scalars['String']>;
  /**
   * Scheduling software being used by the caregiver for verifying shifts.
   * Can be null when there's no employeeExternalId or missing mapping.
   */
  schedulingSoftware?: Maybe<SchedulingSoftware>;
  /**
   * Whether the user has received recognition points in the past 30 days.
   * This is only queryable by admins belonging to the same organization as the user,
   * if they have the appropriate permissions.
   * @deprecated Use `hasReceivedRecognitionInPast30Days` instead
   */
  hasReceivedRecognitionPointsInPast30Days: Scalars['Boolean'];
  /**
   * Whether the user has received recognition (points or draw tickets) in the past 30 days.
   * This is only queryable by admins belonging to the same organization as the user,
   * if they have the appropriate permissions.
   */
  hasReceivedRecognitionInPast30Days: Scalars['Boolean'];
  /**
   * The timestamp of the user's last recognition points award, or null if the user
   * has never received recognition points.
   * @deprecated Use `lastRecognitionReceivedDate` instead
   */
  lastRecognitionPointsReceivedDate?: Maybe<Scalars['Timestamp']>;
  /**
   * The timestamp of the user's last recognition award, or null if the user
   * has never received recognition.
   */
  lastRecognitionReceivedDate?: Maybe<Scalars['Timestamp']>;
  /**
   * Whether the user has logged in to the app in the past 30 days.
   * This is only queryable by admins belonging to the same organization as the user,
   * if they have the appropriate permissions.
   */
  hasLoggedInToAppInPast30Days: Scalars['Boolean'];
  /**
   * The ISO date-only string of the user's last login to the app, or null if the user
   * has never logged in.
   * This is only queryable by admins belonging to the same organization as the user,
   * if they have the appropriate permissions.
   */
  lastLoginDate?: Maybe<Scalars['Date']>;
  /** The user's address. */
  address?: Maybe<RewardsUserAddress>;
  /** The user's latest NPS survey answer, or null if the user has not completed an NPS survey. */
  latestNps?: Maybe<Scalars['Int']>;
  /** Shifts within the last 30 days */
  shiftsWorkedInPast30Days: Scalars['Int'];
  /** The number of EVV compliant shifts worked in the last 30 days */
  evvCompliantShiftsWorkedInPast30Days: Scalars['Int'];
  /** The ID of the HHAeXchange Caregiver ID associated with the user, if any. */
  hhaxCaregiverId?: Maybe<Scalars['Int']>;
  /** The HHAeXchange Caregiver Code associated with the user, if any. */
  hhaxCaregiverCode?: Maybe<Scalars['String']>;
  /** The HHAeXchange Alternate Caregiver Code associated with the user, if any. */
  hhaxAltCaregiverCode?: Maybe<Scalars['String']>;
  /** The HHAeXchange Caregiver Disciplines associated with the user, if any. */
  hhaxCaregiverDisciplines?: Maybe<Array<Scalars['String']>>;
  /** The number of unviewed recognition points for the user. */
  unviewedRecognitionPointsCount: Scalars['Int'];
  /**
   * The most recent recognition points received by the user.
   * @deprecated Use `lastRecognitionReceived` instead
   */
  lastRecognitionPointsReceived?: Maybe<RecognitionPoints>;
  /** The most recent recognition received by the user. */
  lastRecognitionReceived?: Maybe<Recognition>;
  /**
   * The user's caregiver profile (if any).
   *
   * It contains their availability, patient preferences, and other information.
   */
  caregiverProfile?: Maybe<CaregiverProfile>;
  /** Computes match & details for a shift posting for the user. */
  phiComputeMatchForShiftPosting: PhiCaregiverShiftPostingMatchContext;
  /** The user's tags. */
  tags: Array<RewardsTag>;
};


export type RewardsUserPhiComputeMatchForShiftPostingArgs = {
  shiftPostingId: Scalars['ID'];
  phiAccessReason: Scalars['String'];
};

export type RewardsUserAddress = RewardsUserCaAddress | RewardsUserUsAddress;

export type RewardsUserCaAddress = {
  __typename?: 'RewardsUserCAAddress';
  countryCode: MailingAddressCountryCode;
  postalCode?: Maybe<Scalars['String']>;
};

export type RewardsUserCurrentShiftMilestoneDetails = {
  __typename?: 'RewardsUserCurrentShiftMilestoneDetails';
  id: Scalars['ID'];
  currentMilestone: RewardsShiftMilestone;
  percentageCompleted: Scalars['Float'];
  hoursBetweenPreviousAndCurrentMilestone: Scalars['Float'];
  shiftHoursCompletedTowardCurrentMilestone: Scalars['Float'];
  totalShiftHoursWorked: Scalars['Float'];
};

export type RewardsUserGroup = {
  __typename?: 'RewardsUserGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RewardsUserIdentity = {
  /** The user's ID. Same as the user's identity ID. */
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
};

export enum RewardsUserLoginLinkFormat {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type RewardsUserLoginResponse = {
  __typename?: 'RewardsUserLoginResponse';
  accessToken: Scalars['String'];
};

export type RewardsUserPersonalContactInfo = RewardsUserPersonalContactInfoData | RewardsUserPersonalContactInfoSuppressed;

export type RewardsUserPersonalContactInfoData = {
  __typename?: 'RewardsUserPersonalContactInfoData';
  id: Scalars['ID'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type RewardsUserPersonalContactInfoSuppressed = {
  __typename?: 'RewardsUserPersonalContactInfoSuppressed';
  id: Scalars['ID'];
};

/** Rewards user-facing redemption */
export type RewardsUserRedemption = {
  __typename?: 'RewardsUserRedemption';
  id: Scalars['ID'];
  redemptionMethod: RedemptionMethod;
  status: RewardsUserRedemptionStatus;
  dollars: Scalars['Float'];
  points: Scalars['Int'];
  requestedAt: Scalars['Timestamp'];
  redeemedItems: Array<RedemptionItem>;
};

/** Status displayed to the user for a redemption */
export enum RewardsUserRedemptionStatus {
  Pending = 'PENDING',
  Fulfilled = 'FULFILLED',
  Rejected = 'REJECTED'
}

export type RewardsUserReferralStats = {
  __typename?: 'RewardsUserReferralStats';
  id: Scalars['ID'];
  totalNumberOfShares: Scalars['Int'];
  totalNumberOfApplicants: Scalars['Int'];
  totalNumberOfCandidatesHired: Scalars['Int'];
};

export type RewardsUserShiftMilestoneDetails = {
  __typename?: 'RewardsUserShiftMilestoneDetails';
  id: Scalars['ID'];
  allOrderedMilestones: Array<RewardsShiftMilestone>;
  currentMilestoneDetails?: Maybe<RewardsUserCurrentShiftMilestoneDetails>;
};

export type RewardsUserUsAddress = {
  __typename?: 'RewardsUserUSAddress';
  countryCode: MailingAddressCountryCode;
  zipCode?: Maybe<Scalars['String']>;
};

export type RewardsUsersToSyncListResponse = {
  __typename?: 'RewardsUsersToSyncListResponse';
  total: Scalars['Int'];
  items: Array<SyncOutcomeRewardsUser>;
};

export type RewardsUsersToSyncSearch = {
  name?: Maybe<Scalars['String']>;
};

export enum Role {
  Superuser = 'SUPERUSER',
  Cognito = 'COGNITO',
  CustomerIo = 'CUSTOMER_IO',
  Nevvon = 'NEVVON',
  Retool = 'RETOOL',
  RewardsUser = 'REWARDS_USER',
  RewardsAdmin = 'REWARDS_ADMIN',
  RewardsSuperuser = 'REWARDS_SUPERUSER',
  SchoolsStudent = 'SCHOOLS_STUDENT'
}

export type RotatingSurveyQuestionsConfig = {
  __typename?: 'RotatingSurveyQuestionsConfig';
  requiredSurveyQuestions: Array<SurveyQuestionType>;
  rotatingSurveyQuestions: Array<SurveyQuestionType>;
  numQuestionsPerSurvey: Scalars['Int'];
};

export type RotatingSurveyQuestionsConfigInput = {
  /** The questions that will be included in all surveys sent. */
  requiredSurveyQuestions: Array<SurveyQuestionType>;
  /** The list of questions that will be rotated through for each survey sent. */
  rotatingSurveyQuestions: Array<SurveyQuestionType>;
  /** The total number of questions (required + rotating) that will be included in each survey sent. */
  numQuestionsPerSurvey: Scalars['Int'];
};

export enum SchedulingSoftware {
  Hhaexchange = 'Hhaexchange',
  Alayacare = 'Alayacare',
  Axiscare = 'Axiscare',
  Wellsky = 'Wellsky',
  Unknown = 'Unknown'
}

export type SchoolsEmployer = {
  __typename?: 'SchoolsEmployer';
  id: Scalars['ID'];
  name: Scalars['String'];
  profileHTML: Scalars['String'];
  /** For schools students only: true if the authenticated student has applied to this employer. */
  applied: Scalars['Boolean'];
};

export type SchoolsEmployerSurvey = {
  __typename?: 'SchoolsEmployerSurvey';
  id: Scalars['ID'];
  question: Scalars['String'];
  answers: Array<SchoolsEmployerSurveyAnswer>;
  results: Array<SchoolsEmployerSurveyResult>;
};

export type SchoolsEmployerSurveyAnswer = {
  __typename?: 'SchoolsEmployerSurveyAnswer';
  id: Scalars['ID'];
  answer: Scalars['String'];
};

export type SchoolsEmployerSurveyResult = {
  __typename?: 'SchoolsEmployerSurveyResult';
  id: Scalars['ID'];
  employer: SchoolsEmployer;
  answers: Array<SchoolsEmployerSurveyResultAnswer>;
};

export type SchoolsEmployerSurveyResultAnswer = {
  __typename?: 'SchoolsEmployerSurveyResultAnswer';
  answer: SchoolsEmployerSurveyAnswer;
  percentage: Scalars['Float'];
};

export type SchoolsJobApplication = {
  __typename?: 'SchoolsJobApplication';
  id: Scalars['ID'];
};

export enum SchoolsJobApplicationDesiredHours {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export enum SchoolsJobApplicationDesiredShiftDaysOfWeek {
  MondayToFriday = 'MONDAY_TO_FRIDAY',
  WeekendsOnly = 'WEEKENDS_ONLY'
}

export enum SchoolsJobApplicationDesiredShiftTimeOfDay {
  Mornings = 'MORNINGS',
  WorkDays = 'WORK_DAYS',
  Evenings = 'EVENINGS',
  Nights = 'NIGHTS'
}

export enum SchoolsJobApplicationTravelCapability {
  PublicTransitOnly = 'PUBLIC_TRANSIT_ONLY',
  AbleToDrive = 'ABLE_TO_DRIVE'
}

export type SchoolsStudent = {
  __typename?: 'SchoolsStudent';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  graduationDate: Scalars['MonthAndYear'];
  createdApplication: Scalars['Boolean'];
};

export type SchoolsStudentLoginResponse = {
  __typename?: 'SchoolsStudentLoginResponse';
  accessToken: Scalars['String'];
};

export type SearchForRewardsUsersFilterInput = {
  /**
   * Allows filtering by organization branch ID.
   * If provided, will only show results from given branch(es)
   * If not provided, will show results from all branches
   * If [null] is provided, will show results that have no branch assigned
   * If [] is provided, will show NO results at all
   */
  branchIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export enum SharePlatform {
  CopiedLink = 'COPIED_LINK',
  Email = 'EMAIL',
  Sms = 'SMS',
  Facebook = 'FACEBOOK',
  Messenger = 'MESSENGER',
  Linkedin = 'LINKEDIN',
  Whatsapp = 'WHATSAPP'
}

export enum ShiftPostingBroadcastChannel {
  Sms = 'SMS'
}

export type ShiftPostingBroadcastHistoryItem = {
  __typename?: 'ShiftPostingBroadcastHistoryItem';
  id: Scalars['ID'];
  sentAt: Scalars['Timestamp'];
  channel: ShiftPostingBroadcastChannel;
  caregiver: RewardsUser;
};

export type ShiftPostingDateRangeInput = {
  /** Start date for filtering shift postings (inclusive). */
  startDate: Scalars['Timestamp'];
  /** End date for filtering shift postings (exclusive). */
  endDate: Scalars['Timestamp'];
};

export enum ShiftPostingUrgency {
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW'
}

export enum ShiftPostingUrgencyReason {
  BedBoundPatient = 'BED_BOUND_PATIENT',
  LiveInShift = 'LIVE_IN_SHIFT',
  OvernightShift = 'OVERNIGHT_SHIFT',
  MidDayShift = 'MID_DAY_SHIFT',
  ShortShift = 'SHORT_SHIFT',
  WeekendShift = 'WEEKEND_SHIFT',
  SplitShift = 'SPLIT_SHIFT',
  LastMinuteShift = 'LAST_MINUTE_SHIFT'
}

export type ShiftRewardGoalDetails = {
  __typename?: 'ShiftRewardGoalDetails';
  visit: ShiftRewardGoalVisitDetail;
};

export type ShiftRewardGoalTracker = {
  __typename?: 'ShiftRewardGoalTracker';
  id: Scalars['ID'];
};

export type ShiftRewardGoalVisitDetail = {
  __typename?: 'ShiftRewardGoalVisitDetail';
  id: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
};

export type SocialPost = {
  __typename?: 'SocialPost';
  id: Scalars['ID'];
  type: SocialPostType;
  details?: Maybe<SocialPostDetails>;
  publishedAt: Scalars['Timestamp'];
  /**
   * Branch details for this post, if it was published for a branch.
   * Returns null if the post was organization-wide.
   */
  branch?: Maybe<RewardsOrganizationBranch>;
  /**
   * The users who were tagged in the post.
   *
   * Note that this does not expose the RewardsUser type,
   * since it only exposes a subset of user information
   * (e.g. their name).
   */
  taggedUsers: Array<SocialPostTaggedUser>;
  /** Number of reactions to the post, grouped by reaction type. */
  reactionsSummary: Array<ReactionsSummary>;
  /**
   * As a logged in Rewards User, this returns the reactions
   * that the user has recorded for the post.
   * Does not include reactions that have been removed.
   */
  myRecordedReactionsSummary: Array<ReactionsSummary>;
  /**
   * As a logged in Rewards User, this returns
   * if the user has viewed this post or not.
   */
  viewed: Scalars['Boolean'];
  /** Uploaded video attached to the post; null if no video. */
  videoId?: Maybe<Scalars['String']>;
  /** Resolved video when videoId is set; null otherwise. */
  video?: Maybe<RewardVideo>;
  /**
   * As a logged in Rewards User, this returns my current daily reward if
   * it is type "view_social_post" and tied to this specific social post.
   */
  myViewSocialPostDailyReward?: Maybe<DailyReward>;
};

export type SocialPostDetails = CustomSocialPostDetails | BirthdaySocialPostDetails | WorkMilestoneSocialPostDetails | RedemptionSocialPostDetails;

export type SocialPostRedemption = {
  __typename?: 'SocialPostRedemption';
  redemptionId: Scalars['ID'];
  userId: Scalars['ID'];
  redemptionPointsAmount: Scalars['Int'];
};

export type SocialPostTaggedUser = {
  __typename?: 'SocialPostTaggedUser';
  id: Scalars['ID'];
  /**
   * The user's first name and last initial.
   *
   * If the user has opted out of appearing in the social feed,
   * this field will be null.
   */
  firstNameLastInitial?: Maybe<Scalars['String']>;
};

export enum SocialPostType {
  Custom = 'CUSTOM',
  Welcome = 'WELCOME',
  Birthday = 'BIRTHDAY',
  WorkMilestone = 'WORK_MILESTONE',
  Redemption = 'REDEMPTION'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Status = {
  __typename?: 'Status';
  status: Scalars['String'];
  version: Scalars['String'];
};

export type SubmissionYesNoFieldAnswerInput = {
  fieldId: Scalars['String'];
  value: JobPostingYesNoFieldAnswer;
};

export type SubmitJobApplicationResponse = {
  __typename?: 'SubmitJobApplicationResponse';
  applicantUploadToken: Scalars['ID'];
  applicationSubmissionId: Scalars['ID'];
};

export type SurveyAverageScoreResponse = {
  __typename?: 'SurveyAverageScoreResponse';
  averageScore: Scalars['Float'];
  previousAverageScore?: Maybe<Scalars['Float']>;
};

export type SurveyCommentsFiltersInput = {
  /**
   * When provided, only comments associated with a score equal to this value will be returned.
   * Must be between 1 and 5, where 5 is most positive.
   */
  score?: Maybe<Scalars['Int']>;
  /**
   * When provided, will only consider comments that were submitted within the given date range.
   * If no date range is provided, will return all comments.
   */
  dateRange?: Maybe<SurveyInsightsDateRangeInput>;
};

export type SurveyEngagementResponse = {
  __typename?: 'SurveyEngagementResponse';
  numSent: Scalars['Int'];
  /**
   * The number of surveys sent out that received a response.
   * If a user submitted the same survey more than once, it still counts as a single response here.
   */
  numResponses: Scalars['Int'];
  /** The fraction (between 0 and 1) of the surveys sent out that received a response. */
  responseRate: Scalars['Float'];
  reward: SurveyReward;
};

export type SurveyGoalDetails = {
  __typename?: 'SurveyGoalDetails';
  /**
   * The URL to the survey that should be completed to achieve this goal.
   *
   * Note: this attribute should always be present on available survey
   * goals, but is nullable in case of configuration error.
   * In the case when the URL is missing there should be an error
   * raised on the front-end.
   */
  externalSurveyUrl?: Maybe<Scalars['String']>;
  anonymousSubmission: Scalars['Boolean'];
};

export type SurveyGoalTracker = {
  __typename?: 'SurveyGoalTracker';
  id: Scalars['ID'];
  surveyType: SurveyGoalTrackerSurveyType;
};

export enum SurveyGoalTrackerSurveyType {
  PulseCheck = 'PULSE_CHECK',
  QuickCheck = 'QUICK_CHECK'
}

export type SurveyInsightsDateRange = {
  __typename?: 'SurveyInsightsDateRange';
  label: SurveyInsightsDateRangeLabel;
  customLabel?: Maybe<Scalars['String']>;
  year: Scalars['Int'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  month?: Maybe<Scalars['String']>;
};

export type SurveyInsightsDateRangeInput = {
  label: SurveyInsightsDateRangeLabel;
  year: Scalars['Int'];
};

export enum SurveyInsightsDateRangeLabel {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
  TrialWeek_1 = 'TRIAL_WEEK_1',
  TrialWeek_4 = 'TRIAL_WEEK_4',
  Launch = 'LAUNCH'
}

export type SurveyNpsScorePreviousResultsResponse = {
  __typename?: 'SurveyNPSScorePreviousResultsResponse';
  /**
   * The NPS score, from -100 to 100.
   * This will be null if the survey type does not support NPS score,
   * or there was no data for the previous date range.
   */
  npsScore?: Maybe<Scalars['Int']>;
  dateRange: SurveyInsightsDateRange;
};

export type SurveyNpsScoreResponse = {
  __typename?: 'SurveyNPSScoreResponse';
  /**
   * The NPS score, from -100 to 100.
   * This will be null if the survey type does not support NPS score,
   * or there was no data for the requested date range.
   */
  npsScore?: Maybe<Scalars['Int']>;
  /**
   * NPS score from up to 4 date ranges prior to the requested date range.
   * Ordered from newest to oldest.
   */
  previousScores?: Maybe<Array<SurveyNpsScorePreviousResultsResponse>>;
};

export type SurveyQuestionPreviousResultsResponse = {
  __typename?: 'SurveyQuestionPreviousResultsResponse';
  averageScore: Scalars['Float'];
  dateRange: SurveyInsightsDateRange;
};

export type SurveyQuestionResponse = {
  __typename?: 'SurveyQuestionResponse';
  /** The ID of the survey submission, which belongs to all the question responses from the survey. */
  surveySubmissionId: Scalars['ID'];
  /** The score given to the question between 1 and 5, where 5 is most positive. */
  score: Scalars['Int'];
  /** The comment given to provide detail to the score. */
  comment: Scalars['String'];
  /** The user who submitted the survey. Null if the submission was anonymous. */
  user?: Maybe<RewardsUser>;
};

export type SurveyQuestionResultsResponse = {
  __typename?: 'SurveyQuestionResultsResponse';
  averageScore: Scalars['Float'];
  numComments: Scalars['Int'];
  /**
   * Average score for the question from up to 4 date ranges prior to the requested date range.
   * Ordered from newest to oldest.
   */
  previousAverageScores?: Maybe<Array<SurveyQuestionPreviousResultsResponse>>;
};

export type SurveyQuestionScoreCount = {
  __typename?: 'SurveyQuestionScoreCount';
  score: Scalars['Int'];
  count: Scalars['Int'];
};

export enum SurveyQuestionType {
  MeaningfulRecognition = 'MEANINGFUL_RECOGNITION',
  ManageableWorkload = 'MANAGEABLE_WORKLOAD',
  ReliableTransportation = 'RELIABLE_TRANSPORTATION',
  LeadershipSupport = 'LEADERSHIP_SUPPORT',
  Resources = 'RESOURCES',
  Nps = 'NPS',
  QuickCheckWeeklySentiment = 'QUICK_CHECK_WEEKLY_SENTIMENT',
  QuickCheckEmployeeValue = 'QUICK_CHECK_EMPLOYEE_VALUE',
  QuickCheckFeedbackEffectiveness = 'QUICK_CHECK_FEEDBACK_EFFECTIVENESS',
  QuickCheckSupervisorCommunication = 'QUICK_CHECK_SUPERVISOR_COMMUNICATION',
  QuickCheckSupervisorReachability = 'QUICK_CHECK_SUPERVISOR_REACHABILITY',
  QuickCheckNps = 'QUICK_CHECK_NPS',
  QuickCheckClientImpact = 'QUICK_CHECK_CLIENT_IMPACT',
  QuickCheckManageableWorkload = 'QUICK_CHECK_MANAGEABLE_WORKLOAD',
  QuickCheckScheduleBalance = 'QUICK_CHECK_SCHEDULE_BALANCE',
  QuickCheckScheduleSatisfaction = 'QUICK_CHECK_SCHEDULE_SATISFACTION',
  QuickCheckRecognitionRegularity = 'QUICK_CHECK_RECOGNITION_REGULARITY',
  QuickCheckRecognitionImpact = 'QUICK_CHECK_RECOGNITION_IMPACT',
  QuickCheckClientSatisfaction = 'QUICK_CHECK_CLIENT_SATISFACTION',
  FirstShiftWillingToReturnToClient = 'FIRST_SHIFT_WILLING_TO_RETURN_TO_CLIENT',
  FirstShiftEasyToGetToClient = 'FIRST_SHIFT_EASY_TO_GET_TO_CLIENT',
  FirstShiftCoordinatorSupport = 'FIRST_SHIFT_COORDINATOR_SUPPORT',
  FirstShiftAdditionalHoursRequested = 'FIRST_SHIFT_ADDITIONAL_HOURS_REQUESTED'
}

export type SurveyReward = {
  __typename?: 'SurveyReward';
  numDrawTickets?: Maybe<Scalars['Int']>;
  numPoints?: Maybe<Scalars['Int']>;
};

export enum SurveyType {
  PulseCheck = 'PULSE_CHECK',
  FirstShiftCheckIn = 'FIRST_SHIFT_CHECK_IN',
  QuickCheck = 'QUICK_CHECK'
}

export enum SyncOperationType {
  Include = 'INCLUDE',
  Exclude = 'EXCLUDE'
}

export enum SyncOutcome {
  NoChange = 'NO_CHANGE',
  WillBeActivated = 'WILL_BE_ACTIVATED',
  WillBeDeactivated = 'WILL_BE_DEACTIVATED'
}

export type SyncOutcomeRewardsUser = {
  __typename?: 'SyncOutcomeRewardsUser';
  rewardsUser: RewardsUser;
  syncOutcome: SyncOutcome;
};

export type TagGroup = {
  __typename?: 'TagGroup';
  type: Scalars['String'];
  tags: Array<RewardsTag>;
};

export type TagIdInput = {
  tagId: Scalars['ID'];
};

export type TimeBasedlUnlockCriteria = {
  __typename?: 'TimeBasedlUnlockCriteria';
  unlocksAt: Scalars['Timestamp'];
};

export type TimeToFirstShiftAdminGoalDetails = {
  __typename?: 'TimeToFirstShiftAdminGoalDetails';
  /**
   * List of users who have started within the goal period but have no visits scheduled.
   * Limit of 3 users will be returned.
   */
  usersToSchedule: Array<RewardsUser>;
};

export type TimeToFirstShiftAdminGoalTracker = {
  __typename?: 'TimeToFirstShiftAdminGoalTracker';
  id: Scalars['ID'];
  targetAverageDaysToFirstShift: Scalars['Int'];
  targetNewHiresScheduledPercentage: Scalars['Int'];
  /**
   * The total number of scheduleable new hires during the goal period.
   * This may be null if the goal progress has not yet been updated.
   */
  totalScheduleableNewHires?: Maybe<Scalars['Int']>;
  /**
   * The total number of new hires during the goal period who have been scheduled
   * for their first shift.
   * This may be null if the goal progress has not yet been updated.
   */
  totalNewHiresWithFirstShift?: Maybe<Scalars['Int']>;
  /**
   * The current average number of days to first shift for new hires during the goal period.
   * This may be null if the goal progress has not yet been updated, or if no new hires
   * have been scheduled yet.
   */
  averageDaysToFirstShift?: Maybe<Scalars['Float']>;
  progressUpdatedAt?: Maybe<Scalars['Timestamp']>;
};

export type TimeToFirstShiftInsightMetric = EligibleTimeToFirstShiftInsightMetric | IneligibleTimeToFirstShiftInsightMetric;


export type TimezoneOption = {
  __typename?: 'TimezoneOption';
  id: Scalars['String'];
  name: Scalars['String'];
  alternativeName: Scalars['String'];
  mainCities: Array<Scalars['String']>;
  currentTimeFormat: Scalars['String'];
};

export type TotalHiresInsightMetric = {
  __typename?: 'TotalHiresInsightMetric';
  id: Scalars['ID'];
  hiredCandidateCount: Scalars['Int'];
};

export type TotalVisitHoursByWeek = {
  __typename?: 'TotalVisitHoursByWeek';
  id: Scalars['ID'];
  weekStart: Scalars['Date'];
  totalVisitHours: Scalars['Int'];
};

/**
 * The current progress of a track, where `totalEarnablePointsForTrack` is the point sum of available, locked, and achieved goals within a track,
 * and `pointsEarnedSoFar` is the point sum of achieved goals within a track.
 */
export type TrackProgress = {
  __typename?: 'TrackProgress';
  pointsEarnedSoFar: Scalars['Int'];
  totalEarnablePointsForTrack: Scalars['Int'];
};

export type TransactionMetadata = TransactionMetadataUnknown | TransactionMetadataReferralJobShare | TransactionMetadataReferralRecruitmentStep | TransactionMetadataReferralRetentionMilestone | TransactionMetadataReferralAssignedAsReferringEmployee | TransactionMetadataReferralCorrection | TransactionMetadataRecognition | TransactionMetadataEvvStreakGoal | TransactionMetadataEvvPunchCard | TransactionMetadataMobileAppAdoption | TransactionMetadataMilestoneRewards | TransactionMetadataSurvey | TransactionMetadataWeekendShift | TransactionMetadataLastMinuteShift | TransactionMetadataWatchedVideo | TransactionMetadataTrainingProgram | TransactionMetadataBillableHoursIncrease | TransactionMetadataRedemption | TransactionMetadataRedemptionRejected | TransactionMetadataDrawWinner | TransactionMetadataCompleteCaregiverProfile | TransactionMetadataWelcomeGoal | TransactionMetadataShiftReward | TransactionMetadataBirthdayGoal | TransactionMetadataAnniversaryGoal | TransactionMetadataPointsRemoval | TransactionMetadataPointsRedeemed | TransactionMetadataDailyReward;

export type TransactionMetadataAnniversaryGoal = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataAnniversaryGoal';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataBillableHoursIncrease = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataBillableHoursIncrease';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataBirthdayGoal = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataBirthdayGoal';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export enum TransactionMetadataCategory {
  Referral = 'REFERRAL',
  Recognition = 'RECOGNITION',
  ClockInOut = 'CLOCK_IN_OUT',
  Milestone = 'MILESTONE',
  Survey = 'SURVEY',
  Weekend = 'WEEKEND',
  LastMinute = 'LAST_MINUTE',
  Video = 'VIDEO',
  Training = 'TRAINING',
  HoursIncrease = 'HOURS_INCREASE',
  Other = 'OTHER',
  Redemption = 'REDEMPTION',
  Draw = 'DRAW',
  CaregiverProfile = 'CAREGIVER_PROFILE',
  Welcome = 'WELCOME',
  ShiftReward = 'SHIFT_REWARD',
  Birthday = 'BIRTHDAY',
  Anniversary = 'ANNIVERSARY',
  PointsRemoval = 'POINTS_REMOVAL',
  PointsRedeemed = 'POINTS_REDEEMED',
  DailyReward = 'DAILY_REWARD'
}

export type TransactionMetadataCompleteCaregiverProfile = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataCompleteCaregiverProfile';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataDailyReward = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataDailyReward';
  category: TransactionMetadataCategory;
  dailyRewardId: Scalars['ID'];
};

export type TransactionMetadataDrawWinner = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataDrawWinner';
  category: TransactionMetadataCategory;
  drawWinner: DrawWinner;
};

export type TransactionMetadataEvvPunchCard = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataEVVPunchCard';
  category: TransactionMetadataCategory;
  punchCardOffer: RewardOffer;
};

export type TransactionMetadataEvvStreakGoal = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataEVVStreakGoal';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataLastMinuteShift = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataLastMinuteShift';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataMilestoneRewards = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataMilestoneRewards';
  category: TransactionMetadataCategory;
  milestoneRewardStep: UserMilestoneRewardStep;
};

export type TransactionMetadataMobileAppAdoption = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataMobileAppAdoption';
  category: TransactionMetadataCategory;
};

export type TransactionMetadataPointsRedeemed = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataPointsRedeemed';
  category: TransactionMetadataCategory;
  redemption?: Maybe<Redemption>;
  rewardsUserRedemption?: Maybe<RewardsUserRedemption>;
  adminEmail?: Maybe<Scalars['String']>;
  adminFirstName?: Maybe<Scalars['String']>;
  adminLastName?: Maybe<Scalars['String']>;
};

export type TransactionMetadataPointsRemoval = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataPointsRemoval';
  category: TransactionMetadataCategory;
  adminEmail?: Maybe<Scalars['String']>;
  adminFirstName?: Maybe<Scalars['String']>;
  adminLastName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type TransactionMetadataRecognition = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataRecognition';
  category: TransactionMetadataCategory;
  recognitionPoints: RecognitionPoints;
};

export type TransactionMetadataRedemption = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataRedemption';
  category: TransactionMetadataCategory;
  redemption?: Maybe<Redemption>;
  rewardsUserRedemption?: Maybe<RewardsUserRedemption>;
};

export type TransactionMetadataRedemptionRejected = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataRedemptionRejected';
  category: TransactionMetadataCategory;
  redemption: Redemption;
  rewardsUserRedemption?: Maybe<RewardsUserRedemption>;
};

export type TransactionMetadataReferralAssignedAsReferringEmployee = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataReferralAssignedAsReferringEmployee';
  category: TransactionMetadataCategory;
  candidate: Candidate;
  referral?: Maybe<Referral>;
};

export type TransactionMetadataReferralCorrection = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataReferralCorrection';
  category: TransactionMetadataCategory;
  candidate: Candidate;
  referral?: Maybe<Referral>;
};

export type TransactionMetadataReferralJobShare = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataReferralJobShare';
  category: TransactionMetadataCategory;
  jobPosting: JobPosting;
};

export type TransactionMetadataReferralRecruitmentStep = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataReferralRecruitmentStep';
  category: TransactionMetadataCategory;
  candidate: Candidate;
  referral?: Maybe<Referral>;
  stepName: CandidateRecruitmentStepName;
};

export type TransactionMetadataReferralRetentionMilestone = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataReferralRetentionMilestone';
  category: TransactionMetadataCategory;
  candidate: Candidate;
  referral?: Maybe<Referral>;
  durationMonths?: Maybe<Scalars['Int']>;
  durationHours?: Maybe<Scalars['Int']>;
};

export type TransactionMetadataShiftReward = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataShiftReward';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataSurvey = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataSurvey';
  category: TransactionMetadataCategory;
  surveyType?: Maybe<SurveyType>;
};

export type TransactionMetadataTrainingProgram = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataTrainingProgram';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataUnknown = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataUnknown';
  category: TransactionMetadataCategory;
};

export type TransactionMetadataWatchedVideo = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataWatchedVideo';
  category: TransactionMetadataCategory;
  video: RewardVideo;
};

export type TransactionMetadataWeekendShift = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataWeekendShift';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TransactionMetadataWelcomeGoal = CategorizedTransactionMetadata & {
  __typename?: 'TransactionMetadataWelcomeGoal';
  category: TransactionMetadataCategory;
  goal: Goal;
};

export type TwilioSmsFailureMetric = {
  __typename?: 'TwilioSmsFailureMetric';
  errorCode: Scalars['Int'];
  numSms: Scalars['Int'];
};

export type UsMailingAddress = {
  __typename?: 'USMailingAddress';
  countryCode: MailingAddressCountryCode;
  stateAbbreviation: UsStateAbbreviation;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  zipCode: Scalars['String'];
};

export enum UsStateAbbreviation {
  Al = 'AL',
  Ak = 'AK',
  As = 'AS',
  Az = 'AZ',
  Ar = 'AR',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Dc = 'DC',
  Fm = 'FM',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Mh = 'MH',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Mp = 'MP',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pw = 'PW',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Vi = 'VI',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY'
}

export type UnreadShiftPostingMatchSummary = {
  __typename?: 'UnreadShiftPostingMatchSummary';
  hasUnreadLatestShiftPostingMatch: Scalars['Boolean'];
};

export type UnreadSocialPostSummary = {
  __typename?: 'UnreadSocialPostSummary';
  hasUnreadLatestPost: Scalars['Boolean'];
};

export type UpdateOrganizationSocialFeedSettingsInput = {
  disabledPostTypes?: Maybe<Array<SocialPostType>>;
};

export type UpdateReferralStructureInput = {
  retentionMilestones: Array<UpdateReferralStructureRetentionMilestoneInput>;
  recruitmentSteps: Array<UpdateReferralStructureRecruitmentStepInput>;
  jobShareStructure?: Maybe<UpdateReferralStructureJobShareStructureInput>;
};

export type UpdateReferralStructureJobShareStructureInput = {
  reward: UpdateReferralStructureJobStructureRewardItemsInput;
  maxAwardableSharesPerMonth: Scalars['Int'];
};

export type UpdateReferralStructureJobStructureDrawTicketInput = {
  numTicketsPerJobShare: Scalars['Int'];
};

export type UpdateReferralStructureJobStructureManualMonthlyRaffleInput = {
  numTicketsPerJobShare: Scalars['Int'];
  numWinnersSelectedPerMonth: Scalars['Int'];
  prizeText: Scalars['String'];
};

export type UpdateReferralStructureJobStructurePointsInput = {
  pointValue: Scalars['Int'];
};

export type UpdateReferralStructureJobStructureRewardItemsInput = {
  type: OrganizationCandidateStepRewardType;
  jobStructurePointReward?: Maybe<UpdateReferralStructureJobStructurePointsInput>;
  jobStructureDrawTicketReward?: Maybe<UpdateReferralStructureJobStructureDrawTicketInput>;
  jobStructureManualMonthlyRaffleReward?: Maybe<UpdateReferralStructureJobStructureManualMonthlyRaffleInput>;
};

export type UpdateReferralStructureRecruitmentStepInput = {
  step: CandidateRecruitmentStepName;
  pointValue: Scalars['Int'];
};

export type UpdateReferralStructureRetentionMilestoneInput = {
  unit: Scalars['String'];
  pointValue: Scalars['Int'];
  durationHours: Scalars['Int'];
};


export type UploadBulkImportResponse = {
  __typename?: 'UploadBulkImportResponse';
  bulkImportId: Scalars['ID'];
};

export type UploadCandidateResumeResponse = {
  __typename?: 'UploadCandidateResumeResponse';
  resumeId: Scalars['ID'];
};

export type UploadJobApplicationResumeResponse = {
  __typename?: 'UploadJobApplicationResumeResponse';
  resumeId: Scalars['ID'];
};

export type UserEligibilityExclusionFilters = {
  __typename?: 'UserEligibilityExclusionFilters';
  tagCombinations: Array<UserEligibilityTagCombination>;
  phoneNumbers: Array<Scalars['String']>;
  emailAddresses: Array<Scalars['String']>;
  emailDomains: Array<Scalars['String']>;
};

export type UserEligibilityExclusionFiltersInput = {
  tagCombinations: Array<UserEligibilityTagCombinationInput>;
  phoneNumbers: Array<Scalars['String']>;
  emailAddresses: Array<Scalars['String']>;
  emailDomains: Array<Scalars['String']>;
};

export type UserEligibilityFilters = {
  __typename?: 'UserEligibilityFilters';
  inclusionFilters: UserEligibilityInclusionFilters;
  exclusionFilters: UserEligibilityExclusionFilters;
};

export type UserEligibilityFiltersInput = {
  inclusionFilters: UserEligibilityInclusionFiltersInput;
  exclusionFilters: UserEligibilityExclusionFiltersInput;
};

export type UserEligibilityInclusionFilters = {
  __typename?: 'UserEligibilityInclusionFilters';
  tagCombinations: Array<UserEligibilityTagCombination>;
};

export type UserEligibilityInclusionFiltersInput = {
  tagCombinations: Array<UserEligibilityTagCombinationInput>;
};

export type UserEligibilitySettings = {
  __typename?: 'UserEligibilitySettings';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  organizationId: Scalars['Int'];
  externalIntegrationId: Scalars['String'];
  filters: UserEligibilityFilters;
};

export type UserEligibilityTagCombination = {
  __typename?: 'UserEligibilityTagCombination';
  tagType: Scalars['String'];
  /** This can also include `NULL` as a value to indicate that the users without any tags of given type are eligible. */
  tagIds: Array<Scalars['String']>;
  tags: Array<RewardsTag>;
};

export type UserEligibilityTagCombinationInput = {
  tagType: Scalars['String'];
  /** This can also include `NULL` as a value to indicate that the user should be eligible if they have no tags of given type at all. */
  tagIds: Array<Scalars['String']>;
};

export type UserIdentity = {
  __typename?: 'UserIdentity';
  id: Scalars['String'];
  role: Role;
  name: Scalars['String'];
};

export type UserMilestoneRewardStep = {
  __typename?: 'UserMilestoneRewardStep';
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
  goal: MilestoneGoal;
  /** The # points to be earned by completing this milestone. */
  pointValue: Scalars['Int'];
  /** Progress is in # hours or # visits, depending on the goal. */
  progress: Scalars['Int'];
};

export type UserMilestoneRewards = {
  __typename?: 'UserMilestoneRewards';
  id: Scalars['ID'];
  organizationId: Scalars['Int'];
  milestoneSteps: Array<UserMilestoneRewardStep>;
  mustCompleteEVV: Scalars['Boolean'];
  /** Whether all milestones for this user have been completed or not. */
  allMilestonesComplete: Scalars['Boolean'];
  /** Current in-progress milestone step. Null if all milestones complete. */
  currentMilestoneStep?: Maybe<UserMilestoneRewardStep>;
  /**
   * Next milestone step (not yet in-progress).
   * Null if current milestone is the last one, or if all milestones complete.
   */
  nextMilestoneStep?: Maybe<UserMilestoneRewardStep>;
  stopped: Scalars['Boolean'];
};

export type UserShiftBookingAccess = {
  __typename?: 'UserShiftBookingAccess';
  canAccessShiftBooking: Scalars['Boolean'];
};

export type ValidateAtsJobResult = {
  __typename?: 'ValidateATSJobResult';
  valid: Scalars['Boolean'];
  teamId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum VideoStatus {
  PendingUpload = 'PENDING_UPLOAD',
  Uploaded = 'UPLOADED',
  Deleted = 'DELETED'
}

export enum VideoType {
  Welcome = 'WELCOME',
  Custom = 'CUSTOM'
}

export type Visit = {
  __typename?: 'Visit';
  id: Scalars['ID'];
  startAt: Scalars['Timestamp'];
  endAt: Scalars['Timestamp'];
  /**
   * Indicates if the visit is an open shift, which means that
   * a caregiver is able to submit their interest in picking up the shift.
   */
  isOpenShift: Scalars['Boolean'];
  /**
   * Indicates if the current user has submitted their interest in picking up the shift
   * (in order to display if the user has submitted interest or not).
   */
  myRewardsUserIndicatedInterestInOpenShift: Scalars['Boolean'];
  /** Allows a REWARDS_ADMIN to see the list of users who have indicated interest in picking up the shift. */
  usersInterestedInOpenShift: Array<RewardsUser>;
  /**
   * Deprecated. Use `phiLinkToVisitInSchedulingSystemV2` instead.
   * @deprecated Use `phiLinkToVisitInSchedulingSystemV2` instead
   */
  phiLinkToVisitInSchedulingSystem?: Maybe<Scalars['String']>;
  /**
   * A link to the visit in the scheduling system.
   *
   * This may return `null`, for e.g. if the integration is not configured
   * correctly (e.g. HHAXIntegration is missing entId), or if the visit
   * is not associated with an integration that supports this feature.
   */
  phiLinkToVisitInSchedulingSystemV2?: Maybe<Scalars['PHIString']>;
  /** Scheduling software that this Visit originates from. */
  schedulingSoftware: SchedulingSoftware;
  /** The points to be earned by the caregiver who works this shift, if any. */
  shiftRewardPoints?: Maybe<Scalars['Int']>;
  /**
   * If the caregiver must confirm the assigned visit and has not yet,
   * this is the ID of the shift posting visit that must be confirmed.
   * If the visit has already been confirmed or does not require confirmation,
   * this will be `null`.
   */
  shiftPostingVisitIdPendingConfirmation?: Maybe<Scalars['ID']>;
  /** The location of the visit, if available. */
  location?: Maybe<Scalars['String']>;
  /**
   * The short location of the visit, if available.
   * This will not include the state - just the city.
   */
  locationShort?: Maybe<Scalars['String']>;
  /** The ZIP5 of the visit, if available. */
  zip5?: Maybe<Scalars['String']>;
};

export type VisitClockDetails = {
  clockedAt: Scalars['Timestamp'];
  method: VisitClockMethod;
};

export enum VisitClockMethod {
  MobileApp = 'MOBILE_APP',
  Ivr = 'IVR',
  SystemAutoClock = 'SYSTEM_AUTO_CLOCK',
  Unknown = 'UNKNOWN'
}

export type VisitMilestoneGoal = {
  __typename?: 'VisitMilestoneGoal';
  type: Scalars['String'];
  visitNumber: Scalars['Int'];
};

export enum VisitRemovalReason {
  Cancelled = 'CANCELLED'
}

export enum VistResult {
  Confirmed = 'CONFIRMED',
  MissedByCaregiver = 'MISSED_BY_CAREGIVER'
}


export type WatchVideoGoalDetails = {
  __typename?: 'WatchVideoGoalDetails';
  /**
   * The ID of the video that should be completed to achieve this goal.
   *
   * Note: this attribute should always be present on available video
   * goals, but is nullable in case of configuration error.
   * In the case when the video ID is missing there should be an error
   * raised on the front-end.
   */
  videoId?: Maybe<Scalars['ID']>;
  video?: Maybe<RewardVideo>;
};

export type WatchVideoGoalTracker = {
  __typename?: 'WatchVideoGoalTracker';
  id: Scalars['ID'];
  videoType: WatchVideoGoalTrackerVideoType;
};

export enum WatchVideoGoalTrackerVideoType {
  WelcomeVideo = 'WELCOME_VIDEO'
}

export type WeekendShiftGoalDistributionConfig = {
  __typename?: 'WeekendShiftGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  weekendShiftRewardOverride?: Maybe<GoalConfigRewardOverride>;
};

export type WeekendShiftGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  weekendShiftRewardOverride?: Maybe<GoalRewardsInput>;
};

export type WeekendShiftGoalTracker = {
  __typename?: 'WeekendShiftGoalTracker';
  id: Scalars['ID'];
  trackedVisit?: Maybe<WeekendShiftGoalTrackerVisitDetail>;
  availability?: Maybe<Scalars['String']>;
};

export type WeekendShiftGoalTrackerVisitDetail = {
  __typename?: 'WeekendShiftGoalTrackerVisitDetail';
  id: Scalars['ID'];
  rangeStart: Scalars['Timestamp'];
  rangeEnd: Scalars['Timestamp'];
};

export type WelcomeGoalDistributionConfig = {
  __typename?: 'WelcomeGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  welcomeRewardOverride?: Maybe<GoalConfigRewardOverride>;
  daysUntilExpirationOverride?: Maybe<Scalars['Int']>;
};

export type WelcomeGoalDistributionConfigAdminInput = {
  welcomeRewardOverride?: Maybe<GoalRewardsInput>;
  daysUntilExpirationOverride?: Maybe<Scalars['Int']>;
};

export type WelcomeGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  welcomeRewardOverride?: Maybe<GoalRewardsInput>;
  daysUntilExpirationOverride?: Maybe<Scalars['Int']>;
};

export type WelcomeGoalTracker = {
  __typename?: 'WelcomeGoalTracker';
  id: Scalars['ID'];
  hasLoggedIn?: Maybe<Scalars['Boolean']>;
};

export type WelcomeVideoGoalDistributionConfig = {
  __typename?: 'WelcomeVideoGoalDistributionConfig';
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
  welcomeVideoRewardOverride?: Maybe<GoalConfigRewardOverride>;
};

export type WelcomeVideoGoalDistributionConfigAdminInput = {
  welcomeVideoRewardOverride?: Maybe<GoalRewardsInput>;
};

export type WelcomeVideoGoalDistributionConfigInput = {
  enabled: Scalars['Boolean'];
  welcomeVideoRewardOverride?: Maybe<GoalRewardsInput>;
};

export enum WorkMilestoneSocialPostCopyVariant {
  VisitsFirstShiftMultipleCaregivers = 'VISITS_FIRST_SHIFT_MULTIPLE_CAREGIVERS',
  VisitsFirstShiftOneCaregiver = 'VISITS_FIRST_SHIFT_ONE_CAREGIVER',
  VisitsFirstShiftOneCaregiverUnlocked = 'VISITS_FIRST_SHIFT_ONE_CAREGIVER_UNLOCKED',
  VisitsSecondShiftMultipleCaregivers = 'VISITS_SECOND_SHIFT_MULTIPLE_CAREGIVERS',
  VisitsSecondShiftOneCaregiver = 'VISITS_SECOND_SHIFT_ONE_CAREGIVER',
  HoursMultipleCaregiversAmazing = 'HOURS_MULTIPLE_CAREGIVERS_AMAZING',
  HoursMultipleCaregiversWayToGo = 'HOURS_MULTIPLE_CAREGIVERS_WAY_TO_GO',
  HoursMultipleCaregiversHatsOff = 'HOURS_MULTIPLE_CAREGIVERS_HATS_OFF',
  HoursOneCaregiverWow = 'HOURS_ONE_CAREGIVER_WOW',
  HoursOneCaregiverShout = 'HOURS_ONE_CAREGIVER_SHOUT',
  HoursOneCaregiverIncredible = 'HOURS_ONE_CAREGIVER_INCREDIBLE'
}

export type WorkMilestoneSocialPostDetails = {
  __typename?: 'WorkMilestoneSocialPostDetails';
  id: Scalars['ID'];
  milestone: WorkMilestoneSocialPostMilestone;
  copyVariant: WorkMilestoneSocialPostCopyVariant;
};

export type WorkMilestoneSocialPostMilestone = WorkMilestoneSocialPostMilestoneVisit | WorkMilestoneSocialPostMilestoneHours;

export type WorkMilestoneSocialPostMilestoneHours = {
  __typename?: 'WorkMilestoneSocialPostMilestoneHours';
  id: Scalars['ID'];
  numHours: Scalars['Int'];
};

export type WorkMilestoneSocialPostMilestoneVisit = {
  __typename?: 'WorkMilestoneSocialPostMilestoneVisit';
  id: Scalars['ID'];
  visitNumber: Scalars['Int'];
};
